export const tr = {
  app: {
    home: 'Ev',
    playerScout: 'Oyuncu izleme',
    playerComparison: 'Oyuncu Karşılaştırma',
    playerRecruitment: 'Oyuncu Alımı',
    collections: 'Koleksiyonlar',
    favoritePlayers: 'Favori Oyuncular',
    teamAnalytics: 'Takım Analitiği ',
    gameAnalysis: 'Maç Analizi',
    seasonStats: 'Sezon İstatistiği',
    leagueTable: 'Puan Durumu',
    scoresAndFixtures: 'Skor & Fikstür',
    notifications: 'Bildirimler',
    administration: 'İdare',
    inbox: 'Gelen Kutusu',
    teamStats: 'Takım İstatistiği',
    blog: 'Blog',
    leagues: 'Ligler',
    squadBuilder: 'Kadro Yapıcı',
    playerAlerts: 'Player Alerts',
    searchAlerts: 'Search Alerts',
    videoUploadTool: 'Video Upload Tool',
    videoPlaylists: 'Playlists',
    uploadedGames: 'Uploaded games',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
    validateEvents: 'Etkinlikleri Doğrula'
  },
  playerRecruitment: {
    title: 'Oyuncu sayfası',
    subtitle: 'Oyuncunun özelliklerini ve istatistiklerini daha derinlemesine inceleyin',
    league: 'Lig',
    selectedSeason: 'Seçilmiş Sezon',
    year: 'Yıl',
    radar: 'Radar',
    positions: 'Pozisyonlar',
    numberOfPlayers: 'Oyuncu Sayısı',
    template: 'Taslak',
    compareWith: 'İle Karşılaştır',
    previousPerformance: 'Önceki Performans',
    xGames: '{0} Maçlar',
    average: 'Averaj',
    leagueAverage: 'Lig Averajı',
    selectSeason: 'Bir sezon seçin',
    positionsPlayed: 'Oynanan Pozisyon',
    minMax: 'Min & Maks',
    top5Leagues: 'En iyi 5 Lig',
    infoMessage: ' Sezon Min ve Maks\'ı etkinleştirmek için yalnızca bir sezonu işaretleyin ',
    infoMessage2: 'Aynı Oyuncular için aynı sezonu seçin',
    dataPer90MinText: '90 dakika başına veri',
    adjustToPossessionText: '* Top sahipliği için ayarlandı',
    text: 'Yazı',
    lollipop: 'Lolipop',
    polar: 'Polar',
    noGamesBetweenDates: 'Seçilen tarihler arasında maç bulunamadı',
    radarTemplates: {
      Goalkeeper: 'Kaleci',
      GoalkeeperCustom: 'Kaleci Özel',
      GoalkeeperCustom1: 'Kaleci Özel 1',
      GoalkeeperCustom2: ' Kaleci Özel 2',
      GoalkeeperCustom3: ' Kaleci Özel 3',
      GoalkeeperCustom4: ' Kaleci Özel 4',
      GoalkeeperCustom5: ' Kaleci Özel 5',
      GoalkeeperCustom6: ' Kaleci Özel 6',
      Defender: 'Savunmacı',
      DefenderCustom: 'Defans Özel',
      DefenderCustom1: 'Savunmacı Özel 1',
      DefenderCustom2: ' Savunmacı Özel 2',
      DefenderCustom3: ' Savunmacı Özel 3',
      DefenderCustom4: ' Savunmacı Özel 4',
      DefenderCustom5: ' Savunmacı Özel 5',
      DefenderCustom6: ' Savunmacı Özel 6',
      FullBack: 'Bek Oyuncu',
      FullBackCustom: 'FullBack Özel',
      FullBackCustom1: ' Bek Oyuncu Özel 1',
      FullBackCustom2: ' Bek Oyuncu Özel 2',
      FullBackCustom3: ' Bek Oyuncu Özel 3',
      FullBackCustom4: ' Bek Oyuncu Özel 4',
      FullBackCustom5: ' Bek Oyuncu Özel 5',
      FullBackCustom6: ' Bek Oyuncu Özel 6',
      FullBackPredictive: ' Bek Oyuncu Özel ',
      Midfielder: 'Orta Saha',
      MidfielderCustom: 'Orta Saha Oyuncusu Özel',
      MidfielderCustom1: ' Orta Saha Özel 1',
      MidfielderCustom2: ' Orta Saha Özel 2',
      MidfielderCustom3: ' Orta Saha Özel 3',
      MidfielderCustom4: ' Orta Saha Özel 4',
      MidfielderCustom5: ' Orta Saha Özel 5',
      MidfielderCustom6: ' Orta Saha Özel 6',
      MidfielderPredictive: ' Tahmin edilebilen Orta Saha',
      MidfielderDefensive: 'Defansif Orta Saha ',
      MidfielderOffensive: 'Ofansif Orta Saha',
      AttackingMidfielder: 'Ofansif Orta Saha',
      MidfielderWing: ' Kanat Orta Saha',
      Winger: 'Kanat Oyuncu',
      WingerCustom: 'Kanat Özel',
      WingerCustom1: ' Kanat Oyuncu Özel 1',
      WingerCustom2: ' Kanat Oyuncu Özel 2',
      WingerCustom3: ' Kanat Oyuncu Özel 3',
      WingerCustom4: ' Kanat Oyuncu Özel 4',
      WingerCustom5: ' Kanat Oyuncu Özel 5',
      WingerCustom6: ' Kanat Oyuncu Özel 6',
      WingerOffensive: 'Ofansif Kanat Oyuncu',
      Forward: 'Forvet',
      ForwardCustom: 'Özel İlet',
      ForwardCustom1: 'Forvet Özel 1',
      ForwardCustom2: ' Forvet Özel 2',
      ForwardCustom3: ' Forvet Özel 3',
      ForwardCustom4: ' Forvet Özel 4',
      ForwardCustom5: ' Forvet Özel 5',
      ForwardCustom6: ' Forvet Özel 6',
      ForwardPredictive: 'Forvet',
      WingBack: 'Kanat Bek',
      WingBackCustom: 'WingBack Özel',
      WingBackCustom1: ' Kanat Bek Özel 1',
      WingBackCustom2: ' Kanat Bek Özel 2',
      WingBackCustom3: ' Kanat Bek Özel 3',
      WingBackCustom4: ' Kanat Bek Özel 4',
      WingBackCustom5: ' Kanat Bek Özel 5',
      WingBackCustom6: ' Kanat Bek Özel 6',
      WingBackMedia: ' Kanat Bek (Sosyal Medya)',
      FullBackMedia: 'Bek (Sosyal Medya)',
      MidfielderMedia: 'Orta Saha (Sosyal Medya)',
      WingerMedia: 'Kanat (Sosyal Medya)',
      ForwardMedia: 'Forvet (Sosyal Medya)',
      PhysicalWingBack: 'Fiziksel Kanat Bek',
      PhysicalForward: ' Fiziksel Forvet',
      PhysicalWinger: 'Fiziksel Kanat',
      PhysicalMidfielder: ' Fiziksel Orta Saha',
      PhysicalFullBack: ' Fiziksel Bek',
      PhysicalDefender: ' Fiziksel Defans',
      PhysicalWingBackLMO: ' Fiziksel Kanat Bek ',
      PhysicalForwardLMO: ' Fiziksel Forvet ',
      PhysicalWingerLMO: ' Fiziksel Kanat',
      PhysicalMidfielderLMO: ' Fiziksel Orta Saha',
      PhysicalFullBackLMO: ' Fiziksel Bek',
      PhysicalDefenderLMO: ' Fiziksel Defans'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Kaleci',
      Defender: 'Defans',
      FullBack: 'Bek',
      FullBackPredictive: 'Tahmin edilebilen Bek',
      Midfielder: 'Orta Saha',
      MidfielderPredictive: ' Tahmin edilebilen Orta Saha',
      MidfielderDefensive: 'Defansif Orta Saha ',
      MidfielderOffensive: 'Ofansif Orta Saha',
      AttackingMidfielder: 'Ofansif Orta Saha',
      MidfielderWing: 'Kanat Orta Saha',
      Winger: 'Kanat',
      WingerOffensive: 'Ofansif Kanat',
      Forward: 'Forvet',
      ForwardPredictive: ' Tahmin edilebilen Forvet',
      WingBack: 'Kanat Bek',
      WingBackMedia: ' Kanat Bek (Sosyal Medya)',
      FullBackMedia: 'Bek (Sosyal Medya)',
      MidfielderMedia: 'Orta Saha (Sosyal Medya)',
      WingerMedia: 'Kanat (Sosyal Medya)',
      ForwardMedia: 'Forvet (Sosyal Medya)',
      PhysicalWingBack: 'Fiziksel Kanat Bek',
      PhysicalForward: ' Fiziksel Forvet',
      PhysicalWinger: 'Fiziksel Kanat',
      PhysicalMidfielder: ' Fiziksel Orta Saha',
      PhysicalFullBack: ' Fiziksel Bek',
      PhysicalDefender: ' Fiziksel Defans',
      PhysicalWingBackLMO: ' Fiziksel Kanat Bek ',
      PhysicalForwardLMO: ' Fiziksel Forvet ',
      PhysicalWingerLMO: ' Fiziksel Kanat',
      PhysicalMidfielderLMO: ' Fiziksel Orta Saha',
      PhysicalFullBackLMO: ' Fiziksel Bek',
      PhysicalDefenderLMO: ' Fiziksel Defans'
    },
    radarDescription: {
      basicStatistics: {
        title: 'Basit İstatistikler',
        minutes: 'dakikalar',
        goals: 'goller		',
        assists: 'asistler',
        redCards: 'kırmızı kartlar',
        yellowCards: 'sarı kartlar',
        games: 'oyunlar',
        goalsReceived: 'penaltı olmadan atılan goller',
        xGFaced: 'xG yenilen'
      },
      profiles: {
        3: {
          1: ' Hem kısa hem de uzun paslarda topu ayağında tutan yetenekli kaleci.',
          2: 'Hem kısa hem de uzun pas yüzdeleriyle ayaklarla oynama ve oyunun başlangıcında önemli olma becerisi.',
          3: 'Pas ölçümleri nedeniyle bu profili ilgi çekici bir seçenek haline getiren iyi ayak hareketi.',
          4: 'İster kendi sahasında, ister rakip sahada yaptığı paslarla öne çıkan profil.',
          5: 'Topun ayağında olması ve yüksek pas becerileri sayesinde mükemmel güvenlik.',
          6: 'İyi ayak hareketi, topu fırlatırken güvenlik sağlıyor ve yüksek oranda kısa ve uzun pasları tamamlıyor.',
          7: 'Hem kısa hem de uzun pasların yüksek yüzdesi, dolaşımda kalite sağlıyor.'
        },
        5: {
          1: ' Bire birde iyi giden ve çok sayıda müdahale ve durdurma gerçekleştiren defans oyuncusu.',
          2: 'Bireysel düellolarda hem yukarıda hem de mücadelede çok etkili bir merkez savunma oyuncusu ve iyi bir okuma öngörülüyor.',
          3: 'Bireysel savunma düellolarında iyi performans gösteren merkezi savunma, bu da büyük miktarda iyileşme anlamına geliyor.',
          4: 'Savunma seviyesi yüksek, müdahaleler ve müdahaleler sayesinde büyük miktarda topu kurtarabilen profil.',
          5: 'Müdahalede çok etkili savunma ve çok sayıda müdahale ile bireysel çatışmalarda öne çıkıyor.',
          6: 'Maç başına yüksek sayıda toparlanma kapasitesine sahip stoper, rakibin oyununu okuma ve kesme becerisine sahip, müdahalelerde yüksek hassasiyet ve sıklığa sahip.',
          7: 'Müdahalelerin etkinliği ve sıklığı ve önceden tahmin edilebilecek iyi okumalar sayesinde yüksek miktarda iyileşme sağlayan defans profili.'
        },
        6: {
          1: ' Fırsat yaratmada büyük katkı veren oyunu iyi okuyan savunma.'
        },
        7: {
          1: ' Hücum ve defans oyunu arasında dengeli bir performansa sahip oyuncu (büyük katkı "xG güçlenme") (yüksek top kazanım sayısı).'
        },
        8: {
          1: ' Bire bir savunmada sağlam ve hem müdahele hem de araya girişlerde yüksek top kazanımı.'
        },
        9: {
          1: ' Tehlikeli pozisyonlar fırsatlar yaratan büyük hücum katkısı olan oyuncu.'
        },
        10: {
          1: ' Çok fazla alanı koruyabilen, top kapmalara katkıda bulunabilen ve takımın yarattığı toplamla ilgili olarak ilgili bir "xG güçlenme" yüzdesine sahip olan eksiksiz bir oyuncu.'
        },
        11: {
          1: ' Hücumda çok az etkisi olmasına rağmen, yüksek savunma performansına ve pas içinde büyük etkililiğe sahip orta saha oyuncusu.'
        },
        12: {
          1: ' Yüksek katkı sağlayan, şans yaratan iyi bir hava verimliliğine sahip ayrıca çok sayıda müdahale ve araya girişlerde bulunan eksiksiz orta saha oyuncusu, '
        },
        15: {
          1: ' Bire bir ve iyi seviyede tamamlanan ortalarda yetenekli, şutlardan daha fazla beklenen asist üreten kanat oyuncusu.'
        },
        16: {
          1: ' Dikine atılan top yüzdesi ve topla ilerlemesi yüksek olan, aynı zamanda şans yaratan ve ortada bir kanat oyuncusundan daha fazla etkiye sahip olan oyuncu.'
        },
        17: {
          1: ' İyi top sürme becerisine sahip oyuncu, hareketleri önemli paslardan daha fazla şut (xG) oluşturmak için içeriye girmeye çalışır (xA).'
        },
        18: {
          1: ' Top ayağında değilken harika bir iş çıkaran, oyunu ne zaman bir şutla bitireceğini veya ne zaman pas geçeceğini iyi bilen bir forvet.'
        },
        22: {
          1: ' Büyük bir hareket kabiliyeti ile topları almak, kanatlara iletmek ve tehlikeli fırsatlar yaratan forvet. Maç başına toplam dokunuş sayısına göre ceza sahası dışındaki dokunuşları daha yüksek yüzdeli.'
        }
      },
      description: 'Açıklama',
      conjuction: ' ve ',
      conjuction2: ' ve ',
      over: 'üst',
      under: 'alt',
      respectively: ', sırasıyla',
      Defending1: {
        1: ' Savunma performansı en iyi 5 ligin en kötüleri arasında '
      },
      Defending2: {
        1: 'Performansı ortalamanın altında olduğu için defansif olarak iyi bir rol sergilemiyor.'
      },
      Defending3: {
        1: 'Defansif olarak iyi bir rol sergiliyor, seviye ortalamanın biraz üzerinde.'
      },
      Defending4: {
        1: ' Ortalamanın üzerinde performansla savunma görevlerinde olağanüstü çalışma '
      },
      Defending5: {
        1: ' En iyi 5 ligin en iyi player_positions\'larına benzer bir performansla savunma görevlerinde olağanüstü '
      },
      Saving1: {
        1: ' Çok düşük performansa sahip, topu bloke etmekte çok zorluk çeken kaleci '
      },
      Saving2: {
        1: ' Seviyesi ortalamanın altında olduğu için kaleci olarak iyi bir performans göstermiyor '
      },
      Saving3: {
        1: ' Kabul edilebilir performansa sahip kaleci, en iyi 5 ligin ortalamasında, metric_name\'yi geliştirmek zorunda '
      },
      Saving4: {
        1: ' Özellikle metric_name\'de öne çıkan, en iyi 5 lig ortalamasının üzerinde iyi bir seviyeye sahip kaleci '
      },
      Saving5: {
        1: ' Kurtarıcı eksiksiz bir oyuncu, tüm ölçümleri onu Avrupa\'nın en iyi 5 liginin kalecileriyle karşılaştırarak rakipleri arasında ilk %20\'ye yerleştiriyor.'
      },
      Passing1: {
        1: ' Topla birlikte seviyesi en kötü oyuncular arasında '
      },
      Passing2: {
        1: ' Geçişler söz konusu olduğunda, performansları ortalamanın altında '
      },
      Passing3: {
        1: ' Pas seviyesi kabul edilebilir, ortalamanın biraz over_under_average üzerinde '
      },
      Passing4: {
        1: ' Çok iyi pas seviyesi, ortalamanın çok üzerinde '
      },
      Passing5: {
        1: ' Çoğu oyuncudan daha yüksek bir performansla efektif pas seviyesi '
      },
      Aerial1: {
        1: ' Hava toplarında çok zayıf bir oyuncu, bu açıdan pozisyonunun en kötüleri arasında '
      },
      Aerial2: {
        1: ' Hava toplarını kazanmaya gelince, oyuncu iyi performans göstermiyor, ortalamanın altında '
      },
      Aerial3: {
        1: ' Hava toplarında kabul edilebilir seviye, ortalamanın biraz over_under_average '
      },
      Aerial4: {
        1: ' Yukarıdakilere kıyasla oyunda mükemmel performans ve bu hususta yüksek efektiflik'
      },
      Aerial5: {
        1: ' Hava oyunundaki metrikleri onu en iyiler arasına yerleştiriyor '
      },
      Shooting1: {
        1: ' Kale önünde çok kötü istatistikler, bu konuda en kötü oyunculardan '
      },
      Shooting2: {
        1: ' Çok geliştirilebilir şut seviyesi, ortalamanın altında '
      },
      Shooting3: {
        1: ' Hücum görevlerinde kabul edilebilir performans, ortalamanın biraz over_under_average'
      },
      Shooting4: {
        1: ' Tüm oyuncuların %60\'ının üzerinde bir performansla ceza sahası içinde çok iyi bir performans sergiliyor '
      },
      Shooting5: {
        1: ' Olağanüstü bir performansla hücum görevlerinde harika yetenekler, onu bu konuda en iyiler arasına yerleştiriyor '
      },
      Association1: {
        1: ' Topla birlikte performansı çok düşük, en iyi 5 ligin en kötüleri arasında '
      },
      Association2: {
        1: 'Bu konuda ortalamanın altında kaldığı için top ayağındayken geliştirmesi gereken çok fazla konu var'
      },
      Association3: {
        1: 'Topla iyi ilişki kuruyor, ortalamanın biraz üstünde over_under_average '
      },
      Association4: {
        1: 'Topla olan iyi ilişkisi çok dikkat çekici bir seviyede '
      },
      Association5: {
        1: ' Top ayaktayken olağanüstü bir yaratıcılık, en iyi oyuncular arasında'
      },
      BallHandling1: {
        1: ' Korkunç top hakimiyeti performansı, en iyi 5 lige kıyasla en kötüler arasında '
      },
      BallHandling2: {
        1: ' Top hakimiyetine gelince, seviyesi ortalamanın altında '
      },
      BallHandling3: {
        1: ' Kabul edilebilir seviyede top hakimiyeti, ortalamanın biraz üzerinde over_under_average '
      },
      BallHandling4: {
        1: ' Top hakimiyeti açısından bu konudaki rakamlarda en iyiye yakın yüksek seviye '
      },
      BallHandling5: {
        1: ' En iyi 5 ligin en iyileri arasında olağanüstü top kullanma yeteneği '
      },
      Crosses1: {
        1: 'Topu ceza sahasına sokarken kötü performans. Geçiş ölçümlerinde en kötü oyuncular arasında'
      },
      Crosses2: {
        1: 'Ortalarıyla tehlike yaratma konusunda ortalamanın altında bir performans'
      },
      Crosses3: {
        1: 'Ceza sahasına orta gönderme konusunda kabul edilebilir, ancak gelişmekte olan bir seviye, ortalama civarında'
      },
      Crosses4: {
        1: 'Topu geçerken iyi istatistikler, ortalamanın çok üzerinde'
      },
      Crosses5: {
        1: 'Ceza sahasına orta yapan en iyi oyuncular arasında, özellikle de bu konuda en etkili profillerin ilk %20\'si arasında'
      },
      Carries1: {
        1: 'Top hakimiyeti açısından oyuncuların en kötü %20\'si arasında'
      },
      Carries2: {
        1: 'Topa sahip olma performansı onun pozisyonundaki oyuncular için ortalamanın çok uzağında'
      },
      Carries3: {
        1: 'Top hakimiyeti açısından ortalamaya yakın, ortalamanın biraz üzerinde bir performans'
      },
      Carries4: {
        1: 'Çok iyi derinlik ve top hakimiyetine sahip olağanüstü bir oyuncu'
      },
      Carries5: {
        1: 'Çok yetenekli bir top tutucu, top tutma kategorisindeki metriklerde yüksek bir performansa sahip'
      },
      Turnovers1: {
        1: 'Rakiplerin tehlike üretmesini kolaylaştıran yüksek top kayıpları ile performansı çok olumsuz. Bu metrikte en kötüler arasında'
      },
      Turnovers2: {
        1: 'Çok sayıda tehlikeli top kaybı rakiplere avantaj sağlıyor; bu kayıpları azaltmak için ciddi bir gelişim gerekiyor'
      },
      Turnovers3: {
        1: 'Bu oyuncu top kayıpları açısından ortalamanın biraz üzerinde, bu nedenle performansında hala iyileştirme için yer var'
      },
      Turnovers4: {
        1: 'Top kayıplarında, en az top kaybeden oyuncuların %60\'ının üzerinde kayda değer bir performans'
      },
      Turnovers5: {
        1: 'Takımının topa sahip olma konusunda en iyi oyuncuları arasında yer almasını sağlayan az sayıdaki top kaybına dikkat çekmek gerekir'
      },
      SequenceInvolvement1: {
        1: 'Topa sahip olma konusunda veriler olumlu değil; hareketler çok az kez bir şutla sonuçlanıyor'
      },
      SequenceInvolvement2: {
        1: 'Topa sahip olunan pozisyonların bitirilişi oldukça gelişime açık, pozisyonlar neredeyse hiç şutla sonuçlanmıyor ve bu durum performansı ortalamanın çok altında gösteriyor'
      },
      SequenceInvolvement3: {
        1: 'Kale önünde topa sahip olma konusunda kabul edilebilir bir seviyede, ortalamanın biraz üzerinde bir yüzdelik dilime sahip, dolayısıyla büyük bir gelişme olasılığı var'
      },
      SequenceInvolvement4: {
        1: 'Takımının sahip olduğu pozisyonları, bazıları golle sonuçlanan şutlarla tamamlama becerisi sayesinde bu kategoride kayda değer bir performans sergiledi'
      },
      SequenceInvolvement5: {
        1: 'Takımın sahip olduğu pozisyonları tehlike yaratan şutlarla tamamlama konusunda en öne çıkanlar arasında yer alıyor'
      },
      OutPlay1: {
        1: 'Oyuncunun savunma yapılarını bozma konusunda çok az etkisi olduğu görülüyor'
      },
      OutPlay2: {
        1: 'İlerleme ve savunma kırma konusundaki katkısı, pozisyon standartlarının altında'
      },
      OutPlay3: {
        1: 'Ara sıra avantaj yaratabilen, pozisyon ortalamasına yakın performans sergileyen bir oyuncu'
      },
      OutPlay4: {
        1: 'Savunma hatlarını sık sık kırar ve dengesizlikler oluşturur'
      },
      OutPlay5: {
        1: 'Pozisyonunda rakipleri saf dışı bırakma ve ilerleme yaratma konusunda en öne çıkanlar arasında'
      },
      LineBreakingPasses1: {
        1: 'Savunma hatlarını kıran pasları nadiren dener veya tamamlar, bu tür aksiyonlarda katkısı çok azdır'
      },
      LineBreakingPasses2: {
        1: 'Hatlar arasında veya baskı arkasında takım arkadaşlarını düzenli olarak bulmakta zorlanır, katkısı pozisyon standartlarının altında kalır'
      },
      LineBreakingPasses3: {
        1: 'Oyuncu ara sıra hat kırıcı paslar verir ve bu alanda pozisyon ortalamasına yakındır'
      },
      LineBreakingPasses4: {
        1: 'Oyuncunun pasla sık sık hatları kırdığı ve rakip blokların dengesini bozduğu görülüyor'
      },
      LineBreakingPasses5: {
        1: 'Ligde hat kırma ve baskıyı aşma konusunda en etkili pasörlerden biri; bu, başlıca güçlü yönlerinden biridir'
      },
      PassUnderPressure1: {
        1: 'Rakipler yaklaştığında sakinliği veya etkinliği korumakta zorlanıldığı görülüyor'
      },
      PassUnderPressure2: {
        1: 'Yoğun baskı altında pas isabetini korumakta zorlanan bir oyuncu'
      },
      PassUnderPressure3: {
        1: 'Baskı altındaki paslarda ortalama seviyede. Baskıyla fena başa çıkılmaz ancak her zaman temiz bir uygulama yapılamaz'
      },
      PassUnderPressure4: {
        1: 'Baskıya rağmen sık sık takım arkadaşlarını bulur, bu tür paslarda ortalamanın üstündedir'
      },
      PassUnderPressure5: {
        1: 'Yoğun baskı altında olağanüstü soğukkanlılık ve isabet gösterir; bu açıdan pozisyonunun en iyileri arasında yer alır'
      },
      BallReceived1: {
        1: 'İleri bölgede çok az pas alır; düzenli olarak hatlar arasında oynamaz'
      },
      BallReceived2: {
        1: 'Rakip yarı sahada markajsız birkaç top alır ancak istikrarlı değildir'
      },
      BallReceived3: {
        1: 'Hücum bölgelerinde orta seviyede markajsız top alır'
      },
      BallReceived4: {
        1: 'Sık sık hatlar arasında ve baskısız bölgelerde top alır'
      },
      BallReceived5: {
        1: 'Hatlar arasında çok sayıda top alır, savunmacılardan uzak ve kilit bölgelerde bulunur'
      },
      OnBallPressure1: {
        1: 'Nadiren pres yapar ve neredeyse hiç top taşıyan oyuncuya yaklaşmaz. Yoğunluğu düşüktür'
      },
      OnBallPressure2: {
        1: 'Bazen güçlü presler yapar ancak sık değildir. Genel yoğunluğu düşük seviyededir'
      },
      OnBallPressure3: {
        1: 'Topa sahip rakibe yakın bölgelerde orta düzeyde pres yapar'
      },
      OnBallPressure4: {
        1: 'Top taşıyana düzenli olarak yaklaşan disiplinli bir pres oyuncusu'
      },
      OnBallPressure5: {
        1: 'Topsuzken çok yoğun, oldukça disiplinli ve rakibe baskı yapmak için çok çalışır'
      },
      SpatialCoverage1: {
        1: 'Oyuncu, alan kaplama ve kontrolüne çok sınırlı katkı sağlar, takımın formasyonu ve taktik yapısına katılımı minimumdur. Hem topa sahipken hem de savunmada alan hakimiyeti zayıftır, kolektif organizasyona etkisi azdır'
      },
      SpatialCoverage2: {
        1: 'Oyuncunun alan hakimiyeti ortalamanın altındadır, sahayı kaplamada bazı katkılar gösterir ancak pozisyon sürekliliği ve takım uyumunda eksikler vardır. Taktik yapıya etkisi düzensizdir'
      },
      SpatialCoverage3: {
        1: 'Oyuncu ortalama düzeyde alan hakimiyeti gösterir, alan kaplama ve kontrolüne istikrarlı şekilde katkı sağlar. Pozisyonu genellikle doğru ve işlevseldir'
      },
      SpatialCoverage4: {
        1: 'Oyuncu ortalamanın üzerinde alan hakimiyeti sunar, saha kaplama ve pozisyon yapısına yüksek katılım gösterir. Formu koruma ve geçişlere uyum sağlama yeteneği, kompaktlık ve kilit alanların kontrolüne önemli ölçüde katkı sağlar'
      },
      SpatialCoverage5: {
        1: 'Oyuncu mükemmel düzeyde alan hakimiyetine ulaşır, pozisyonunu optimize ederek takımın formasyonuna ve taktik yapısına belirleyici etki yapar'
      },
      OffBallPressure1: {
        1: 'Oyuncu topsuzken çok sınırlı savunma baskısı uygular, rakiplerin hareketlerini bozmaz veya hata yapmaya zorlamaz. Baskı ve savunma yapısına katkısı minimumdur'
      },
      OffBallPressure2: {
        1: 'Oyuncu topsuzken ortalamanın altında savunma baskısı uygular, bazen rakibe yaklaşır ancak zamanlama ve pozisyonlama tutarsızdır'
      },
      OffBallPressure3: {
        1: 'Oyuncu topsuzken ortalama düzeyde baskı uygular, pozisyonlama ve zamanlaması genellikle etkilidir'
      },
      OffBallPressure4: {
        1: 'Oyuncu topsuzken ortalamanın üzerinde savunma baskısı uygular, rakiplerin hareketlerini sık sık bozar ve zaman ile alanlarını daraltır'
      },
      OffBallPressure5: {
        1: 'Oyuncu topsuzken savunma baskısında üst düzeydedir, rakipleri sürekli rahatsız eder, pas kanallarını kapatır ve top kayıplarına zorlar'
      },
      Distance1: {
        1: 'Ortalamanın çok altında mesafe katedilir (sahadaki hareketlilik çok sınırlıdır)'
      },
      Distance2: {
        1: 'Maç başına kat ettiği mesafe üst düzey futbolda yaygın olandan daha azdır (ortalamanın altında aktiftir)'
      },
      Distance3: {
        1: 'Lig ortalamasına yakın makul miktarda mesafe kateder (fiziksel katkısı dengelidir)'
      },
      Distance4: {
        1: 'Sürekli olarak yüksek mesafeler kateder, bu da güçlü dayanıklılık gösterir'
      },
      Distance5: {
        1: 'Fiziksel hacmi olağanüstüdür. En çok mesafe kateden oyuncular arasında yer alır'
      },
      Sprint1: {
        1: 'Ortalamanın aksine çok az yüksek hızlı koşu yapar (maç boyunca sprint yükü minimumdur)'
      },
      Sprint2: {
        1: 'Pozisyonuna göre sprint sıklığı ortalamanın altındadır (yüksek hızlı hareketlerde patlayıcılık sınırlıdır)'
      },
      Sprint3: {
        1: 'Maç başına ortalama düzeyde sprint yapar (lig ortalamasına yakındır)'
      },
      Sprint4: {
        1: 'Sprint sıklığıyla öne çıkar, ortalamanın oldukça üzerindedir. Maç boyunca patlayıcı koşular yapar'
      },
      Sprint5: {
        1: '90 dakikada en yüksek sprint hacmine sahip ilk %20 oyuncu arasındadır'
      },
      Acceleration1: {
        1: 'Hız değiştirme yeteneği belirgin şekilde ortalamanın altındadır, maçta çok az patlayıcı hızlanma yapar'
      },
      Acceleration2: {
        1: 'Benzer oyunculara göre hızlanma sayısı ortalamanın altındadır çünkü kısa mesafe patlamaları sınırlıdır'
      },
      Acceleration3: {
        1: 'Lig ortalamasına yakın makul sayıda hızlanma yapar. Hız değişimleri göze çarpmaz ancak istatistikleri doğrudur'
      },
      Acceleration4: {
        1: 'Hızlı ve tekrarlayan hızlanma yeteneği güçlüdür, hızlanma oranı ortalamanın oldukça üzerindedir'
      },
      Acceleration5: {
        1: 'Tekrarlayan hızlanmalarda en patlayıcı %20 oyuncu arasındadır, ortalamanın çok üzerinde sayılar kaydeder'
      },
      Speed1: {
        1: 'Fiziksel olarak yavaş ya da maçlarda yüksek yoğunluklu eforlarını sakınan bir oyuncu olabilir'
      },
      Speed2: {
        1: 'En yüksek hız değerleri rekabetçi ortalamanın biraz altındadır'
      },
      Speed3: {
        1: 'Maç boyunca ortalama en yüksek hız değerlerini korur'
      },
      Speed4: {
        1: 'Sık sık yüksek hızlara ulaşır, bu da hızlı ve güçlü olduğunu gösterir'
      },
      Speed5: {
        1: 'Çok yüksek en yüksek hızlara ulaşır. Hız açısından fark yaratabilir'
      },
      LineBreakingCarries1: {
        1: 'Top sürerek nadiren hat kırar. Topla ilerleme konusunda girişkenliği eksiktir'
      },
      LineBreakingCarries2: {
        1: 'Bazen hat kıran top sürmeler yapar ancak sık değildir'
      },
      LineBreakingCarries3: {
        1: 'Orta düzeyde başarılı hat kırma top sürmeleri yapar'
      },
      LineBreakingCarries4: {
        1: 'Sık sık top sürerek hatları aşar ve ilerlemeyi destekler'
      },
      LineBreakingCarries5: {
        1: 'Gerçek bir top sürme uzmanıdır, sürekli ve yüksek hacimde hat kırar'
      },
      LineBreakingActions1: {
        1: 'Hat kıran aksiyonları (pas ve top sürme) çok azdır, nadiren risk alır'
      },
      LineBreakingActions2: {
        1: 'Bazen ilerleyici aksiyonlar (pas ve top sürme) üretir ama nadiren, genelde yatay oynar'
      },
      LineBreakingActions3: {
        1: 'Düzenli olarak hat kıran paslar ve top sürmeler yapar, ilerlemeye katkı sağlar'
      },
      LineBreakingActions4: {
        1: 'Teknik ve zekasıyla rakip hatlarını kıran çok sayıda aksiyon üretir'
      },
      LineBreakingActions5: {
        1: 'Gerçek bir ilerleme uzmanıdır, pas ve top sürme ile sürekli hat kırar'
      },
      OffBallRuns1: {
        1: 'Oyuncu topsuzken çok az amaçlı hareket yapar, hücumda sınırlı destek sağlar'
      },
      OffBallRuns2: {
        1: 'Oyuncu ortalamanın altında topsuz hareketlilik gösterir, ara sıra hücumu destekler ama zamanlama ve niyet açısından istikrarsızdır'
      },
      OffBallRuns3: {
        1: 'Oyuncu ortalama düzeyde amaçlı topsuz koşu yapar, uygun zamanlama ile alan yaratır'
      },
      OffBallRuns4: {
        1: 'Oyuncu ortalamanın üzerinde topsuz hareketlilik gösterir, savunma yapısını bozan ve pas opsiyonları yaratan koşular yapar'
      },
      OffBallRuns5: {
        1: 'Oyuncu topsuz hareketlilikte üst düzeydedir, oyunu öngörür ve hücum fırsatlarını maksimize eden akıllı koşular yapar'
      },
      OverMaxValue: {
        1: 'Over_max_metric_name\'de maksimum değerin üzerinde bir performansla olağanüstü bir yeteneğe sahip, bu açıdan bu oyuncuyu en iyi 5 ligin ilk %10\'una sokuyor'
      },
      OverAverageSeason: {
        1: ' over_average_metric_name\'deki performansı ile ilgili olarak lig ortalamasının üzerinde league_name (over_average_metric_value vs average_metric_value)',
        2: ' Rakamlarını league_name ligindekilerle karşılaştırırsanız over_average_metric_name\'de performansının ortalamanın üzerinde olduğunu söyleyebilirsiniz. (over_average_metric_value vs average_metric_value)'
      },
      UnderMinValue: {
        1: ' under_min_metric_name\'ye gelince, en iyi 5 Ligin en düşük percent_metric_name\'sine yerleştirdiği için performansını büyük ölçüde artırmalıdır. '
      },
      Over70Percent: {
        1: ', özellikle over_70_metric_name\'de, sırasıyla 90 dakikada over_70_metric_value ile öne çıkıyor',
        2: ', sırasıyla 90 dakikada over_70_metric_value ile over_70_metric_name içinde %70\'in üzerinde',
        3: ', özellikle over_70_metric_name\'de, sırasıyla 90 dakikada over_70_metric_value ile öne çıkıyor '
      },
      Under30Percent: {
        1: ', under_30_metric_name\'de daha fazla çalışmak zorunda çünkü sırasıyla 90 dakika başına under_30_metric_value ile performansı düşük',
        2: ', under_30_metric_name\'de, sırasıyla 90 dakikada under_30_metric_value ile performansı beklenenin altında olduğu için dikkate değer bir şekilde gelişmek zorunda',
        3: ', sırasıyla 90 dakikada under_30_metric_value ile under_30_metric_name için, daha iyi sayılar elde etmek için daha çok denemesi gerekiyor'
      },
      OverAverageSeasonMoreThanOne: {
        1: ' league_name deki lig ortalamasını aşan performanslarını vurgulamak güzel. '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value on average)'
      },
      Over70PercentIndividualPressure: {
        1: 'topu geri almak için çok iyi bir bireysel baskı yapıyor',
        2: ', topu geri almak için rakibe yüksek baskı'
      },
      Under30PercentIndividualPressure: {
        1: 'Topu kazanmak için baskısını daha da arttırmak zorunda kaldı',
        2: 'Rakibi baskı altına alma konusunda daha fazla çaba sarf etmek zorunda kalmak söz konusu'
      }
    },
    himSelf: 'kendi',
    ownSeason: 'Kendi Sezonu',
    minMaxTooltip: ' Radarın minimum ve maksimum değerlerine uygun ',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Giriş',
    latestBlogPosts: 'Son Blog Postu',
    signIn: 'Giriş Yap',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    passwordForgotten: 'Şifremi Unuttum',
    signUp: 'Üye Ol',
    enter: 'Giriş',
    forceTitle: 'Kullanımda bir hesap',
    forceMessage: ' Hesap başka bir cihaza bağlı. Onu çıkarıp bu cihaza bağlamak ister misin?',
    forgotMyPassword: 'Şifremi unuttum',
    firstLogin: 'İlk Giriş',
    firstLoginMessage: ' Güvenlik nedeniyle ilk girişinizde yeni bir şifre belirlemeniz gerekmektedir. Uygulamayı görüntülemek için tercih edilen dile ek olarak ',
    firstLoginOverview: 'İşte hesabınıza, liglere ve erişebileceğiniz ürünlere genel bir bakış.',
    passwordConfirmation: 'Şifre Onaylaması',
    forgotPasswordMessage: ' E-postanızı yazın, e-postayla ilişkili geçerli bir hesap varsa, gelen kutunuzda parolanızı sıfırlamak için sonraki adımlar gösterilir. ',
    resetPassword: 'Şifre Sıfırlama',
    resetPasswordLinkInvalid: 'Bu bağlantı geçersiz veya süresi dolmuş. Giriş sayfasından yeni bir şifre sıfırlama talep edin.',
    skipSettings: 'Ayarları atla',
    contact: 'İletişim',
    cookiesText: 'Bu site, hizmetlerini sağlamak ve trafiğinizi analiz etmek için Google çerezlerini kullanır. Hizmet kalitesini sağlamak, kullanım istatistikleri oluşturmak ve suistimalleri tespit edip ele almak için.',
    contactUs: 'Bize Ulaşın',
    newsTitle: 'Yeni: Fiziksel Skorlar!',
    newsText: 'Orijinal olay verisi Skorumuzun yanına iki yeni fiziksel performans Skoru ekledik: <b>Dayanıklılık Skoru</b> ve <b>Hız & Güç Skoru</b>.<br> Dayanıklılık, sahayı istikrarlı şekilde kat eden ve yüksek iş yükünü sürdüren oyuncuları öne çıkarırken, Hız & Güç maksimum hız, sprintler ve patlayıcı hızlanmalara odaklanır.'
  },
  settings: {
    pageSubtitle: 'Uygulamadaki deneyiminizi yapılandırın',
    language: 'Dil',
    availableLeagues: 'Mevcut Ligler',
    availableSeasons: 'Mevcut Sezonlar',
    availableProducts: 'Mevcut Ürünler',
    organization: 'Şirket',
    changePassword: 'Şifremi Değiştir',
    seasonTemplates: 'Sezon şablonları',
    seasonTemplatesSubtitle: ' Daha sonra Oyuncu Sıralaması ve Oyuncu İzlemesinde seçilebilecek kendi sezon şablonlarınızı oluşturun ',
    templateName: 'Şablon İsmi',
    selectTemplate: 'Düzenlemek için şablon seçin',
    radarDefault: 'Varsayılan Radar',
    default: 'Varsayılan',
    tabs: {
      options: 'Ayarlar',
      templates: 'Şablonlar',
      availableLeagues: 'Mevcut Ligler',
      contactData: 'GBE İletişim Verileri'
    },
    contactData: {
      userDetails: 'Kullanıcı bilgileri',
      firstName: 'İsim',
      lastName: 'Soyad',
      contactDetails: ' GBE İletişim Verileri ',
      name: 'İsim',
      phone: 'Sabit Numara',
      mobile: 'Cep numarası',
      email: 'E-mail',
      representativeDetails: ' GBE için temsilci detayları'
    },
    currency: 'Döviz Kuru',
    fieldPreferences: ' Alan Tercihleri ',
    visualizationsPreferences: ' Görselleştirme Tercihleri ',
    fieldColor: 'Alan rengi',
    fieldColors: {
      green: 'Yeşil',
      blue: 'Mavi',
      white: 'Beyaz',
      black: 'Siyah',
      grey: 'Grey'
    },
    defaultPlayerVisualization: ' Varsayılan Oyuncu Görselleştirme ',
    appPreferences: 'Uygulama Seçenekleri',
    darkMode: 'Karanlık Mod',
    showTour: 'Rehberli Turu Atla',
    customStats: ' Özel İstatistikler ',
    radarTemplates: 'Radar Şablonları',
    radarTemplatesSubtitle: ' Oyuncu Performansı ve Oyuncu Sıralamasında daha sonra seçilebilecek kendi metrik şablonlarınızı oluşturun ',
    radarCategories: {
      Custom1: 'Özel 1',
      Custom2: 'Özel 2',
      Custom3: 'Özel 3',
      Custom4: 'Özel 4',
      Custom5: 'Özel 5',
      Custom6: 'Özel 6',
      Physical: 'Fiziksel',
      CustomPhysical1: 'Özel Fiziksel 1',
      CustomPhysical2: 'Özel Fiziksel 2',
      CustomPhysical3: 'Özel Fiziksel 3',
      CustomPhysical4: 'Özel Fiziksel 4',
      CustomPhysical5: 'Özel Fiziksel 5',
      CustomPhysical6: 'Özel Fiziksel 6'
    },
    templateRemoveTitle: 'Şablon Kaldır',
    templateRemoveMsg: ' Şablon Kaldırmak istiyor musun?',
    templateEditTitle: 'Şablonu Kaydet',
    templateEditMsg: 'Kaydedilmemiş bir şablon var, düzenlemek için başka bir şablon yüklemeden önce kaydetmek istiyor musunuz?',
    category: 'Kategori',
    playerRadar: 'Oyuncu Radarı',
    teamRadar: 'Takım Radarı',
    statsAlert: ' Kaydetmek için en az bir istatistik ekleyin ',
    recommended: 'Tavsiye edilir',
    warning: 'İzin verilen maksimum radar sayısına ulaşan pozisyonlar var. Lütfen tüm şablonları silin veya düzenleyin',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'İspanyolca',
      numeric: 'Sayısal'
    },
    showMediaMode: 'Medya Modunu Göster',
    statTemplates: 'Oyun İstatistikleri Şablonları',
    statTemplatesSubtitle: 'Çok sayıda metrik arasından seçim yaparak kendi şablonlarınızı oluşturun',
    ratingFormat: {
      ratingFormat: 'Derecelendirme Formatı',
      numbers: 'Sayılar',
      letters: 'A\'dan F\'ye harfler'
    }
  },
  playerDetail: {
    passport: 'Pasaport',
    secondPassport: 'İkinci Pasaport',
    age: 'Yaş',
    dateOfBirth: 'Doğum Tarihi',
    height: 'Boy',
    weight: 'Kilo',
    wage: 'Maaş',
    history: 'Tarih',
    positions: 'Pozisyonlar',
    injuries: 'Sakatlıklar',
    transfers: 'Transferler',
    nationalTeam: 'Milli Takım',
    addFavorite: 'Favorilere Ekle',
    removeFavorite: 'Favorilerden Çıkar',
    contractEnd: 'Sözleşme sonu',
    yearsOld: ' yaşında',
    playerAvailability: 'Uygunluk',
    playerUsage: 'Oynanan Dakikalar',
    usage: 'Kullanım',
    addToCollection: 'Koleksiyona Ekle',
    performance: 'Performans',
    info: 'Bilgi',
    career: 'Kariyer',
    playerStyle: 'Oyuncu Stili',
    radar: 'Radar',
    finishingMap: 'Bitiricilik Haritası',
    threatMap: 'Tehdit Haritası',
    keyPassMap: 'Kilit Pas Haritası',
    beeswarm: 'Sıralama',
    allGames: 'Bütün Oyunlar',
    eventsMap: 'Olay Haritası',
    lbpMap: 'Hat Kırma Geçişleri',
    obpMap: 'Bilya Basıncında',
    pupMap: 'Baskı Altında Geçer',
    obrMap: 'Top Makbuzları',
    fullName: 'Tam İsim',
    academy: 'Akademi',
    name: 'İsim',
    lastName: 'Soyad',
    playerAvailabilityLong: 'Sakatlık veya cezalı olmayan sezonun % ',
    playerUsageLong: 'Oynanan dakika',
    playerAvailability1: ' sakatlık veya cezalı olmayan maçlar ',
    playerAvailability2: 'bu seneki maçlar',
    playerUsage1: 'oynanan dakikalar',
    playerUsage2: 'toplam takım dakikası',
    notMinutesThisSeason: 'Bu sezon dakika oynamadı',
    seasonPlaceholder: ' Aktif sezon yok ',
    inactivePlayer: 'Aktif olmayan oyuncu',
    inactivePlayerMessage: ' Daha fazla bilgiye ihtiyacınız varsa, bir rapor isteyebilirsiniz. ',
    goRequest: ' İsteğe Git ',
    warningMinutes: ' Dikkat: 450 dakikadan az oynandı, analiz gerçeği yansıtmayabilir ',
    scoreWarningMinutes: 'Toplamda en az 450 dakika oynamış oyuncular',
    pdScoreWarningMinutes: 'Toplamda en az 450 dakika oynamış oyuncular (maç başına en az 60 dakika)',
    warningSeasonGames: ' Sezonda 5\'ten az maç oynandı, bu nedenle Min ve Maks \'En İyi 5 Lig\'',
    warningStatsRemoved: 'Bazı istatistikler gösterilmiyor çünkü seçilen sezon için mevcut değil',
    warningBeeswarm: 'Oyuncu gösterilmiyor çünkü seçilen sezon için veri bulunmamaktadır',
    warningPlayersZeroValue: '0 olan {x} oyuncu gösterilmiyor ',
    onlyPlayersThatFit: ' Yalnızca Radar Şablonuna uyan Oyuncular ',
    gamesPlayedNotEnough: 'Yeterli maç oynanmadığı için seçenekler devre dışı bırakıldı',
    gbe: 'GBE',
    analysis: 'Analiz',
    documents: 'Belgeler',
    rankDefensive: 'Defansif',
    rankBallHandling: 'Top kontrolü',
    rankGoal: 'Gol Katkısı',
    rankXt: 'Tehdit',
    rankIndex: 'Index',
    visitHistory: 'Geçmiş',
    placer: 'Saha',
    touchesMap: 'Müdahele Haritası',
    heatMap: 'Isı Haritası',
    ageProfile: 'Yaş Profili',
    strongFoot: 'Güçlü Ayak',
    player: 'Player',
    outOf: 'out of',
    in: 'in',
    radius: 'Yarıçap',
    blur: 'Bulanıklık',
    careerTable: {
      nationalTeamCareer: 'Milli Takım Kariyeri',
      nationalTeamCompetitions: 'Milli Takım Yarışmaları'
    },
    physicalProgression: 'Physical Progression',
    gpi: 'Küresel Oyuncu Endeksi',
    warningGPI: 'Yalnızca son 30 gün içinde ELO liglerinde aktif olan oyuncular için geçerlidir',
    diffGPI: 'Son maçtan itibaren değişim',
    rankingInTheWorld: 'Dünyada #{0}',
    rankingInTheLeague: '{1} içinde #{0}',
    max: 'Maks',
    gpiChart: 'Son {0} maçın Global Oyuncu Endeksi değerine dayalı grafik',
    percentileRange: 'Yüzdelikler {0} ile {1} arası',
    months: 'aylar',
    month: 'ay',
    contractExpOver4Years: 'Sözleşmenin sona ermesi',
    contractExpSoon: 'Sözleşme yakında sona erecek',
    contractFinalYear: 'Sözleşmenin son yılı',
    freeAgent: 'Serbest temsilci',
    gpiDescription: 'Küresel Oyuncu Endeksi (GPI), futbolcuları takım güçleri, rakip güçleri, maç performansları ve uygunluklarına göre değerlendiren standartlaştırılmış bir oyuncu derecelendirme sistemidir. Elo derecelendirme sisteminden ilham alan bu sistem, oyuncu derecelendirmelerinin keyfi temeller yerine gerçek rekabetçi ortamları yansıtmasını sağlar.',
    turnoversMap: 'Ciro ve Geri Kazanım Haritası',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Başarılı Dokunuşlar',
    unsuccessfulTouch: 'Başarısız Dokunuşlar',
    showLegend: 'Açıklamayı Göster'
  },
  finishingMap: {
    typesOfShot: 'Şut tipleri',
    shotStrategy: ' Şut Stratejisi',
    strategiesCount: '{count} stratejiler',
    areas: 'Alanlar',
    bodyPart: 'Vücut bölgeleri',
    more: 'daha fazla',
    selectAll: 'Hepsini seç',
    minutes: 'Dakikalar',
    circles: 'Ortalar',
    boxes: 'Ceza sahası Isı Haritası',
    lines: 'çizgiler',
    games: 'Maçlar',
    perShot: 'Şut başına',
    goal: 'Gol',
    missedShot: 'Kaçan Şut',
    savedShot: 'Kurtarılan Şut',
    shotOnPost: 'Direğe çarpan şut',
    missedChance: 'Kaçan fırsat',
    openPlay: 'Açık Oyun',
    regularPlay: 'Standart Oyun',
    fastBreak: 'Kontra Atak',
    individualPlay: 'Bireysel Oyun',
    setPiece: ' Duran Top ',
    fromCorner: 'Kornerden',
    freeKick: 'Free Kick',
    indirectFreeKick: 'Endirek Free Kick',
    throwInSetPiece: ' Duran Toptan Oyun Kurma',
    inBox: 'Ceza Sahası İçinde',
    goalArea: 'Altı Pas içinde',
    boxLeft: 'Ceza Sahasının Solu',
    boxCenter: 'Ceza Sahasının Ortası',
    boxRight: 'Ceza Sahasının Sağı',
    outOfBox: 'Ceza Sahasının Dışından',
    outBoxDeepLeft: 'Ceza Sahasının Dışından sol dipten',
    outBoxDeepRight: 'Ceza Sahasının Dışından sağ dipten',
    outBoxLeft: 'Ceza Sahasının Solundan',
    outBoxCentreLeft: 'Ceza Sahasının Orta Solundan',
    outBoxCentre: 'Ceza Sahası Dışı Ortadan',
    outBoxCentreRight: 'Ceza Sahası Dışı Sağ Ortadan',
    outBoxRight: 'Ceza Sahası Dışının Sağından',
    left35: '+35 Sol',
    centreLeft35: '+35 Sol Orta',
    centre35: '+35 Orta',
    centreRight35: '+35 Sağ Orta',
    right35: '+35 Sağ',
    head: 'Kafa',
    rightFooted: 'Sağ Ayaklı',
    leftFooted: 'Sol Ayaklı',
    otherBodyPart: 'Vücudun Diğer Bölümü',
    chart: {
      shots: 'Şutlar',
      xGPerShot: 'xG şut başına',
      exceptionTextPenaltyGoals: '* Penaltı Atışlar= 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Penaltı Atışlar= 0.765 xGOT',
      exceptionTextOwnGoals: '* Kendi kalesine gol dikkate alınmadı',
      og: 'OG',
      penaltiesExcluded: 'Penaltı golleri çıkarılmıştır',
      ownGoalsExcluded: 'Kendi Kalesine Atılan Goller Hariç',
      sumOfxG: ' xG toplamı',
      exceptionShotsOutOfRange: '* Menzil dışındaki şutlar gösterilmiyor'
    },
    inGoal: 'Kale çizgisinde',
    outOfGoal: 'Kale çizgisi dışında',
    highLeft: 'Sol Yukarı',
    highCenter: 'Orta Yukarı ',
    highRight: 'Sağ Yukarı ',
    lowLeft: 'Sol Alt',
    lowCenter: 'Orta Alt',
    lowRight: 'Sağ Alt',
    outHighLeft: 'Sol Dışarıdan Yukarı',
    high: 'Orta Dışarıdan Yukarı',
    outHighRight: ' Sağ Dışarıdan Yukarı ',
    closeHighLeft: 'Yakın Sol Yukarı',
    closeHigh: 'Yakın Orta Yukarı',
    closeHighRight: ' Yakın Sağ Yukarı ',
    closeLeft: 'Yakın Sol Alt',
    closeRight: 'Yakın Sağ Alt',
    finishingTable: ' Bitirme Sıralaması ',
    onGoal: 'Kaleyi Bulan',
    distributionFilters: 'Dağıtım Filtreleri',
    penalty: 'Penaltı',
    penaltyShootout: 'Penaltı Atışları',
    onlyPercentage: 'Yüzdeyi göster',
    showAll: 'Hepsini göster',
    chanceMissed: 'Şans Kaçırıldı'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Kilit Paslar',
      xAPerPass: 'xA Pas Başına',
      xAOpenPlay: 'xA Açık Oyun',
      xASetPiece: 'xA Duran Top '
    }
  },
  beeswarm: {
    template: 'Şablon',
    templates: {
      Goalkeeper: 'Kaleci',
      Defender: 'Defans',
      'Full-Back': 'Bek',
      FullBack: 'Bek',
      'Wing-Back': 'Kanat-Bek',
      WingBack: 'Kanat-Geri',
      Midfielder: 'Orta Saha',
      AttackingMidfielder: 'Ofansif Orta saha',
      Winger: 'Kanat',
      Forward: 'Forvet',
      Physical: 'Fiziksel'
    },
    compareWith: 'ile karşılaştır',
    highlightPlayersOf: 'Oyuncuları Vurgulayın',
    highlightPlayers: 'Öne çıkan oyuncular',
    per90: '90 dakika başına veri',
    highlightTeams: 'Takımları Vurgula',
    filterTeams: 'Takımları Filtrele',
    warningZeros: 'Yalnızca ters olmayan istatistikler için'
  },
  collections: {
    newCollection: 'Yeni Koleksiyon',
    editCollection: 'Koleksiyonu düzenle',
    name: 'İsim',
    visibility: 'Görünürlük',
    privacity: {
      publicTitle: 'Kamu',
      publicDescription: ' Siz ve kulübünüz için görünür ',
      privateTitle: 'Özel',
      privateDescription: ' Sadece sizin için görünür ',
      supervisedTitle: 'Gözetimli',
      supervisedDescription: 'Yalnızca siz ve amiriniz tarafından görülebilir'
    },
    addSuccess: 'Başarıyla eklendi',
    createAddSuccess: ' Başarıyla oluşturuldu ve eklendi ',
    editSuccess: ' Başarıyla güncellendi ',
    deleteSuccess: 'Başarıyla silindi',
    title: 'Oyuncuların koleksiyonları',
    publics: 'Kamuya açıklar',
    privates: 'Özeller',
    supervised: 'Gözetimli',
    totalMarketValue: ' Toplam piyasa değeri ',
    avgMarketValue: ' Ortalama piyasa değeri ',
    avgAge: 'Ortalama Yaş',
    searchBarPlaceholder: ' Koleksiyona eklemek için oyuncuları arayın ve seçin ',
    deleteCollection: 'Koleksiyonu sil',
    deleteCollectionMessage: 'Koleksiyonu silmek istediğine emin misin?',
    removePlayer: 'Oyuncuyu çıkar',
    removePlayerMessage: 'Oyuncuyu koleksiyondan çıkarmak istediğinine emin misin?',
    subtitle: 'Oyuncu İzlemeni düzenle',
    notExitingTemplate: 'Hala şablon yok'
  },
  searchbar: {
    placeholder: 'Aramak için şu şekilde yazın (ör. "david arsenal")',
    players: 'Oyuncular',
    teams: 'Takımlar',
    games: 'Maçlar',
    leagues: 'Ligler',
    explore: 'Daha fazla Sonuç Göster',
    placeholderNoResults: 'Şablon için her hangi bir sonuç yok',
    teamPlaceholder: ' Bir takımı karşılaştırmak için arayın ve seçin '
  },
  favorites: {
    showOnly: 'Sadece göster',
    selfFavorites: 'Favorilerim',
    clubFavorites: 'Favori kulüpler',
    contractExpiration: 'Sözleşme Sonu',
    groupBy: 'Gruplandır',
    noGrouped: 'Hiç biri',
    maxSelection: ' Sadece seçebilir ',
    selectAtleastOne: ' En azından birini seçin ',
    comparePlayers: 'Oyuncu karşılaştır',
    selectedPlayers: 'seçilen oyuncular',
    subtitle: 'Favorilerinizi yönetin',
    generateXlsx: ' XLSX yarat',
    generating: 'Yaratılıyor...',
    subscribed: 'Subscribed',
    subscribedTooltip: 'Subscribe to recieve a mail when a game have been played',
    deleteSelected: 'Seçileni sil'
  },
  expiration: {
    summer: 'Yaz',
    winter: 'Kış'
  },
  positions: {
    noposition: 'Pozisyon Yok',
    goalkeeper: 'Kaleci',
    goalkeepers: 'Kaleciler',
    defender: 'Savunma',
    defenders: ' Savunmacılar',
    defenses: 'Savunmlalar',
    fullback: 'Bek Oyuncu',
    fullbacks: ' Bek Oyuncular',
    midfielder: 'Orta Saha',
    midfielders: ' Orta Sahalar',
    winger: 'Kanat',
    wingers: ' Kanatlar',
    forward: 'Forvet',
    forwards: 'Forvetler ',
    wingback: 'Kanat Bek',
    wingbacks: 'Kanat Bekler'
  },
  dPos: {
    1: {
      name: 'Goalkeeper',
      alias: ''
    },
    2: {
      name: 'Right Full Back',
      alias: 'RFB'
    },
    3: {
      name: 'Right Center Back',
      alias: 'RCB'
    },
    4: {
      name: 'Left Center Back',
      alias: 'LCB'
    },
    5: {
      name: 'Left Full Back',
      alias: 'LFB'
    },
    6: {
      name: 'Defensive Midfielder',
      alias: 'DM'
    },
    7: {
      name: 'Right Winger',
      alias: 'RW'
    },
    8: {
      name: 'Center Midfielder',
      alias: 'CM'
    },
    9: {
      name: 'Striker',
      alias: 'ST'
    },
    10: {
      name: 'Attacking Midfielder',
      alias: 'AM'
    },
    11: {
      name: 'Left Winger',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: ' İle karşılaştır ',
    lastSeasonSelectText: 'Son Sezon',
    lastAndCurrentSeasonSelectText: 'Son+ Mevcut Sezon',
    currentSeasonSelectText: ' Mevcut Sezon ',
    lastNgamesSelectText: 'Son {x} Maç',
    npgVsXGTitle: 'Penaltısız Goller VS xG',
    totalXGLabel: 'Toplam xG',
    xGLabel: 'xG',
    totalNPGLabel: ' Toplam Penaltısız Goller ',
    xGAgainstvsNPGAgainstTitle: 'xG aleyhine VS aleyhine Penaltısız Goller ',
    totalXGAgainstLabel: 'toplam xG aleyhine ',
    xGAgainstLabel: 'xG aleyhine ',
    totalNPGAgainstLabel: ' Aleyhine Toplam Penaltısız Goller ',
    xGvsxGAgainstTitle: 'xG VS xG aleyhine ',
    pointsVsXPointsTitle: 'Puanlar VS Beklenen Puanlar',
    xTTitle: ' Oyun akışı ',
    totalXPoints: 'Toplam xPoints',
    totalPoints: 'Toplam Puanlar',
    requestedReports: 'Talep edilen raporlar',
    playersScouted: 'İzlenen Oyuncular',
    performanceVSAverageChart: 'Performans VS Ortalama',
    perPositions: 'Pozisyon Başına',
    perLeagues: 'Lig Başına ',
    perMonths: 'Aylar Başına ',
    perClients: 'Müşteri Başına ',
    ofPreposition: 'nin',
    idJChartTitle: 'Oyun insiyatifi',
    idJChartLabel: 'Index GI',
    vJOChartTitle: 'Offensive Game Volume',
    vJOChartLabel: 'Index OGV',
    preJOChartTitle: ' Ofansif Oyun Hassasiyeti ',
    preJOChartLabel: 'Index OGPre',
    proJOChartTitle: ' Ofansif Oyun İlerlemesi ',
    proJOChartLabel: 'Index OGPro',
    chart: 'Grafik',
    table: 'Tablo',
    showLeaguesWithAtLeast: 'En az',
    playersScoutedSuffix: 'izlenen oyuncular'
  },
  table: {
    history: {
      season: 'Sezon',
      team: 'Takım',
      position: 'Pozisyon',
      side: 'Taraf',
      games: 'Maçlar',
      minutes: 'Dakikalar',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Kaçırılan Maçlar',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Sezon',
      team: 'Takım',
      injury: 'Sakatlık',
      dateFrom: 'Başlangıç Tarihi',
      dateTo: 'Bitiş Tarihi',
      daysLost: 'Kaybedilen Günler',
      gamesLost: 'Kaybedilen Maçlar',
      allInjuries: 'Tüm Sakatlıklar'
    },
    transfers: {
      season: 'Sezon',
      date: 'Tarih',
      teamFrom: 'Takımdan',
      teamTo: 'Takıma',
      marketValue: 'Piyasa Değeri',
      fee: 'Bedel',
      type: 'Tip'
    },
    caps: {
      team: 'Takım',
      debut: 'Başlangıç',
      games: 'Maçlar',
      goals: 'Goller',
      coachDuringDebut: 'Başlangıç zamanı Antrenör',
      debutAge: 'Başlangıç Yaşı'
    },
    roster: {
      country: 'Ülke',
      player: 'Oyuncu',
      positions: 'Pozisyon',
      minutes: 'Dakikalar',
      games: 'Maçlar',
      goals: 'Goller',
      assists: 'Asistler',
      cards: 'Kartlar',
      gamesExplicit: 'Oynanan Maçlar'
    },
    league: {
      title: 'Lig sayfası',
      subtitle: 'Lig sıralamasının ve istatistiklerinin derinliklerine inin',
      team: 'Takım',
      games: 'GP',
      gamesExplicit: 'Oynanan Maçlar',
      gamesRanking: 'GP',
      gamesRankingExplicit: 'Oynanan Maçla',
      points: 'Pts',
      pointsExplicit: 'Puanlar',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Beklenen Puanlar',
      goalsScored: 'NPG',
      goalsScoredExplicit: 'Penaltı Olmayan Goller',
      xG: 'xG',
      xGExplicit: 'Beklenen Goller',
      goalsAgainst: 'NPGA',
      goalsAgainstExplicit: 'Aleyhine atılan penaltı olmayan goller',
      xGAgainst: 'xGA',
      xGAgainstExplicit: 'Aleyhine Beklenen Goller',
      xGAgainstDiff: 'xGA Diff',
      xGAgainstDiffExplicit: 'Aleyhine Beklenen Goller Farkı',
      form: 'Form',
      sos: 'SoS',
      sosExplicit: 'Fikstür Gücü',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Ev Sahibi Avantajı',
      difficultyAboveAvg: 'Ortalamanın üstü zorluk',
      differentGames: '* Oynanan Farklı Oyun Sayısı ',
      berth: 'Derecelendirme'
    },
    usersOfClient: {
      userName: 'İsim',
      userRole: 'Kullanıcı',
      devRole: 'Dev',
      adminRole: 'Yönetici',
      servicesRole: 'Hizmetler',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Sıralama',
      elevenRole: 'Onbirler',
      similarityRole: 'Benzerlik',
      gameAnalysisRole: 'Maç Analizi',
      clientStatsRole: 'Müşteri İstatislikleri',
      created: 'Yaratıldı',
      type: 'Tip',
      logins: 'Girişler',
      lastLogin: 'Son giriş',
      trialDate: 'Deneme Tarihi'
    },
    clientLeagues: {
      league: 'Lig',
      area: 'Bölge',
      tier: 'Sıra',
      seasons: 'Sezonlar',
      currentMatchDay: 'Maç günü',
      regular: 'Düzenli',
      youthLeague: 'Genç',
      clientActive: 'Aktif',
      visibleLeagues: 'Görünür Ligler',
      male: 'Erkekler ligi',
      female: 'Kadınlar ligi'
    },
    connections: {
      title: 'Ortak Kombinasyonlar',
      playerFrom: 'Oyuncudan',
      playerTo: 'Oyuncuya',
      passes: 'Paslar',
      passesTooltip: 'Başarılı Pasların Toplam Sayısı',
      passesFinalThird: 'PF ⅓',
      passesFinalThirdTooltip: 'Ceza Sahası çizgisine atılan paslar'
    },
    playerPassMapData: {
      title: 'Pas İstatistikleri',
      player: 'Oyuncu',
      passes: 'Paslar',
      passesPct: '% Paslar',
      xA: 'xA',
      xG: 'xG',
      xT: 'xTehdit',
      playerTooltip: 'Oyuncu İsmi',
      passesTooltip: 'Toplam Pas Sayısı',
      passesPctTooltip: '% Başarılı Paslar',
      xATooltip: 'Beklenen Asistler',
      xGTooltip: 'Beklenen Goller',
      xTTooltip: 'Beklenen Tehditler'
    },
    playerAllGames: {
      gameDate: 'Tarih',
      game: 'Maç',
      team: 'Takım',
      positionsPlayed: 'Pozisyonlar',
      minsPlayed: 'Dakikalar',
      gameActions: 'Aksiyonlar',
      gameDateTooltip: 'Maç Tarihi',
      gameTooltip: 'Maç',
      positionsPlayedTooltip: 'Oynanan Pozisyonlar',
      minsPlayedTooltip: 'Oynanan Dakikalar',
      gameActionsTooltip: 'Goller, Asistler, Kartlar',
      from: 'Başlangıç',
      to: '-Son',
      goalText: 'Gol ',
      assistText: 'Assist',
      penaltyText: 'Penaltı ',
      ownGoalText: 'Kendi Kalesine Gol',
      yellowCardText: 'Sarı Kart',
      secondYellowCardText: 'İkinci Sarı Kart',
      redCardText: 'Kırmızı Kart',
      substitutionIN: 'Giren ',
      substitutionOUT: 'Çıkan',
      suspendedText: 'İhraç',
      Team: 'Teçhizat'
    },
    gameFlow: {
      phase: 'Aşama ',
      mins: 'Dakikalar',
      team: 'Takım',
      period: 'Periyot',
      possession: '%Topa Sahiplik',
      possessionTooltip: '% Topa Sahiplik',
      xT: 'xTehdir',
      xTTooltip: ';Beklenen Tehdit',
      pft: 'PF ⅓',
      pftTooltip: 'Ceza Sahası Çizgisine Atılan Pas',
      xG: 'xG',
      xGTooltip: 'Beklenen Goller'
    }
  },
  game: {
    title: 'Oyun sayfası',
    subtitle: 'Oyunun özelliklerini ve istatistiklerini daha derinlemesine inceleyin',
    header: {
      gameDetails: 'Detaylar',
      gameStats: 'Stats',
      gameFinishingMap: 'Bitiricilik Haritası',
      gameKeyPassMap: 'Kilit Pas Haritası',
      gamePassMap: 'Pas Haritası',
      gameThreat: 'Maç Tehdidi',
      gameFlow: 'Maç Akışı',
      gameAnalysis: 'Maç Analizi',
      gamePhysicalStats: 'Fiziksel İstatistikler',
      possessions: 'Topa Sahip Olma Oranı',
      bench: 'Yedek Külübesi',
      video: 'Video highlights',
      preGame: 'Maç öncesi',
      postGame: 'Maç sonrası',
      areaCoverage: 'Alan kapsamı'
    },
    passMap: {
      typeOfPlay: 'Oyun türü:',
      passes: 'Paslar:',
      team: 'Takım',
      minutes: 'Dakikalar:',
      select: 'Seç',
      all: 'Hepsi',
      attacking: 'Ofansif',
      defending: 'Defansif',
      forwards: 'Forvet',
      backwards: 'Geriye Doğru',
      sideways: 'Yana Doğru',
      longBall: 'Uzun Top',
      successfullPasses: 'Başarılı Paslar',
      homeTeam: 'Ev Sahibi',
      awayTeam: 'Deplasman Takımı',
      passingMatrix: 'Geçiş Matrisi',
      passer: 'Pas Veren',
      receiver: 'Pas Alan',
      passOutcome: 'Pas Sonucu',
      passDirection: 'Pas Yönü',
      half: 'Yarı',
      offensive: 'Ofansif',
      defensive: 'Defansif',
      passingConnections: 'Pas bağlantıları',
      pitchView: 'Saha',
      passSingular: 'Pas',
      passPlural: 'Pas',
      playerLocation: 'Oyuncu Konumu',
      passLegend: 'Ortalama Dokunma Konumu',
      minuteRange: 'Dakika aralığı'
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: 'Topa sahip olma oranı',
      expectedPoints: 'Beklenen Puanlar',
      directness: 'Doğrudanlık',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Duran Top',
      xA: 'xA',
      xASetPiece: 'xA Duran Top',
      xT: 'xT',
      xTSetPiece: 'xT Duran Top',
      touchesInOppBox: 'Touches in Opponent Box',
      passesFinalThird: 'Ceza Sahası çizgisine paslar',
      interceptions: 'Araya girmeler',
      recoveries: 'Recoveries',
      recoveriesOppHalf: 'Recoveries Opponent Half',
      tackles: 'Müdaheleler',
      tacklesWasDribbled: 'Kazanılan 1\'e 1 Savunma Mücadeleleri',
      fouls: 'Fouller',
      yellowCards: 'Sarı Kartlar',
      redCards: 'Kırmızı Kartlar',
      passes: 'Paslar',
      passing: 'Paslar %',
      crosses: 'Koşular',
      crossing: 'Koşular %',
      shots: 'Şutlar',
      shotsOnTarget: 'Kaleyi Bulan Şut',
      ppdaExplicit: ' Savunma Aksiyonu Başına Yenilen Paslar ',
      xgExplicit: ' Beklenen Goller',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Turnuva Ortalaması.',
      winChanceTooltip: 'Galibiyet olasılığı oluşturulan ve yenilen xG\'ye göre ',
      drawChance: 'Beraberlik',
      xgAgainst: 'xG Aleyhine',
      averagePossession: 'Topa Sahip Olma',
      averageShots: 'Şutlar',
      averagexG: 'Beklenen Şutlar',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      recoveriesRate: 'İyileşme Oranı',
      turnoversRate: 'Ciro Oranı'
    },
    detail: {
      halfTime: 'Devre Arası',
      overTime: 'Uzatmalar',
      showStats: 'İstatistikleri Göster',
      hideStats: 'İstatistikleri Kapat',
      bench: 'Yedek Kulübesi',
      showShotOptions: 'Şut Opsiyonlarını Göster',
      hideShotOptions: ' Şut Opsiyonlarını Kapat ',
      showPassOptions: 'Pas Opsiyonlarını Göster',
      hidePassOptions: ' Pas Opsiyonlarını Kapat ',
      endGame: 'Maç Sonu',
      penalties: 'Penaltılar'
    },
    timeline: {
      events: {
        goal: 'Gol',
        goal_ownGoal: 'Kendi Kalesine',
        goal_penalty: 'Penaltı Golü',
        card: 'Kart',
        card_yellowCard: 'Sarı Kart',
        card_secondYellowCard: 'İkinci Sarı Kart',
        card_redCard: 'Kırmızı Kart',
        formationChange: 'Taktik Değişikliği',
        substitution: 'Oyuncu Değişikliği',
        saveShot: 'Kurtarılan Şut',
        saveShot_penalty: 'Kurtarılan Penaltı Vuruşu',
        missedShot: 'Kaçırılan Şut',
        missedShot_penalty: 'Kaçırılan Penaltı Vuruşu',
        shotOnPost: 'Direkten Dönen Şut',
        shotOnPost_penalty: ' Direkten Dönen Penaltı Vuruşu ',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: '’nun Golü ',
      redCardTo: 'Kırmızı Kart  ',
      missedPenalty: 'Kaçırılan penaltı'
    },
    gameThreat: {
      typeOfPlay: 'Aksiyon Tipi',
      regularPlay: 'Düzenli Oyun',
      setPiece: 'Duran Top',
      setPiecePlay: 'Duran Top',
      throwInSetPiecePlay: 'Taç Atışı',
      throwInPlay: 'Taç Atışı',
      gkThrow: 'Kaleci atışı',
      gkKick: 'Kaleci vuruşu',
      kickOff: 'Başlamak',
      actionEnding: 'Aksiyon Sonu',
      pass: 'Pas',
      shot: 'Şut',
      foul: 'Faul',
      other: 'Diğer',
      threat: 'Tehlike',
      legendSumOfXT: 'xT toplamı',
      legendPass: 'Pas',
      legendShot: 'Şut',
      legendCarryAndAction: 'Taşı ve Aksiyon',
      legendCarryAndPass: 'Taşı ve Pas',
      legendOnlyShowing: 'Yalnızca xT’li bireysel aksiyonları gösteren > ',
      legendOnlyShowingPart1: 'Yalnızca Bireyleri Gösteren',
      legendOnlyShowingPart2: ' xT’li eylemler > ',
      legendOnlyShowingSetPiece: 'Yalnızca xT’li Duran top aksiyonlarını gösteren > ',
      legendOnlyShowingOpenPlay: 'Yalnızca xT’li Devam Eden Oyun aksiyonlarını gösteren > ',
      legendPlays: 'Aksiyonlar',
      legendPerPlay: 'Aksiyon Başına',
      legendCarry: 'Taşıma',
      penaltyPlay: 'Penaltı',
      freeKickTakenPlay: 'Free Kick Oyunu',
      cornerTakenPlay: 'Korner Oyunu ',
      fromCornerPlay: 'Korner Oyunu ',
      keeperThrowPlay: 'Kaleci Fırlatma Oyunu',
      fastBreakPlay: 'Kontra Atak Oyunu',
      indirectPlay: 'Endirek Oyun',
      minutes: 'Dakikalar',
      games: 'Oyunlar',
      xT: 'xT',
      xTPer90: '90 başına xT '
    },
    gameAnalysis: {
      next: 'Sonraki',
      previous: 'Önceki',
      phaseLabel: 'Aşama',
      phasesLabel: 'Aşamalar',
      dot: '. ',
      comma: ', ',
      from: '’den',
      to: '’na',
      and: ' ve ',
      steps: {
        finishingMapFullGame: 'Bitiricilik Haritası',
        keyPassMapFullGame: 'Kilit Pas Haritası',
        gameFlow: 'Oyun Akışı',
        finishingMapPerPhases: 'Aşama Başına Bitiricilik Haritası',
        keyPassMapPerPhases: 'Aşama Başına Kilit Pas Haritası',
        passMapPerPhases: 'Aşamalar Başına Pas Haritası'
      },
      step1: {
        table: {
          draw: 'Beraberlik',
          win: 'Galibiyet',
          lose: 'Yenilgi',
          possession: 'Topa Sahip Olma ',
          xP: 'Beklenen Puanlar',
          directness: 'Doğrudanlık',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG Açık Oyun',
          xGSetPiece: 'xG Duran Top',
          xA: 'xA',
          xAOpenPlay: 'xA Açık Oyun'
        },
        text: {
          firstParagraph: {
            1: 'Sağdaki harita home_team_name ve away_team_name tarafından oluşturulan beklenen golleri gösterir. Yeniden doldurulan çemberler, golle sonuçlanan şutlardır. Dairelerin boyutu, her çekimin xG değerine bağlıdır'
          },
          lastParagraph: {
            1: ' Bir sonucun olasılık yüzdesi ve beklenen puan sayısı, atış simülasyonu ile hesaplanır (100.000 atış simülasyonu yapılır ve sonuç ve puan alma olasılığı tahmin edilebilen bir şekilde değerlendirilir).'
          },
          targetHighTeamXG: {
            1: 'target_team_name, aynı şekilde rival_team_name, yüksek hacimli beklenen hedefler oluşturmayı başardı '
          },
          targetHighTeamOpenPlayXG: {
            1: ' Bu oyunda, target_team_name şanslarının çoğu açık oyunlardan geldi '
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: ' Bu oyunda, target_team_name şanslarının çoğu, açık oyunlar tarafından oluşturuldu (rival_team_name \'nın aksine)'
          },
          targetHighTeamSetPieceXG: {
            1: ' Bu oyunda, target_team_name şanslarının çoğu duran top oyunlarından geldi '
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: ' Bu oyunda, target_team_name şanslarının çoğu, duran top oyunları tarafından oluşturuldu (rival_team_name \'nın aksine)'
          },
          targetHighTeamCornerXG: {
            1: ' Bu oyunda, target_team_name şanslarının çoğu köşe vuruşu oyunlarından geldi '
          },
          targetLowTeamGoalConversion: {
            1: ' ancak gole çevirim düşüktü '
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: ' target_team_name hem açık oyunlarda hem de duran toplarda yüksek miktarda beklenen gol yarattı '
          },
          targetHighTeamGoalConversion: {
            1: ' ayrıca yüksek bir hedef dönüşüm oranına sahip olmak. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', yaratılan şanslardan hiçbirini gole çevirememek '
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' ama daha fazla gol atma tehlikesi yarattı '
          },
          targetHighTeamXGvsGameRival: {
            1: ' Bu oyunda, target_team_name, rival_team_name \'ndan daha fazla tehlike yarattı '
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' ve daha fazla gol atabilirdi. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' ancak yaratılan fırsatlardan herhangi birisini gole çeviremedi. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' oyun sonrası simülasyonumuza göre team_winning_chance kazanma şansını eşleştirmek.'
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' target_team_name şanslarının çoğu açık oyunlardan geldi. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' target_team_name şanslarının çoğu, duran top oyunlarından kaynaklandı. '
          },
          startTargetHighTeamCornerXG: {
            1: ' Şansların çoğu köşe vuruşlarından geldi. '
          },
          targetSimilarTeamXG: {
            1: ' Bu oyunda, her iki takım da xG açısından rakibe benzer miktarda tehlike yarattı., '
          },
          targetSimilarTeamXGGoalDiff: {
            1: ' ancak target_team_name, fırsatları tamamlamada daha iyi performans gösterdi. '
          },
          targetLowTeamXGGoalDiff: {
            1: ' Sonuç ne olursa olsun, target_team_name, Beklenen Hedefler açısından rakip için fazla tehlike oluşturmadı.'
          },
          targetLowTeamXGZeroGoalDiff: {
            1: ' target_team_name, oyunu kazanmak için Beklenen Hedefler açısından rakibe yeterince tehlike oluşturmadı '
          },
          rivalHighTeamXG: {
            1: ' ve rival_team_name\'nın çok fazla tehlike oluşturmasına izin verdi.'
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Bu kreasyonla, bu, target_team_name\'nin oyun sonrası simülasyonumuza göre yalnızca team_winning_chance kazanacağı bir oyundur. '
          },
          targetHighTeamGoalConversion2: {
            1: ' yüksek bir gole dönüştürme oranına sahip olmak '
          },
          winningChance: {
            1: ' Her iki takımın şut sayısı ve xG\'si göz önüne alındığında, target_team_name bu oyunu çoğu kez team_winning_şansı kazanmış olmalıydı. '
          },
          highPlayerXGManyShots: {
            1: ' Player_name\'nin shot_value çekimlerinde xg_value xG oluşturduğunu belirtmek ilginçtir. '
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' gol atmak için xg_value xG\'ye ihtiyaç duymak.'
          },
          highPlayerXGOneGoal: {
            1: ' gol atmak için. '
          },
          highPlayerXGAnyGoal: {
            1: ', hiçbir gol atamamasına rağmen. '
          },
          highPlayerXGNotManyShots: {
            1: ' Player_name\'nin birkaç çekimde xg_value xG oluşturduğunu belirtmekte fayda var. '
          },
          highManyPlayerXG: {
            1: ' Player_name ve player_name2\'nin sırasıyla xg_value ve xg_value2 <b>xG</b> oluşturduğunu belirtmek ilginçtir. '
          },
          highTeamXGPerShot: {
            1: ' target_team_name tarafından yapılan şutların seçimi ile ilgili olarak, şut başına ortalama xg xg_per_shot_value ile gol olma olasılığı açısından çok iyiydiler. '
          },
          highTeamXGPerShotVSGameRival: {
            1: ' target_team_name \'nın şut seçimi, atış başına ortalama xg_per_shot_value xG olması nedeniyle rival_team_name\'ndan çok daha iyiydi.'
          },
          xGTimesNotAfter70xG: {
            1: ' Oluşturulan yüksek xG\'ye rağmen, target_team_name oyunun sonunda tehlike yaratmakta sorun yaşıyordu.'
          },
          xGTimesBefore25xG: {
            1: ' target_team_name özellikle her iki yarının başında çok fazla tehlike yarattı. '
          },
          xGTimesAfter25xG: {
            1: ' target_team_name özellikle her iki yarının sonunda çok fazla tehlike yarattı. '
          },
          xGTimesBefore25xGvsItself: {
            1: ' target_team_name tehlikenin çoğunu ilk yarının başında yarattı. '
          },
          xGTimesAfter25xGvsItself: {
            1: ' target_team_name tehlikenin çoğunu ilk yarının sonunda yarattı. '
          },
          xGTimesBefore70xGvsItself: {
            1: ' target_team_name tehlikenin çoğunu ikinci yarının başında yarattı.'
          },
          xGTimesAfter70xGvsItself: {
            1: ' target_team_name tehlikenin çoğunu ikinci yarının sonunda yarattı. '
          },
          xGTimesBefore25xG2: {
            1: ' target_team_name, xg_value beklenen golleri oluşturan şanslarla oyuna çok sağlam başladı.'
          },
          xGTimesAfter25xG2: {
            1: ' target_team_name, oyunun ilk yarısını xg_value beklenen golleri oluşturma şansıyla bitirdi. '
          },
          xGTimesBefore70xG: {
            1: ' target_team_name, devre arası arasından xg_value beklenen golleri oluşturma şansıyla çıktı.'
          },
          xGTimesAfter70xG: {
            1: ' target_team_name ikinci yarıyı xg_value beklenen golleri yaratan şanslarla tamamladı.'
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: ' target_team_name ikinci yarının sonunda çok fazla tehlike yarattı.'
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: ' target_team_name ikinci yarının başında çok fazla tehlike yarattı. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: ' target_team_name ilk yarının sonunda çok fazla tehlike yarattı. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: ' target_team_name ilk yarının başında çok fazla tehlike yarattı'
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: ' target_team_name, tehlikesinin çoğunu ilk yarıda yaratırken, ikinci yarıda rival_team_name aynı şeyi yaptı. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: ' target_team_name, tehlikesinin çoğunu ikinci yarıda yaratırken, rival_team_name ilk yarıda aynısını yaptı.'
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: ' Beklenen Goller açısından en büyük tehlikenin ilk yarıda oluştuğu bir maçtır.'
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: ' Beklenen Goller açısından en çok tehlikenin ikinci yarıda oluştuğu bir maçtır. '
          },
          xGTimesFirstHalfXG: {
            1: ' target_team_name ilk yarıda tehlikenin çoğunu yaratmayı başardı. '
          },
          xGTimesSecondHalfXG: {
            1: ' target_team_name ikinci yarıda tehlikenin çoğunu yaratmayı başardı. '
          },
          xGTimesFirstHalfXGRival: {
            1: ' target_team_name, ilk yarıda Beklenen Goller açısından tehlikenin çoğuna izin verdi.'
          },
          xGTimesSecondHalfXGRival: {
            1: 't target_team_name, ikinci yarıda beklenen goller açısından tehlikenin çoğuna izin verdi. '
          },
          highInBoxXG: {
            1: ' Şut haritası, tehlikenin çoğunun ceza sahası içindeki şutların nasıl geldiğini gösterir. '
          },
          highOutOfBoxXG: {
            1: ' Şut haritasında, bu oyunda target_team_name\'nin ceza sahası dışından çok fazla tehlike oluşturduğu görülüyor. '
          },
          highInBoxXGRival: {
            1: ' Target_team_name tarafından yaratılan tehlikenin çoğunun ceza sahası içindeki şutlardan geldiğini belirtmek isterim. '
          },
          highInBoxXGRival2: {
            1: ' I target_team_name tarafından yaratılan tehlikenin çoğunun ceza sahası içindeki şutlardan geldiğini vurgulamak da ilginçtir. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name ceza sahası içindeki tehlikelerden kaçınarak iyi performans gösterdi. '
          },
          highTeamChancesHighPPDARival: {
            1: ' Target_team_name baskısının olmaması, ppda_value’de Savunma Aksiyonu Başına Pas\'a izin vermesi, rival_team_name nın yüksek sayıda şans yaratmasının anahtarlarından biriydi..'
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name, zaferin anahtarlarından biri olarak, savunma başına yalnızca ppda_value pasa izin verdi. '
          },
          lowPPDA: {
            1: ' target_team_name, rival_team_name oyununu kesintiye uğratarak harika bir iş çıkardı ve Savunma başına yalnızca ortalama ppda_value pasa izin verdi. '
          },
          highPossession: {
            1: ' target_team_name possession_value ile topa sahip oldu'
          },
          highPPDARival: {
            1: ' topun rahat akışının yanı sıra '
          },
          chancesCreated: {
            1: ', bu da yüksek sayıda açık oyun şansına sahip olmalarını sağladı (chances_value). '
          },
          chancesCreatedRival: {
            1: ', rival_team_name yüksek sayıda açık oyun şansı (chances_value) yaratabilmiş olsa da. '
          },
          xGPerShotRival: {
            1: ', rival_team_name, şut başına xg_per_shot_value xG ile daha tehlikeli şanslar yaratabilse de. '
          },
          winGame: {
            1: ' maçı kazanmanın anahtarlarından biri olarak. '
          },
          notEnoughWinGame: {
            1: ' maçı kazanmaya yeterli olmayan. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'İlk gol, player_name tarafından player_error_name hatasından yararlanılarak geldi'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'ilk ve tek gol, player_name tarafından player_error_name hatasından yararlanılarak geldi'
          },
          lastPhaseOfGame: {
            1: ' oyunun son bölümünde. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: ' maçı kazandıran gol, player_name tarafından player_error_name hatasından yararlanılarak geldi. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Maçı beraberliğe taşıyan gol, player_name tarafından player_error_name hatasından yararlanılarak geldi.. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'player_error_name tarafından yapılan hata target_team_name’e maçı beraberliğe taşıma şansı verdı. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name player_error_name’in hatasından yararlanarak öne geçti.'
          },
          xGChance: {
            1: ' xg_value xG. şansıyla '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'rival_team_name’in maçı kazanmak için attığı gol player_error_name’in hatasıyla  player_name’den geldi. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'player_error_name’in hatası rival_team_name’e maçı beraberliğe getirme şansı verdi. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name error_name’in hatasından yararlanarak öne geçti'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name maç boyunca yaratılan tek büyük şansta golü buldu, bu gol  xG map ile an xG of xg_value. Gördüğümüz player_name tarafından geldi '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name maç esnasında yaratılan tüm fırsatları gole çevirdi.'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name target_team_name’in an xG of xg_value ile gol atabileceği tek fırsatı yarattı '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: ' target_team_name, gol olma olasılığının %40\'ının üzerinde  olan chances_value şanslarından hiçbirini elde edemedi. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name skorda öne geçmek için büyük bir xg_value xG şansına sahipti. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 't target_team_name, skorda öne geçmek için xG ile %40\'ın üzerinde chances_value şansına sahipti. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 't target_team_name, skorda öne geçmek için yüksek xG ile chances_value şansına sahipti. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name direğe çarpan xg_value xG skorunda öne geçme şansına sahipti. '
          },
          beforeEndOfGame: {
            1: 'Maçın bitişinden önce '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name maçı kazanmak adına xg_value xG şansa sahipti. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name maçı kazanmak için  xg %40’ın üzerinde chances_value şansa sahipti. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name maçı kazanmak için  yüksek xG  chances_value şansına sahipti. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name skorda öne geçmek için yüksek xg_value xG şansına sahipti '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 't target_team_name, skorda öne geçmek için xG ile %40\'ın üzerinde chances_value şansına sahipti. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 't target_team_name, skorda öne geçmek için yüksek xG ile chances_value şansına sahipti. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name direğe çarpan xg_value xG skorunda öne geçme şansına sahipti. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name, oyunu şanssız bir şekilde berabere getirmek için xg_value xG şansına sahipti. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name, oyunu %30\'dan fazla puan alma olasılığıyla berabere bırakmak için chances_value şansına sahipti. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name direğe isabet eden topla biten maçı berabere bitirmek için xg_value xG şansına sahipti. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Beraberlik',
          win: 'Galibiyet',
          possession: 'Topa sahip olma',
          xP: 'Beklenen Puanlar',
          directness: 'Doğrudanlık',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA Açık Oyun',
          xASetPiece: 'xA Duran Top',
          chancesCreated: 'Yaratılan Şanslar',
          shotsOnTarget: 'Kaleyi Bulan Şut'
        },
        text: {
          firstParagraph: {
            1: 'Bu resim beklenen asistlerini göstermektedir <b style=\'color:home_color\'>home_team_name</b> and <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA Kilit Pas başına. '
          },
          keyPassesGeneratedFrom: {
            1: ', özellikle tarafından verilen kilit paslar '
          },
          highTeamXAvsXG: {
            1: ' xA haritasının gösterdiği gibi, target_team_name tarafından yaratılan tehlikenin çoğu, bireysel eylemlerden ziyade kombinasyon oyunlarından geliyor'
          },
          openPlay: {
            1: 'açık oyunlar'
          },
          setPiece: {
            1: 'duran top oyunları'
          },
          cornerKicks: {
            1: 'korner vuruşları'
          },
          combinationPlays: {
            1: 'kombinasyon oyunlarıc'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'Bu oyunda, target_team_name her bir kombinasyon oyunundan tehlike yarattı'
          },
          individualActions: {
            1: ' ve bireysel aksiyonlara'
          },
          dangerFromIndividualActions: {
            1: 'Bu oyunda, target_team_name tarafından yaratılan tüm tehlikeler bireysel aksiyonlarla yaratıldı.'
          },
          highTeamXAvsXGRival: {
            1: ' Oyun sırasında target_team_name\'nin izin verdiği şanslar, xA haritası görüntülenirken kombinasyon oyunlarından geliyordu.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name \'den gelen paslarda sağlamdı '
          },
          manyPlayerKeyPasses: {
            1: 'player_name\'nin key_passes kilit paslarında xa_value xA oluşturduğunu belirtmek ilginçtir. '
          },
          playerAssists: {
            1: ' xa_per_assist gerekli xA asist başına.'
          },
          giveAssist: {
            1: ' asist yapmak için'
          },
          noAssists: {
            1: ', hiçbir pasın asiste dönüşmemesine rağmen'
          },
          highXANotManyShots: {
            1: 'It player_name’in bazı paslarda xa_value xA yaratması ilginçtir.'
          },
          manyPlayersHighXA: {
            1: 'player_name ve player_name2’nin xA sırasıyla xa_value xa_value2 xA yaratması ilginçtir'
          },
          xATimes: {
            1: ' target_team_name, tehlikesinin çoğunu ilk yarıda yaratırken, rival_team_name aynısını'
          },
          firstHalf: {
            1: ' ilk yarı '
          },
          secondHalf: {
            1: ' ikinci yarı '
          },
          left: {
            1: 'sol taraf'
          },
          center: {
            1: 'orta '
          },
          right: {
            1: 'sağ taraf '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Beklenen Goller açısından tehlikenin çoğunun sırasında oluştuğu bir maç.'
          },
          xAFirstHalf: {
            1: 'target_team_name daha fazla tehlikeyi ’da ilk yaratmıştır '
          },
          xATimesXARival: {
            1: 'target_team_name beklenen goller açısından daha fazla tehlikeyi ’da yaratmıştır'
          },
          xASides: {
            1: ' target_team_name tehlikesinin çoğu side_name\'den üretildi (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'rival_team_name tehlikenin çoğunu side_name’dan yaratırken (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'rival_team_name tarafından yaratılan tehlikenin çoğu  özellikle side_name ‘dan geldi. (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name özellikle etkiliydi '
          },
          xAPerChanceCreated: {
            1: ' xa_value ortalamasıyla birlikte'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name özellikle etkiliydi '
          }
        }
      },
      step3: {
        text: {
          chance: ' şans',
          chances: ' şanslar',
          goal: ' gol',
          goals: ' goller',
          home: 'ev sahibi',
          away: 'karşı takım',
          last: 'son',
          first: 'ilk',
          goalScorer: 'gol atan',
          goalScorers: 'gol atanlar',
          lastPhase: 'maçın son anları, ',
          phase: {
            1: 'maçın phase_position anında, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b>  (<b style=\'color:more_color\'>more_xt_team_value xT</b>) den daha fazla beklenen tehlike yarattı <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'e bu süre içinde daha fazla dakika için yaptı (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> of the rival)'
          },
          rivalTeamMoreMinutes: {
            1: 'ancak daha uzun süre tehlike yaratan rakip takımdı (<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> of the rival) in this period of the game'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> daha fazla tehlike yaratan takımdı (<b style=\'color:max_color\'>max_xt_team_value xT</b>)  <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> daha fazla tehlike yaratırken (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) at <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Maçın bu periyodunda her iki takım da rakip kaleciyi geçmeyi başardı. <b>number_of_goals_each_team</b> each one. Ev sahibi takım <b style=\'color:#3366FF\'>home_player_name_goals</b>  yoluyla ve karşı takım <b>away_player_name_goals</b> yoluyla'
          },
          oneTeamTakesTheLead: {
            1: 'gol anlamında <b style=\'color:replace_color\'>goal_scored_team_name</b> rakip takımın kalecisini <b style=\'color:replace_color\'>home_player_name_goals</b> as goal_scorer_word ile alt ederek <b style=\'color:replace_color\'>difference_number_of_goals</b> farkla yendi.'
          }
        }
      },
      step4: {
        table: {
          team: 'Takım',
          period: 'Periyot',
          possession: 'Sahip.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OP',
          tooltip: {
            team: 'Takım',
            period: 'Periyot',
            possession: 'Topa Sahip oLMA',
            ppda: 'Savunma başına yenilen paslar',
            xGOpenPlay: 'xG Açık Oyun'
          }
        },
        text: {
          clearly: 'açıkça',
          very: 'çok ',
          haveGotText1: 'only got',
          haveGotText2: 'bundan daha fazla yedi',
          gaveUpPoss: 'topa sahip olmaktan vazgeçti',
          lostPoss: 'topa sahip olmayı kaybetii',
          too: 'da ',
          possession: {
            1: 'Oyunun bu aşamasında <b style=\'color:team_color\'>team_name</b> clear_text topa sahip olmayı kontrol etti'
          },
          equalPossession: {
            1: ' Maçın bu aşamasında, top hakimiyeti oldukça dengeli olduğu için kimse diğerine hakim olmadı, ancak sayılara bakıldığında, <b =\'color:team_color\'>topluluk_değeri%</b> topla oynama oranıyla <b style=\'color:team_color\'>team_name</b>, rakiplerini biraz geride bıraktı. '
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b>  kötü bir topa baskı izniyle <b style=\'color:rival_team_color\'>rival_team_name</b> ‘na verilen <b style=\'color:target_team_color\'>ppda_value savunma başına pas </b>'
          },
          lowPossessionLowPPDA: {
            1: ', fakat <b style=\'color:target_team_color\'>target_team_name</b> rival_team_name  <b>PPDA</b> of <b>ppda_value</b> ile topla oynarken topa iyi bir baskı gösterdi'
          },
          highPossessionLowPPDA: {
            1: ' ve rival_team_name ndan gelen very_textlow düşük baskı yoğunluğu nedeniyle oynayabildi '
          },
          highPossessionHighPPDA: {
            1: ' rival_team_name’ın topa baskı şiddeti çok very_texthigh olmasına rağmen'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>  ceza sahası çizgisine yakın alanlarda pas yaparak  <b>pft_value</b> <b>Passes in the Final Third</b> . '
          },
          highPossessionMidLowPFT: {
            1: 'Topa yüksek oranda sahip olmadan bağımsız olarak <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passes in the Final Third</b>. '
          },
          lowPossessionHighPFT: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> possession_text bu süreçte olmasına rağmen, <b>pft_value</b> <b>Passes in the Final Third</b> vermeyi başardı. '
          },
          midPossessionHighPFT: {
            1: ' Bu aşamada oldukça dengeli bir pozisyona sahip olmak,<b style=\'color:target_team_color\'>target_team_name</b> b>pft_value</b> <b>Passes in the Final Third</b> vermesini engellemedi. '
          },
          highPFTHighTouchesIOB: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b>, ceza sahası çizgisine yakın bölgede oyunu kontrol etmenin yanı sıra rakip ceza sahasında da çok fazla yer aldı. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> ceza sahası yakın çizgisinde topu kontrol edebildi ancak rakip ceza sahasına topu taşıyamadı.'
          },
          highPFTMidTouchesIOB: {
            1: ' <b>Passes in the Final Third</b> sayısı düşünüldüğünde, <b style=\'color:target_team_color\'>target_team_name</b> rakip ceza sahasında daha fazla tehlike yaratmalıydı.'
          },
          lowPFTHighTouchesIOB: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b>  ceza sahası çizgisine yakın bölgede çok fazla pas tamamlayamamış olsada, rakip ceza sahasına girmeyi bir çok kez başardı. '
          },
          midPFTHighTouchesIOB: {
            1: 'Ceza sahası çizgisine yakın bölgede yapılan paslar düşünüldüğünde, <b style=\'color:target_team_color\'>target_team_name</b> rakip ceza sahasına bir çok kez girmeyi başardı. '
          },
          maxDirectness: {
            1: ' <b style=\'color:max_dir_color\'>target_team_name</b> ‘nin a <b>Directness</b> of <b>directness_value</b> ile daha ofansif oynadığı oyunun, oyunun bu aşaması olduğunu belirtmekte fayda var. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>  maçın geri kalanına bakıldığında daha fazla xG yaratabildi. '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> iyi bir sayıda Beklenen Goller yaratmayı başardı.'
          },
          highXG: {
            1: 'iyi bir sayıda Beklenen Goller yarattı'
          },
          highXGLowPossession: {
            1: ' topun kontrolüne sahip olmamasına rağmen '
          },
          highXGLowShots: {
            1: ' sadece birkaç şutta, <b>xG </b>  şut başına <b>xg_per_shot_value</b>’a sahip'
          },
          highXGLowXGPerShot: {
            1: ' şut başına xG too_textlow olsa da. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b rakibe hiçbir tehlike yaratmayı başaramadı.'
          },
          lowXGMinXG: {
            1: 'Beklenen gollerin yaratılması açısından, <b style=\'color:target_team_color\'>target_team_name</b> için kötü bir oyundu.'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> çok düşük sayıda Beklenen Goller yarattı.'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> iyi sayıda Beklenen Goller yaratamadı.'
          },
          lowXGHighPossession: {
            1: ' topun kontrolüne sahip olsalar da. '
          },
          lowXGHighShots: {
            1: ' bir çok kez şut çekmelerine rağmen'
          },
          lowXGHighPFT: {
            1: ' sahanın <b>pft_value</b> <b> ceza sahası çizgisine yakın bölümünde </b> pasları tamamlamasına rağmen. '
          },
          midXGQuintileMinXG: {
            1: ' xG yaratımı açısından kötü olmasa da bu, <b style=\'color:target_team_color\'>target_team_name</b> için oyunun bu açıdan en zayıf aşamasıydı. '
          },
          midXGQuintileMaxXG: {
            1: ' Bu, <b style=\'color:target_team_color\'>target_team_name</b>\'nin en yüksek <b>xG (xg_value)</b>\'yi oluşturabildiği aşamaydı'
          }
        }
      },
      step5: {
        table: {
          team: 'Takım',
          period: 'Periyot',
          possession: 'Sahip olma',
          directness: 'Doğr.',
          passesFinalThird: 'PF ⅓',
          tooltip: {
            team: 'Takım',
            period: 'Periyot',
            possession: 'Topa Sahip Olma',
            directness: 'Doğrudanlık',
            passesFinalThird: 'Ceza Sahası çizgisine paslar'
          }
        },
        text: {
          last: 'son',
          goal: 'gol',
          goals: 'goller',
          chance: 'şans',
          chances: 'şanslar',
          first: 'ilk',
          homeTeam: 'ev sahibi takım',
          awayTeam: 'konuk takım',
          home: 'ev',
          away: 'konuk',
          clearly: 'kesinlikle',
          slightly: 'hafifçe',
          firstOrLastPhase: {
            1: 'Oyunun bu phase_position bölümünde, ',
            2: 'Maçın phase_position bölümünde, '
          },
          phase: {
            1: 'Oyunun bu bölümünde, '
          },
          bothZeroGoalsScored: {
            1: ' her iki takım da puan tablosunu değiştiremeden.'
          },
          equalGoalsScored: {
            1: '<b>number_goals</b> gol atmak'
          },
          differentGoalsScored: {
            1: ' <b>number_goals</b> gol atmak'
          },
          equalPossesion: {
            1: ' her iki takım da zamanın tam olarak <b>poss_value%</b> oranında topa sahipti '
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> topa rakibinden  (zamanın <b style=\'color:more_color\'>more_poss_team_value%</b> kadarı ) daha fazla dakika sahipti <b style=\'color:less_color\'>less_poss_team_name</b> ( zamanın <b style=\'color:less_color\'>less_poss_team_value%</b> kadarı )'
          },
          equalDirectness: {
            1: ' her iki takım da oyunu aynı doğrudanlıkla oynadı (<b>directness_value</b> her biri)'
          },
          moreDirectnessSameTeam: {
            1: ' onlar da rakiplerine göre daha dikine ve oyunu direkt olarak oynuyorlardı. <b style=\'color:more_color\'>more_dir_team_value</b> vs <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: ' ancak, rakibinden (<b style=\'color:less_color\'>less_dir_team_value</b>) daha doğrudan (<b style=\'color:more_color\'>more_dir_team_value</b>) oynayan ev sahibi deplasman takımıydı.)'
          },
          equalChancesCreated: {
            1: 'Her iki takım da aynı sayıda şans yarattı, tam olarak <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> yalnızca <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> yarattı ve adverb_text rakip tarafından daha iyi bir performansı gösterdi (<b style=\'color:more_color\'>more_cc_team_value more_chance_text yaratıldı </b>). '
          },
          equalXA: {
            1: '<b>Beklenen Asistlerin xa_value</b> yansıtıldığı gibi, her iki takım da eşit fırsatlara sahipti, '
          },
          moreXA: {
            1: 'The home_away team <b>diff_xa_team_value rakibe kıyasla </b> (<b style=\'color:more_color\'>more_xa_team_value</b>  <b style=\'color:less_color\'>less_xa_team_value</b>) daha fazla Beklenen Asist üretti, '
          },
          xAOpenPlay: {
            1: 'sırasıyla yaratarak <b style=\'color:more_color\'>more_xa_op_value</b> ve<b style=\'color:less_color\'>less_xa_op_value xA Açık Oyun</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' her biri',
          respectively: ', sırasıyla',
          with: ' (birlikte <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'oyuncu ',
          playerWere: 'oyuncular',
          firstPhase: {
            1: 'maçın ilk bölümünde, en önemli player_text ',
            2: 'Oyunun ilk bölümünde öne çıkan isim ise şuydu: '
          },
          otherPhase: {
            1: '<b style=\'color:replace_color\'>min_from\'</b> ve <b style=\'color:replace_color\'>min_to\'</b> arasında belirtilmelidir. '
          },
          lastPhase: {
            1: 'Oyunun son bölümünde, bahsedersek ',
            2: 'Oyunun son bölümüne ilişkin olarak, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b>, takımının en yüksek sayıda başarılı pasını yaparken, tam olarak <b style=\'color:replace_color\'>successfull_passes_value pasları</b>'
          },
          playerMaxTotalPasses: {
            1: ' rakamlar onun da olduğunu gösterdiğinde daha da değerli hale geliyor. '
          },
          playerMaxTotalPasses2: {
            1: ' with_text en çok pas girişiminde bulunan oyuncu (<b style=\'color:replace_color\'>total_passes_value pasları</b>). '
          },
          playerNotMaxTotalPasses: {
            1: ' en fazla pası denememiş olsa da (<b style=\'color:replace_color\'>player_name</b> ile birlikte <b style=\'color:replace_color\'>total_passes_value paslar</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: ' bu süre boyunca denemek, her birini <b style=\'color:replace_color\'>total_passes_value paslar</b>.'
          },
          playerMaxPctPasses: {
            1: '<b style=\'color:replace_color\'>% Tamamlanan paslar açısından </b>, <b style=\'color:replace_color\'>player_name</b> yüksek bir <b style=\'color:replace_color\'>max_pct_passes_value%</b> sahiptir. ',
            2: 'Pas başarı oranı ile ilgili olarak, bahsetmeye değer <b style=\'color:replace_color\'>player_name</b> with a <b style=\'color:replace_color\'>max_pct_passes_value%</b> pass success rate</b>. '
          },
          playerSumTotalXG: {
            1: 'Bu zaman aralığında takım toplamda <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Bu bölümde, <b style=\'color:replace_color\'>team_name</b>, <b style=\'color:replace_color\'>xG</b> değerinden bir <b style=\'color:replace_color\'>sum_xg_value</b>, oluşturdu'
          },
          ZeroSumXG: {
            1: ' Tüm takım arasında toplam <b style=\'color:replace_color\'>all_team_total_pass</b> yapmalarına rağmen, tek bir şans bile yaratamadıkları için boşunaydı.',
            2: ' Bu bölümde yapılan <b style=\'color:replace_color\'>all_team_total_pass\'lar</b> tek bir gol şansı bile yaratmadı. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b>  <b style=\'color:replace_color\'>xg_value xG</b>  ile ve <b style=\'color:replace_color\'>player_xa_name</b>  <b style=\'color:replace_color\'>xa_value xA</b> ile şans yaratma açısından en tehlikeli oyuncular olarak. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: ' <b style=\'color:replace_color\'>xg_value xG</b> ve <b style=\'color:replace_color\'>xa_value xA</b> ile <b style=\'color:replace_color\'>player_name</b> takımının şansının çoğunun yaratıcısı.'
          },
          playersMaxXGMaxXA: {
            1: ' diğerlerinin yanı sıra her biri kilit paslarıyla <b style=\'color:replace_color\'>xa_value xA</b>\'ı tetikleyen <b style=\'color:replace_color\'>players_name</b>\'e teşekkürler. '
          },
          playerMaxXGZeroXA: {
            1: ' yaratılan şansın tüm yüküne sahip olan <b style=\'color:replace_color\'>xg_value xG</b> ile <b style=\'color:replace_color\'>player_xg_name</b> olmak, onları kendi başına yaratmak zorunda olduğu için herhangi bir kilit pas alamadı. '
          },
          playersMaxXGZeroXA: {
            1: 'yaratılan şanslara sahip olan <b style=\'color:replace_color\'>player_xg_name</b> with <b style=\'color:replace_color\'>xg_value xG</b> onları kendi başına yaratmak zorunda oldukları için herhangi bir kilit pas alamadılar. '
          },
          oneMaxConnections: {
            1: 'Maçın bu bölümünde aralarında en çok pas yapan ikili toplam <b style=\'color:replace_color\'>connections_value passes</b> pasla <b style=\'color:replace_color\'>couple_name</b> oldu. ',
            2: '<b style=\'color:replace_color\'>couple_name</b> oluşturduğu ikilili,  <b style=\'color:replace_color\'>connections_value</b> kez aralarında paslaştılar. ',
            3: '<b style=\'color:replace_color\'>couple_name</b> ikilisi, maçın bu bölümünde en çok pas veren ikili oldu ve bunu hatta <b style=\'color:replace_color\'>connections_value</b> kısmında yaptılar. '
          },
          twoMaxConnections: {
            1: '<b style=\'color:replace_color\'>couple_name</b> ve <b style=\'color:replace_color\'>couple_name2</b>\'nin oluşturduğu iki çift aralarında <b style=\'color:replace_color\'>connections_value</b> kez paslaşarak bu periyot için en çok tekrarlanan bağlantılardı. '
          },
          moreThanTwoMaxConnections: {
            1: '<b style=\'color:replace_color\'>couple_name</b> gibi oyuncu çiftleri, birbirlerine <b style=\'color:replace_color\'>connections_value passes</b> yaptı. '
          },
          oneMinConnections: {
            1: 'Diğer bir yandan, birbiriyle en az pas yapan <b style=\'color:replace_color\'>couple_name</b> sadece <b style=\'color:replace_color\'>connections_value passes</b> ile. ',
            2: 'Diğer bir yandan, <b style=\'color:replace_color\'>couple_name</b> arasında kurulan tandem sadece <b style=\'color:replace_color\'>connections_value</b> kez bağlantı sağladı. '
          },
          twoMinConnections: {
            1: 'Diğer bir yandan, <b style=\'color:replace_color\'>couple_name</b> ave <b style=\'color:replace_color\'>couple_name2</b> birbileri arasında çok az paslaştılar (<b style=\'color:replace_color\'>connections_value passes</b>). '
          },
          moreThanTwoMinConnections: {
            1: ' the <b style=\'color:replace_color\'>couple_name</b> ikilisi gibi kombinasyonlar aralarında çok bağlantı saplayamadı hatta <b style=\'color:replace_color\'>connections_value passes</b> ile en az yaygın kombinasyonlar arasında oldu'
          }
        }
      },
      step7: {
        ballPossession: 'Topa Sahip Olma',
        gamePossessionDist: 'Topa Sahip Olma Dağılımı'
      }
    },
    gamePossessionMap: {
      of: '-nin',
      to: 'karşı',
      and: 've',
      endsWith: 'ile bitmekte',
      time: 'zaman',
      touches: 'Dokunuşlar',
      passes: 'Paslar',
      threat: 'Tehdit',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Dakikalar',
      duration: 'süre',
      endsGoal: 'Bitiş gölü',
      endsInBox: 'Ceza Sahasında biten',
      withShot: 'Şutla Birlikte',
      withCross: 'Koşuyla Birlikte',
      possession: 'Topa Sahip Olma',
      events: 'Anlar',
      filters: 'Filtreler',
      filtersWarning: ' Tehdit yalnızca şut çekilmeyen topla oynamalara uygulanır',
      sumWarning: 'Filtre, dizideki tüm şutların xG toplamına uygulanır, bu yüzden 1\'den büyük olabilir',
      show: 'Şov',
      sequenceNumbers: 'Sıra Numarası',
      jerseyNumbers: 'Forma',
      pass: 'Pas',
      carryAndPass: 'Taşıma & Pas',
      carryAndAction: 'Taşıma & Aksiyon',
      carryAndShot: 'Taşıma & Şut',
      shotFailed: 'Kaçan Şut',
      goal: 'Gol',
      savedShot: 'Kurtarılan Şut',
      missedShot: 'Kaçan Şut',
      shotOnPost: 'İsabetli Şut',
      headerGoal: 'Kafa Golü',
      headerFailed: 'Kaçan Kafa Vuruşu',
      failed: 'Başarısız',
      with: 'ile'
    },
    report: {
      title: 'Game Report',
      maps: 'Maps',
      xGRace: 'xG Race',
      lineups: 'Lineups',
      button: 'Oyunun tam PDF raporunu oluşturun',
      mobileButton: 'PDF rapor',
      most: 'Çoğu',
      topXPlayers: 'En İyi {x} Oyuncu',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Oyunun Fiziksel Veri Raporu'
    },
    avgScoreTooltip: 'Dakika başına ortalama puan',
    status: {
      scheduled: 'planlanmış',
      postponed: 'Ertelendi',
      cancelled: 'İptal edildi',
      inPlay: 'Canlı',
      finished: 'Bitti',
      awarded: 'Ödüllendirildi',
      dataAvailable: 'Veriler önümüzdeki saatlerde mevcut olacak'
    },
    preGameAnalysis: {
      showExpectations: 'Beklentileri Göster',
      hideExpectations: 'Beklentileri Gizle',
      goalsPeriods: 'Hedef Dönemleri',
      synergyIndex: 'Sinerji İndeksi',
      synergyIndexSubtitle: 'Pasör-finişçi bağlantısının genel gücü'
    }
  },
  general: {
    1: 'Bir',
    2: 'İki',
    3: 'Üç',
    4: 'Dört',
    5: 'Beş',
    8: 'Sol',
    9: 'İkisi de',
    10: 'Sağ',
    create: 'Yarat',
    save: 'Kaydet',
    cancel: 'İptal Et',
    delete: 'Sil',
    edit: 'Düzelt',
    reset: 'Sıfırla',
    go: 'Git',
    formErrors: {
      required: 'Bu Alanın Girilmesi Gereklidir',
      passwordMatch: 'Şifre Geçerli Değil',
      minLength: 'Minimum uzunluk',
      maxLength: 'Maksimum uzunluk',
      emailValid: 'Geçerli bir e-mail girilmelidir',
      youthAge: 'Yaş 10 ile 23 arasında olmalıdır',
      seasonYear: 'Yıl 2016 ile 2050 arasında olmalıdır',
      integer: 'Ondalık sayılara izin verilmez'
    },
    confirmationTitle: 'Emin misin?',
    confirmationMessage: ' Lütfen işlemi gerçekleştirmek isteyip istemediğinizi onaylayın ',
    yes: 'Evet, eminim',
    no: 'Hayır',
    search: 'Ara',
    clearFilters: 'Filtreleri temizle',
    minimum: 'Minimum',
    maximum: 'Maksimum',
    minimumPercent: '(%)Minimum Yüzde',
    period: 'Periyot',
    exclude: 'Çıkar',
    team: 'Takım',
    clear: 'Temizle',
    all: 'Hepsi',
    ground1: 'Tümü',
    ground2: 'İç Saha',
    ground3: 'Deplasman',
    filter: 'Filtre',
    noData: 'Sonuç bulunamadı',
    noDataGivenFilters: 'Girilen filtrelerle bir sonuç bulunamadı',
    similarityMinutesWarning: '450 dakikadan az oynandığı için veri yok',
    templateOnlyEditable: 'Şablon yalnızca şu kişi tarafından düzenlenebilir ',
    close: 'Kapat',
    load: 'Yükle',
    filters: 'Filtreler',
    players: 'Oyuncular',
    teams: 'Takımlar',
    compare: 'Karşılaştır',
    seeMore: 'Daha Fazla Gör',
    seeLess: 'Daha Az Gör',
    request: 'Talep Et',
    notes: 'Notlar',
    closeSession: 'Çıkış',
    settings: 'Ayarlar',
    player: 'Oyuncular',
    state: 'Durum',
    updated: 'Yüklendi',
    file: 'Dosya',
    uploadFile: 'Yüklenen Dosya',
    reports: 'Raporlar',
    download: 'İndir',
    new: 'Yeni',
    comparison: 'Karşılaştırma',
    scout: 'İzleme',
    favorites: 'Favoriler',
    moreOptions: 'Daha fazla ayar',
    lessOptions: 'Daha az ayar',
    today: 'Bugün',
    home: 'Ev Sahibi',
    away: 'Konuk Takım',
    until: 'kadar',
    firstHalf: 'İlk Yarı',
    secondHalf: 'İkinci Yarı',
    firstPeriodOT: 'İlk Y. UZ',
    secondPeriodOT: 'İkinci Y. UZ',
    postponed: 'Ertelendi',
    stats: 'İstatistikler',
    yesterday: 'Dün',
    last: 'Son',
    startDate: 'Başlangıç Tarihi',
    active: 'Aktif',
    playerLimit: 'Oyuncu Limiti',
    type: 'Tip',
    successMessage: 'İşlem Başarılı',
    failMessage: 'İşlem Başarısız',
    by: 'Tarafından',
    checkYourInbox: 'Gelen kutunu kontrol et',
    faq: 'Kavramlar Dizini',
    globalSearch: 'Global Arama',
    gamesLost: 'Kaybedilen Maçlar',
    outOf: 'arasında',
    avgSeason: 'Sezon Ort.',
    leftDays: 'kalan günler',
    notifyError: 'Hata Bildir',
    notify: 'Bildir',
    comments: 'Yorumlar',
    searches: 'Aramalar',
    now: 'Şimdi',
    twoHoursAgo: 'İki Saat önce',
    incomings: 'Gelenler',
    departures: 'Gidenler',
    transferLoans: 'Kiralıklar',
    transfers: 'Transferler',
    movements: 'Hareketler',
    incomes: 'Gelirler',
    expenditures: 'Harcamalar',
    action: 'Aksiyon',
    target: 'Hedef',
    uses: 'kullanışlı',
    users: 'Kullanıcılar',
    since: '-den beri',
    mediaMode: 'Medya modu',
    white: 'Beyaz',
    enabled: 'Aktive edildi',
    disabled: 'Devredışı bırakıldı',
    left: 'Sol',
    right: 'Sağ',
    both: 'İkisi de',
    'left-both': 'Sol İkisi de',
    'right-both': 'Sağ İkisi de',
    'left foot': 'Sol',
    'right foot': 'Sağ',
    files: 'Dosyalar',
    confirm: 'Kabul ET',
    currentStep: 'Mevcut Adım',
    phases: 'Fazlar',
    entries: 'Girişler',
    none: 'Hiç',
    times: 'zamanlar',
    darkMode: 'Karanlık mod',
    client: 'Müşteri',
    visits: 'Ziyaretler',
    lastVisit: 'Son Ziyaret',
    strong: 'Güçlü',
    medium: 'Orta',
    weak: 'Zayıf',
    goal: 'Gol',
    list: 'Liste',
    map: 'Harita',
    copiedToClipboard: 'panoya kopyalandı',
    division: 'Lig',
    many: 'Çok',
    few: 'Biraz',
    median: 'Medyan',
    topRight: 'en Sağ',
    topLeft: 'en Sol',
    bottomRight: 'Sağ Alt',
    bottomLeft: 'Sol Alt',
    library: 'Kütühane',
    mediaLibrary: 'Medya Kütüphanesi',
    for: 'İçin',
    stat: 'İstatistik',
    position: 'Pozisyon',
    order: 'Sipariş',
    add: 'Ekle',
    visualization: 'Görselleştirme',
    basic: 'Basit',
    selectAll: 'Hepsini Seç',
    unselectAll: 'Tümünün Seçimini Kaldır',
    distribution: 'Dağıtım',
    end: 'Son',
    accuracy: 'Oran',
    opponent: 'Rakip',
    ownTeam: 'Kendi Takımı',
    center: 'Orta',
    line: 'Çizgi',
    live: 'Canlı',
    unavailable: 'mevcut değil',
    calendar: 'Takvim',
    activeLeague: 'Aktif Lig',
    similarity: 'Benzerlik',
    emptyForSelectAll: 'Boş Hepsini Seç',
    size: 'Boyut',
    selectPlayersRestriction: '1 ve {x} arasında oyuncu seç',
    group: 'Group',
    alerts: 'Alerts',
    shortcuts: 'Shortcuts',
    share: 'Share',
    dataAvailable: 'Veriler yakında hazır olacak',
    someStatsAvailableSoon: 'Bazı istatistikler yakında mevcut olacak',
    monthGamesWarning: 'Seçilen ayın oyunları yakında satışa sunulacak',
    metrics: 'Metrikler',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: 'Asla',
    unlimited: 'Sınırsız',
    user: 'Kullanıcı',
    warning: 'Uyarı',
    requests: 'İstekler',
    contactSales: 'İletişim Satış',
    comingSoon: 'Çok Yakında!',
    firstPost: '1. Gönderi',
    secondPost: '2. Gönderi',
    dZone: 'D Bölgesi',
    penaltySpot: 'Penaltı Noktası',
    secondPlay: '2. Oyun',
    otherZone: 'Diğer Bölge',
    baseline: 'Temel',
    youth: 'Youth',
    male: 'Male',
    direct: 'Doğrudan',
    indirect: 'Dolaylı',
    processing: 'Processing',
    addNew: 'Yeni Ekle',
    createdBy: 'Tarafından oluşturuldu',
    downloading: 'Downloading',
    displayType: 'Sunum Türü',
    alreadyExists: 'zaten var',
    aggregation: 'Birleştirme',
    unavailableLeagues: 'Oyuncunun oynadığı liglerin hiçbirine erişiminiz yoktur',
    meters: 'Meters',
    quantity: 'Quantity',
    allTime: 'All Times',
    games: 'Games',
    unit: 'Birim',
    categories: 'Kategoriler',
    maintenanceWarning: 'Bakım çalışması devam ediyor',
    maintenanceMessage: 'Bazı güncellemeler yapıyoruz. Şu anda yaptığınız değişiklikler kaydedilmeyecek. Sabır gösterdiğiniz için teşekkürler!',
    seeAll: 'Hepsini gör',
    from: 'Kimden',
    to: 'Kime',
    showFilters: 'Filtreleri göster',
    hideFilters: 'Filtreleri gizle',
    horizontal: 'Yatay',
    vertical: 'Dikey',
    drop: 'Düşürmek',
    orientation: 'Oryantasyon',
    goalProbability: 'Hedef Olasılığı',
    assistProbability: 'Destek Olasılığı',
    attackingDirection: 'Saldırı Yönü',
    currentTeam: 'Mevcut Takım',
    expectations: 'Beklentiler',
    sideBySide: 'Yan yana',
    teamValue: 'Takım değeri',
    fieldLayout: 'Saha Düzeni',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Armalar',
    pcts: 'PCT\'ler'
  },
  playerScout: {
    dlabDatabase: 'Driblab Veritabanı',
    league: 'Lig',
    top5: 'En iyi 5',
    topCountries: 'Ülkeler',
    tier: 'Sıra',
    division1: 'Birinci Lig',
    division2: 'İkinci Lig',
    division3: 'Üçüncü Lig ',
    division4: 'Dördüncü Lig',
    division5: 'Beşinci Lig',
    division6: 'Altıncı Lig',
    summary: 'Özet',
    offensive: 'Of',
    defensive: 'Def',
    gk: 'GK',
    all: 'Hepsi',
    physical: 'Fiziksel',
    arrigo: 'Arrigo',
    yearTooltip: 'Sadece bir yıl izin verilir',
    expectedThreat: 'xTehdit',
    expectedThreatTooltip: 'tüm topla oynama oranlarına tehdit eklendi',
    expectedThreatOP: 'xTehlike OP',
    expectedThreatOPTooltip: 'Akan oyun topla oynama oranlarına tehdit eklendi',
    expectedThreatInTeam: 'xtehdit takımda %',
    expectedThreatInTeamTooltip: ' tehdit oranı Oyuncu tarafından takıma eklendi',
    ballProgression: 'Top İlerlemesi',
    ballProgressionTooltip: '+10 metre ilerleme',
    deepProgression: 'Derin İlerleme',
    deepProgressionTooltip: 'Son beşte topla ilerleme',
    ballRetention: '% Top Tutma',
    ballRetentionTooltip: ' Topun Başarıyla Tutulduğu Aksiyonların Yüzdesi ',
    ballRetentionOppHalf: '% Top Tutma OH',
    ballRetentionOppHalfExplicit: ' Topa sahip olduğunuz ve rakibin sahasında kaybetmediğiniz sürenin yüzdesi ',
    finishing: 'Bitiricilik',
    finishingTooltip: 'Gol olarak biten şutların oranı',
    scoringContribution: 'Skor katkısı',
    scoringContributionTooltip: 'Assist + Goller',
    xgPerShot: 'xG şut başına',
    xgPerGoal: 'xG gol başına',
    headerPerCross: 'Koşu başına Kafa vuruşu',
    completedCrosses: 'Tamamlanan Koşular',
    crossingPct: '% Koşular',
    crossingEfficiency: 'Koşu Verimliliği',
    crossingEfficiencyTooltip: ' Geçiş Verimliliği (Kalite ve Miktarı Ölçer)',
    longBalls: 'Uzun Toplar',
    longPassing: '% Uzun Top',
    dribblingPct: '% Dripling',
    throughBalls: 'Dikine Toplar',
    oppBoxTouches: 'Rakip Ceza sahasında topa dokunuş',
    oppBoxTouchesTooltip: ' Rakip Ceza sahasında topa dokunuş ',
    openPlayKeyPasses: 'OP Kilit Paslar',
    openPlayKeyPassesTooltip: 'Şutla biten Akan Oyun Pasları',
    xGBuildup: 'xG Yüklemesi',
    xGBuildupTooltip: 'xG oyuncunun dahil olduğu şutla biten dizilerin (xG Şut ve Kilit hariç)',
    Assists: 'Asistler',
    passPercentage: '% Paslar',
    passPerLongBall: 'LB başına Pas',
    passPerLongBallExplicit: 'Uzun Top başına Pas',
    nonPenaltyGoals: 'Penaltıdan Atılmayan Goller',
    xG: 'xG',
    xGExplicit: 'Beklenen Goller',
    shots: 'Şutlar',
    xGShot: 'şut başsına xG',
    xGChain: 'xG Zincir',
    xGChainTooltip: ' Oyuncunun dahil olduğu şutlarla biten sekansların xG\'si ',
    chancesCreated: 'Şutla biten paslar',
    chances: 'Şanslar',
    dribbles: 'Driplingler',
    dribblesSuccessfull: 'Başarılı driplingler',
    touches: 'Rakip Takım Ceza Sahasında Dokunuşlar',
    xA: 'xA',
    xAExplicit: 'Beklenen Asistler',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Akan oyunda Beklenen Asistler',
    passesOpponentBox: ' Rakip Takım Ceza Sahasında Paslar ',
    passesOB: 'OB’de paslar',
    passesFinalThirdTooltip: ' Ceza Sahası Çizgisine Yakın alanda Paslar ',
    passesSuccessful: 'Başarılı Paslar.',
    passesSuccessfulTooltip: ' Başarılı Paslar ',
    ballProgressionPassing: 'Pas tarafından BP',
    ballProgressionPassingTooltip: 'Pas tarafından Topa Sahip Olma',
    ballProgressionDribbling: 'Top taşımayla BP',
    ballProgressionDribblingTooltip: 'Top taşımayla topa sahip olma',
    passesTotal: 'Paslar',
    passesTotalTooltip: 'Toplam Pas denemeleri',
    shortPassesSuccessful: 'Başarılı SP',
    shortPassesSuccessfulTooltip: 'Tamamlanan kısa pas sayıları',
    shortPassesTotal: 'Toplam SP',
    shortPassesTotalTooltip: 'Denenen Kısa Pas Sayıları',
    tackles: 'Müdaheleler *',
    adjustedTackles: ' Topa Sahip Olmaya Ayarlanan Müdahaleler ',
    interceptions: 'Araya girmeler*',
    adjustedInterceptions: 'Topa Sahip olmaya Ayarlanan Araya Girmeler',
    aerials: 'Hava topları',
    aerialsPercent: '% Hava Topları',
    aerialEfficiency: 'Hava Toplarında Verimlilik',
    aerialEfficiencyTooltip: ' Hava Toplarında Verimlilik (Kalite ve Miktarı Ölçer)',
    twd: 'TwD',
    tacklesWasDribbled: 'Kazanılan 1\'e 1 Savunma Mücadeleleri',
    fouls: 'Fouller',
    indPressure: 'Bireysel Baskı',
    pressure: 'Baskı',
    dispossessed: 'El konulmuş',
    recoveries: 'Geri Kazanımlar',
    primary: 'Birincil',
    secondary: 'İkincil',
    position: 'Pozisyon',
    nationality: 'Uyruk',
    height: 'Boy (cm)',
    minHeight: 'Min. Boy',
    maxHeight: 'Max. Boy',
    age: 'Yaş',
    minAge: 'Min. Yaş',
    maxAge: 'Max. Yaş',
    games: 'Oyunlar',
    minGames: 'Min. Oyunlar',
    maxGames: 'Max. Oyunlar',
    minutes: 'Dakikalar',
    minMinutes: 'Min. Dakikalar',
    maxMinutes: 'Max. Dakikalar',
    minPercentMinutes: 'Min. Yüzde dakikalar',
    dates: 'Tarihler',
    marketValue: '(€) Piyasa Değeri',
    teams: 'Takımlar',
    contractEnd: 'Sözleşme Sonu',
    minValue: 'Min. Değer',
    maxValue: 'Max. Değer',
    excludeTeams: 'Takımları Çıkar',
    recentSearches: 'Yakın Aramalar',
    saveSearch: 'Aramayı Kaydet',
    loadSearch: 'Aramayı Yükle',
    loadCollection: 'Koleksiyonu yükle',
    collection: 'Koleksiyon',
    search: 'Arama',
    searchesList: 'Arama Listesi',
    mySearches: 'Aramalarım',
    mySearchesDescription: 'Daha önceden kaydettiğin',
    recentSearchesDescription: 'Yaptığın son 10 arama',
    searchToLoad: 'Yüklemek için Ara',
    recentSearch: 'Yakın Aramalar',
    saveSearchSuccess: 'Arama başarıyla kaydedildi',
    removeSearch: 'Aramayı Sil',
    removeSearchMessage: 'Bu aramayı silmek istediğine emin misin? ?',
    updateSearch: 'Aramayı güncelle',
    updateSearchMessage: 'Aramayı güncellemek istediğinizden emin misiniz?',
    deleteSearchSuccess: 'Arama silinmiştir',
    playersFound: 'Bulunan oyuncular',
    addToCollection: 'Koleksiyona Ekle',
    npg: 'NPG',
    goals: 'Goller',
    value: 'Değer',
    nationalTeams: 'Milli Takımlar',
    gbeScore: 'GBE',
    dlIndex: 'Skor',
    minGbe: 'Min. GBE',
    goalsConceded: 'Yenilen Goller',
    npgConceded: 'NPG Yenlien',
    npgConcededTooltip: 'Penaltısız yenilen Goller',
    xGOTConceded: 'xG İsabetli yenilenler',
    xGOTConcededTooltip: 'İsabetli şutların xG’si',
    goalsPrevented: 'Engellenen Goller',
    xGFacedPerShotOnTarget: 'şut başına xGOT',
    xGFacedPerShotOnTargetTooltip: 'Yenilen şut başına isabetli xG',
    xGSavedPerxGFacedOnTarget: 'xG Kurtarışları',
    xGSavedPerxGFacedOnTargetTooltip: 'xG’yi hesaba katan Kurtarış Yüzdesi',
    savesPct: '% Kurtarış',
    savesOutOfBoxPct: '% Ceza Sahası dışından kurtarış',
    savesInBoxPct: '% Ceza Sahası içinden kurtarış ',
    xGFacedPerGoal: 'Gol başına yüzleşilen xG ',
    xGFacedPerGoalTooltip: 'Gol atmak için gereken xG ',
    catchingPct: '% Yakalanan',
    catchingTooltip: 'Yakalanan kurtarışların yüzdesi',
    passingOwnHalfPct: '% kendi Sahasında Paslaşma',
    passingOwnHalfPctTooltip: 'Kendi sahasında yaptığı isabetli paslaşmaların yüzdesi',
    passingOppHalfPct: '% Rakip takım sahasında paslaşma',
    passingOppHalfPctTooltip: ' Rakip takım sahasında başarılı paslaşma oranı',
    passingContribution: '% Pas Desteği',
    passingContributionTooltip: 'Pas yaparak Tehdite destek sağlamak – Ortalamanın üstünde',
    shotsPerGoal: 'Gol başına şut',
    passesFinalThird: 'Ceza Sahası Çizgisine Yakın alanda Paslar',
    passingFinalThird: '% Ceza Sahası Çizgisine Yakın alanda Paslaşma',
    claimAccuracy: 'Topu kapma oranı',
    claimAccuracyTooltip: 'Toplar ortalamanın üstünde kapıldı',
    highTurnovers: 'Yüksek Top kayıpları',
    highTurnoversTooltip: 'Hedefe 40 metreden daha yakın top kayıpları',
    shotEndingHighTurnovers: 'HT ile biten Şutlar',
    shotEndingHighTurnoversTooltip: 'Yüksek top kayıplarını bitiren Şutlar',
    goalEndingHighTurnovers: 'HT bitiren şutlar',
    goalEndingHighTurnoversTooltip: 'Yüksek Top kaybı bitiren Goller',
    avgCarriesProgress: 'Ortalama İlerleme',
    avgCarriesProgressTooltip: ' Topu dikey olarak hareket ettiren ortalama mesafe (metre)',
    carriesChance: 'Şans Bitiş',
    carriesChanceTooltip: 'Kilit Pasla Biten Top Sürme',
    carriesAssist: 'Assist sonlandıran',
    carriesAssistTooltip: 'Asistle Biten Top Sürme ',
    carriesShot: 'Şut sonlandıran',
    carriesShotTooltip: ' Şutla Biten Top Sürme ',
    carriesGoal: 'Gol sonlandıan',
    carriesGoalTooltip: ' Golle Biten Top Sürme ',
    shotEndingSequence: ' Şut sonlandıran ',
    shotEndingSequenceTooltip: ' Oyuncunun dahil olduğu bir Şutla biten sekansların Sayısı',
    goalEndingSequence: 'Gol Sonlandıran',
    goalEndingSequenceTooltip: 'Oyuncunun dahil olduğu bir Golle biten Dizilerin Sayısı',
    gbeScoreTooltip: ' FA Football\'un Yönetim Organı Onayı ',
    goalsPreventedTooltip: ' Kaleci tarafından kurtarılan Penaltı Olmayan Goller (xG yenilen- NPG Yenildi)',
    freePlayers: 'Boş Oyuncular',
    index: 'Index',
    playerName: 'İsim',
    teamName: 'Takım',
    secondPos: 'İkinci Sıra',
    side: 'Taraf',
    onlyOnLoan: 'Sadece kiralık',
    dob: 'Doğum Yılı',
    countryName: 'Ülke',
    secondCountryName: 'İkinci Ülke',
    seasonYear: 'Sezon',
    assists: 'Assist',
    placeholder: 'Lig Filtreleri ekleyerek Başlayabilirsin.',
    placeholder2: 'Sonuçları göstermek için arama düğmesine tıklayın',
    passesPct: '% Paslar',
    passingPct: '% Paslar',
    oppBoxPasses: 'Rakip Ceza Sahasında Paslar',
    adjustedClearances: ' Düzenlenmiş Top Uzaklaştırmalar',
    aerialsPct: '% Hava Topları',
    leagueCountryCode: 'Lig Ülke Kodu',
    shooting: '% İsabetli Şut',
    xtPassing: 'xT Paslaşma',
    xtPassingTooltip: 'Paslaşmayla eklenen tehlikeler',
    xtDribbling: 'xT Top Sürme',
    xtDribblingTooltip: 'Top sürmeyle eklenen tehlikeler',
    foot: 'Güçlü Ayak',
    aggressiveActions: 'Agresif Aksiyonlar',
    aggressiveActionsTooltip: ' Topu kaybettikten sonraki iki saniye içinde denenen müdahale sayısı ',
    tacklesAttempted: 'Denenen müdaheleler',
    highDefensiveActionPct: '% HD Aksiyonları',
    highDefensiveActionPctTooltip: ' Rakip kaleye 40 metre yakın yapılan Savunma Hareketlerinin Yüzdesi ',
    individualPressureOppHalf: 'Rakip Takim sahasında baskıu',
    individualPressureOppHalfTooltip: ' Rakip yarıda rakibe baskı yapan bir oyuncunun başarılı çabalarının (geri alınan topa sahip olma) sayısını ölçen metrik',
    xGBuildUp5Pass: 'xG Geliştirme 5p',
    xGBuildUp5PassTooltip: ' Bir oyuncunun yer aldığı xG miktarı, yalnızca son 5 pas (şut ve şutla sonuçlanan paslar hariç))',
    chancesCreatedOpenPlay: 'Yaratılan Şanslar OP',
    chancesCreatedOpenPlayTooltip: 'Açık oyunda şuta dönüşen pas Sayısı',
    fmf: {
      Defender: 'Savunmacı',
      aerial: 'Hava Topu',
      goodDefender: 'İyi Savunmacı',
      goodPresence: 'İyi Pozisyon Alma',
      playmaking: 'Oyun Kurma',
      Fullback: 'Bek',
      defensiveness: 'Defansifliği',
      offensiveness: 'Ofansifliği',
      fast: 'Hızlı',
      Forward: 'Forvet',
      goalChances: 'Gol Şansları',
      goodDecissions: 'İyi kararlar',
      individualTechnique: 'Bireysel Teknik',
      Goalkeeper: 'Kaleci',
      footWork: 'Ayak Oyunu',
      leadership: 'Liderlik',
      Midfielder: 'Defensif Orta Saha',
      balance: 'Denge',
      ballRetention: '% Top tutma',
      offensivePasses: 'Offensif Paslar',
      recoveries: 'Topu Kurtarma',
      shotToGoal: 'Gol Şutu',
      'Attacking-Midfielder': 'Ofansif Orta Saha',
      defensiveGame: 'Defansif Oyun',
      offensiveGame: 'Ofansif Oyun',
      Winger: 'Kanat',
      crossing: 'Koşu',
      deepProgressions: 'Derin İlerleme',
      defendingEffort: 'Savunma eforu',
      facing: 'Yüzleşme'
    },
    yellowCards: 'Sarı Kartlar',
    redCards: 'Kırmızı Kartlar',
    alert: 'Alert',
    yearOfBirth: 'Doğum yılı',
    minYearOfBirth: 'Minimum doğum yılı',
    maxYearOfBirth: 'Maksimum doğum yılı',
    women: 'Kadınlar',
    continental: 'Kıtasal',
    countryCup: 'Ülke Kupası',
    statsName: 'İstatistik adı',
    abbreviation: 'Kısaltma',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Yalnızca oynanan son normal sezon gösteriliyor',
    gamesWith60PlusMinsTooltip: '60 dakikadan fazla oynanan minimum oyun sayısı',
    starts: 'Başlangıçlar',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: '5 oyuncuya kadar karşılaştır',
    requestReport: 'Rapor Talep Et',
    searchBarPlaceholder: 'Oyuncu veya takım ara',
    allStats: 'Tüm İstatislikler',
    placeholder: 'Bazı Oyuncular eklemeye başlayabilirsin'
  },
  reports: {
    detailedInsights: 'Detaylı analiz edin',
    features: 'Raporun İçerikleri',
    performance: 'Performans',
    evolution: 'Gelişim',
    compareWithMyTeam: 'Takımımla birlikte karşılaştır',
    similarPlayers: 'Benzer Oyuncular',
    potentialTeams: 'Potansiyel Takımlar',
    requestSuccess: 'Talep Başarıyla Gönderildi',
    requestAt: 'Talep Edildi',
    reportConversation: 'Rapor Görüşmesi',
    writeYourMessage: 'Mesajını yaz….',
    you: 'Sen'
  },
  state: {
    requested: 'Talep Edildi',
    inProgress: 'İşlemde',
    delivered: 'İletildi'
  },
  langs: {
    es: 'İspanyolca',
    en: 'İngilizce',
    fr: 'Fransızca',
    de: 'Almanca',
    it: 'İtalyanca',
    pt: 'Portekizce',
    tr: 'Türkçe',
    jp: 'Japonca',
    cn: 'Çince',
    sa: 'Arap',
    nl: 'Hollandalı',
    pl: 'Lehçe',
    sv: 'İsveççe',
    cs: 'Çekçe',
    ko: 'Korece',
    hu: 'Macarca',
    ru: 'Rusca'
  },
  langsArea: {
    europe: 'Avrupa',
    asia: 'Asya',
    arabic: 'Arapça'
  },
  inbox: {
    subtitle: 'Güncel Kal',
    new_injury_alert: 'Yeni Sakatlık Bildirimi',
    new_contract_alert: 'Yeni Kontrat Bildirimi',
    new_team_alert: 'Yeni imza uyarısı',
    new_marketValue_alert: 'Yeni Piyasa Değeri Bildirimi',
    new_game_alert: 'Yeni Oyun Oynandı Uyarısı',
    receive_mail: 'E-posta alma',
    receive_mail_subtitle: 'Filtrelere uyan oyuncularla günlük e-posta alın',
    receive_notifications: 'Bildirimler',
    receive_notifications_subtitle: 'Filtreden geçen oyuncularla birlikte uygulamada bildirimler alın',
    changedTo: '’’na değiştirildi',
    alerts: 'Bildirimler',
    includedIn: 'içinde eklendi',
    noContract: 'Sözleşme Olmayan',
    newMessages: 'Yeni Mesajlar',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder: 'The user will receive the reply along with the status update'
    }
  },
  gameAnalysis: {
    subtitle: 'Son maçlardan bilgi al',
    subtitle2: '7 gün içerisindeki maçları göster',
    subtitle3: 'Son maçlardan içgörüler edinin ve sıradakileri keşfedin',
    seeDetail: 'Detayları Gör'
  },
  statsNaming: {
    Possession: 'Topa Sahip Olma Oranı',
    TimePossession: 'Topa Sahip Olma Süresi',
    PassesPerShots: 'Şut başına Paslar',
    PPDA: 'PPDA',
    ExpectedPoints: 'Beklenen Puanlar',
    Points: 'Puanlar',
    Directness: 'Doğrudanlık',
    PassesPerLongBall: 'Uzun top başına Paslar',
    CrossingPerXG: 'xG başına Koşular',
    PenaltySavedPenaltyFaced: 'Kurtarılan Penaltı/Penaltı Atışı',
    Goals: 'Goller',
    PenaltyShots: 'Penaltı vuruşları',
    PenaltyGoals: 'Penaltı golleri',
    NonPenaltyGoals: 'Penaltısız Goller',
    NPGOpenPlay: 'PHG Akan Oyun',
    NPGSetPiece: 'PHG Duran Top',
    Shooting: 'Şut Çekme',
    Finishing: 'Bitiricilik',
    xGEfficiency: 'xG Verimi',
    HeaderPerShot: 'Şut başına Kafa Vuruşu',
    HeaderPerCross: 'Koşu başına Kafa Vuruşu',
    HeadedGoals: 'Başlı Hedefler',
    GoalsConceded: 'Yenilen Goller',
    SavesInBox: 'Kutuya Kaydedilir',
    SavesOutBox: 'Kutunun Dışında Kaydeder',
    Assists: 'Assistler',
    ThroughBalls: 'Dikine Toplar',
    CrossEfficiency: 'Koşu Verimi',
    ScoringContribution: 'Skor Katkısı',
    xAssistsOpenPlay: 'xAssists Akan Oyun',
    xAssistsSetPiece: 'xAssists Duran Top',
    xAssistsOpenPlayInTeam: 'Takımda xAssists Akan Oyun',
    xAssistsSetPieceInTeam: 'Takımda xAssists Duran Top',
    xGBuildupFinalThird: 'xG Ceza sahası çizgisine yakın geliştirme',
    xGChainFinalThird: 'xG Ceza sahası çizgisine yakın zincir',
    BallProgressionPassing: 'Pas başına Topla ilerleme',
    BallProgressionDribbling: 'Taşıma başına Topla ilerleme',
    TacklesWasDribbled: 'Kazanılan 1\'e 1 Savunma Mücadeleleri',
    TacklesSuccessful: 'Başarılı mücadeleler',
    Interceptions: 'Araya Girmeler',
    Clearances: 'Kurtarışlar',
    Fouls: 'Fouller',
    Recoveries: 'Kurtarmalar',
    Shots: 'Şutlar',
    ShotsPerGoal: 'Gol başına Şutlar',
    ShortPassesSuccessful: 'Başarılı Kısa Paslar',
    PassingSuccessForwardPct: 'İleriye Atılan Pas Başarısının %’si',
    PassingSuccessBackwardPct: 'Geriye Atılan Pas Başarısının %’si',
    PassingForwardBackwardPct: '% Passing Forward per Backward',
    LongBallPerPassesPct: 'Pas Başına Atılan Uzun Top %’si ',
    LongBallReceived: 'Yenilen Uzun Toplar',
    LongBallReceivedOppHalf: 'Rakip Ceza Sahasında\'Alınan Uzun Toplar\'',
    OffensiveActions: 'Ofansif Aksiyonlar',
    DribblesAttempted: 'Dripling Denemeleri',
    SuccessfulDribblesPct: 'Başarılı Dripling %’si',
    OffensiveTouchesOutBoxPct: 'Ceza sahası dışında ofansif müdaheleler %’si',
    BallRetention: 'Top tutma %’si',
    PassingPct: 'Pas %’si',
    PassingOwnHalfPct: 'Kendi sahasında Pas %’si',
    PassingOppHalfPct: 'Rakip sahada Pas %’si',
    PassingFinalThird: 'Ceza Sahası Çizgisine yakın atılan Pas',
    PassesFinalThirdTotal: 'Toplam Geçiş Sonu ⅓',
    PassingFinalThirdPct: 'Ceza Sahası Çizgisine yakın atılan Pas\' %’si',
    LongBallSuccessful: 'Tamamlanan Uzun Toplar',
    LongBallPct: 'Uzun Top %’si',
    LongBallTotal: 'Toplam Uzun Toplar',
    SavesPct: 'Kurtarış %’si’',
    SavesInBoxPct: 'Ceza Sahası içerisinde Kurtarış %’si’',
    SavesOutOfBoxPct: 'Ceza Sahası Dışından Kurtarış %’si’',
    xGSavedPerXGFacedOnTarget: 'xG Kurtarılan/xG İsabetli Şut',
    xGFacedOnTargetPerGoalReceived: 'Gol Başına gelen xG',
    xGFacedOnTargetEfficiency: 'Engellenen Goller',
    xGFacedOnTarget: 'xG İsabetli Şut',
    IndividualPressure: 'Bireysel Baskı',
    AerialEfficiency: 'Hava Topları Verimliliği',
    AerialWins: 'Hava Topu Kazanma',
    AerialWinsPct: 'Hava Topu Kazanma %’si',
    xG: 'Beklenen Goller',
    xGDiff: 'xG Farkı',
    xGOpenPlay: 'xG Açık Oynatma',
    xGSetPiece: 'xG Duran Top',
    xGPerShot: 'şut başına xG ',
    ChancesCreated: 'Yaratılan Şanslar',
    CompletedCrosses: 'Tamamlanan Şutlar',
    Crossing: 'Koşu %’si',
    OpenPlayKeyPasses: 'Akan Oyun Kilit Paslar',
    OpenPlayKeyPassesInTeam: 'Takımda Akan Oyun Kilit Paslar %’si',
    OpenPlayPassesIntoOpponentBox: 'Rakip Takım Ceza Sahasına Atılan Açık Oyun Pasları',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Rakip Takım Ceza Sahasına Atılan Açık Oyun Pasları',
    xAssists: 'Beklenen Asistler',
    xGChain: 'xG zincir',
    xGBuildup: 'xG Geliştirme',
    xGBuildupInTeam: 'xG Geliştirme in Team',
    BallProgression: 'Topla ilerleme',
    SuccessfulDribbles: 'Başarılı Driplingler',
    Dispossessed: 'Kaybedilen',
    TouchesInOpponentBox: 'Rakip Ceza Sahasında Müdaheleler',
    xGSavedPerShot: 'Şut başına Kurtarılan xG ',
    BallRetentionOppHalf: 'Rakip Yarı Sahasında Top Kapma %’si ',
    DeepProgression: 'Derin İlerleme',
    DeepProgressionFinalThird: 'Ceza Sahası Çizgisine yakın Derin İlerleme',
    FoulsTaken: 'Maruz Kalınan Fauller',
    PenaltiesTaken: 'Atılan Penaltılar',
    BlockedCrosses: 'Engellenen Koşular',
    BlockedShots: 'Engellenen Şutlar',
    Blocks: 'Engellemeler',
    NonPenaltyGoalsAgainst: 'Yenilen Penaltısız Goller',
    Headers: 'Kafa Topları',
    AveragePassDistance: 'Ortalama Pas Mesafesi',
    ProgressiveRuns: 'İlerme Sağlanan KOşular',
    xT: 'Beklenen Tehdit (xT)',
    xTOpenPlay: 'xT Akan Oyun',
    xTSetPiece: 'xT Duran Top',
    xGOT: 'Beklenen İsabetli Şutlar',
    BadActions: 'Hatalı Hareketler',
    BadActionsOwnHalf: 'Kendi Sahasında Hatalı Hareketler',
    AerialsWonOwnBox: 'Kendi Ceza Sahasında Kazanılan Hava Topları',
    AerialsWonOppBox: 'Rakip Ceza Sahasında Kazanılan Hava Toplar',
    AerialsTotalOppBox: 'Rakip Ceza Sahasında Kazanılan Toplam Hava Topları',
    AerialsTotalOwnBox: 'Kendi Ceza Sahasında Kazanılan Hava Topları',
    FoulsOwnHalfPct: 'Kendi Yarı Sahasında Yapılan Faul %’si',
    RecoveriesOppHalf: 'Rakip Ceza Sahasında Top Kapma',
    DuelsPct: 'Başarılı Müdaheleler %’si ',
    TacklesUnsuccessful: 'Başarısız mücadeleler',
    TacklesWasDribbledFirstThird: 'Ceza Sahası Çizgisine Yakın yerlerde Driplinglenen Müdaheleler ',
    TacklesWasDribbledSecondThird: 'Kazanılan 1\'e 1 Savunma Mücadeleleri ⅔',
    TacklesWasDribbledFinalThird: 'Kazanılan 1\'e 1 Savunma Mücadeleleri Topla ⅓',
    BallProgressionFinalThird: ' Ceza Sahası Çizgisine Yakın yerlerde Topla İlerleme',
    DuelsTotal: 'İkili Mücadeleler',
    QuickRecoveries: 'Hızlı Top Çalma',
    ShotsPerNPG: 'NPG başına Şut',
    ShotsOutBox: 'Ceza Sahası Dışından Şut',
    GoalsOutBox: 'Ceza Sahası Dışından Gol',
    ShootingOutBox: 'Ceza Sahası Dışından atılan Şut %’si ',
    HandPassing: 'Elle Atılan Pas %’si',
    Catching: 'Yakalama %’si',
    Caught: 'Yakalanan Kurtarışlar',
    ClaimAccuracy: 'Topu Kapma Oranı',
    HighTurnovers: 'Yüksek Top Kayıpları',
    ShotEndingHighTurnovers: ' Yüksek Top Kaybını sonlandıran Şut',
    GoalEndingHighTurnovers: ' Yüksek Top Kaybını sonlandıran Gol ',
    AverageCarriesProgress: 'Ortalama Topu Taşıma Başarısı',
    ChanceEndingCarries: 'Topu Taşımayı sonlandıran Şanslar',
    AssistEndingCarries: 'Topu taşımayı sonlandıran Asist',
    ShotEndingCarries: ' Topu taşımayı sonlandıran Şut',
    GoalEndingCarries: ' Topu taşımayı sonlandıran Gol',
    ShotEndingSequence: 'Sekansı sonlandıran Şut',
    GoalEndingSequence: 'Sekansı sonlandıran Gol',
    xGPerNPG: 'NPG başına xG',
    AerialWonOffensive: 'Kazanılan Ofansif Hava Topları',
    AerialWonDefensive: 'Kazanılan Defansif Hava Topları',
    xGAgainst: 'Kazanılan xG ',
    xGDiffAgainst: 'Kazanılan Farkı xG',
    xGPerNPGAgainst: 'Kazanılan NPG başına xG',
    xGSetPieceAgainst: 'Kazanılan Duran Top başına xG',
    xGOpenPlayAgainst: 'Kazanılan Akan Oyun xG',
    xGPerShotAgainst: 'Yenilen Şut başına xG',
    ShotsAgainst: 'Yenilen Şut',
    ShotsOnTargetAgainst: 'Hedefe isabet eden şutlar',
    ShotsOnTargetInBoxAgainst: 'Ceza Alanı İçinde Kaleyi Bulan Şutlar Yenildi',
    ShotsOnTargetOutBoxAgainst: 'Ceza Alanı Dışından Hedefe Yönelik Şutlar Yenildi',
    RivalPossession: 'Rakip Topa Sahip Olma',
    AerialDefensivePct: 'Savunma Hava Topu %’si ',
    HighRecoveries: 'Yüksek Top Kazanma',
    HighDefensiveActions: 'Yüksek Defansif Aksiyon',
    HighDefensiveActionPct: 'Yüksek Defansif Aksiyon %’si ',
    HighDefensiveDistance: 'Yüksek Defansif Mesafe',
    PassesPerPossession: 'Topa Sahip Olma başına Paslar',
    LengthPerPossession: 'Topa Sahip Olma başına Mesafe',
    xTNet: 'Net xT',
    AvgCarriesDistance: 'Ortalama Top Taşıma Mesafesi',
    PassesForwardPct: 'İleriye Atılan Pas %’si ',
    PassesForwardSuccessful: 'Başarılı İleri Geçişler',
    PassesForwardTotal: 'Toplam İleri Paslar',
    TacklesAttempted: 'Müdahele Denemesi',
    DuelsLost: 'Kaybedilen İkili Mücadeleler',
    Carries: 'Top Taşıma',
    CarriesPct: '% Top Taşıma',
    Aerials: 'Hava Topları',
    ProgressivePassesReceivedIntoBox: 'Ceza Sahası içine gelen ilerleyen Paslar',
    PassesOppHalf: 'Rakip Yarı Sahada Yapılan Paslar',
    ShotsOnTarget: 'İsabetli Şutlar',
    AggressiveActions: 'Aggresif Aksiyonlar',
    Crosses: 'Koşular',
    xGBuildup5pass: 'xGGeliştiem 5 tane Pasl',
    SpeedSequence: 'Sekansın Hızı',
    Touches: 'Müdaheleler',
    AerialsTotalOppHalf: 'Rakip Yarı Sahasında Toplam Hava Topu',
    AerialsWonOppHalf: 'Antenler Rakip Kazandı. Yarım',
    AerialsWonOppHalfPct: 'Rakip Yarı Sahasında kazanılan Hava Topu %’si ',
    AerialsPctOppBox: 'Rakip Ceza Sahasında kazanılan Hava Topu %’si ',
    AerialsPctOwnBox: 'Kendi Ceza Sahasında kazanılan Hava Topu %’si ',
    AerialDefensive: 'Savunma Hava Düelloları',
    AerialOffensive: 'Saldırgan Hava Düelloları',
    AerialOffensivePct: '% Saldırgan Hava Düelloları',
    IndividualPressureOppHalf: 'Rakip Yarı sahasında Bireysel Baskı',
    ChancesCreatedOP: 'Akan oyunda yaratılan Şanslar',
    TouchesPerShot: 'Şut başına Müdahele',
    PassesFinalThirdTotalPct: 'Ceza sahası Çizgisine yakın atılan pasların %’si',
    xACrosses: 'Koşulardan xA',
    Passes: 'Paslar',
    PassesSuccessful: 'Başarılı Paslar',
    TacklesWasDribbledFouls: 'Yer Düelloları %',
    OffsidesCaught: 'Yakalanılan Ofsaytlar',
    ProgressivePassesReceivedFinalThird: ' Ceza sahası Çizgisine yakın alınan Paslar',
    ProgressivePassesReceived: 'Alınan İlerleyici Paslar',
    Breadth: 'Uzaklık',
    DuelsDefTotal: 'Defansif ikili mücadeleler',
    DefensiveActions: 'Defansif Aksiyonlar',
    ProgressivePassesReceivedOppHalf: 'Rakip Yarı Sahasında alınan İlerleyici Paslar',
    CompletedCrossesOP: 'Akan oyunda tamamlanan koşular',
    CrossingOP: 'Akan Oyunda koşu %’si ',
    CrossesOP: 'Toplam Ortalar Açık Oyun',
    PassingContribution: 'Pas Katkısı %’si',
    BallProgressionOppHalfInTeam: 'Takımda Rakip Yarı sahasında Pas Katkısı %’si ',
    PassesOPIntoBoxInTeam: 'Takımda Akan Oyunda ceza sahasına atılan pas %’si',
    TouchesOppBoxInTeam: 'Takımda Rakip ceza sahasında yapılan müdahele %’ ',
    xGOPInTeam: 'Takımda Açık Oyun xG %’si',
    DeepPasses: 'Derin Paslar',
    DeepPassesTotal: 'Derin Geçişler',
    DefensiveDuelsPct: 'Defansif İkili Mücadeleler %’si ',
    DefensiveDistance: 'Defansif Mesafe',
    QuickRecoveriesPct: 'Hızlı Top Kazanımlar %’si ',
    DiffDefensiveDistanceTeam: 'Takım Defansıf Mesafe Farkı',
    xTPassing: 'xT Pas',
    xTPassing100Passes: '100 Pas Yapma xT ',
    ProgressivePassesAccurate: 'İlerleyici Paslar',
    PassAbility: 'Pas Yeteneği',
    OPPassesIntoOppBoxPct: 'Rakip Ceza Sahasına doğru Akan Oyunda yapılan Pas %’si ',
    EntriesOppBox: 'Rakip Ceza Sahasına Girişler',
    Crosses6yardBox: 'Gol Çizgisine yapılan Koşular',
    Cutbacks: 'Kesmeler',
    xTDribbling: 'xT Dripling',
    AvgShotDistance: 'Ortalama Şut Mesafesi',
    xGOnTarget: 'İsabetli xG t',
    FinishingxGOT: 'Bitiricilik xGOT',
    DribblesWonOwnHalf: 'Kendi Yarı sahasında kazanılan Driplingler',
    DribblesOwnHalf: 'Kendi Yarı sahasında Dripling',
    DribblesOwnHalfPct: 'Kendi Yarı sahasında Dripling %’si ',
    DribblesWonOppHalf: 'Rakip Yarı sahasında kazanılan driplingler',
    DribblesOppHalf: 'Rakip Yarı Sahasında Dripling',
    DribblesOppHalfPct: '% Rakip yarı sahada dripling',
    DribblesWonFinalThird: 'Sahanın son üçte birlik bölümünde başarılı dripling',
    DribblesFinalThird: 'Sahanın son üçte birlik bölümünde dripling',
    DribblesFinalThirdPct: '% Sahanın son üçte birlik bölümünde dripling',
    ShotEndingHighRecoveries: 'Şutla sonuçlanan yüksek toplar',
    PassingFinalThirdAgainst: 'Son 1/3\'e yapılan paslar (rakip)',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Ceza sahasına açık oyunda gelen toplam pas (rakip)',
    EntriesOppBoxAgainst: 'Ceza sahasına girişler (rakip)',
    DeepProgressionAgainst: 'Yenilen derin ilerlemeler',
    TouchesInOpponentBoxAgainst: 'Ceza sahasında rakip temasları',
    Score: 'Skor',
    PDScore: 'Fiziksel Puan',
    OrlegiScore: 'Skor Orlegi',
    SirScore: 'Sirius Skor',
    ExcScore: 'Excelsior Skor',
    xTOPInTeam: 'Takımda xT Akan Oyun',
    YellowCards: 'Sarı Kartlar',
    RedCards: 'Kırmızı Kartlar',
    xTOpenPlayAgainst: 'Kazanılan xT Akan Oyun',
    xTSetPieceAgainst: 'Kazanılan xT Duran Top',
    NPGOpenPlayAgainst: 'Kazanılan PHG Akan Oyun',
    NPGSetPieceAgainst: 'Kazanılan PHG Duran Top',
    PassesOppHalfPerPossession: 'Topa Sahip Olma Başına Pas Rakip Yarı',
    AverageTimeRecovery: 'Ortalama Kurtarma Süresi',
    ExpectedPassing: '% Beklenen Pas Geçme',
    NumPossession10Passes: 'Possessions 10 Passes',
    PassesReceived: 'Alınan Geçişler',
    PassesReceivedFinalThird: 'Passes Received Final ⅓',
    ProgressivePassesTotalPct: '% Aşamalı Geçişler',
    ShortPassesPct: 'Kısa Paslar %',
    TouchesOppBoxOppTeam: 'Sahadayken Takımın Ceza Sahasında Rakip Temasları',
    ShotsOnTargetOppTeam: 'Sahadayken Kaleye Gelen İsabetli Şutlar',
    NPGOppTeam: 'Sahadayken Rakibin Penaltı Hariç xG Değeri',
    ShotsOpenPlay: 'Açık oyun şutları',
    xGSetPiecePerxG: 'Duran top xG\'si / xG',
    ShotsOpenPlayAgainst: 'Açık oyunda karşılaşılan şutlar',
    ShotsFromDribble: 'Dripling Sonrası Şutlar',
    GoalsFromDribble: 'Dripling Sonrası Goller',
    PassesIntoFinalThird: 'Son Üçe Yapılan Paslar',
    PassesIntoFinalThirdTotal: 'Toplam Son Üçüncüye Geçişler',
    PassesInsideFinalThird: 'Son Üçteki Paslar',
    PassesInsideFinalThirdTotal: 'Finaldeki Toplam Geçiş Sayısı ⅓',
    PassesFinalThirdNoArea: 'Son Üçüncüyü Geçti (Kutusuz)',
    PassesIntoOppBox: 'Rakip Ceza Sahasına Paslar',
    CarriesFinalThird: 'Son Üçe Top Sürmeler',
    CarriesInsideFinalThird: 'Son Üçteki Top Sürmeler',
    CarriesFinalThirdNoBox: 'Son Üçüncüyü Taşıyor (Kutusuz)',
    CarriesIntoOppBox: 'Rakip Ceza Sahasına Top Sürmeler',
    TimePossessionAgainst: 'Rakip Topla Oynama Süresi',
    TimePossessionTotal: 'Toplam Topla Oynama Süresi',
    PassesInBox: 'Kendi Ceza Sahasındaki Paslar',
    LongThrowInSuccessful: 'Başarılı Uzun Taç Atışı',
    LongThrowInTotal: 'Toplam Uzun Taç Atışı',
    LongThrowInPct: '% Başarılı Uzun Taç Atışı',
    Games: 'Oynanan Oyunlar',
    PointsPerGame: 'Maç Başına Puan',
    ExpectedPointsDiff: 'Beklenen Puan Farkı',
    PassesTotalOwnHalf: 'Toplam Pas Kendi Yarısı',
    PassesOwnHalf: 'Kendi Yarısını Geçer',
    PassesTotalOppHalf: 'Toplam Rakip Yarısını Geçti',
    ProgressivePassesTotal: 'Toplam Aşamalı Geçişler',
    DuelsWon: 'Kazanılan Düellolar',
    NonPenaltySaves: 'Penaltısız Kurtarışlar',
    BadActionsOppHalf: 'Kötü Eylemler Rakip Yarı',
    CarriesSuccessful: 'Başarılı Taşır',
    ShotsOnTargetOutBox: 'Ceza Alanı Dışında Hedefe Yönelik Şutlar',
    TotalDistance: 'Toplam Mesafe',
    DistanceIP: 'Mesafe TIP',
    DistanceOOP: 'Mesafe OTIP',
    SprintsNumber: 'Sprint Miktarı',
    SprintsDistance: 'Sprint Mesafesi',
    WalkingDistance: 'Yürüme Mesafesi',
    JoggingDistance: 'Jogging Mesafesi',
    RunningDistance: 'Koşu Mesafesi',
    ExtremeAccelerations: 'Aşırı İvmelenmeler',
    NumberOfRuns: 'Koşu Sayısı',
    HsrNumber: 'HSR Miktarı',
    HsrDistance: 'HSR Mesafe',
    SprintNumberDeclinePct: '% Depar Sayısı Düşüşü',
    SprintDistanceDeclinePct: '% Depar Mesafesi Düşüşü',
    SprintNumberDecline: 'Depar Sayısı Düşüşü',
    SprintDistanceDecline: 'Depar Mesafesi Düşüşü',
    HsrDistancePct: '% HSR Mesafe',
    SprintDistancePct: '% Depar Mesafesi',
    Accelerations: 'İvme Miktarı',
    ExplosiveDistance: 'Patlayıcı Mesafe',
    MaxSpeed: 'Maks. Hız',
    AvgMaxSpeed: 'Ort. Maks. Hız',
    MaxAccelerations: 'Maks. İvme',
    BypassedPlayersByPasses: 'Aşılan Oyuncular',
    BypassedDefendersByPasses: 'Aşılan Savunmacılar',
    PassesBypassingPlayers: 'Oyuncuları Aşan Paslar',
    PassesBypassingDefenders: 'Savunmacıları Aşan Paslar',
    BypassedPlayersPerPass: 'Pas Başına Aşılan Oyuncular',
    BypassedDefendersPerPass: 'Pas Başına Aşılan Savunmacılar',
    LineBreakingPasses: 'Hat Kıran Paslar',
    LineBreakingPassesMD: 'Hat Kıran Paslar MD',
    LineBreakingPassesM: '',
    LineBreakingThroughBalls: 'Hat Kıran Ara Paslar',
    LineBreakingPassesPerPass: '% Pas Başına Hat Kıran Pas Oranı',
    TotalPassesUnderStrongPressure: 'Yoğun Baskı Altında Toplam Paslar',
    TotalPassesUnderLightPressure: 'Baskı Altında Toplam Paslar',
    SuccessfulPassesUnderStrongPressure: 'Yoğun Baskı Altında Paslar',
    SuccessfulPassesUnderLightPressure: 'Baskı Altında Paslar',
    PassingUnderStrongPressure: '% Yoğun Baskı Altında Paslaşma',
    PassingUnderLightPressure: '% Baskı Altında Paslaşma',
    PassReceiptsInSpaceCompleted: 'Boş Alanda Tamamlanan pas Alımları',
    PassReceiptsInSpace: 'Boşlukta Alınan Paslar',
    PassReceiptsInSpaceCompletedFirstThird: 'Boşlukta Alınan Paslar İlk Üçte',
    PassReceiptsInSpaceCompletedSecondThird: 'Boşlukta Alınan Paslar İkinci Üçte',
    PassReceiptsInSpaceCompletedFinalThird: 'Boşlukta Alınan Paslar Son Üçte',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Rakip Sağ Yarı Sahada Boşlukta Alınan Paslar',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Rakip Orta Yarı Sahada Boşlukta Alınan Paslar',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Rakip Sol Yarı Sahada Boşlukta Alınan Paslar',
    PassReceiptsInSpaceFirstThird: 'Boşlukta Pas Alımı İlk Üçte',
    PassReceiptsInSpaceSecondThird: 'Boşlukta Pas Alımı İkinci Üçte',
    PassReceiptsInSpaceFinalThird: 'Boşlukta Pas Alımı Son Üçte',
    PassReceiptsInSpaceOppHalfRight: 'Rakip Sağ Yarı Sahada Boşlukta Pas Alımı',
    PassReceiptsInSpaceOppHalfCenter: 'Rakip Orta Yarı Sahada Boşlukta Pas Alımı',
    PassReceiptsInSpaceOppHalfLeft: 'Rakip Sol Yarı Sahada Boşlukta Pas Alımı',
    TotalStrongOnBallPressures: 'Top Üzerindeki Güçlü Baskılar Toplamı',
    TotalLightOnBallPressures: 'Top Üzerindeki Baskılar Toplamı',
    SuccessfulStrongOnBallPressures: 'Top Üzerindeki Güçlü Baskılar',
    SuccessfulLightOnBallPressures: 'Top Üzerindeki Baskılar',
    StrongOnBallPressuresPct: '% Güçlü Baskılar',
    LightOnBallPressuresPct: '% Baskılar',
    TimesBypassedByPasses: 'Paslarla Geçilen',
    TimesBypassedByCarries: 'Top Sürerek Geçilen',
    TimesBypassedByActions: 'Aksiyonlarla Geçilen',
    BypassedPlayersByCarries: 'Top Sürerek Geçilen Oyuncular',
    BypassedDefendersByCarries: 'Top Sürerek Geçilen Savunmacılar',
    BypassedPlayersByActions: 'Aksiyonlarla Geçilen Oyuncular',
    BypassedDefendersByActions: 'Aksiyonlarla Geçilen Savunmacılar',
    CarriesBypassingPlayers: 'Oyuncuları Geçen Top Sürmeler',
    CarriesBypassingDefenders: 'Savunmacıları Geçen Top Sürmeler',
    BypassedPlayersPerCarry: 'Top Sürme Başına Geçilen Oyuncular',
    BypassedDefendersPerCarry: 'Top Sürme Başına Geçilen Savunmacılar',
    LineBreakingCarries: 'Hatlar Arası Top Sürmeler',
    LineBreakingCarriesMD: 'Defans ve Orta Saha Arası Top Sürmeler',
    LineBreakingCarriesM: 'Orta Saha Hattı Arası Top Sürmeler',
    LineBreakingCarriesD: 'Defans Hattı Arası Top Sürmeler',
    LineBreakingCarriesPerCarry: '% Top Sürme Başına Hatlar Arası Geçiş',
    LineBreakingActions: 'Hatlar Arası Aksiyonlar',
    LineBreakingActionsMD: 'Defans ve Orta Saha Arası Aksiyonlar',
    LineBreakingActionsM: 'Orta Saha Arası Aksiyonlar',
    LineBreakingActionsD: 'Defans Arası Aksiyonlar',
    PassesPerLineBreakingPass: 'Hatlar Arası Pas Başına Pas',
    CarriesPerLineBreakingCarry: 'Hatlar Arası Top Sürme Başına Top Sürme',
    LinesBrokenByPasses: 'Pas ile Kırılan Hatlar',
    LinesBrokenByCarries: 'Top Sürerek Kırılan Hatlar',
    LinesBrokenByActions: 'Aksiyon ile Kırılan Hatlar',
    LinesBrokenPerPass: 'Pas Başına Kırılan Hat Sayısı',
    LinesBrokenPerCarry: 'Top Sürme Başına Kırılan Hat Sayısı',
    AvgLastDefenderDistanceIP: 'Son Savunmacı Mesafesi IP',
    AvgLastDefenderDistanceOOP: 'Son Savunmacı Mesafesi OOP',
    AvgDefensiveLineDistanceIP: 'Savunma Hattı Mesafesi IP',
    AvgDefensiveLineDistanceOOP: 'Savunma Hattı Mesafesi OOP',
    AvgRBDistanceIP: 'Sağ Bek Mesafesi IP',
    AvgRBDistanceOOP: 'Sağ Bek Mesafesi OOP',
    AvgLBDistanceIP: 'Sol Bek Mesafesi IP',
    AvgLBDistanceOOP: 'Sol Bek Mesafesi OOP',
    AvgBlockDistanceIP: 'Blok Mesafesi IP',
    AvgBlockDistanceOOP: 'Blok Mesafesi OOP',
    AvgBlockAreaIP: 'Blok Alanı IP',
    AvgBlockAreaOOP: 'Blok Alanı OOP',
    AvgDefensiveLineWidthOOP: 'Savunma Hattı Genişliği OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Hücum Hattı Son Üçte Genişlik IP',
    AvgLByIP: 'Sol Bek Pozisyonu IP',
    AvgRByIP: 'Sağ Bek Pozisyonu IP',
    AvgOffensiveLineDistanceIP: 'Hücum Hattı Mesafesi IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Hücum Hattı Son Üçte Mesafe IP',
    AvgOffensiveLineWidthIP: 'Hücum Hattı Genişliği IP',
    OffBallRuns: 'Top Dışındaki Koşu Toplamı',
    OffBallRunsOverlap: 'Bindirme Koşuları',
    OffBallRunsUnderlap: 'İç Koşular',
    OffBallRunsRunAhead: 'Öne Koşular',
    OffBallRunsRunBehind: 'Savunma Arkasına Koşular',
    OffBallRunsCrossReceiver: 'Orta Alma Koşusu',
    OffBallRunsSupport: 'Destek Koşusu',
    OffBallRunsComingShort: 'Kısa Destek Koşusu',
    description: {
      Possession: 'Takımın topla oynama yüzdesi',
      TimePossession: 'Takımın Topa Sahip Olma Süresi',
      PassesPerShots: 'Şut başına verilen ortalama pas sayısı',
      PPDA: 'Savunma Aksiyonu Başına Yenilen Paslar. PPDA takımın top rakipteyken rakibe yaptığı baskıyı ölçer. Bu değer rakibin atak kesilmeden önce yapabildiği pas sayısına karşılık gelir. Değer ne kadar yüksek ise, rakip o kadar pası tamamlamış demektir.',
      Directness: 'Bir takımın ne kadar direkt oynadığını ölçer. Takımın yaptığı dikine pasların, yana doğru atılan pasların miktarına göre bu değer artar ve azalır.',
      ExpectedPoints: 'Bir takım alması beklenen puanı, Gol Beklentisi ve Gol Yeme Beklentisi üzerinden ölçer. Bu metrik takımın aldığı puan ile karşılaştırılınca takımın perfromansını gerçekten anlamamızı sağlar.',
      PassesPerLongBall: 'Tamamlanan pas içerisinde başarılı uzun pas yüzdesi',
      CrossingPerXG: 'Ortalardan gelen gollerin yüzdesi',
      PenaltySavedPenaltyFaced: 'Karşılaşılan tüm penaltı atışlarından kurtarılan penaltı atışlarının yüzdesi',
      Goals: 'atılan gollerin sayısı',
      PenaltyShots: 'Penaltı noktasından kullanılan toplam şut sayısı',
      PenaltyGoals: 'Penaltı noktasından atılan toplam gol sayısı',
      NonPenaltyGoals: 'Penaltı Harici Gollerin sayısı',
      NPGOpenPlay: 'Number of goals scored by open play actions excluding penalty goals',
      NPGSetPiece: 'Number of goals scored by set piece actions excluding penalty goals',
      Shooting: 'Kaleyi bulan şutların yüzdesi',
      Finishing: 'Gol olan şutların yüzdesi',
      xGEfficiency: 'Bir oyuncunun gol atabilmesi için gerekli Gol Beklentisi miktarı',
      HeaderPerShot: 'kafa topu sayısı',
      HeaderPerCross: 'Takım tarafından tamamlanan ortalar içerisinden kafa vuruşu ile biten orta yüzdesi',
      Assists: 'yapılan asist sayısı',
      ThroughBalls: 'gol için koşu yapan bir oyuncuya atılan pasların sayısı',
      CrossEfficiency: 'Yapılan başarılı ortaların sayısı ile yüzdesini birleştiren metrik',
      ScoringContribution: 'yapılan asist ve gollerin sayısı',
      xAssistsOpenPlay: 'Açık oyundan elde edilen oyun başına beklenen asist sayısı',
      xAssistsSetPiece: 'Duran toplarla oyun başına beklenen asist sayısı',
      xAssistsOpenPlayInTeam: 'Açık oyundan elde edilen takımda dakikalık oyun başına beklenen asist sayısı',
      xAssistsSetPieceInTeam: 'Duran toplarla takımda dakikalık oyun başına beklenen asist sayısı',
      xGChainFinalThird: 'Sahanın son üçte birlik bölümünde oyuncunun yer aldığı xG miktarı',
      xGBuildupFinalThird: 'Sahanın son üçte birlik bölümünde oyuncunun yer aldığı xG miktarı (şut ve şut pası hariç)',
      BallProgressionPassing: 'Oyuncunun pas ile topu 10 metre veya daha fazla ilerlettiği sayı',
      BallProgressionDribbling: 'Oyuncunun topu taşıyarak topu 10 metre veya daha fazla ilerletme sayısı',
      TacklesWasDribbled: 'Oyuncunun müdahele ile kazadığın top yüzdesi ile verkaç yapılan yüzdeyi karşılaştıran metrik. Gösterge ne kadar büyükse o kadar iyi',
      TacklesSuccessful: 'Oyuncunun yaptığı başarılı müdahale sayısı',
      Interceptions: 'oyuncunun top hedefine ulaşmasın diye yaptığı atak kesme sayısı',
      Clearances: 'oyuncunun tehlikeli bölgeden topu uzaklaştırma sayısı',
      Fouls: 'oyuncunun yaptığı faul sayısı',
      Recoveries: 'oyuncunun topu geri kazanma sayısı',
      Shots: 'toplam şut sayısı',
      ShotsPerGoal: 'Kaleciye penaltı harici gol atabilmek için gerekli kaleyi bulan şut sayısı',
      ShortPassesSuccessful: 'tamamlanan kısa paslar (12 metrede az)',
      PassingSuccessForwardPct: 'İleriye doğru başarılı atılan pasların yüzdesi',
      PassingSuccessBackwardPct: 'Geriye doğru atılan başarılı pasların yüzdesi',
      PassingForwardBackwardPct: 'İleri doğru atılan pasların geriye atılan paslara oranı',
      LongBallPerPassesPct: 'Oyuncu tarafından tamamlanan tüm paslar içerisinde uzun pasların yüzdesi (>32 metre).',
      LongBallReceived: 'Alınan uzun paslar (>32 merte)',
      LongBallReceivedOppHalf: 'Rakip takım yarı sahasında alınan uzun paslar (>32 metre)',
      OffensiveActions: 'Saldırgan Eylemler',
      DribblesAttempted: 'dripling girişimi',
      SuccessfulDribblesPct: 'Başarılı dripling/dripling girişimi',
      OffensiveTouchesOutBoxPct: 'Kutudan Çıkan Hücum Dokunuş Yüzdesi',
      BallRetention: 'Top sahip oldunan ama kaybedilmeyen zamanların yüzdesi',
      PassingPct: 'Oyuncu tarafından verilen tüm paslar içerisinde tamamlanan pasların yüzdesi',
      PassingOwnHalfPct: 'Oyuncu tarafından verilen tüm paslar içerisinde tamamlanan pasların yüzdesi (sadece kendi yarı sahasında)',
      PassingOppHalfPct: ' Oyuncu tarafından verilen tüm paslar içerisinde tamamlanan pasların yüzdesi (sadece rakip yarı sahada)',
      PassingFinalThird: 'sahanın son üçte birlik bölümüne tamamlanan paslar',
      PassesFinalThirdTotal: 'Ortalar, duran toplar, köşe vuruşları ve taç atışları hariç, son üçte birlik kısımda biten toplam pas atışı sayısı',
      PassingFinalThirdPct: ' Oyuncu tarafından verilen tüm paslar içerisinde tamamlanan pasların yüzdesi (sadece sahanın son üçte birlik bölümüne)',
      LongBallSuccessful: '32 metre içerisinde tamamlanan paslar',
      LongBallPct: '32 metreden uzapa tamamlanan paslar/32 metreden uzağa toplam pas girişimi',
      LongBallTotal: '32 metrenin üzerindeki toplam geçiş sayısı',
      SavesPct: 'Toplam kaleye gelen şut içerisinden kurtarılan şutların yüzdesi',
      SavesInBoxPct: 'Ceza sahası içerisinde gelen şutların kurtarılma yüzdesi',
      SavesOutOfBoxPct: 'Ceza sahası şutların kurtarılma yüzdesi',
      xGSavedPerXGFacedOnTarget: 'Kaleci tarafından kurtarılan xG yüzdesini gösteren katsayı. Bu metrikteki, 1 değeri, kalecinin kaleye çekilen şutlardan beklenen tüm golleri kurtardığı anlamına gelirken, 0 değeri, rakip takımı tarafından oluşturulan tüm gol beklentilerinin gol ile sonuçlandığı anlamına gelir',
      xGFacedOnTargetPerGoalReceived: 'Kaleciye gol atmak için kaç tane Gol B:eklentisi gerektiğini gösteren metrik. Bu metrikteki yüksek bir oran, kaleciye gol atmak için yüksek sayıda xG oluşturmanın gerektiği anlamına gelir',
      xGFacedOnTargetEfficiency: 'Kaleci tarafından kurtarılan Penalt Harici Gol sayısı. Bu, kaleci tarafından kurtarılan Gol Beklentisi sayısından yenilen (penaltı hariç) gol sayısıdır. Kaleci sayesinde rakip tarafından atılamayan gol sayısını gösterir',
      xGFacedOnTarget: 'Kalecinin karşılaştığı toplam xG (kurtarılan ve atılan)',
      IndividualPressure: 'Bir oyuncunun rakibe pres yaparken yaptığı başarılı çabası (geri kazanılan top) sayısını ölçen metrik',
      AerialEfficiency: 'Başarılı hava topu mücadelelerinin yüzdesini, kazanılan hava topu mücadelelerinin sayısı ile birleştiren metrik',
      AerialWins: 'oyuncunun kazandığı hava topu mücadelesi',
      AerialWinsPct: 'Oyuncunun dahil olduğu toplam hava topu mücadelesi sayısından oyuncunun kazandığı hava topu mücadelesi sayısı',
      xG: 'oyun başına Gol Beklentisi. Bu metrik hareketin farklı değişkenlere (mesafe, açı, oyun türü…) dayalı olarak bir şutun golle sonuçlanma olasılığını ölçer.',
      xGDiff: 'xG ve Hedefler arasındaki fark',
      xGOpenPlay: 'Açık Oyun tarafından oluşturulan Beklenen Hedefler',
      xGSetPiece: 'Set Hücumu ile oluşturulan Gol Beklentisi',
      xGPerShot: 'Oyuncunun çektiği şutların xG’si. Bu metrik çekilen şutların ortalama tehlikesini ölçer. Ne kadar yüksek olursa, şutların gol olma olasılığı o kadar yüksek olur. Şut başına xG, oyuncunun atışlarını iyi seçtiği anlamına gelir.',
      ChancesCreated: 'Şut pası sayısı',
      CompletedCrosses: 'tamamlanan ortaların sayısı',
      Crossing: 'Orta girişimi içerisinden tamamlanan ortaların yüzdesi',
      OpenPlayKeyPasses: 'akan oyun sırasında oyuncu tarafından tamamlanan pasların sayısı',
      OpenPlayKeyPassesInTeam: '% Takımın dakikada akan oyun sırasında oyuncu tarafından tamamlanan pasların sayısı',
      OpenPlayPassesIntoOpponentBox: 'oyuncu tarafından akan oyunda rakip ceza sahasına tamamlanan pas sayısı',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'oyuncu tarafından akan oyunda rakip ceza sahasına tamamlanan pas sayısı',
      xAssists: 'Bir maçta oluşturulan şansların kalitesini analiz eden metrik. Her asistin, şutun gol olma olasılığını temel alan bir değeri vardır. Bu değer, pasın yerine, stiline, oyunun durumuna vb. göre belirlenir. xG’den farklı olarak, xA bir oyuncunun matıken asist sayısından daha yüksek olması gereken bir metriktir, çünkü bir oyuncu sadece paslarının kalitesinden sorumludur (xA), asist sayısı ise bitiriciye bağlıdır',
      xGChain: 'Oyuncunun yer aldığı xG miktarı',
      xGBuildup: 'xG’ye benzer ancak aksiyonun son 2 oyuncusunu hesaba katmaz (şut ve şut pası hariç)',
      xGBuildupInTeam: 'xG Geliştirme in Team',
      BallProgression: 'Oyuncunun topu pas ile veya topu taşıyarak veya ikisini birden yaparak 10 metre veya daha fazla ileri taşıma sayısı',
      SuccessfulDribbles: 'tamamlanan başarılı dripling',
      Dispossessed: 'bir oyuncunun müdahele ile topu kaybetme sayısı',
      TouchesInOpponentBox: 'oyuncunun müdahele ile rakip ceza sahasında topu kaybetme sayısı',
      xGSavedPerShot: 'Kaleni bulan şutlarda gol yeme olasılığı ortalaması',
      BallRetentionOppHalf: 'Rakip yarı sahada topa sahip olup kaybedilmeyen anların yüzdesi',
      DeepProgression: 'Oyuncunun topu taşıyarak sahanın son beşte birlik bölümüne ulaştırma sayısı artı son beşte birlik bölümde topa sahip olma sayısı',
      DeepProgressionFinalThird: 'Oyuncunun topu taşıyarak sahanın son üçte birlik bölümüne ulaştırma sayısı artı son üçte birlik bölümde topa sahip olma sayısı',
      FoulsTaken: 'oyuncunun maruz kaldığı faul sayısı',
      PenaltiesTaken: 'oyuncunun rakip ceza sahasında maruz kaldığı faul sayısı',
      BlockedCrosses: 'oyuncunun engellediği orta sayısı',
      BlockedShots: 'oyuncunun engellediği şut',
      NonPenaltyGoalsAgainst: 'yenilen penaltı harici gol sayısı',
      GoalsConceded: 'oyun başına yenilen gol sayısı',
      Headers: 'Kafa ile yapılan şutların sayısı',
      HeadedGoals: 'oyun başına kafayla atılan gol sayısı',
      Points: 'Takımın kazandığı puan sayısı',
      SavesInBox: 'oyun başına ceza sahası içindeki şutlardan kurtarılanların sayısı',
      SavesOutBox: 'oyun başına ceza sahası dışındaki şutlardan kurtarılanların sayısı',
      ShotsOnTargetInBoxAgainst: 'oyun başına ceza sahası içinden kaleyi bulan şutların sayısı',
      ShotsOnTargetOutBoxAgainst: 'oyun başına ceza sahası dışından kaleyi bulan şutların sayısı',
      AveragePassDistance: 'Pasların ortalama mesafesi',
      ProgressiveRuns: 'Topu rakip kaleye %20 yaklaştırmak için yapılan başarılı top taşıma',
      xT: 'Tehdit Beklentisi (xT) bir oyuncunun topu golle sonuçlanma olasığının daha yüksek olduğu alanlara taşıyarak veya pas vererek rakibine oluşturduğu tehdidi ölçer.',
      xTOpenPlay: 'akan oyun ile oluşturulan tehdit beklentisi',
      xTSetPiece: 'duran top ile oluşturulan tehdit beklentisi',
      xGOT: 'Kaleyi bulan gol beklentisi. Kalecinin karşılaştığı gol beklentisi sayısı. Bu metrik sadece kaleyi bulan şutları hesaba katar (Kaçırılan şutlar ve direkten dönen şutlar hariç)',
      BadActions: 'Hatalı Hareketler',
      BadActionsOwnHalf: 'Kendi yarı sahanda yapıtığın tüm kötü aksiyonlar',
      AerialsWonOwnBox: 'Kendi ceza sahanda kazanılan hava topu mücadelesi',
      AerialsWonOppBox: 'Rakip ceza sahasında kazanılan hava topu mücadelesi',
      AerialsTotalOppBox: 'Rakip ceza sahasında toplam hava topu mücadelesi',
      AerialsTotalOwnBox: 'Kendi ceza sahasında toplam hava topu mücadelesi',
      FoulsOwnHalfPct: 'Kendi yarı sahasında yapılan faul yüzdesi',
      RecoveriesOppHalf: 'başına rakip yarı sahada topu geri kazanma',
      DuelsPct: 'Başarılı ikili mücadele yüzdesi',
      TacklesUnsuccessful: 'Bir oyuncunun, rakibinin başarılı bir şekilde yanından geçerek topu sürmesi nedeniyle topu kazanmada başarısız olma sayısı',
      TacklesWasDribbledFirstThird: 'Sahanın son üçte birlik bölümünde oyuncunun topu geri kazanma yüzdesi',
      TacklesWasDribbledSecondThird: 'Kazanılan 1\'e 1 Savunma Mücadeleleri ⅔',
      TacklesWasDribbledFinalThird: 'Kazanılan 1\'e 1 Savunma Mücadeleleri Topla ⅓',
      BallProgressionFinalThird: 'Sahanın son üçte birlik bölümünde topu ilerletme',
      DuelsTotal: 'Her yapılan toplam Tackle, Aerials, Topa Dokunma, Dripling ve Faul sayısı',
      QuickRecoveries: 'Topu kendi kalesine 40 metre uzaklıkta kaybettikten 8 saniye sonra geri kazanma',
      ShotsPerNPG: 'Penaltı harici gol atmak için ortalama şut sayısı',
      ShotsOutBox: 'ceza sahası dışından atılan şut sayısı',
      GoalsOutBox: 'ceza sahası dışından gol sayısı',
      ShootingOutBox: 'Ceza sahası dışından kaleyi bulan şut yüzdesi',
      HandPassing: 'El ile verilen pasların hedefi bulması',
      Catching: 'Kalecinin topu yakaladığı toplardaki kurtarış yüzdesi',
      Caught: 'Kalecinin topu yakalayıp tuttuğu yeri kurtararak ikinci bir oyunu önler',
      ClaimAccuracy: 'Kalecinin havadan gelen topları kurtarma/engelleme başarısını ölçer. Eğer 1’den büyük ise kaleci beklenenden daha fazla havadan gelen top kurtarmış demektir',
      HighTurnovers: 'Kaleye 40 metre uzaklıkta yapılan top kaybı',
      ShotEndingHighTurnovers: 'Rakip takımın şutu ile biten top kaybı (kaleye 40 metre uzaklıkta kaybedilen top)',
      GoalEndingHighTurnovers: 'Rakip takımın golü ile bite ntop kaybı (kaleye 40 metre uzaklıkta kaybedilen top)',
      AverageCarriesProgress: 'Oyuncunun topu dikine taşayarak kat ettiği ortalam mesafe (metre)',
      ChanceEndingCarries: 'En az 7 metre top sürüp şut pası verme',
      AssistEndingCarries: 'En az 7 metre top sürüp şut pası verme',
      ShotEndingCarries: 'En az 7 metre top sürüp şut çekme',
      GoalEndingCarries: 'En az 7 metre top sürüp gol atma',
      ShotEndingSequence: 'Oyuncunun dahil olduğu şut ile biten aksiyonlar',
      GoalEndingSequence: 'Oyuncunun dahil olduğu gol ile biten aksiyonlar',
      xGPerNPG: 'Penaltı harici gol atmak için gereken Gol Beklentisi',
      AerialWonOffensive: 'Kazanılan ofansif ikili mücadeleOffensive Aerial Duels Won',
      AerialWonDefensive: 'Kazanılan Defansif Hava Topları',
      xGAgainst: 'Gol Yeme Bekentisi',
      xGDiffAgainst: 'Kazanılan Farkı xG',
      xGPerNPGAgainst: 'Yenilen penaltı harici gol başına Gol Yeme Beklentisi',
      xGSetPieceAgainst: 'Rakibin set hücumundan gol beklentisi',
      xGOpenPlayAgainst: 'Kazanılan Akan Oyun xG',
      xGPerShotAgainst: 'Atılan şutlardan gol yeme beklentisi',
      ShotsAgainst: 'kalene çekilen şutlar',
      ShotsOnTargetAgainst: 'oyun başına kaleye isabet eden şut sayısı',
      RivalPossession: 'Rakibin topla oynaması',
      AerialDefensivePct: 'Kazanılan defansif hava topu mücadelesi yüzdesi',
      HighRecoveries: 'Rakip kaleye 40 metre uzaklıkta geri kazanılan top',
      HighDefensiveActions: 'Kendi kale çizgisine 40 metre uzaklıkta yapılan defansif aksiyonların (Müdaheleler, Atak Kesmeler, Engellemeler, Fauller ve 1e1)',
      HighDefensiveActionPct: 'Kendi kale çizgisine 40 metre uzaklıkta yapılan defansif aksiyonların yüzdesi (Müdaheleler, Atak Kesmeler, Engellemeler, Fauller ve 1e1)',
      HighDefensiveDistance: 'Defansif Mesafe',
      PassesPerPossession: 'Topla oynama başına yapılan pas sayısı',
      LengthPerPossession: 'Topla oynama başına mesafe',
      xTNet: 'Net xT',
      AvgCarriesDistance: 'Ortalama top taşıma mesafesi',
      PassesForwardPct: '% İleriye dönük pas',
      PassesForwardSuccessful: 'Başarılı İleri Geçişler',
      PassesForwardTotal: 'Toplam İleri Paslar',
      TacklesAttempted: 'Müdahele Girişimi',
      DuelsLost: 'Kaybedilen İkili Mücadele',
      Carries: 'Top Taşıma',
      CarriesPct: '% Top Taşıma',
      Aerials: 'Hava Topu',
      ProgressivePassesReceivedIntoBox: 'Ceza sahasında alınan ileriye dönük paslar',
      PassesOppHalf: 'Rakip sahaya atılan başarılı paslar',
      ShotsOnTarget: 'kaleyi bulan şut',
      AggressiveActions: 'Topu kaybettikten 2 saniye sonra yapılan müdahele girişimi sayısı',
      Crosses: 'toplam orta sayısı',
      xGBuildup5pass: 'Oyuncunu yer aldığı, sadece son 5 pası kapsayan xG miktarı(şut ve şut pası hariç)',
      DefensiveDistance: 'Defansif ikili mücadelelerin kendi kalesine olan uzaklığı',
      SpeedSequence: 'Takımın topla oynarkenki ortalam hızı (zamana göre katedilen metre)',
      Touches: 'oyuncunun topa sahip olduğu zaman sayısı',
      AerialsTotalOppHalf: 'rakip yarı sahadaki hava topu mücadelesi',
      AerialsWonOppHalf: 'Her oyun süresinde rakibin yarı sahasında başarılı hava düelloları',
      AerialsWonOppHalfPct: 'Rakip yarı sahada kazanılan hava topu mücadelesi yüzdesi',
      AerialsPctOppBox: 'Rakip ceza sahasında kazanılan hav topu mücadelesi yüzdesi',
      AerialsPctOwnBox: 'Kendi ceza sahasında kazanılan hava topu mücadelesi yüzdesi',
      AerialDefensive: 'Rakip takım topa sahipken yapılan hava düellolarının toplam sayısı',
      AerialOffensive: 'Kendi takımı topa sahipken yapılan hava düellolarının toplam sayısı',
      AerialOffensivePct: 'Kendi takımı topa sahipken kazanılan hava topu düellolarının yüzdesi',
      IndividualPressureOppHalf: 'Rakip yarı sahada rakibe baskı yaparken başarılı çabası hesaplayan metrik (geri kazanılan top)',
      ChancesCreatedOP: 'akan oyun sırasında verilen şut pası sayısı',
      TouchesPerShot: 'Şut başına oyuncunun topa dokunma sayısı',
      PassesFinalThirdTotalPct: 'Sahanın son üçte birlik bölümüne atılan başarılı pas yüzdesi',
      xACrosses: 'ortalar ile oluşturulan asist beklentisi',
      Passes: 'toplam pas sayısı',
      PassesSuccessful: 'tamamlanan psların sayısı',
      TacklesWasDribbledFouls: 'Toplam top çalma ve yapılan faullerin yüzdesi olarak kazanılan top çalma yüzdesi',
      OffsidesCaught: 'Düşülen Ofsayt',
      ProgressivePassesReceivedFinalThird: 'Sahanın son üçte birlik bölümündealınan ileriye dönük paslar',
      ProgressivePassesReceived: 'Alınan ileri doğru paslar',
      Breadth: 'Sahanın kenarlarında yapılan müdahele, mücadele, atak kesme ve faullerin toplamı',
      DuelsDefTotal: 'Defansif İkili Mücadeleler',
      DefensiveActions: 'Rakip dripling girişimi yaparken alınan Defansif Aksiyonlar (Müdaheleler, Mücadeleler ve Fauller)',
      ProgressivePassesReceivedOppHalf: 'Rakip yarı alanda alınan ileriye dönük paslar',
      CompletedCrossesOP: 'Açık oyunda tamamlanan orta',
      CrossingOP: '% Açık oyunda orta yapma',
      CrossesOP: 'Açık oyun sırasında toplam orta sayısı',
      PassingContribution: 'Karşılayanın konumunu dikkate alarak pas tehdidini ölçen yüzde',
      BallProgressionOppHalfInTeam: '% Takımın rakip yarı sahada top ilerletmesi',
      PassesOPIntoBoxInTeam: '% Takımın akan oyunda ceza sahası içine verdiği pas',
      TouchesOppBoxInTeam: '% Takımın rakip ceza sahasında topla buluşması',
      xGOPInTeam: '% xG Takımın Açık Oyunu',
      DeepPasses: 'Rakip kalenin 20 metre çapından bu bölgenin içerisine verilen paslar',
      DeepPassesTotal: 'Rakip kalenin 20 metrelik yarıçapının dışından atılan ve o alanın içinde biten pasların toplamı',
      DefensiveDuelsPct: 'Toplam defansif ikili mücadeleler içinden kazanılan defansif ikili mücadele yüzdesi',
      QuickRecoveriesPct: 'Rakibin atak kesmelerine ve müdahelelerine karşı yapılan topu hızlı geri kazanmaların yüzdesi',
      DiffDefensiveDistanceTeam: 'Takımın defansif mesafesi ile oyuncunun defansif mesafesi arasındaki fark',
      xTPassing: 'Sadece pas ile oluşturulan tehdit beklentisi',
      xTPassing100Passes: 'Sadece pas ve 100 pas ile oluşturulan tehdit beklentisi',
      ProgressivePassesAccurate: 'X doğrultusunda tamamlanan 10 metrelik veya daha uzun paslar',
      PassAbility: 'Pas beklentisinin (xP) tamamlanan paslara oranı',
      OPPassesIntoOppBoxPct: 'Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box',
      EntriesOppBox: 'Rakip ceza sahasına pasların ve topu taşımaların sayısı',
      Crosses6yardBox: 'Altı pasa açılan toplam orta sayısı',
      Cutbacks: 'Son çizgiden geriye ve rakip ceza sahası içerisine pas',
      xTDribbling: 'Sadecedripling ile oluşturulan tehdit beklentisi',
      AvgShotDistance: 'Çekilen tüm şutların kaleye ortalama mesafesi',
      xGOnTarget: 'Kaleyi bulan şutlardan Gol Beklentisi. Şutun atıldığı konumu kullanarak bir şutun golle sonuçlanma olasılığını ölçer',
      FinishingxGOT: 'Ortalamanın üzerinde bir golle biten şut yüzdesi. Bu metrik, şutu çeken oyuncunun şutlarının kalitesine ne kadar değer kattığını ölçer',
      DribblesWonOwnHalf: 'Kendi yarı sahasında yapılan başarılı dripling',
      DribblesOwnHalf: 'Kendi yarı sahasında yapılan dripling sayısı',
      DribblesOwnHalfPct: 'Kendi yarı sahasında yapılan başarılı driping ve dripling girişimi yüzdesi',
      DribblesWonOppHalf: 'Rakip yarı sahada başarılı dripling',
      DribblesOppHalf: 'Rakip yarı sahada dripling girişimi sayısı',
      DribblesOppHalfPct: 'Rakip yarı sahada başarılı dripling ve dripling girişimi yüzdesi',
      DribblesWonFinalThird: 'Sahanın son üçte birlik bölümünde yapılan başarılı dripling',
      DribblesFinalThird: 'Sahanın son üçte birlik bölümünde yapılan dripling girişimi sayısı',
      DribblesFinalThirdPct: 'Sahanın son üçte birlik bölümünde yapılan başarılı dripling ve dripling girişimi yüzdesi',
      ShotEndingHighRecoveries: 'Şutla sonuçlanan yüksek toplar (rakip kaleye 40 metre veya daha yakın alanda kazanılan toplar)',
      PassingFinalThirdAgainst: 'Rakibin son üçlüğe yaptığı başarılı paslar',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Rakibin açık oyunda ceza sahamıza yaptığı toplam pas sayısı',
      EntriesOppBoxAgainst: 'Rakibin ceza sahamıza yaptığı pas ve top sürme giriş sayısı',
      DeepProgressionAgainst: 'Rakibin top sürerek son beşte bire ulaştığı ve topun bizim ilk beşte birde olduğu pozisyon sayısı',
      TouchesInOpponentBoxAgainst: 'Rakibin ceza sahamıza sahip olduğu toplam pozisyon sayısı',
      Score: 'Farklı metriklere dayalı oyuncu performansı',
      PDScore: 'Farklı fiziksel ölçümlere dayalı oyuncu fiziksel performansı',
      OrlegiScore: 'Farklı metriklere dayalı oyuncu performansı',
      SirScore: 'Farklı metriklere dayalı oyuncu performansı',
      ExcScore: 'Farklı metriklere dayalı oyuncu performansı',
      xTOPInTeam: 'Takımınızın toplamına göre oyunda üretilen beklenen tehlike (xT)',
      YellowCards: 'Sarı Kartlar',
      RedCards: 'Kırmızı Kartlar',
      xTOpenPlayAgainst: 'Açık oyun sırasında Tehdit Beklentisi (xT)',
      xTSetPieceAgainst: 'Duran Toplardan Tehdit Beklentisi (xT)',
      NPGOpenPlayAgainst: 'Kazanılan PHG Akan Oyun',
      NPGSetPieceAgainst: 'Kazanılan PHG Duran Top',
      PassesOppHalfPerPossession: 'Topa Sahip Olma Başına Pas Rakip Yarı',
      AverageTimeRecovery: 'Ortalama Kurtarma Süresi',
      ExpectedPassing: 'Tamamlanmış olması gereken Geçişlerin Yüzdesi',
      NumPossession10Passes: 'Possessions 10 Passes',
      PassesReceived: 'Alınan Geçişler',
      PassesReceivedFinalThird: 'Passes Received Final ⅓',
      ProgressivePassesTotalPct: '% Aşamalı Geçişler',
      ShortPassesPct: 'Kısa Paslar %',
      TouchesOppBoxOppTeam: 'Oyuncu sahadayken ceza sahasında verilen rakip aksiyon sayısı',
      ShotsOnTargetOppTeam: 'Oyuncu sahadayken kaleye isabetli şut sayısı',
      NPGOppTeam: 'Oyuncu sahadayken penaltı hariç yenen gol sayısı',
      xGSetPiecePerxG: '1 xG üretmek için gereken duran top xG\'si',
      ShotsOpenPlay: 'Açık oyunda üretilen şut sayısı',
      ShotsOpenPlayAgainst: 'Açık oyunda karşılaşılan şut sayısı',
      ShotsFromDribble: 'Bir rakibi çalımladıktan sonra yapılan şutlar',
      GoalsFromDribble: 'Bir rakibi çalımladıktan sonra atılan goller',
      PassesIntoFinalThird: 'Son üçteki bölgeden yapılan başarılı paslar',
      PassesIntoFinalThirdTotal: 'Dışarıdan başlayıp son üçte birlik alanda biten toplam pas denemeleri',
      PassesInsideFinalThird: 'Son üçte (başlangıcı ve bitişi aynı bölgede olan) yapılan başarılı paslar',
      PassesInsideFinalThirdTotal: 'Son üçte birlik kısımda atılan pasların toplamı (son üçte birlik kısımda başlangıç ​​ve bitiş)',
      PassesFinalThirdNoArea: 'Son Üçüncüyü Geçti (Kutusuz)',
      PassesIntoOppBox: 'Rakip ceza sahasında sona eren başarılı paslar',
      CarriesFinalThird: 'Son üçte sona eren en az 7 metrelik top sürmeler',
      CarriesInsideFinalThird: 'Son üçte (başlangıç ve bitiş bu bölgede) yapılan en az 7 metrelik top sürmeler',
      CarriesFinalThirdNoBox: 'Son Üçüncüyü Taşıyor (Kutusuz)',
      CarriesIntoOppBox: 'Rakip ceza sahasında sona eren en az 7 metrelik top sürmeler',
      TimePossessionAgainst: 'Rakip takımın topla oynama süresi',
      TimePossessionTotal: 'Her iki takımın toplam topla oynama süresi',
      PassesInBox: 'Kendi ceza sahasında yapılan başarılı paslar',
      LongThrowInSuccessful: 'Yan çizgiden yapılan ve 20+ metreyi aşan başarılı uzun taç atışı',
      LongThrowInTotal: 'Yan çizgiden yapılan 20+ metrelik uzun taç atışlarının toplamı',
      LongThrowInPct: 'Başarılı olan uzun taç atışlarının yüzdesi (20+ metre)',
      Games: 'Oynanan Oyunlar',
      PointsPerGame: 'Maç Başına Puan',
      ExpectedPointsDiff: 'Beklenen Puan Farkı',
      PassesTotalOwnHalf: 'Kendi yarı sahasından yapılan toplam pas sayısı',
      PassesOwnHalf: 'Kendi yarı sahasından yapılan başarılı pas sayısı',
      PassesTotalOppHalf: 'Rakip yarıdan yapılan toplam pas sayısı',
      ProgressivePassesTotal: 'X ekseninde 10 metre veya daha fazla toplam geçiş sayısı',
      DuelsWon: 'Başarılı düellolar (Müdahaleler, Havalar, Topa Dokunuşlar, Driblingler ve Yapılan Fauller)',
      NonPenaltySaves: 'Penaltı atışları hariç kurtarışlar',
      BadActionsOppHalf: 'Rakip yarı alanda yapılan tüm kötü eylemlerin toplamı (başarısız pas, başarısız top alma, topa sahip olma, ofsayt pası, topa dokunma başarısız)',
      CarriesSuccessful: 'Başarılı bir etkinlikle biten en az 7 metrelik taşıma sayısı',
      ShotsOnTargetOutBox: 'Ceza sahası dışından hedefe yapılan şutlar',
      TotalDistance: 'Oyuncunun bir maçta kat ettiği toplam mesafe',
      WalkingDistance: 'Oyuncunun bir maçta 2 m/s (7,2 km/s) hızın altında yürüyerek kat ettiği toplam mesafe',
      JoggingDistance: 'Oyuncunun bir maçta 2 m/s (7,2 km/s) ile 4 m/s (14,4 km/s) hız aralığında koşarak kat ettiği toplam mesafe',
      RunningDistance: 'Oyuncunun bir maçta 4 m/s (14,4 km/s) ile 5,5 m/s (19,8 km/s) hız aralığında koşarak kat ettiği toplam mesafe',
      ExtremeAccelerations: 'Oyuncunun 3 m/s²\'den fazla hızlanma sayısı',
      NumberOfRuns: 'Oyuncunun bir maçta 4 m/s (14,4 km/s) ile 5,5 m/s (19,8 km/s) hız aralığında tamamladığı koşu sayısı',
      DistanceIP: 'Oyuncunun bir maçta topa sahipken kat ettiği mesafe (Takımın Topla Oynadığı Sürede)',
      DistanceOOP: 'Oyuncunun bir maçta topa sahip olmadan kat ettiği mesafe (Rakip Takımın Topla Oynadığı Sürede)',
      HsrNumber: 'Oyuncunun bir maçta en az 1 saniye süreyle 5,5 m/s (19,8 km/s) veya daha yüksek ama 7 m/s (25,2 km/s) altında hızla hareket ettiği sayı',
      HsrDistance: 'Oyuncunun bir maçta 5,5 m/s (19,8 km/s) veya daha yüksek ama 7 m/s (25,2 km/s) altında hızla kat ettiği toplam mesafe',
      HsrDistancePct: 'Toplam mesafeye göre Yüksek Hızda Koşu (HSR) Mesafesi yüzdesi',
      SprintsNumber: 'Oyuncunun bir maçta en az 1 saniye süreyle 7 m/s (25,2 km/s) veya daha yüksek hızla hareket ettiği sayı',
      SprintsDistance: 'Oyuncunun bir maçta 7 m/s (25,2 km/s) veya daha yüksek hızla kat ettiği toplam mesafe',
      SprintNumberDeclinePct: 'Maçın ikinci yarısına kıyasla yapılan sprint sayısındaki azalma yüzdesi',
      SprintDistanceDeclinePct: 'Maçın ikinci yarısına kıyasla sprint sırasında koşulan mesafedeki azalma yüzdesi',
      SprintNumberDecline: 'Maçın ikinci yarısına kıyasla yapılan sprint sayısında azalma',
      SprintDistanceDecline: 'Maçın ikinci yarısına kıyasla sprint sırasında koşulan mesafenin azalması',
      SprintDistancePct: 'Toplam mesafeye göre Sprint Mesafesi yüzdesi',
      Accelerations: 'Oyuncunun 1,5 m/s² ile 3 m/s² arasında hızlandığı sayı',
      ExplosiveDistance: 'Patlayıcı Mesafe',
      MaxSpeed: 'Oyuncunun ulaştığı maksimum hız',
      AvgMaxSpeed: 'Oyuncunun ulaştığı ortalama maksimum hız',
      MaxAccelerations: 'Oyuncunun ulaştığı maksimum ivme (metre/saniye²)',
      BypassedPlayersByPasses: 'Topa sahip oyuncunun başlangıçta kale tarafındaki oyuncu sayısı ile olay sonunda kale tarafındaki oyuncu sayısı arasındaki fark',
      BypassedDefendersByPasses: 'Topa sahip oyuncunun başlangıçta kale tarafındaki savunmacı sayısı ile olay sonunda kale tarafındaki savunmacı sayısı arasındaki fark',
      PassesBypassingPlayers: 'Oyuncuları geçen pas sayısı',
      PassesBypassingDefenders: 'Savunmacıları geçen pas sayısı',
      BypassedPlayersPerPass: 'Pas başına geçen toplam oyuncu sayısı',
      BypassedDefendersPerPass: 'Pas başına geçen toplam savunmacı sayısı',
      LineBreakingPasses: 'Topu en az %10 oranında rakip kaleye yaklaştıran ve yakın savunmacı çiftlerini geçen veya savunma hattının arkasından geçen tamamlanmış paslar',
      LineBreakingPassesMD: 'Orta saha ve savunma hatlarını geçen başarılı paslar',
      LineBreakingPassesM: 'Orta saha hattını geçen başarılı paslar',
      LineBreakingThroughBalls: 'Savunma hattını geçen başarılı paslar',
      LineBreakingPassesPerPass: 'Pas başına kırılan hat sayısı',
      TotalPassesUnderStrongPressure: 'Yoğun baskı altında (0-2 metre mesafedeki rakip oyuncu) yapılan toplam pas sayısı',
      TotalPassesUnderLightPressure: 'Hafif baskı altında (2-4 metre mesafedeki rakip oyuncu) yapılan toplam pas sayısı',
      SuccessfulPassesUnderStrongPressure: 'Yoğun baskı altında (0-2 metre mesafedeki rakip oyuncu) yapılan başarılı pas sayısı',
      SuccessfulPassesUnderLightPressure: 'Hafif baskı altında (2-4 metre mesafedeki rakip oyuncu) yapılan başarılı pas sayısı',
      PassingUnderStrongPressure: 'Yoğun baskı altında (0-2 metre mesafedeki rakip oyuncu) yapılan başarılı pas yüzdesi',
      PassingUnderLightPressure: 'Hafif baskı altında (2-4 metre mesafedeki rakip oyuncu) yapılan başarılı pas yüzdesi',
      PassReceiptsInSpaceCompleted: 'Pas alıcısının hücum yarı sahasında olduğu ve kale yönüne doğru 5 metre yarıçapında savunmacı bulunmadığı durumdaki paslar',
      PassReceiptsInSpace: 'Hücum yarı sahasında alınıp, kale yönüne doğru 5 metre yarıçapında savunmacı bulunmayan paslar',
      PassReceiptsInSpaceCompletedFirstThird: 'Alıcının ilk üçte bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedSecondThird: 'Alıcının ikinci üçte bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedFinalThird: 'Alıcının son üçte bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Alıcının rakip yarı sahanın sağında bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Alıcının rakip yarı sahanın ortasında bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Alıcının rakip yarı sahanın solunda bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceFirstThird: 'İlk üçte alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceSecondThird: 'İkinci üçte alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceFinalThird: 'Son üçte alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceOppHalfRight: 'Rakip yarı sahanın sağında alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceOppHalfCenter: 'Rakip yarı sahanın ortasında alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceOppHalfLeft: 'Rakip yarı sahanın solunda alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      TotalStrongOnBallPressures: 'Topa sahip oyuncuya yapılan yoğun baskı sayısı (0-2 metre içinde)',
      TotalLightOnBallPressures: 'Topa sahip oyuncuya yapılan hafif baskı sayısı (2-4 metre içinde)',
      SuccessfulStrongOnBallPressures: 'Başarılı yoğun baskı sayısı (0-2 metre içinde)',
      SuccessfulLightOnBallPressures: 'Başarılı hafif baskı sayısı (2-4 metre içinde)',
      StrongOnBallPressuresPct: 'Başarılı ve toplam yoğun baskı yüzdesi (0-2 metre mesafede)',
      LightOnBallPressuresPct: 'Başarılı ve toplam hafif baskı yüzdesi (2-4 metre mesafede)',
      TimesBypassedByPasses: 'Pasla geçilme sayısı (toplam)',
      TimesBypassedByCarries: 'Top sürerek geçilme sayısı (toplam)',
      TimesBypassedByActions: 'Pas ve top sürme ile geçilme sayısı (toplam)',
      BypassedPlayersByCarries: 'Top sürerek geçilen rakip sayısı (savunmacı ve orta saha)',
      BypassedDefendersByCarries: 'Top sürerek geçilen savunmacı sayısı',
      BypassedPlayersByActions: 'Pas ve top sürme ile geçilen rakip sayısı (savunmacı ve orta saha)',
      BypassedDefendersByActions: 'Pas ve top sürme ile geçilen savunmacı sayısı',
      CarriesBypassingPlayers: 'Oyuncu geçen top sürme sayısı',
      CarriesBypassingDefenders: 'Savunmacı geçen top sürme sayısı',
      BypassedPlayersPerCarry: 'Top sürme başına geçilen rakip ortalaması',
      BypassedDefendersPerCarry: 'Top sürme başına geçilen savunmacı ortalaması',
      LineBreakingCarries: 'Savunma hattını aşan top sürme sayısı',
      LineBreakingCarriesMD: 'Orta saha ve savunma hatlarını aşan top sürme sayısı',
      LineBreakingCarriesM: 'Orta saha hattını aşan top sürme sayısı',
      LineBreakingCarriesD: 'Savunma hattını aşan top sürme sayısı',
      LineBreakingCarriesPerCarry: 'Top sürme başına hat aşma yüzdesi',
      LineBreakingActions: 'Savunma hattını aşan pas ve top sürme sayısı (birlikte)',
      LineBreakingActionsMD: 'Orta saha ve savunma hatlarını aşan pas ve top sürme sayısı',
      LineBreakingActionsM: 'Orta saha hattını aşan pas ve top sürme sayısı',
      LineBreakingActionsD: 'Savunma hattını aşan pas ve top sürme sayısı',
      PassesPerLineBreakingPass: 'Hat kırıcı pas başına toplam pas oranı',
      CarriesPerLineBreakingCarry: 'Hat kırıcı top sürme başına toplam top sürme oranı',
      LinesBrokenByPasses: 'Pasla kırılan hat sayısı (toplam)',
      LinesBrokenByCarries: 'Top sürmeyle kırılan hat sayısı (toplam)',
      LinesBrokenByActions: 'Pas ve top sürme ile kırılan hat sayısı (toplam)',
      LinesBrokenPerPass: 'Pas başına kırılan hat oranı',
      LinesBrokenPerCarry: 'Top sürme başına kırılan hat oranı',
      AvgLastDefenderDistanceIP: 'Son savunmacı (kendi kalesine en yakın oyuncu) ile kale çizgisi arasındaki mesafe (topla)',
      AvgLastDefenderDistanceOOP: 'Son savunmacı (kendi kalesine en yakın oyuncu) ile kale çizgisi arasındaki mesafe (topsuz)',
      AvgDefensiveLineDistanceIP: 'En gerideki savunma hattı ile kale arasındaki mesafe (topla)',
      AvgDefensiveLineDistanceOOP: 'En gerideki savunma hattı ile kale arasındaki mesafe (topsuz)',
      AvgRBDistanceIP: 'Sağ bek ile kendi kalesi arasındaki mesafe (topla)',
      AvgRBDistanceOOP: 'Sağ bek ile kendi kalesi arasındaki mesafe (topsuz)',
      AvgLBDistanceIP: 'Sol bek ile kendi kalesi arasındaki mesafe (topla)',
      AvgLBDistanceOOP: 'Sol bek ile kendi kalesi arasındaki mesafe (topsuz)',
      AvgBlockDistanceIP: 'En gerideki ve en ilerideki oyuncu arasındaki mesafe (topla)',
      AvgBlockDistanceOOP: 'En gerideki ve en ilerideki oyuncu arasındaki mesafe (topsuz)',
      AvgBlockAreaIP: 'Tüm saha oyuncularını çevreleyen alan (takımın kapladığı alan) (topla)',
      AvgBlockAreaOOP: 'Tüm saha oyuncularını çevreleyen alan (takımın kapladığı alan) (topsuz)',
      AvgDefensiveLineWidthOOP: 'En gerideki oyuncu hattının genişliği (topsuz)',
      AvgOffensiveLineLastThirdWidthIP: 'Son üçteki hücum hattının yatay genişliği (topla)',
      AvgLByIP: 'Sol bekin pozisyonu (topla)',
      AvgRByIP: 'Sağ bekin pozisyonu (topla)',
      AvgOffensiveLineDistanceIP: 'Kendi kalesi ile hücum hattı arasındaki mesafe (topla)',
      AvgOffensiveLineLastThirdDistanceIP: 'Kendi kalesi ile son üçteki hücum hattı arasındaki mesafe (topla)',
      AvgOffensiveLineWidthIP: 'Hücum hattının yatay genişliği (topla)',
      OffBallRuns: 'Hücumu desteklemek için niyetli topsuz koşular',
      OffBallRunsOverlap: 'Oyuncunun top taşıyan takım arkadaşının dışından (taç çizgisine yakın) yaptığı bindirme koşusu',
      OffBallRunsUnderlap: 'Oyuncunun takım arkadaşının içinden, saha merkezine daha yakın bir şekilde yaptığı koşu',
      OffBallRunsRunAhead: 'Toplu oyuncuyu geçen ancak son savunma çizgisinin önünde kalan koşu',
      OffBallRunsRunBehind: 'Son savunma hattını geçen, defans ile kaleci arasına sızan koşu',
      OffBallRunsCrossReceiver: 'Oyuncu ceza sahasına koşup orta almak için pozisyon alır',
      OffBallRunsSupport: 'Oyuncu top taşıyan oyuncunun hizasına koşar ve yakın pas seçeneği sunar',
      OffBallRunsComingShort: 'Oyuncu top taşıyana yaklaşarak yakın destek veya geri pas opsiyonu sunar',
      AerialsOppHalf: 'rakip yarı sahadaki başarılı hava topu mücadelesi',
      CarriesIntoFinalThird: 'Son üçte birlik kısmın dışından içeriye doğru en az 7 metrelik boru hatları',
      SpeedScore: 'Farklı hız ölçümlerine dayalı oyuncu fiziksel performansı',
      EnduranceScore: 'Farklı ölçümlere dayalı oyuncu dayanıklılığı fiziksel performansı',
      SwitchPlaySuccessful: 'Topun yanal yer değiştirmesinin rakip kaleye doğru yer değiştirmesinden daha büyük olduğu 32 metreyi aşan tamamlanan pasların sayısı',
      SwitchPlayTotal: 'Topun yanal deplasmanının rakip kaleye doğru deplasmanından daha fazla olduğu 32 metreyi aşan pas denemelerinin toplam sayısı',
      PassesInsideOppHalf: 'Rakip yarıda başlayan ve biten toplam pas sayısı',
      PassesInsideOppHalfSuccessful: 'Rakip yarıda başlayan ve biten tamamlanan pasların sayısı',
      TacklesAttemptedFirstThird: 'Sahanın ilk üçte birinde yapılan müdahalelerin toplam sayısı',
      TacklesAttemptedSecondThird: 'Sahanın ikinci üçte birinde yapılan toplam müdahale sayısı',
      TacklesFirstThird: 'Sahanın ilk üçte birinde yapılan başarılı müdahale sayısı',
      TacklesSecondThird: 'Sahanın ikinci üçte birinde yapılan başarılı müdahale sayısı',
      FoulsOwnHalf: 'Oyuncunun kendi yarı sahasında yaptığı faul sayısı',
      TouchesOppHalf: 'Rakip yarıdaki topa dokunma sayısı',
      TacklesAttemptedNotAdjusted: 'Topa sahip olma ayarlaması yapılmadan yapılan toplam müdahale sayısı',
      TacklesSuccessfulNotAdjusted: 'Topa sahip olma ayarlaması olmadan toplam başarılı müdahale sayısı',
      AvgTop5MaxSpeed: 'Oyuncunun en yüksek beş maksimum hızının ortalaması',
      LBPReceived: 'Alınan hat kırma paslarının sayısı. Bunlar, topu rakip kaleye en az %10 yaklaştıran ve bir çift defans oyuncusunu yakın mesafeden kesen veya savunma hattının ötesine geçen tamamlanmış paslardır.',
      LBPMReceived: 'Rakip orta saha çizgisini aşan pasların sayısı',
      LBPMDReceived: 'Hem rakip orta sahayı hem de savunma hatlarını aşan pasların sayısı',
      ThroughBallReceived: 'Rakibin son savunma hattını aşan pasların sayısı',
      HsrDistanceIP: 'Sprint mesafesi >21 km/saat topa sahipken',
      HsrDistanceOOP: 'Topun yokluğunda sürat mesafesi >21 km/saat',
      JoggingDistanceIP: 'Sahip olunan koşu mesafesi',
      JoggingDistanceOOP: 'Topun dışında koşu mesafesi',
      RunningDistanceIP: 'Sahip olunan koşu mesafesi',
      RunningDistanceOOP: 'Topun dışında koşu mesafesi',
      SprintsDistanceIP: 'Sprint mesafesi >24 km/s topa sahipken',
      SprintsDistanceOOP: 'Topun yokluğunda sürat mesafesi >24 km/saat',
      WalkingDistanceIP: 'Yürüme mesafesi',
      WalkingDistanceOOP: 'Mülkiyet dışında yürüme mesafesi',
      RunningNumberIP: 'Oyuncunun topa sahipken en az 1 saniyelik bir süre boyunca 4 m/s (14,4 km/sa) ile 5,5 m/s (19,8 km/sa) arasındaki bir hızda hareket etme sayısı',
      RunningNumberOOP: 'Oyuncunun en az 1 saniye boyunca topa sahip olmadan 4 m/s (14,4 km/sa) ila 5,5 m/s (19,8 km/sa) arasında bir hızda hareket etme sayısı',
      RunningDistancePctIP: 'Topa sahip olarak kat edilen toplam mesafeye göre Koşu Mesafesinin yüzdesi',
      RunningDistancePctOOP: 'Topa sahip olmadan kat edilen toplam mesafeye göre Koşu Mesafesinin Yüzdesi',
      RunningDistancePct: 'Kat edilen toplam mesafeye göre Koşu Mesafesinin yüzdesi',
      HsrNumberIP: 'Oyuncunun topa sahipken en az 1 saniyelik bir süre boyunca 5,5 m/s (19,8 km/saat) veya buna eşit ancak 7 m/s\'den (25,2 km/saat) daha düşük bir hızda hareket etme sayısı',
      HsrNumberOOP: 'Oyuncunun en az 1 saniyelik bir süre boyunca topa sahip olmadan 5,5 m/s (19,8 km/saat) veya buna eşit ancak 7 m/s\'den (25,2 km/saat) daha düşük bir hızda hareket etme sayısı',
      SprintsNumberIP: 'Oyuncunun topa sahipken en az 1 saniyelik bir süre boyunca 7 m/s\'ye (25,2 km/saat) eşit veya daha yüksek bir hızda hareket etme sayısı',
      SprintsNumberOOP: 'Oyuncunun en az 1 saniye boyunca topa sahip olmadan 7 m/s (25,2 km/saat) veya daha yüksek bir hızda hareket etme sayısı',
      SprintsDistancePctIP: 'Topa sahip olarak kat edilen toplam mesafeye göre Sprint Mesafesinin Yüzdesi',
      SprintsDistancePctOOP: 'Topa sahip olmadan gidilen toplam mesafeye göre Sprint Mesafesinin Yüzdesi',
      SprintsDistancePct: 'Kat edilen toplam mesafeye göre Sprint Mesafesinin yüzdesi',
      PossessionRegain: 'Rakibi kaç kez topu kaybetmeye zorladığınız',
      HandPassesSuccessful: 'Ellerle yapılan başarılı paslar (kaleciler veya duran topun atılması)',
      HandPassesTotal: 'Ellerle yapılan toplam pas sayısı (kaleciler veya duran top atışı)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Takımın topa sahip olma yüzdesi',
      TimePossession: 'Takımın Topa Sahip Olma Süresi',
      PassesPerShots: 'Şut başına verilen ortalama pas sayısı',
      PPDA: 'Rakip topa sahip olurken takımın rakip sahada ortaya koyduğu baskı',
      Directness: 'İleri doğru atılan pasların yana atılan paslara göre daha fazla olması',
      ExpectedPoints: 'Beklenen Hedeflere göre hesaplanan, bir takımın beklediği puan sayısı',
      PassesPerLongBall: 'Tamamlanan pas içerisinde başarılı uzun pas yüzdesi',
      CrossingPerXG: 'Ortalardan gelen Gol Beklentisinin yüzdesi',
      PenaltySavedPenaltyFaced: 'Karşılaşılan tüm penaltı atışlarından kurtarılan penaltı atışlarının yüzdesi',
      Goals: 'atılan gollerin sayısı',
      PenaltyShots: 'Penaltı noktasından kullanılan toplam şut sayısı',
      PenaltyGoals: 'Penaltı noktasından atılan toplam gol sayısı',
      NonPenaltyGoals: 'atılan gol (penaltı hariç)',
      AerialWins: 'kazanılan hava topu mücadelesi',
      AerialEfficiency: 'toplam hava topu mücadelesi ile kazanılan hava topu mücadelesini birleştiren metrik',
      AerialWinsPct: 'Kazanılan hava topu mücadelesi yüzdesi',
      Assists: 'başına asist',
      Catching: 'Kalecinin yakaladığı toplarda kurtarış yüzdesi',
      Caught: 'Kalecinin topu yakalayıp tuttuğu yeri kurtararak ikinci bir oyunu önler',
      ChancesCreated: 'şut pası sayısı',
      ClaimAccuracy: 'Ortalamanın üzerinde sahip olunan top',
      CompletedCrosses: 'tamamlanan başarılı orta',
      Crossing: 'Başarılı orta yüzdesi',
      Dispossessed: 'yapılan top kaybı',
      Finishing: 'Gol ile biten şut yüzdesi',
      xGEfficiency: 'Oyuncunun gol atabilmesi için gerekli gol beklentisi miktarı',
      Fouls: 'yapılan fauller',
      DeepProgression: 'Topu taşıyarak sahanın son beşte birine ulaşma sayısı artı topa son beşincide sahip olma sayısı',
      DeepProgressionFinalThird: 'başına sahanın son üçte birlik bölümünde oyuncunun top ile buluştuğu anlar',
      FoulsTaken: 'maruz kalınan fauller',
      IndividualPressure: 'başarılı çaba (topu geri kazanma)',
      Interceptions: 'yapılan atak kesme',
      LongBallPct: 'Tamamlanan en az 32 metrelik pasların yüzdesi',
      LongBallTotal: '32 metrenin üzerindeki toplam geçiş sayısı',
      LongBallSuccessful: 'tamamlanan en az 32 metrelik pas',
      NPGOpenPlay: 'Goals (excluding penalties) by open play actions',
      NPGSetPiece: 'Goals (excluding penalties) by set piece actions',
      OpenPlayKeyPasses: 'Akan Oyunda şut pası (asistler hariç)',
      OpenPlayKeyPassesInTeam: '% Takımın dakikada Akan Oyunda şut pası (asistler hariç)',
      PassingFinalThird: 'sahanın son üçte birlik bölümünde başarılı pas',
      PassesFinalThirdTotal: 'Ortalar, duran toplar, köşe vuruşları ve taç atışları hariç, son üçte birlik kısımda biten toplam pas atışı sayısı',
      PassingFinalThirdPct: 'Sahanın son üçte birlik bölümüne başarılı pas yüzdesi',
      PassingOppHalfPct: 'Rakip yarı sahaya başarılı pas yüzdesi',
      PassingOwnHalfPct: 'Kendi yara sahana başarılı pas yüzdesi',
      PassingPct: 'Başarılı Pas Yüzdesi',
      Recoveries: 'oyuncunun topu geri kazanma sayısı',
      SavesInBoxPct: 'ceza sahası içinden çekilen şutlarda kurtarış yüzdesi',
      SavesOutOfBoxPct: 'ceza sahası dışından çekilen şutlarda kurtarış yüzdesi',
      SavesPct: 'Kurtarış Yüzdesi',
      ScoringContribution: 'asist ve gol sayısı',
      xAssistsOpenPlay: 'Açık oyundan elde edilen oyun başına beklenen asist sayısı',
      xAssistsSetPiece: 'Duran toplarla oyun başına beklenen asist sayısı',
      xAssistsOpenPlayInTeam: 'Açık oyundan elde edilen takımda dakikalık oyun başına beklenen asist sayısı',
      xAssistsSetPieceInTeam: 'Duran toplarla takımda dakikalık oyun başına beklenen asist sayısı',
      xGChainFinalThird: 'Bir oyuncunun son üçte birlik kısımda yer aldığı xG miktarı',
      xGBuildupFinalThird: 'Bir oyuncunun son üçte birlik kısımda yer aldığı xG miktarı (şutlar ve şutla sonuçlanan paslar hariç)',
      BallProgressionPassing: 'Oyuncunun topu pas vererek topu 10 metre veya daha fazla ilerletme sayısı',
      BallProgressionDribbling: 'Oyuncunun topu taşıyarak topu 10 metre veya daha fazla ilerletme sayısı',
      Shooting: 'Kaleyi bulan şutların yüzdesi (penaltı hariç)',
      Shots: 'çekilen şut sayısı',
      ShotsPerGoal: 'Gol atmak için çekilen ortalama şut sayısı',
      SuccessfulDribbles: 'tamamlanan başarılı dripling',
      TacklesSuccessful: 'müdahele sayısı toplamı',
      TacklesWasDribbled: 'Müdahele ile ikili mücadele kazanma yüzdesi',
      ThroughBalls: 'defans çizgisini bozan pas sayısı',
      TouchesInOpponentBox: 'rakip ceza sahasında top kontrolü sayısı',
      xAssists: 'oluşturulan Asist Beklentisi',
      xG: 'oluşturulan Gol Beklentisi',
      xGDiff: 'xG ve Hedefler arasındaki fark',
      xGOpenPlay: 'Açık oyundan elde edilen beklenen goller',
      xGSetPiece: ' Duran Top ile oluşturulan Gol Beklentisi',
      xGBuildup: 'xG hazırlanışına katılım',
      xGBuildupInTeam: 'xG Geliştirme in Team',
      BallProgression: 'topu pas veya taşıma yolu ile ileriye götürme',
      xGChain: 'xG zincirine katılım',
      xGPerNPG: 'penaltısız gol atmak için gereken gol beklentisi',
      xGPerShot: 'Şut başına gol beklentisi',
      xGSavedPerShot: 'Çekilen şut başına kurtarılan xG ortalaması',
      xGSavedPerXGFacedOnTarget: 'Kaleyi bulan xG başına kurtarılan xG ortalaması',
      xGFacedOnTargetPerGoalReceived: 'Gol atabilmek için kaç Gol Beklentisine ihtiyaç olduğunu gösterir',
      xGFacedOnTargetEfficiency: 'kaleci tarafından önlenen Penaltı Harici Gollerin sayısı',
      xGFacedOnTarget: 'kalecinin karşılaştığı toplam xG (kurtarılan ve atılan)',
      HighTurnovers: 'Kendi kalenden 40 metre yakında yapılan top kayıpları',
      OpenPlayPassesIntoOpponentBox: 'başına akan oyunda oyuncu tarafında rakip ceza sahasına tamamlanan paslar',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'başına akan oyunda oyuncu tarafında rakip ceza sahasına tamamlanan paslar',
      ChancesCreatedOP: 'başına akan oyun sırasında şut pası sayısı',
      PenaltiesTaken: 'başına oyuncunun rakip ceza sahasında maruz kaldığı faul sayısı',
      BlockedCrosses: 'başına oyuncunun engellediği ortalar',
      BlockedShots: 'başına oyuncunun engellediği şut',
      NonPenaltyGoalsAgainst: 'başına penaltı harici yenen gollerin sayısı',
      Headers: 'Kafa ile yapılan şutların sayısı',
      AveragePassDistance: 'Metre cinsinden pasların ortalama mesafesi',
      ProgressiveRuns: 'Top rakip kaleye %20 daha fazla yaklaştıran başarılı topu taşımalar',
      xT: 'başına topu tehlikeli bölgeye taşıma ile oluşturulan tehdit',
      xTOpenPlay: 'Akan başına Akan Oyun sırasında oluşturulan Tehdit Beklentisi',
      xTSetPiece: 'duran top ile oluşturulan tehdit beklentisi',
      xGOT: 'Kalecinin karşılaştığı tüm gol beklentisi sayısı',
      BadActions: 'Hatalı Hareketler',
      BadActionsOwnHalf: 'Kendi yarı sahanda maruz kalınan tüm kötü aksiyonların toplamı',
      AerialsWonOwnBox: 'Kendi ceza sahsası içerisinde kazanılan hava topu mücadelesi',
      AerialsWonOppBox: 'Rakip ceza sahası içerisinde kazanılan hava topu sayısı',
      AerialsTotalOppBox: 'Rakip ceza sahsası içerisinde toplam hava topu mücadelesi',
      AerialsTotalOwnBox: 'Kendi ceza sahası içerisinde toplam hava topu mücadelesi',
      FoulsOwnHalfPct: 'Kendi yarı sahanda maruz kalınan faul yüzdesi',
      RecoveriesOppHalf: 'başına rakip yarı sahada topu geri kazanma',
      DuelsPct: 'İkili Mücadele Başarı Yüzdesi',
      TacklesUnsuccessful: 'Bir oyuncunun, rakibinin başarılı bir şekilde yanından geçerek topu sürmesi nedeniyle topu kazanmada başarısız olma sayısı',
      TacklesWasDribbledFirstThird: 'Oyuncunun sahanın son üçte birlik bölümünde topu kaybettikten sonra geri kazanma yüzdesi',
      TacklesWasDribbledSecondThird: 'Kazanılan 1\'e 1 Savunma Mücadeleleri ⅔',
      TacklesWasDribbledFinalThird: 'Kazanılan 1\'e 1 Savunma Mücadeleleri Topla ⅓',
      BallProgressionFinalThird: 'Oyuncunun sahanın son üçte birlik bölümüne 10 metre veya daha fazla girme sayısı',
      DuelsTotal: 'Her yapılan toplam tackle, aerials, topa dokunma, dripling ve faul sayısı',
      QuickRecoveries: 'Topu kaybettikten 8 saniye sonra kaleye 40 veya daha uzak mesafed yapılan topu geri kazanma',
      ShotsPerNPG: 'Penaltı harici gol atmak için gereken ortalama şut sayısı',
      ShotsOutBox: 'başına ceza sahası dışından şut sayısı',
      GoalsOutBox: 'başına ceza sahası dışından gol sayısı',
      ShootingOutBox: 'Ceza sahası dışından çekilen şutların yüzdesi',
      HandPassing: 'El ile pas başarısı',
      ShotEndingHighTurnovers: 'Rakip takımın şutu ile bite ntop kayıpları (kaleye 40 metreden yakın mesafede yapılan top kayıpları',
      GoalEndingHighTurnovers: 'Rakip takımın golü ile biten top kayıpları (kaleye 40 metreden yakın mesafede yapılan top kayıpları',
      AverageCarriesProgress: 'Top taşıma başına oyuncunun ortalama topu dikine taşıma mesafesi (metre)',
      ChanceEndingCarries: 'Şut pası ile biten en az 7 metre top taşıma',
      AssistEndingCarries: 'Gol pası ile biten en az 7 metre top taşıma',
      ShotEndingCarries: 'Şut ile biten en az 7 metre top taşıma',
      GoalEndingCarries: 'Gol ilte biten en az 7 metre top taşıma',
      ShotEndingSequence: 'Oyuncunun dahil olduğu şut ile biten aksiyonlar',
      GoalEndingSequence: 'Oyuncunun dahil olduğu Gol ile sonlanan aksiyonların sayısı',
      AerialWonOffensive: 'kazanılan ofansif hava topu mücadelesi',
      AerialWonDefensive: 'kazanılan defansif hava topu mücadelesi',
      xGAgainst: 'Gol Yeme Beklentisi',
      xGDiffAgainst: 'Kazanılan Farkı xG',
      xGPerNPGAgainst: 'Penaltı harici yenen gol başına Gol Beklentisi ',
      xGOpenPlayAgainst: 'Kazanılan Akan Oyun xG',
      xGSetPieceAgainst: 'Kalene yapılan Duran Top ile oluşturulan Gol Beklentisi',
      xGPerShotAgainst: 'Kaleni bulan şut başına Gol Beklentisi',
      ShotsAgainst: 'kaleni bulan şut',
      ShotsOnTargetAgainst: 'bir kaleyi bulan şutlar',
      RivalPossession: 'Rakibin topla oynaması',
      AerialDefensivePct: 'Defansif hava topu mücadelesi kazanma yüzdesi',
      HighRecoveries: 'Rakip kaleye 40 metre yakınlıkta topu geri kazanma',
      HighDefensiveActions: 'Kendi kale çizgisine 40 metre uzaklıkta yapılan defansif aksiyonların (Müdaheleler, Atak Kesmeler, Engellemeler, Fauller ve 1e1)',
      HighDefensiveActionPct: 'Kendi kale çizgisinden 40 metre uzaklıkt alınan Defansif Aksiyonların yüzdesi (Müdaheleler, Atak Kesmeler, Engellemeler, Fauller ve 1e1)',
      HighDefensiveDistance: 'Kaleye 40 metre veya daha uzakta alınan defansif aksiyonlar',
      PassesPerPossession: 'Topla Oynama Başına Pas Sayısı',
      LengthPerPossession: 'Topla Oynama Mesafesi',
      xTNet: 'Net xT',
      AvgCarriesDistance: 'Ortalama Top Taşıma Mesafesi',
      PassesForwardPct: '% İleriye Giden Paslar',
      PassesForwardSuccessful: 'Başarılı İleri Geçişler',
      PassesForwardTotal: 'Toplam İleri Paslar',
      TacklesAttempted: 'Müdahele Girişimi',
      DuelsLost: 'Kaybedilen Mücadele',
      Carries: 'Top Taşıma',
      CarriesPct: '% Top Taşıma',
      Aerials: 'Hava Topu',
      ProgressivePassesReceivedIntoBox: 'Ceza sahasında alınan ileriye dönük paslar',
      PassesOppHalf: 'Rakip sahaya atılan başarılı paslar',
      LongBallReceived: 'Alınan uzun topların (>32 metre) sayısı',
      ShotsOnTarget: 'kaleyi bulan şut sayısı',
      AggressiveActions: 'Topu kaybettikten sonra iki saniye içerisinde yapılan müdahele girişimi sayısı',
      Crosses: 'toplam açılan orta sayısı',
      xGBuildup5pass: 'Oyuncunun dahil olduğu xG sayısı, sadece son 5 pas (şut ve şut pası hariç)',
      DefensiveDistance: 'Gerçekleştirilen defansif mücadelelerin kendi kalesine ortalama uzaklığı',
      SpeedSequence: 'Takımın topa sahip oluşunun ortalama hızı (zamana göre kat edilen metre)',
      Touches: 'Oyuncunun topa sahip olma sayısı',
      AerialsTotalOppHalf: 'rakip yarı sahadaki toplam hava topu mücadelesi',
      AerialsWonOppHalf: 'Her oyun süresinde rakibin yarı sahasında başarılı hava düelloları',
      AerialsWonOppHalfPct: 'Rakip yarı sahada kazanılan hava topu mücadelesinin yüzdesi',
      AerialsPctOppBox: 'Rakip ceza sahasında kazanılan hava topu mücadelesinin yüzdesi',
      AerialsPctOwnBox: 'Kendi ceza sahanda kazanılan hava topu mücadelesinin yüzdesi',
      AerialDefensive: 'Rakip takım topa sahipken yapılan hava düellolarının toplam sayısı',
      AerialOffensive: 'Kendi takımı topa sahipken yapılan hava düellolarının toplam sayısı',
      AerialOffensivePct: 'Kendi takımı topa sahipken kazanılan hava topu düellolarının yüzdesi',
      IndividualPressureOppHalf: 'Rakip yarı sahada rakibe baskı sırasında oyuncunun başarılı çabasını (topu geri kazanma) ölçen metrik',
      TouchesPerShot: 'Şut başına oyuncuların topa dokunma sayısı',
      PassesFinalThirdTotalPct: 'Sahanın son üçte birlik bölümünde yapılan başarılı pasların yüzdesi',
      xACrosses: 'ortalar ile oluşturulan Asist Beklentisi',
      Passes: 'yapılan pasların toplamı',
      PassesSuccessful: 'tamamlanan paslar',
      TacklesWasDribbledFouls: 'Toplam top çalma ve yapılan faullerin yüzdesi olarak kazanılan top çalma yüzdesi',
      OffsidesCaught: 'Yakalanılan Ofsaylar',
      ProgressivePassesReceivedFinalThird: 'Sahanın son  ⅓ bölümünde alınan ileriye dönük paslar',
      ProgressivePassesReceived: 'Alınan ileri dönük paslar',
      Breadth: 'sahanın kenar bölgelerinde müdahaelelerin, mücadelelerin, atak kesmelerin ve maruz kalınan faullerin toplamı',
      DuelsDefTotal: 'Defansif İkili Mücadele',
      DefensiveActions: 'Rakip dripling yapmaya çalışırken alınan defansif aksiyonlar (Müdaheleler, Mücadeleler ve Fauller)',
      ProgressivePassesReceivedOppHalf: 'Rakip yarı sahada alınan ileriye dönük paslar',
      CompletedCrossesOP: 'Akan oyunda tamamlanan ortalar',
      CrossingOP: '% Akan oyunda orta',
      CrossesOP: 'Açık oyun sırasında toplam orta sayısı',
      PassingContribution: 'Karşılayanın konumunu dikkate alarak pas tehdidini ölçen yüzde',
      BallProgressionOppHalfInTeam: '% Rakip yarı sahada topu ilerletme',
      PassesOPIntoBoxInTeam: '% Akan oyunda ceza sahası içerisine paslar',
      TouchesOppBoxInTeam: '% Takımın rakip ceza sahasında topla buluşması',
      xGOPInTeam: '% Takımın açık oyunda xG',
      DeepPasses: 'Rakip kalenin 20 metrelik çapı uzaklığında yapılan ve bu alanın içinde biten paslar',
      DeepPassesTotal: 'Rakip kalenin 20 metrelik yarıçapının dışından atılan ve o alanın içinde biten pasların toplamı',
      DefensiveDuelsPct: 'Kazanılan defansif mücadelelerin toplam defansif ikili mücadelelere göre yüzdesi',
      QuickRecoveriesPct: 'Topu çabuk geri kazanma, araya girme ve müdahele girişimi yüzdesi',
      DiffDefensiveDistanceTeam: 'Oyuncunun defansif mesafesi ile kendi takımının defansif mesafesi arasındaki fark',
      xTPassing: 'Paslar ile oluşturulan Tehdit Beklentisi',
      xTPassing100Passes: 'Sadece paslar ve 100 pasta bir oluşturulan Tehdit Beklentisi',
      ProgressivePassesAccurate: 'X aksında 10 metre veya daha uzun tamamlanmış paslar',
      PassAbility: 'Tamamlanan pasın pas beklentisi oranı (xP)',
      OPPassesIntoOppBoxPct: 'Rakip ceza sahasına açık oyunda pas girişimi ve rakip ceza sahasına açık oyunda pas girişimi yüzdesi',
      EntriesOppBox: 'Rakip ceza sahasına pas ve top taşıma sayısı',
      Crosses6yardBox: 'Altı pasa açılan ortaların toplamı',
      Cutbacks: 'Son çizgiden arkaya ve rakip ceza sahasının içine pas vermek',
      xTDribbling: 'Sadece dripling kaynaklı Tehdit Beklentisi',
      AvgShotDistance: 'Her şutun ortalama kaleye uzaklığı',
      xGOnTarget: 'başına kaleyi bulan şutlar içerisinde Gol Beklentisi.',
      FinishingxGOT: 'Ortalamanın üzerinde bir golle biten şut yüzdesi',
      DribblesWonOwnHalf: 'Kendi yarı sahasında başarılı dripling',
      DribblesOwnHalf: 'Kendi yarı sahasında dripling girişimi sayısı',
      DribblesOwnHalfPct: 'Kendi yara sahasında başarılı dripling ve dripling girişimi yüzdesi',
      DribblesWonOppHalf: 'Rakip yarı sahada başarılı dripling',
      DribblesOppHalf: 'Rakip yarı sahada dripling girişimi sayısı',
      DribblesOppHalfPct: 'Rakip yarı sahada başarılı dripling ve dripling girişimi yüzdesi',
      DribblesWonFinalThird: 'Sahanın son üçte birlik bölümünde başarılı dripling',
      DribblesFinalThird: 'Sahanın son üçte birlik bölümünde dripling girişimi sayısı',
      DribblesFinalThirdPct: 'Sahanın son üçte birlik bölümünde başarılı dripling ve dripling girişimi yüzdesi',
      ShotEndingHighRecoveries: 'Şutla sonuçlanan yüksek toplar (rakip kaleye 40 metre veya daha yakın alanda kazanılan toplar)',
      PassingFinalThirdAgainst: 'Rakibin son üçlüğe yaptığı başarılı paslar',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Rakibin açık oyunda ceza sahamıza yaptığı toplam pas sayısı',
      EntriesOppBoxAgainst: 'Rakibin ceza sahamıza yaptığı pas ve top sürme giriş sayısı',
      DeepProgressionAgainst: 'Rakibin top sürerek son beşte bire ulaştığı ve topun bizim ilk beşte birde olduğu pozisyon sayısı',
      TouchesInOpponentBoxAgainst: 'Rakibin ceza sahamıza sahip olduğu toplam pozisyon sayısı',
      Score: 'Farklı metriklere dayalı oyuncu performansı',
      PDScore: 'Farklı fiziksel ölçümlere dayalı oyuncu fiziksel performansı',
      OrlegiScore: 'Farklı metriklere dayalı oyuncu performansı',
      SirScore: 'Farklı metriklere dayalı oyuncu performansı',
      ExcScore: 'Farklı metriklere dayalı oyuncu performansı',
      xTOPInTeam: 'Takımınızın toplamına göre oyunda üretilen beklenen tehlike (xT)',
      YellowCards: 'Sarı Kartlar',
      RedCards: 'Kırmızı Kartlar',
      xTOpenPlayAgainst: 'Açık oyunda başına Tehdit Beklentisi (xT)',
      xTSetPieceAgainst: 'Oyunun başına duran toplardan kaynaklanan Tehdit Beklentisi (xT)',
      NPGOpenPlayAgainst: 'Kazanılan PHG Akan Oyun',
      NPGSetPieceAgainst: 'Kazanılan PHG Duran Top',
      PassesOppHalfPerPossession: 'Topa Sahip Olma Başına Pas Rakip Yarı',
      AverageTimeRecovery: 'Ortalama Kurtarma Süresi',
      ExpectedPassing: 'Tamamlanmış olması gereken Geçişlerin Yüzdesi',
      NumPossession10Passes: 'Possessions 10 Passes',
      PassesReceived: 'Alınan Geçişler',
      PassesReceivedFinalThird: 'Passes Received Final ⅓',
      ProgressivePassesTotalPct: '% Aşamalı Geçişler',
      ShortPassesPct: 'Kısa Paslar %',
      TouchesOppBoxOppTeam: 'Oyuncu sahadayken ceza sahasında verilen rakip aksiyon sayısı',
      ShotsOnTargetOppTeam: 'Oyuncu sahadayken kaleye isabetli şut sayısı',
      NPGOppTeam: 'Oyuncu sahadayken penaltı hariç yenen gol sayısı',
      xGSetPiecePerxG: '1 xG üretmek için gereken duran top xG\'si',
      ShotsOpenPlay: 'Açık oyunda üretilen şut sayısı',
      ShotsOpenPlayAgainst: 'Açık oyunda karşılaşılan şut sayısı',
      ShotsFromDribble: 'Bir rakibi çalımladıktan sonra yapılan şutlar',
      GoalsFromDribble: 'Bir rakibi çalımladıktan sonra atılan goller',
      PassesIntoFinalThird: 'Son üçteki bölgeden yapılan başarılı paslar',
      PassesIntoFinalThirdTotal: 'Dışarıdan başlayıp son üçte birlik alanda biten toplam pas denemeleri',
      PassesInsideFinalThird: 'Son üçte (başlangıcı ve bitişi aynı bölgede olan) yapılan başarılı paslar',
      PassesInsideFinalThirdTotal: 'Son üçte birlik kısımda atılan pasların toplamı (son üçte birlik kısımda başlangıç ​​ve bitiş)',
      PassesFinalThirdNoArea: 'Son Üçüncüyü Geçti (Kutusuz)',
      PassesIntoOppBox: 'Rakip ceza sahasında sona eren başarılı paslar',
      CarriesFinalThird: 'Son üçte sona eren en az 7 metrelik top sürmeler',
      CarriesInsideFinalThird: 'Son üçte (başlangıç ve bitiş bu bölgede) yapılan en az 7 metrelik top sürmeler',
      CarriesFinalThirdNoBox: 'Son Üçüncüyü Taşıyor (Kutusuz)',
      CarriesIntoOppBox: 'Rakip ceza sahasında sona eren en az 7 metrelik top sürmeler',
      TimePossessionAgainst: 'Rakip takımın topla oynama süresi',
      TimePossessionTotal: 'Her iki takımın toplam topla oynama süresi',
      PassesInBox: 'Kendi ceza sahasında yapılan başarılı paslar',
      LongThrowInSuccessful: 'Yan çizgiden yapılan ve 20+ metreyi aşan başarılı uzun taç atışı',
      LongThrowInTotal: 'Yan çizgiden yapılan 20+ metrelik uzun taç atışlarının toplamı',
      LongThrowInPct: 'Başarılı olan uzun taç atışlarının yüzdesi (20+ metre)',
      Games: 'Oynanan Oyunlar',
      PointsPerGame: 'Maç Başına Puan',
      ExpectedPointsDiff: 'Beklenen Puan Farkı',
      PassesTotalOwnHalf: 'Kendi yarı sahasından yapılan toplam pas sayısı',
      PassesOwnHalf: 'Kendi yarı sahasından yapılan başarılı pas sayısı',
      PassesTotalOppHalf: 'Rakip yarıdan yapılan toplam pas sayısı',
      ProgressivePassesTotal: 'X ekseninde 10 metre veya daha fazla toplam geçiş sayısı',
      DuelsWon: 'Başarılı düellolar (Müdahaleler, Havalar, Topa Dokunuşlar, Driblingler ve Yapılan Fauller)',
      NonPenaltySaves: 'Penaltı atışları hariç kurtarışlar',
      BadActionsOppHalf: 'Rakip yarı alanda yapılan tüm kötü eylemlerin toplamı',
      CarriesSuccessful: 'Başarılı bir etkinlikle biten en az 7 metrelik taşıma sayısı',
      ShotsOnTargetOutBox: 'Ceza sahası dışından hedefe yapılan şutlar',
      TotalDistance: 'Toplam Mesafe',
      WalkingDistance: 'Oyuncunun maç sırasında 2 m/s\'den (7,2 km/saat) daha düşük bir hızla kat ettiği toplam mesafe',
      JoggingDistance: 'Oyuncunun maç sırasında 2 m/s (7,2 km/sa) ile 4 m/s (14,4 km/sa) arasında bir hızla kat ettiği toplam mesafe',
      RunningDistance: 'Oyuncunun maç sırasında 4 m/s (14,4 km/sa) ila 5,5 m/s (19,8 km/sa) arasında bir hızla kat ettiği toplam mesafe',
      ExtremeAccelerations: 'Oynatıcının 3 m/s\'den fazla hızlanma sayısı<sup>2</sup>',
      NumberOfRuns: '14,4 km/saat ile 19,8 km/saat arasındaki hızlarda tamamlanan koşu sayısı',
      HsrDistance: 'Depar Mesafesi> 19.8 km/h',
      HsrNumber: 'Depar Sayısı> 19.8 km/h',
      HsrDistancePct: '% HSR Mesafesi',
      SprintsNumber: 'Depar Sayısı> 25.2 km/h',
      SprintsDistance: 'Depar Mesafesi> 25.2 km/h',
      SprintNumberDeclinePct: '% Depar Miktarı Düşüşü',
      SprintDistanceDeclinePct: '% Depar Mesafesi Düşüşü',
      SprintNumberDecline: 'Maçın ikinci yarısına kıyasla yapılan sprint sayısında azalma',
      SprintDistanceDecline: 'Maçın ikinci yarısına kıyasla sprint sırasında koşulan mesafenin azalması',
      SprintDistancePct: '% Depar Mesafesi',
      Accelerations: 'İvme Miktarı',
      MaxSpeed: 'Maks. Hız',
      AvgMaxSpeed: 'Oyuncunun ulaştığı ortalama maksimum hız',
      MaxAccelerations: 'Oyuncunun ulaştığı maksimum ivme (metre/saniye²)',
      BypassedPlayersByPasses: 'Topa sahip oyuncunun başlangıçta kale tarafındaki oyuncu sayısı ile olay sonunda kale tarafındaki oyuncu sayısı arasındaki fark',
      BypassedDefendersByPasses: 'Topa sahip oyuncunun başlangıçta kale tarafındaki savunmacı sayısı ile olay sonunda kale tarafındaki savunmacı sayısı arasındaki fark',
      PassesBypassingPlayers: 'Oyuncuları geçen pas sayısı',
      PassesBypassingDefenders: 'Savunmacıları geçen pas sayısı',
      BypassedPlayersPerPass: 'Pas başına geçen toplam oyuncu sayısı',
      BypassedDefendersPerPass: 'Pas başına geçen toplam savunmacı sayısı',
      LineBreakingPasses: 'Topu en az %10 oranında rakip kaleye yaklaştıran ve yakın savunmacı çiftlerini geçen veya savunma hattının arkasından geçen tamamlanmış paslar',
      LineBreakingPassesMD: 'Orta saha ve savunma hatlarını geçen başarılı paslar',
      LineBreakingPassesM: 'Orta saha hattını geçen başarılı paslar',
      LineBreakingThroughBalls: 'Savunma hattını geçen başarılı paslar',
      LineBreakingPassesPerPass: 'Pas başına kırılan hat sayısı',
      TotalPassesUnderStrongPressure: 'Yoğun baskı altında (0-2 metre mesafedeki rakip oyuncu) yapılan toplam pas sayısı',
      TotalPassesUnderLightPressure: 'Hafif baskı altında (2-4 metre mesafedeki rakip oyuncu) yapılan toplam pas sayısı',
      SuccessfulPassesUnderStrongPressure: 'Yoğun baskı altında (0-2 metre mesafedeki rakip oyuncu) yapılan başarılı pas sayısı',
      SuccessfulPassesUnderLightPressure: 'Hafif baskı altında (2-4 metre mesafedeki rakip oyuncu) yapılan başarılı pas sayısı',
      PassingUnderStrongPressure: 'Yoğun baskı altında (0-2 metre mesafedeki rakip oyuncu) yapılan başarılı pas yüzdesi',
      PassingUnderLightPressure: 'Hafif baskı altında (2-4 metre mesafedeki rakip oyuncu) yapılan başarılı pas yüzdesi',
      PassReceiptsInSpaceCompleted: 'Pas alıcısının hücum yarı sahasında olduğu ve kale yönüne doğru 5 metre yarıçapında savunmacı bulunmadığı durumdaki paslar',
      PassReceiptsInSpace: 'Hücum yarı sahasında alınıp, kale yönüne doğru 5 metre yarıçapında savunmacı bulunmayan paslar',
      PassReceiptsInSpaceCompletedFirstThird: 'Alıcının ilk üçte bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedSecondThird: 'Alıcının ikinci üçte bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedFinalThird: 'Alıcının son üçte bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Alıcının rakip yarı sahanın sağında bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Alıcının rakip yarı sahanın ortasında bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Alıcının rakip yarı sahanın solunda bulunduğu ve kaleye doğru 5 metrelik yarıçapta savunmacı olmayan paslar',
      PassReceiptsInSpaceFirstThird: 'İlk üçte alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceSecondThird: 'İkinci üçte alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceFinalThird: 'Son üçte alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceOppHalfRight: 'Rakip yarı sahanın sağında alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceOppHalfCenter: 'Rakip yarı sahanın ortasında alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      PassReceiptsInSpaceOppHalfLeft: 'Rakip yarı sahanın solunda alınan ve kaleye doğru 5 metrelik yarıçapta savunmacı bulunmayan paslar',
      TotalStrongOnBallPressures: 'Topa sahip oyuncuya yapılan yoğun baskı sayısı (0-2 metre içinde)',
      TotalLightOnBallPressures: 'Topa sahip oyuncuya yapılan hafif baskı sayısı (2-4 metre içinde)',
      SuccessfulStrongOnBallPressures: 'Başarılı yoğun baskı sayısı (0-2 metre içinde)',
      SuccessfulLightOnBallPressures: 'Başarılı hafif baskı sayısı (2-4 metre içinde)',
      StrongOnBallPressuresPct: 'Başarılı ve toplam yoğun baskı yüzdesi (0-2 metre mesafede)',
      LightOnBallPressuresPct: 'Başarılı ve toplam hafif baskı yüzdesi (2-4 metre mesafede)',
      TimesBypassedByPasses: 'Pasla geçilme sayısı (toplam)',
      TimesBypassedByCarries: 'Top sürerek geçilme sayısı (toplam)',
      TimesBypassedByActions: 'Pas ve top sürme ile geçilme sayısı (toplam)',
      BypassedPlayersByCarries: 'Top sürerek geçilen rakip sayısı (savunmacı ve orta saha)',
      BypassedDefendersByCarries: 'Top sürerek geçilen savunmacı sayısı',
      BypassedPlayersByActions: 'Pas ve top sürme ile geçilen rakip sayısı (savunmacı ve orta saha)',
      BypassedDefendersByActions: 'Pas ve top sürme ile geçilen savunmacı sayısı',
      CarriesBypassingPlayers: 'Oyuncu geçen top sürme sayısı',
      CarriesBypassingDefenders: 'Savunmacı geçen top sürme sayısı',
      BypassedPlayersPerCarry: 'Top sürme başına geçilen rakip ortalaması',
      BypassedDefendersPerCarry: 'Top sürme başına geçilen savunmacı ortalaması',
      LineBreakingCarries: 'Savunma hattını aşan top sürme sayısı',
      LineBreakingCarriesMD: 'Orta saha ve savunma hatlarını aşan top sürme sayısı',
      LineBreakingCarriesM: 'Orta saha hattını aşan top sürme sayısı',
      LineBreakingCarriesD: 'Savunma hattını aşan top sürme sayısı',
      LineBreakingCarriesPerCarry: 'Top sürme başına hat aşma yüzdesi',
      LineBreakingActions: 'Savunma hattını aşan pas ve top sürme sayısı (birlikte)',
      LineBreakingActionsMD: 'Orta saha ve savunma hatlarını aşan pas ve top sürme sayısı',
      LineBreakingActionsM: 'Orta saha hattını aşan pas ve top sürme sayısı',
      LineBreakingActionsD: 'Savunma hattını aşan pas ve top sürme sayısı',
      PassesPerLineBreakingPass: 'Hat kırıcı pas başına toplam pas oranı',
      CarriesPerLineBreakingCarry: 'Hat kırıcı top sürme başına toplam top sürme oranı',
      LinesBrokenByPasses: 'Pasla kırılan hat sayısı (toplam)',
      LinesBrokenByCarries: 'Top sürmeyle kırılan hat sayısı (toplam)',
      LinesBrokenByActions: 'Pas ve top sürme ile kırılan hat sayısı (toplam)',
      LinesBrokenPerPass: 'Pas başına kırılan hat oranı',
      LinesBrokenPerCarry: 'Top sürme başına kırılan hat oranı',
      AvgLastDefenderDistanceIP: 'Son savunmacı (kendi kalesine en yakın oyuncu) ile kale çizgisi arasındaki mesafe (topla)',
      AvgLastDefenderDistanceOOP: 'Son savunmacı (kendi kalesine en yakın oyuncu) ile kale çizgisi arasındaki mesafe (topsuz)',
      AvgDefensiveLineDistanceIP: 'En gerideki savunma hattı ile kale arasındaki mesafe (topla)',
      AvgDefensiveLineDistanceOOP: 'En gerideki savunma hattı ile kale arasındaki mesafe (topsuz)',
      AvgRBDistanceIP: 'Sağ bek ile kendi kalesi arasındaki mesafe (topla)',
      AvgRBDistanceOOP: 'Sağ bek ile kendi kalesi arasındaki mesafe (topsuz)',
      AvgLBDistanceIP: 'Sol bek ile kendi kalesi arasındaki mesafe (topla)',
      AvgLBDistanceOOP: 'Sol bek ile kendi kalesi arasındaki mesafe (topsuz)',
      AvgBlockDistanceIP: 'En gerideki ve en ilerideki oyuncu arasındaki mesafe (topla)',
      AvgBlockDistanceOOP: 'En gerideki ve en ilerideki oyuncu arasındaki mesafe (topsuz)',
      AvgBlockAreaIP: 'Tüm saha oyuncularını çevreleyen alan (takımın kapladığı alan) (topla)',
      AvgBlockAreaOOP: 'Tüm saha oyuncularını çevreleyen alan (takımın kapladığı alan) (topsuz)',
      AvgDefensiveLineWidthOOP: 'En gerideki oyuncu hattının genişliği (topsuz)',
      AvgOffensiveLineLastThirdWidthIP: 'Son üçteki hücum hattının yatay genişliği (topla)',
      AvgLByIP: 'Sol bekin pozisyonu (topla)',
      AvgRByIP: 'Sağ bekin pozisyonu (topla)',
      AvgOffensiveLineDistanceIP: 'Kendi kalesi ile hücum hattı arasındaki mesafe (topla)',
      AvgOffensiveLineLastThirdDistanceIP: 'Kendi kalesi ile son üçteki hücum hattı arasındaki mesafe (topla)',
      AvgOffensiveLineWidthIP: 'Hücum hattının yatay genişliği (topla)',
      OffBallRuns: 'Hücumu desteklemek için niyetli topsuz koşular',
      OffBallRunsOverlap: 'Oyuncunun top taşıyan takım arkadaşının dışından (taç çizgisine yakın) yaptığı bindirme koşusu',
      OffBallRunsUnderlap: 'Oyuncunun takım arkadaşının içinden, saha merkezine daha yakın bir şekilde yaptığı koşu',
      OffBallRunsRunAhead: 'Toplu oyuncuyu geçen ancak son savunma çizgisinin önünde kalan koşu',
      OffBallRunsRunBehind: 'Son savunma hattını geçen, defans ile kaleci arasına sızan koşu',
      OffBallRunsCrossReceiver: 'Oyuncu ceza sahasına koşup orta almak için pozisyon alır',
      OffBallRunsSupport: 'Oyuncu top taşıyan oyuncunun hizasına koşar ve yakın pas seçeneği sunar',
      OffBallRunsComingShort: 'Oyuncu top taşıyana yaklaşarak yakın destek veya geri pas opsiyonu sunar',
      AerialsOppHalf: 'rakip yarı sahada kazanılan hava topu mücadelesi',
      CarriesIntoFinalThird: 'Son üçte birlik kısmın dışından içeriye doğru en az 7 metrelik boru hatları',
      DribblesAttempted: 'Denenen top sürme sayısı',
      SpeedScore: 'Farklı hız ölçümlerine dayalı oyuncu fiziksel performansı',
      EnduranceScore: 'Farklı ölçümlere dayalı oyuncu dayanıklılığı fiziksel performansı',
      GoalsConceded: 'Yenilen gol sayısı',
      HeadedGoals: 'Kafayla atılan gol sayısı',
      SavesInBox: 'Ceza sahası içindeki şutlardan kurtarılanların sayısı',
      SavesOutBox: 'Ceza sahası dışındaki şutlardan kurtarılanların sayısı',
      ShotsOnTargetInBoxAgainst: 'Ceza sahası içinden kaleyi bulan şutların sayısı',
      ShotsOnTargetOutBoxAgainst: 'Ceza sahası dışından kaleyi bulan şut sayısı',
      SwitchPlaySuccessful: 'Topun yanal yer değiştirmesinin rakip kaleye doğru yer değiştirmesinden daha büyük olduğu 32 metreyi aşan tamamlanan pasların sayısı',
      SwitchPlayTotal: 'Topun yanal deplasmanının rakip kaleye doğru deplasmanından daha fazla olduğu 32 metreyi aşan pas denemelerinin toplam sayısı',
      PassesInsideOppHalf: 'Rakip yarıda başlayan ve biten toplam pas sayısı',
      PassesInsideOppHalfSuccessful: 'Rakip yarıda başlayan ve biten tamamlanan pasların sayısı',
      TacklesAttemptedFirstThird: 'Sahanın ilk üçte birinde yapılan müdahalelerin toplam sayısı',
      TacklesAttemptedSecondThird: 'Sahanın ikinci üçte birinde yapılan toplam müdahale sayısı',
      TacklesFirstThird: 'Sahanın ilk üçte birinde yapılan başarılı müdahale sayısı',
      TacklesSecondThird: 'Sahanın ikinci üçte birinde yapılan başarılı müdahale sayısı',
      FoulsOwnHalf: 'Oyuncunun kendi yarı sahasında yaptığı faul sayısı',
      TouchesOppHalf: 'Rakip yarıdaki topa dokunma sayısı',
      TacklesAttemptedNotAdjusted: 'Topa sahip olma ayarlaması yapılmadan yapılan toplam müdahale sayısı',
      TacklesSuccessfulNotAdjusted: 'Topa sahip olma ayarlaması olmadan toplam başarılı müdahale sayısı',
      AvgTop5MaxSpeed: 'Oyuncunun en yüksek beş maksimum hızının ortalaması',
      LBPReceived: 'Alınan hat kırma paslarının sayısı',
      LBPMReceived: 'Rakip orta saha çizgisini aşan pasların sayısı',
      LBPMDReceived: 'Hem rakip orta sahayı hem de savunma hatlarını aşan pasların sayısı',
      ThroughBallReceived: 'Rakibin son savunma hattını aşan pasların sayısı',
      ShortPassesSuccessful: 'Tamamlanan kısa geçiş sayısı (12 metreden az)',
      PassingSuccessForwardPct: 'Başarılı ileri pasların yüzdesi',
      PassingSuccessBackwardPct: 'Başarılı geri pasların yüzdesi',
      PassingForwardBackwardPct: 'İleri pasların geri paslara oranı',
      LongBallPerPassesPct: 'Toplam paslara göre uzun topların yüzdesi',
      LongBallReceivedOppHalf: 'Rakip sahada alınan uzun topların sayısı',
      OffensiveActions: 'Saldırgan eylemler',
      SuccessfulDribblesPct: 'Başarılı top sürmeler/yapılan toplam top sürme denemeleri',
      OffensiveTouchesOutBoxPct: 'Ceza sahası dışındaki hücum dokunuşlarının yüzdesi',
      HsrDistanceIP: 'Sprint mesafesi >21 km/saat topa sahipken',
      HsrDistanceOOP: 'Topun yokluğunda sürat mesafesi >21 km/saat',
      JoggingDistanceIP: 'Sahip olunan koşu mesafesi',
      JoggingDistanceOOP: 'Topun dışında koşu mesafesi',
      RunningDistanceIP: 'Sahip olunan koşu mesafesi',
      RunningDistanceOOP: 'Topun dışında koşu mesafesi',
      SprintsDistanceIP: 'Sprint mesafesi >24 km/s topa sahipken',
      SprintsDistanceOOP: 'Topun yokluğunda sürat mesafesi >24 km/saat',
      WalkingDistanceIP: 'Yürüme mesafesi',
      WalkingDistanceOOP: 'Mülkiyet dışında yürüme mesafesi',
      PossessionRegain: 'Rakibi kaç kez topu kaybetmeye zorladığınız',
      HandPassesSuccessful: 'Ellerle yapılan başarılı paslar (kaleciler veya duran topun atılması)',
      HandPassesTotal: 'Ellerle yapılan toplam pas sayısı (kaleciler veya duran top atışı)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS\'ler',
      BadActionsOppHalf: 'BAOPF',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SOB',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRMS',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Rakip Yarı Sahasında Hava Topu ',
    CarriesIntoFinalThird: 'Sona Kadar Gidiyor ⅓',
    scoreDifference: 'Puan Farkı: Bu oyunun performansının sezon ortalamasının üstünde mi yoksa altında mı olduğunu gösterir',
    SpeedScore: 'Hız Güç Puanı',
    EnduranceScore: 'Dayanıklılık Puanı',
    HeadedShots: 'Kafa vuruşları',
    HeadedXG: 'xG başlı',
    HeadedSetPieceTooltip: 'Yalnızca duran toplardan kafa vuruşu yapan oyuncular gösteriliyor',
    SwitchPlaySuccessful: 'Başarılı Oynatmayı Değiştir',
    SwitchPlayTotal: 'Oynatma Toplamını Değiştir',
    PassesInsideOppHalf: 'Opp Half\'ın içinden geçer',
    PassesInsideOppHalfSuccessful: 'Opp İçerisinden Geçer Yarı Başarılı',
    TacklesAttemptedFirstThird: 'İlk Girişilen Mücadele ⅓',
    TacklesAttemptedSecondThird: 'İkinci Girişim ⅓',
    TacklesFirstThird: 'İlk Önce Başarılı Bir Şekilde Mücadele Ediyor ⅓',
    TacklesSecondThird: 'Başarılı İkinci ⅓',
    FoulsOwnHalf: 'Kendi Yarısının Faulleri',
    TouchesOppHalf: 'Rakibin Yarısına Dokunuyor',
    TacklesAttemptedNotAdjusted: 'Top çalma girişiminde bulunuldu Ayarlanmadı',
    TacklesSuccessfulNotAdjusted: 'Başarılı Mücadele Edildi Ayarlanmadı',
    AvgTop5MaxSpeed: 'Ort. İlk5 Maksimum Hız',
    LBPReceived: 'Alınan Hat Kırma Geçişleri',
    LBPMReceived: 'Alınan Hat Kırma Geçişleri (M Hattı)',
    LBPMDReceived: 'Alınan Hat Kırma Geçişleri (MD Hattı)',
    ThroughBallReceived: 'Alınan Toplar Arasından',
    recoveriesRate: 'Geri Kazanım Oranı',
    turnoversRate: 'Kayıp Oranı',
    HsrDistanceIP: 'HSR Mesafe IP\'si',
    HsrDistanceOOP: 'HSR Mesafesi OOP',
    JoggingDistanceIP: 'Koşu Mesafesi IP\'si',
    JoggingDistanceOOP: 'Koşu Mesafesi OOP',
    RunningDistanceIP: 'Koşu Mesafesi IP\'si',
    RunningDistanceOOP: 'Koşu Mesafesi OOP',
    SprintsDistanceIP: 'Sprint Mesafe IP\'si',
    SprintsDistanceOOP: 'Sprint Mesafesi OOP',
    WalkingDistanceIP: 'Yürüme Mesafesi IP',
    WalkingDistanceOOP: 'Yürüme Mesafesi OOP',
    PossessionRegain: 'Topa Sahip Olmayı Yeniden Kazanma',
    HandPassesSuccessful: 'Başarılı El Geçişleri',
    HandPassesTotal: 'El Geçişleri',
    SprintsNumberIP: 'Sprint Sayısı IP\'si',
    SprintsNumberOOP: 'Sprint Miktarı OOP',
    RunningNumberIP: 'Çalıştırma Miktarı IP\'si',
    RunningNumberOOP: 'Çalıştırılan Miktar OOP',
    HsrNumberIP: 'HSR Miktarı IP',
    HsrNumberOOP: 'HSR Miktarı OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Takım sayfası',
    subtitle: 'Takımın özelliklerini ve istatistiklerini daha derinlemesine inceleyin',
    averageAge: 'Ort. yaş',
    transferBalance: 'Transfer Dengesi',
    roster: 'Kadro',
    stadium: 'Stadyum',
    coach: 'Antrenör',
    transfers: 'Transferler',
    trends: 'Trendler',
    loans: 'Kiralıklar',
    loanFrom: 'kiralık',
    loanTo: 'kiralık',
    latestGames: 'Son Maç',
    latestXGames: 'Son {0} Maç',
    playingFor: 'için oynamak',
    overview: 'Genel Bakış',
    visualization: 'Görselleştirme',
    location: 'Konum',
    outcome: 'Sonuç',
    beeswarm: 'Sıralama',
    parentTeam: 'As Takım',
    childTeam: 'Genç Takım',
    preferredFormation: 'Tercih Edilen Formasyon',
    mostFrecuentFormations: 'En sık görülen oluşumlar',
    viewType: 'Görünüm Türü',
    overviewTab: {
      axisXTotal: 'Toplam',
      axisXper90: '90 dakika başına',
      dataPerGameText: 'Maç başına veri',
      season: 'Sezon',
      last: 'Son',
      current: 'Güncel',
      TeamStyle: 'Oyun Stili',
      TeamDefensive: 'Defansif',
      TeamOffensive: 'Ofansif',
      TeamCustom1: 'Özel 1',
      TeamCustom2: 'Özel 2',
      TeamCustom3: 'Özel 3',
      TeamCustom4: 'Özel 4',
      coach: 'Antrenör',
      groups: {
        Goals: {
          name: 'Goller',
          desc: 'Penaltı Gollerini ve Penaltı Harici Golleri (Akan Oyun Ve Set Oyunu) gösterir.'
        },
        Assists: {
          name: 'Asistler',
          desc: 'Bu sezon daha fazla asisti olan (Akan Oyun ve Set Oyunu) oyuncular.'
        },
        xG: {
          name: 'Gol Beklentisi',
          desc: 'Akan Oyun ve Set Oyununda oluşan Gol Beklentisi toplam xG’ye göre azalarak sıralanır'
        },
        xA: {
          name: 'Asist Beklentisi',
          desc: 'Akan Oyun ve Set Oyunu ile Asist Beklentisi.'
        },
        Finishing: {
          name: 'Bitiricilik',
          desc: 'Gol ile biten şutların yüzdesi.'
        },
        ScoringContribution: {
          name: 'Skor Katkısı',
          desc: 'Takımın Asist ve Gol Sayıları.'
        },
        xT: {
          name: 'Tehdit Beklentisi',
          desc: 'Akan Oyuna, Set Oyununa ve negatif xT ile oluşturulan Tehdit Beklentisi.'
        }
      },
      stats: {
        openPlay: 'Akan Oyun',
        setPiece: 'Duran Top',
        negative: 'Negatif',
        npg: 'Penaltı Harici Goller',
        goalsPenalty: 'Penaltı Golleri',
        npgOpenPlay: 'PHG Akan Oyun',
        npgSetPiece: 'PHG Duran Top',
        assists: 'Asistler',
        assistsConceded: 'Yenilen Asistler',
        assistsOpenPlay: 'Asist Akan Oyun',
        assistsSetPiece: 'Asist Duran Top ',
        xGOpenPlay: 'xG Akan Oyun',
        xGSetPiece: 'xG Duran Top ',
        xAOpenPlay: 'xA Akan Oyun',
        xASetPiece: 'xA Duran Top',
        xAConceded: 'Yenilen xA',
        nonPenaltyShots: 'Penaltı Harici Şutlar',
        penaltyShots: 'Penaltı Şutlar',
        xT: 'Tehdit Beklentisi',
        xTOpenPlay: 'xT Akan Oyun',
        xTSetPiece: 'xT Duran Top ',
        xTNeg: 'Negatif xT',
        totalFinishing: 'Bitiricilik',
        nonPenaltyFinishing: 'Penaltısız Bitiricilik',
        goalsPenaltyFinishing: 'Penaltı Bitiriciliği',
        goal: 'Amaç',
        notGoal: 'Gol Değil',
        chance: 'Şans',
        finished: 'Bitti',
        notFinished: 'Bitmedi',
        walkingDistance: 'Yürüme',
        joggingDistance: 'Jogging',
        runningDistance: 'Koşu',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprint',
        runningNumber: 'Koşu Sayısı',
        hsrNumber: 'HSR Sprint Sayısı',
        sprintsNumber: 'Sprint Sayısı',
        maxSpeed: 'Maksimum Hız',
        accelerations: 'Hızlanmalar',
        extremeAccelerations: 'Aşırı hızlanmalar',
        maxAcceleration: 'Maksimum hızlanma'
      }
    },
    teamAnalysis: 'Takım Analizi',
    agentView: {
      positions: {
        gk: 'KL',
        leftFullback: 'Sol Bek',
        centralDefender: 'Stoper',
        rightFullback: 'Sağ Bek',
        midfielder: 'Orta Saha',
        attackingMidfielder: 'Ofansif Orta Saha',
        leftWinger: 'Sol Kanat',
        rightWinger: 'Sağ Kanat',
        fw: 'SNT'
      },
      groups: {
        contractEnd: 'Ay',
        age: 'Yaşında',
        availability: 'Uygunluk'
      },
      placer: {
        legend: 'Yaşa, kontrata, uygunluğa ve performansa bağlı önem'
      }
    },
    transfersTab: {
      valueMovements: 'Hareketlerin Değeri',
      valueTransfers: 'Transfer Değeri',
      valueLoans: 'Kiralıkların Değeri',
      avgAgeMovements: 'Hareketlerin Ort. Yaşı',
      avgAgeTransfers: 'Transferlerin Ort. Yaşı',
      avgAgeLoans: 'Kiralıkların Ort. Yaşı',
      operations: {
        buys: {
          buy: 'Satın Alma',
          loan: 'Kiralık',
          'end of loan': 'Kiralama Sonu',
          'free transfer': 'Ücretsiz Transfer',
          free: 'Ücretsiz',
          'loan transfer': 'Kiralık',
          other: 'Diğer'
        },
        sells: {
          buy: 'Satılık',
          loan: 'Kiralık',
          'end of loan': 'Kiralama Sonu',
          'free transfer': 'Ücretsiz',
          free: 'Ücretsiz',
          'loan transfer': 'Kiralık',
          other: 'Diğer',
          retired: 'Geri çekildi'
        }
      }
    },
    trendsTab: {
      streaks: 'Çizgiler',
      wins: 'Kazanır',
      cleanSheets: 'Temiz Çarşaflar',
      goalPeriods: 'Gol Atılan Dönemler',
      concededGoalPeriods: 'Gol Yenilen Dönemler',
      comebacks: 'Geri Dönüşler',
      avgTime: 'Ortalama Süre',
      kindOfGoals: 'Tür Hedefler',
      percentWinning: '% Kazanmak',
      percentDrawing: '% Çizim',
      percentLosing: '% Kaybetmek',
      totalOf: 'Toplam',
      minutes: 'dakika',
      before: 'Önce',
      after: 'Sonra',
      playedOn: 'Üzerinde oynandı',
      scored: 'Puanlandı',
      conceded: 'Kabul Edildi',
      ownGoals: 'Kendi Kalesine',
      phasesOfGame: 'Oyunun Evreleri',
      intensityLabel: 'Bölge yoğunluğu',
      intensityByTeam: 'Takıma göre %',
      intensityByLeagueAvg: 'Lig ortalamasına göre %',
      buildup: 'Kurulum',
      midfieldProgression: 'Orta saha ilerleyişi',
      attackOpposition: 'Rakibe saldırı',
      attackingTransition: 'Hücuma geçiş',
      highPress: 'Yüksek pres',
      midBlock: 'Orta blok',
      lowBlock: 'Düşük blok',
      defensiveTransition: 'Savunmaya geçiş',
      draws: 'Beraberlikler',
      losts: 'Kaybetmeler',
      chokes: 'Tuhafazalar',
      zoneTooltip: 'Her bloğun renk gradyanı için kullanılan kriterleri belirler:',
      teamPctTooltip: 'Takımın her bölgede oynadığı toplam sürenin yüzdesine dayanır.',
      leagueAvgPctTooltip: 'Takımın yüzdesini her bölge için lig ortalamasıyla karşılaştırır.',
      leagueAvgMinsTooltip: 'Aynı karşılaştırma kriterlerini lige göre uygular ancak toplam süreyi yüzdeler yerine dakika cinsinden değerlendirir.',
      losses: 'kayıplar',
      results: 'Sonuçlar',
      kindOfConcededGoals: 'Yenilen Gol Türleri',
      showMinutes: 'Dakikaları Göster'
    },
    onOff: 'Aç/Kapat',
    dragUpToXPlayers: '{x} oyuncuya kadar sürükle',
    selectUpToXPlayers: '{x} oyuncuya kadar seç',
    onOffTab: {
      G90: 'Gol 90',
      GA90: '90’a karşı goller',
      diffG90: 'Gol Farkı 90',
      XG90: 'xG 90',
      XGA90: 'xG Karşı 90',
      diffXG90: 'xG Fark 90',
      playersOn: 'Kombo Açık',
      playersOff: 'Kombo Kapalı',
      ground: 'Zemin',
      playersOnThePitch: 'Sahadaki oyuncular',
      playersOffThePitch: 'Saha dışındaki oyuncular',
      attackTitle: 'Atak',
      attackSubTitle: 'Ofansif İstatistikler',
      defenseTitle: 'Defans',
      defenseSubTitle: 'Defansif İstatistikler',
      associationTitle: 'Birlik',
      associationSubTitle: 'İlişkili İstatistikler',
      comboOn: 'Aktif Kombo',
      comboOff: 'Herhangi Başka',
      diffGoals90: 'G Fark 90',
      goals90: 'Penaltı Harici Goller 90',
      goalsAgainst90: 'Penaltı Harici Goller 90',
      xgAgainstPer90: 'xG Karşı 90',
      xgDiffPer90: 'xG Fark 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Kaleyi Bulan Şut 90',
      touchesOppBox90: 'Rakip Ceza Sahasında Topla Buluşma 90',
      shotsOnTargetAgainst90: 'Kaleyi Bulan Şutlar 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Direktlik 90',
      possession: 'Topla Oynama %',
      pctPasses: 'Pas %',
      pctPassesFinalThird: 'Sahanın son üçte birlik bölümünde pas %',
      placeholder: 'Bir takım seçerek başlayın',
      subtitle: 'Takımın metriklerini, kadroya oyuncu ekleyerek veya çıkararak optimize edin'
    },
    terms: {
      short: 'Kısa Dönem',
      mid: 'Yarı Dönem',
      long: 'Uzun Dönem'
    },
    report: {
      title: 'Takım Raporu',
      selectedPeriod: 'Seçilen Dönem',
      stackedCharts: 'Yığılmış Grafikler',
      radars: 'Radarlar',
      generalData: 'Genel Veriler',
      scoringChances: 'Gol Fırsatları',
      areasReport: 'Bölgeler Raporu',
      setPieceReport: 'Duran Top Raporu',
      corners: 'Kornerler',
      cornersAgainst: 'Kornerler Karşı',
      indirectFreeKicks: 'Dolaylı Serbest Vuruşlar',
      indirectFreeKicksAgainst: 'Dolaylı Serbest Vuruşlar Karşı',
      freeKicks: 'Serbest Vuruşlar',
      freeKicksAgainst: 'Serbest Vuruşlar Karşı',
      penaltys: 'Penaltılar',
      freeKicksContribution: 'Serbest Vuruş Katkısı',
      shotsContribution: 'Şut Katkısı',
      topXPlayersByStats: 'İstatistiklere Göre En İyi {x} Oyuncu',
      lastShotZone: 'Son Şut Bölgesi',
      throwSide: 'Taç Tarafı',
      kindOfThrow: 'Taç Türü',
      scored: 'Atılan',
      against: 'Karşı',
      perGame: 'Maç Başına',
      total: 'Toplam',
      efficiency: 'Verimlilik',
      organizedAttack: 'Organize Hücum',
      offTransition: 'Hücum Geçişi',
      chances: 'Fırsatlar',
      chancesScored: 'Gol Fırsatları Sonuçlanan',
      chancesAgainst: 'Fırsatlar Karşı',
      goalsScored: 'Atılan Goller',
      goalsAgainst: 'Yenilen Goller',
      goalsOrganizedAttack: 'Organize Hücum Golleri',
      goalsOffTransition: 'Geçiş Hücumu Golleri',
      goalsSetPiece: 'Duran Top Golleri',
      goalsOrganizedAttackScored: 'Organize Hücum Atılan Goller',
      goalsOrganizedAttackAgainst: 'Organize Hücum Yenilen Goller',
      goalsOffTransitionScored: 'Geçiş Hücumu Atılan Goller',
      goalsOffTransitionAgainst: 'Geçiş Hücumu Yenilen Goller',
      goalsSetPieceScored: 'Duran Top Atılan Goller',
      goalsSetPieceAgainst: 'Duran Top Yenilen Goller',
      crossSide: 'Orta Tarafı',
      externalShot: 'Dış Şut',
      innerPlay: 'İç Oyun',
      throwIn: 'Taç Atışı',
      box: 'Ceza Sahası',
      zone2: 'Bölge 2',
      goalsPerPhases: 'Aşamalara Göre Goller'
    },
    minutesAlert: '*Sadece 450 veya daha fazla dakika oynamış oyuncular gösteriliyor',
    minutesException: '450 veya daha fazla dakika oynamış hiçbir oyuncu yok. Tüm oyuncular gösteriliyor',
    analysis: 'Analiz',
    substitutions: 'Oyuncu Değişiklikleri',
    attackZones: 'Atak Bölgeleri',
    formations: 'Formasyonlar',
    shotZones: 'Şut Bölgeleri',
    crossings: 'Ortalar',
    byTime: 'Zamana Göre',
    byPosition: 'Pozisyona Göre',
    byPlayer: 'Oyuncuya Göre',
    W: 'Galibiyet',
    D: 'Beraberlik',
    L: 'Mağlubiyet',
    substitutionsByGame: 'Maç başına Oyuncu Değişikliği',
    substitutionsShort: 'OD.',
    avgSeasonShort: 'Ort. Sezon',
    startingAt: 'Başlıyor',
    endingAt: 'Bitiyor',
    startingAtInfo: 'İlk olayın yerine dayalı sahip olma payını gösterir',
    endingAtInfo: 'Son olayın yerine dayalı sahip olma payını gösterir',
    endingWithShot: 'Şut ile Bitirme',
    endingInBox: 'Ceza Sahasında Bitirme',
    pfX: 'PF {x}',
    bySide: 'Kenardan',
    cornerKicks: 'Köşe Vuruşu',
    included: 'Dahil',
    excluded: 'Hariç',
    onlyCorner: 'Sadece Korner',
    sizeByMarketValue: 'Piyasa Değerine Göre Boyut',
    timeInTeam: 'Takımdaki Mevsimler',
    newSignings: 'Yeni Transferler',
    sizeBy: 'Size by',
    connections: 'Connections',
    assistant: 'Passer',
    finisher: 'Finisher',
    playersMinutesAlert: 'Seçilen sezonda dakika almış oyuncular gösteriliyor',
    strategyFilterTooltip: 'Duran toplar veya açık oyun sırasında meydana gelen olayları görüntüleyin',
    sideFilterTooltip: 'Yalnızca seçilen tarafta (sol veya sağ) başlayan duran parçaları görüntüle',
    teamMinutesAlert: '*Yalnızca 450 veya daha fazla dakika oynayan takımlar gösteriliyor',
    homeCoach: 'Ev Koçu',
    awayCoach: 'Deplasman Antrenörü'
  },
  leagueTable: {
    subtitle: 'Liglerin durumuna bak'
  },
  leagueMatchdays: {
    byRound: 'Tura göre',
    byDate: 'Tarihe göre',
    byTeam: 'Takıma göre'
  },
  teamStats: {
    subtitle: 'Takımların performansını karşılaştır',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Difference between Expected Goals and Goals',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Difference between Expected Points and Points',
    games: 'GAM',
    gamesExplicit: 'Games played',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Points per Game'
  },
  roles: {
    ROLE_USER: 'Kullanıcı',
    ROLE_ADMIN: 'Yönetici',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Takip',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Oyuncu, takım, oyun ve lig bilgilerini JSON formatında zahmetsizce ayıklayın.',
    ROLE_EVENTING_DATA_description: 'Radar Grafikleri, Oyuncu Sıralamaları, haritalar ve +100 performans ölçütüne dayalı daha fazlası ile istatistiklerin derinliklerine dalın.',
    ROLE_PHYSICAL_DATA_description: 'Kondisyon verilerine erişin ve oyuncuları çeşitli performans ölçütlerine (mesafe, hız, sprint, hızlanma...) göre filtreleyin.',
    ROLE_VIDEO_description: 'Videolar ve kadrolar sağlayın ve derinlemesine analiz için etkinlikler ve istatistiklerle etiketlenmiş maçlar alın.',
    ROLE_DRIBLAB_HUB_description: 'Takvimler, notlar, uyarılar ve belge paylaşımı ile keşif görevlerini verimli bir şekilde takip edin ve yönetin.',
    ROLE_TRACKING_description: 'Kapsamlı analiz için API\'miz aracılığıyla bir oyundaki tüm oyuncuların konumsal verilerini alın.',
    ROLE_ARRIGO_description: 'Eventing ve tracking\'i birleştirerek gelenekselin ötesine geçen ve her aksiyona değer katan yenilikçi metrikler oluşturur.',
    ROLE_REPORTS_description: 'Mükemmel takımı veya oyuncuyu bulmak için analist ekibimizden ayrıntılı keşif raporları isteyin.',
    ROLE_RAW_EVENTING: 'Ham Etkinlik'
  },
  administration: {
    pageSubtitle: 'Uygulamanın çalışmasını yönetme',
    newClient: 'Yeni Kullanıcı',
    clientDuplicateName: 'Bu isimde bir müşteri zaten mevcut. Listeden ilgili müşteriyi seçin ve kullanıcı eklemek için «Yeni Kullanıcı»yı kullanın.',
    newUser: 'Yeni Kullanıcı',
    editClient: 'Kullanıcıyı Düzenle',
    editUser: 'Kullanıcıyı Düzenle',
    clientName: 'İsim',
    permissions: 'İzinler',
    releaseUser: 'Kullanıcıyı Duyur',
    connectAsUser: 'Kullanıcı Olarak Bağlan',
    releaseModalTitle: 'Kullanıcı Onayını Duyurma',
    releaseModalMessage: 'Kullanıcı yeni hesabı ile ilgili bir mail alacak. Onu haberdar etmek istediğine emin misin?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Takım',
      Brand: 'Marka',
      Federation: 'Federasyon',
      Media: 'Medya',
      Agency: 'Ajans',
      Individual: 'Bireysel'
    },
    userType: {
      Ownership: 'Sahip Olma',
      SportingDirector: 'Sportif Direktör',
      Brand: 'Marka',
      Federation: 'Federasyon',
      Media: 'Medya',
      Agency: 'Ajans',
      Individual: 'Bireysel',
      Scout: 'Oyuncu İzleme',
      Coach: 'Antrenör',
      supervision: {
        title: 'Denetim hiyerarşisi',
        subtitle: 'Denetim yalnızca aşağıya doğru akar. Aynı düzeyde denetime izin verilmez.',
        supervisesLowerLevels: 'Aşağıdaki tüm rolleri denetler',
        ruleNoSameLevel: 'Aynı seviyedeki roller birbirini denetleyemez.',
        ruleOnlyDownwards: 'Denetime yalnızca üst rollerden alt rollere doğru izin verilir.',
        ruleLevel3NoSupervision: 'En düşük seviyenin denetim izni yoktur.',
        currentUserType: 'Mevcut kullanıcı türünüz'
      }
    },
    visibleYears: 'Görülen Yıllar',
    areaModalTitle: 'Lig onayını Etkinleştir/Devre Dışı Bırak',
    areaModalMessage: 'Seçili alandaki tüm ligleri etkinleştirmek/devre dışı bırakmak istediğine eimn misin?',
    countStats: 'Count Stats',
    userClientModalTitle: 'User already exists in another client',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Sözleşme',
    contracts: 'Sözleşmeler',
    invoiceName: 'Fatura Adı',
    contractFee: 'Sözleşme Ücreti',
    renewal: 'Yenileme',
    consultancy: 'Danışmanlık',
    deleteContract: 'Müşteri Sözleşmesini Sil',
    deleteContractMessage: 'Sözleşme kalıcı olarak silinecek. Emin misiniz?',
    activeVsHired: 'Aktif vs Anlaşmalı',
    requestedVsHired: 'Talep Edilen vs Anlaşmalı',
    activeVsHiredWithPlaceholder: '{0} Aktif ve {1} İşe Alınmış',
    requestedVsHiredWithPlaceholder: '{0} Talep Edildi ve {1} İşe Alındı',
    salesRepresentative: 'Satış Temsilcisi',
    periodicities: {
      periodicity: 'Periyot',
      annual: 'Yıllık',
      biannual: 'Altı Aylık',
      quarterly: 'Üç Aylık',
      monthly: 'Aylık',
      bimonthly: 'İki Aylık',
      onePayment: 'Tek ödeme',
      fourmonthly: 'Dört ayda bir'
    },
    paymentMethods: {
      payment: 'Ödeme',
      method: 'Yöntem',
      transfer: 'Havale',
      mandate: 'Talimat'
    },
    marketingOptions: {
      marketing: 'Pazarlama',
      socialMediaAdd: 'Sosyal Medya Reklamı',
      videoWithFeedback: 'Geri Bildirimli Video'
    },
    status: {
      status: 'Durum',
      pending: 'Beklemede',
      active: 'Aktif',
      expiringSoon: 'Yakında Sona Erecek',
      expired: 'Süresi Doldu',
      expiringSoonWithDays: 'Sözleşmenin süresi yakında doluyor: {0} gün kaldı'
    },
    updates: {
      roleAdded: '<b>{0}</b>, <b>{2}</b> kişisine <b>{1}</b> rolünü ekledi.',
      roleRemoved: '<b>{0}</b>, <b>{2}</b> kişisinden <b>{1}</b> rolünü kaldırdı.',
      leagueAdded: '<b>{0}</b>, <b>{1}</b> öğesini <b>{2}</b> ligine ekledi.',
      leagueRemoved: '<b>{0}</b>, <b>{1}</b> öğesini <b>{2}</b> liginden çıkardı.',
      seasonAdded: '<b>{0}</b>, <b>{1}</b> öğesini <b>{2}</b> sezonuna ekledi.',
      seasonRemoved: '<b>{0}</b>, <b>{1}</b> öğesini <b>{2}</b> sezonundan çıkardı.',
      updateNotesPlaceholder: 'Lütfen değişiklik için bir açıklama veya ilgili notları buraya ekleyin...',
      updates: 'Güncellemeler',
      products: 'Ürünler'
    },
    clients: 'Müşteriler',
    trials: 'Denemeler',
    activeClients: 'Aktif Müşteriler',
    activeTrials: 'Aktif Denemeler',
    activeTrialUsers: 'Aktif Deneme Kullanıcıları',
    activeContracts: 'Aktif Sözleşmeler',
    expiration: 'Son kullanma tarihi',
    clientWarnings: {
      activeContractInactiveClient: 'Etkin sözleşmeleri olan ancak etkin kullanıcıları olmayan müşteriler',
      activeContractTrialUsers: 'Sözleşme etkinken deneme kullanıcısı olan müşteriler',
      activeUsersWithoutContract: 'Aktif deneme sürümü kullanıcısı olmayan ancak aktif sözleşmesi olmayan müşteriler',
      upcomingExpirations: 'Yaklaşan son kullanma tarihleri',
      renewedContracts: 'Yenilenen sözleşmeler kapsamındaki müşteriler',
      clientsWithWarnings: 'İlgi gerektiren müşteriler',
      enabledUsersWithoutContract: '\'Etkin bir sözleşmesi olmayan, deneme sürümü olmayan kullanıcılar etkinleştirildi\'',
      trialUsersWithContract: 'Etkin bir sözleşmeye rağmen deneme modundaki kullanıcılar',
      activeContractInactiveUsers: 'Müşterinin, tüm kullanıcıların etkin olmadığı etkin bir sözleşmesi vardır',
      activeContract: 'Bu müşterinin aktif bir sözleşmesi var',
      noEnabledUsers: 'Bu istemcinin etkin kullanıcısı yok',
      ongoingTrialInactiveUsers: 'Deneme süresi devam eden ancak etkin kullanıcı bulunmayan müşteriler',
      neverLoggedIn: 'Hiç oturum açmamış müşteriler'
    },
    daysLeft: 'Kalan gün sayısı',
    expiringSoon: 'Süresi yakında doluyor',
    loggedThisWeek: 'Bu hafta giriş yaptınız',
    withWarnings: 'Uyarılarla',
    ofActiveClients: 'aktif müşterilerin',
    endingIn30Days: '30 gün içinde bitiyor',
    neverLogged: 'hiç giriş yapmadım',
    ofActiveTrials: 'aktif denemeler',
    activeClientsWithoutTrial: 'aktif müşteriler (deneme hariç)',
    renewals: 'Yenilemeler',
    ofActiveContracts: 'aktif sözleşmelerin'
  },
  dashboards: {
    lastGame: 'Son Maç Analizi',
    lastGameSimple: 'Son maç',
    seeAllGameInfo: 'Tüm Maç Bilgilerini Gör',
    nextGame: 'Gelecek Maç Önizlemesi',
    myTeam: 'Takımım',
    lastMatchdayGames: 'Son Maç Günü',
    lastAdded: 'Son Eklenen',
    myFavorites: 'Favorilerim',
    seeAllFavorites: 'Tüm favorileri gör',
    placeholderFavorites: 'Oyuncu detaylarından favorilerini ekleyebilirsin',
    placeholderTeamFavorites: 'Takım detaylarından favorilerini ekleyebilirsin',
    placeholderLeagueFavorites: 'Lig detaylarından favorilerini ekleyebilirsin',
    myCollections: 'Koleksiyonum',
    placeholderCollections: 'Herhangi bir koleksiyonun yok',
    lastCreated: 'Son Oluşturulan',
    seeAllCollections: 'Tüm koleksiyonu gör',
    seeRival: 'Rakibi Gör',
    seeMyTeam: 'Takımımı Gör',
    title: 'Panoya Genel Bakış',
    subtitle: 'Tekrar Hoş geldiniz',
    recentPlayers: 'Güncel oyuncular',
    lastScouted: 'Son İzlenen',
    scout: 'Oyuncu İzleme',
    reportsRequested: 'Raporlar',
    lastRequested: 'Son Talep Edilen',
    goInbox: 'Gelen Kutusuna Git',
    placeholderLastScouted: 'Soldaki çubuktan ve oyuncu izleme bölümünden oyuncu araması yapabilirsin',
    placeholderReports: 'Oyuncu detaylarından rapor talep edebilirsin',
    nationalPlayers: 'Diğer ülkelerdeki en değerli milli oyuncular',
    lastGames: 'Son Maçlar',
    nationalPlayersShort: 'Diğer ülkelerdeki milli oyuncular',
    nextMatchdayGames: 'Sıradaki Maç Günü',
    injuredPlayers: 'Sakat Oyuncular',
    atPresent: 'Günümüzde',
    seeAllPlayers: 'Tüm Oyuncuları Gör',
    suspendedPlayers: 'Cezalı Oyuncular',
    placeholderInjured: 'Sakat oyuncu yok',
    teamValueImpacted: 'Takım değeri etkilendi',
    placeholderSuspended: 'Cezalı oyuncu yok',
    placeholderNextGame: 'Uygun maç yok',
    placeholderNoGames: 'Henüz uygun olan maç yok',
    placeholderLastMatchDayNotFound: 'Son maç günü mevcut değil',
    placeholderNextMatchDayNotFound: 'Bir sonraki maç günü mevcut değil',
    usersMostSearch: 'En çok arama yapan kullanıcılar',
    lastTwoDays: 'Son iki gün',
    searchesHistory: 'Arama Geçmişi',
    dayByDay: 'Güncel',
    activeUsersTitle: 'Aktif Kullanıcılar',
    activeUsersSubtitle: 'Geçen ay en az 1 defa oturum açtı',
    onlineUsersTitle: 'Çevrimiçi Kullanıcılar',
    onlineUsersSubtitle: 'Son 1 saat içinde bir şey ara',
    searchesPerformed: 'Yapılan Aramalar',
    onlyClients: 'Sadece kullanıcı',
    activeClientsTitle: 'Aktif Kullanıcılar',
    activeClientsSubtitle: 'En az 1 aktif kullanıcı var',
    last24Hours: 'Son 24 Saat',
    activityHistory: 'Aktivite Geçmişi',
    loginHistory: 'Erişim Geçmişi',
    failLogins: 'Başarısız Erişim',
    successLogins: 'Başarılı Erişim',
    clientStats: 'Kullanıcı İstatistikleri',
    playersMostSearch: 'Daha Çok Aranan Oyuncular',
    toolsMoreUsed: 'Daha Fazla Kullanılan Araçlar',
    hotPlayers: 'Göze Çarpan Oyuncular',
    last_month: 'Son Ay',
    last_week: 'Son Hafta',
    last_day: 'Son Gün',
    nClients: 'Kullanıcı Sayısı',
    userDashboard: 'Kullanıcı Gösterge Tablosu',
    userDashboardSubtitle: 'Hesap faaliyetlerinin özeti',
    offlineDaysOfClient: 'Her müşterinin çevrimdışı günleri',
    hideNoConnected: 'Bağlı olmayanları gizle',
    onlyTrial: 'Sadece deneme müşterileri',
    daysWithoutLogin: 'Giriş yapmadan geçen günler',
    trialDays: 'Deneme günleri'
  },
  faq: {
    subtitle: 'Driblab PRO’nun ne olduğu ile ilgili daha fazla bilgi edinin',
    categories: {
      playerMetrics: 'Oyuncu Metrikleri',
      teamMetrics: 'Takım Metrikleri',
      positions: 'Takım Pozisyonları',
      tools: 'Araç',
      api: 'API',
      videos: 'Eğitmen',
      playerPositions: 'Oyuncu Pozisyonları',
      userTypes: 'Kullanıcı Türleri'
    },
    positions: {
      GK: 'Kaleci',
      DR: 'Sağ Savunmacı / Sağ Bek (SĞB)',
      DC: 'Merkez Savunmacı / Stoper (STP)',
      DL: 'Sol Savunmacı / Sol Bek (SLB)',
      DMR: 'Hücumcu Sağ Bek (SĞKB)',
      DMC: 'Ön Libero (MDO)',
      DML: 'Hücumcu Sol Bek (SLKB)',
      MR: 'Sağ Orta Saha (SĞO)',
      MC: 'Merkez Orta Saha (MO)',
      ML: 'Sol Orta Saha (SLO)',
      AMR: 'Ofansif Sağ Orta Saha / Sağ Kanat (SĞK)',
      AMC: 'Ofansif Orta Saha / İleri Orta Saha (MOO)',
      AML: 'Ofansif Sol Orta Saha / Sol Kanat (SLK)',
      FWR: 'Sağ Forvet / Sağ Santrafor (SLS)',
      FW: 'Forvet / Santrafor (SNT)',
      FWL: 'Sol Forvet / Sol Santrafor (SĞS)'
    },
    metrics: {
      categories: {
        Association: 'Birlik',
        Saving: 'Kurtarış',
        Shooting: 'Şut',
        Defending: 'Savunma',
        Passing: 'Pas',
        BallHandling: 'Top Tekniği',
        Aerial: 'Hava Topu',
        Physical: 'Fiziksel',
        Predictive: 'Tahmini',
        Arrigo: 'Arrigo',
        Score: 'Skor',
        Turnovers: 'Top Kaybı',
        Carries: 'Top Taşıma',
        SequenceInvolvement: 'Dizi Tutulumu',
        Crosses: 'Ortalar',
        Distance: 'Mesafe',
        Sprint: 'Sprint',
        Acceleration: 'İvmelenmeler',
        MaxAcceleration: 'Maksimum Hızlanma',
        Speed: 'Hız',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Hat Kıran Paslar',
        LineBreakingCarries: 'Hat Kıran Top Taşıma',
        LineBreakingActions: 'Hat Kıran Aksiyonlar',
        PassUnderPressure: 'Baskı Altında Pas',
        BallReceived: 'Top Alındı',
        PassesUnderPressure: 'Baskı Altında Geçer',
        OnBallPressureReceived: 'Topla Baskı Altında Kalma',
        OnBallPressure: 'Topa Baskı',
        BallReceiptsInSpace: 'Boş Alanda Top Alma',
        SpatialCoverage: 'Saha Kontrolü',
        OffBallPressure: 'Topsuz Baskı',
        OffBallRuns: 'Topsuz Koşular',
        NoCategory: 'Diğerleri',
        subcategories: {
          Quality: 'Kalite',
          Quantity: 'Miktar',
          TeamComparison: 'Takım karşılaştırması',
          Receptions: 'Kabul',
          LongBalls: 'Uzun paslar',
          Efficiency: 'Verimlilik',
          Ratio: 'Oran',
          Defensive: 'Defansif',
          Offensive: 'Ofansif',
          Foot: 'Ayak',
          Progression: 'İlerleme',
          TopValue: 'En yüksek değer',
          Predictive: 'Tahmini',
          Distance: 'Mesafe',
          Aerial: 'Hava Topu',
          Crosses: 'Ortalar',
          NoCategory: 'Diğerleri'
        },
        desc: {
          Association: 'Birlik',
          Saving: 'Kurtarış',
          Shooting: 'Şut',
          Defending: 'Savunma',
          Passing: 'Pas',
          BallHandling: 'Top Tekniği',
          Aerial: 'Hava Topu',
          Physical: 'Fiziksel',
          Predictive: 'Tahmini',
          Arrigo: 'Arrigo',
          Score: 'Skor',
          Turnovers: 'Top Kaybı',
          Carries: 'Top Taşıma',
          SequenceInvolvement: 'Dizi Tutulumu',
          Crosses: 'Ortalar',
          Distance: 'Farklı hızlarda kat edilen mesafe',
          Sprint: 'Farklı hızlarda koşular',
          Acceleration: 'İvmelenmeler',
          Speed: 'Hız',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Hat Kıran Paslar',
          LineBreakingCarries: 'Hat Kıran Top Taşıma',
          LineBreakingActions: 'Hat Kıran Aksiyonlar',
          PassUnderPressure: 'Baskı Altında Pas',
          BallReceived: 'Top Alındı',
          OnBallPressureReceived: 'Topla Baskı Altında Kalma',
          OnBallPressure: 'Topa Baskı',
          BallReceiptsInSpace: 'Boş Alanda Top Alma',
          SpatialCoverage: 'Saha Kontrolü',
          OffBallPressure: 'Topsuz Baskı',
          OffBallRuns: 'Topsuz Koşular',
          HandPassing: 'Kalecilerin elle yaptığı paslar veya duran top atışı'
        },
        abbr: {
          Association: 'Birlik',
          Saving: 'Kurtarış',
          Shooting: 'Şut',
          Defending: 'Savunma',
          Passing: 'Pas',
          BallHandling: 'Top T.',
          Aerial: 'Hava Topu',
          Physical: 'Fiziksel',
          Predictive: 'Tahmini',
          Arrigo: 'Arrigo',
          Score: 'Skor',
          Turnovers: 'TK',
          Carries: 'Top Taşıma',
          SequenceInvolvement: 'Dizi Tutulumu',
          Crosses: 'Ortalar',
          Distance: 'Mesafe',
          Sprint: 'Koşular',
          Acceleration: 'İvmelenmeler',
          MaxAcceleration: 'Maksimum Hızlanma',
          Speed: 'Hız',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Hat Kıran Paslar',
          LineBreakingCarries: 'Hat Kıran Top Taşıma',
          LineBreakingActions: 'Hat Kıran Aksiyonlar',
          PassUnderPressure: 'Baskı Altında Pas',
          BallReceived: 'Top Alındı',
          OnBallPressureReceived: 'Topla Baskı Altında Kalma',
          OnBallPressure: 'Topa Baskı',
          BallReceiptsInSpace: 'Boş Alanda Top Alma',
          SpatialCoverage: 'Saha Kontrolü',
          OffBallPressure: 'Topsuz Baskı',
          OffBallRuns: 'Topsuz Koşular',
          HandPassing: 'El Geçişi'
        },
        HandPassing: 'El Geçişi'
      },
      types: {
        1: '90 başına',
        2: 'Yüzde',
        3: 'Değer',
        4: 'Verimlilik',
        5: 'Ortalama',
        6: 'Maç Başı',
        7: 'Fark',
        8: 'Maks'
      },
      moreInfo: 'Daha fazlasını burada okuyabilirsiniz'
    },
    api: {
      subtitle: 'Farklı taleplerden veri al',
      resourcesTitle: 'Kaynaklar',
      authentication: 'Belgeleme',
      authText: 'API için her talebinizde `İzin` başlığını dahil edin `Taşıyıcı {API_TOKEN}`',
      generate: 'Oluşturmak',
      tokenPlaceholder: 'Eğer token sahibi değilseniz veya süresi dolduysa, \'Oluştur\' bölümüne tıklayın',
      pathParameters: 'Yol Parametreleri',
      queryParameters: 'Sorgu Parametreleri',
      responseModel: 'Yanıt Modeli',
      tokenWarning: '* API kullanmak için bir token oluşturun',
      pathParamsWarning: '* Doldurulmamış Yol Parametreleri var',
      genericDescription: 'Bir API (Uygulama Programlama Arayüzü), geliştiricilerin kendi uygulamalarına veri veya işlevsellik erişimi ve entegrasyonu sağlamasına olanak tanır. Futbol istatistikleri API\'miz, ülkeler, ligler, takımlar, oyuncular, maçlar ve daha fazlası hakkında çeşitli verilere kapsamlı erişim sunar. Bu API\'yi kullanarak, analizler, görselleştirmeler veya diğer yenilikçi çözümler için zengin futbol verilerimizi kullanan uygulamalar oluşturabilirsiniz.',
      methods: {
        getAllCountries: 'Bu yöntem, API\'de mevcut olan tüm ülkelerin tam bir listesini alır ve her ülkenin benzersiz kimliği ve adı gibi temel bilgileri sağlar. Bu endpoint, coğrafi futbol verilerine ihtiyaç duyan uygulamalar için idealdir ve ülke seçimi, filtreleme ve analiz gibi özelliklere olanak tanır. Ayrıca, `countryId` parametresine bağlı diğer endpointlerle etkileşim için temel bir kaynak olarak hizmet ederek API\'nin veri setiyle sorunsuz entegrasyonu ve gezinmeyi sağlar.',
        getCountryDetail: 'Bu yöntem, API\'de mevcut olan belirli bir ülke hakkında ayrıntılı bilgi sağlar. Bu endpoint kullanılarak, ülkenin adı, kodu ve ilgili diğer metadata gibi bilgiler alınabilir. Özellikle coğrafi verilere dayalı bağlamsal bilgiler sunmak veya kullanıcı deneyimini artırmak için ülke bazlı detaylara ihtiyaç duyan uygulamalar için kullanışlıdır. Seçilen bir ülkeyi daha derinlemesine keşfetme imkanı sunarak diğer endpointleri tamamlar.',
        getCountryCompetitions: 'Bu yöntem, belirli bir ülkede mevcut olan tüm turnuvaların bir listesini alır. Kullanıcıların bölgeye göre turnuvaları keşfetmesini sağlayan özellikler oluşturmak için değerli bir kaynaktır ve ülke verilerini ilişkili turnuvalarla sorunsuz bir şekilde birleştirir. Bu endpoint, yerelleştirilmiş futbol içeriklerine veya bölgesel analizlere odaklanan uygulamalar için gereklidir.',
        getAllCompetitionTypes: 'Bu yöntem, API\'de mevcut olan tüm turnuva türlerinin (ligler, kupalar ve uluslararası turnuvalar gibi) bir listesini döndürür. Bu endpoint, turnuvaları kategorize etmek ve kullanıcıya kapsanan farklı etkinlik türlerinin düzenli bir görünümünü sağlamak için idealdir. Turnuva türüne göre futbol verilerini keşfetmek için filtreler veya açılır menüler gibi özellikler oluştururken özellikle faydalıdır.',
        getAllCompetitions: 'Bu yöntem, türü veya konumu ne olursa olsun API\'de mevcut olan tüm turnuvaların kapsamlı bir listesini alır. Bu endpoint, geniş bir futbol turnuvası yelpazesini görüntülemesi veya analiz etmesi gereken uygulamalar için kullanışlıdır ve kullanıcıların ilgilendikleri etkinlikleri keşfetmelerini ve seçmelerini sağlar.',
        getCompetitionAvailable: 'Bu yöntem, API\'de şu anda mevcut olarak işaretlenmiş turnuvaların bir listesini alır. Bu, döndürülen verilerin güncel ve uygulamalarda kullanıma hazır olmasını sağlar. Özellikle aktif veya erişilebilir turnuvalara dayalı özellikler geliştiren geliştiriciler için kullanışlıdır ve kullanıcıların eski veya eksik verilere rastlamadan ilgili etkinlikleri keşfetmelerini sağlar.',
        getCompetitionDetail: 'Bu yöntem, API\'de mevcut olan belirli bir turnuva hakkında ayrıntılı bilgi sağlar. Turnuva hakkında ayrıntılı görünümler, bağlamsal içgörüler veya turnuva özelliklerine dayalı filtreleme seçenekleri gerektiren uygulamalar için özellikle faydalıdır.',
        getCompetitionSeasons: 'Bu yöntem, belirli bir turnuvaya bağlı tüm sezonların bir listesini alır. Bu endpoint, bir turnuvanın geçmişini veya mevcut durumunu kapsamlı bir şekilde sunmayı hedefleyen uygulamalar için gereklidir ve kullanıcıların sezon bazında verileri keşfetmelerine olanak tanır.',
        getSeasonAvailable: 'Bu yöntem, API\'de şu anda mevcut olarak işaretlenmiş sezonların bir listesini sağlar. Canlı veya devam eden futbol etkinliklerine odaklanan uygulamalar için özellikle kullanışlıdır ve kullanıcıların ilgili ve güncel sezon verileriyle etkileşim kurmasını sağlar.',
        getSeasonDetail: 'Bu yöntem, belirli bir sezon hakkında detaylı bilgi alır; bu bilgiler arasında sezonun zaman çizelgesi, ilişkili turnuva ve anahtar meta veriler bulunur. Bu endpoint, belirli bir sezon hakkında derinlemesine bilgiler gerektiren uygulamalar için gereklidir ve sezon özetleri, turnuvaya göre filtreleme veya kullanıcı etkileşimi için detaylı zaman çizelgeleri gibi özellikleri mümkün kılar.',
        getSeasonTeams: 'Bu yöntem, belirli bir sezonda yer alan tüm takımların bir listesini sağlar. Kadro yönetimi, takım performans analizi veya kullanıcılar için sezon bazlı filtreler oluşturma gibi özellikler için idealdir.',
        getSeasonPlayer: 'Bu yöntem, belirli bir sezonda kayıtlı tüm oyuncuların bir listesini alır. Oyuncu kadroları, performans takibi veya seçilen sezona göre oyuncuları filtreleme gibi özellikler oluşturmak için idealdir.',
        getSeasonPlayerStats: 'Bu yöntem, belirli bir sezondaki tüm oyuncular için detaylı istatistikler sağlar. Analizler, oyuncu karşılaştırmaları veya sezon boyunca oyuncuların başarılarını dinamik görselleştirme üzerine odaklanan uygulamalar için özellikle faydalıdır.',
        getSeasonArrigoMetrics: 'Bu yöntem, belirli bir sezondaki tüm oyuncular için birleşik istatistikler sağlar. Özellikle analitik, oyuncu karşılaştırmaları veya sezon boyunca oyuncu başarılarının dinamik görselleştirmelerini oluşturmaya odaklanan uygulamalar için faydalıdır.',
        getSeasonTeamStats: 'Bu yöntem, belirli bir sezonda yer alan tüm takımlar için kapsamlı istatistikler sağlar. Takım analizi, sezon özetleri veya sezon boyunca takım performanslarının karşılaştırılmasına odaklanan uygulamalar için özellikle faydalıdır.',
        getSeasonCoaches: 'Bu yöntem, belirli bir sezonda takımları yöneten tüm antrenörlerin bir listesini alır. Sezon analizleri, antrenör değerlendirmeleri veya sezon boyunca takım yönetimindeki değişiklikleri takip eden uygulamalar için özellikle kullanışlıdır.',
        getSeasonGames: 'Bu yöntem, belirli bir sezonda oynanan tüm maçların bir listesini sağlar. Tam sezon programlarını görüntülemek, maç sonuçlarını analiz etmek veya kullanıcılara sezon maç verilerine kapsamlı erişim sağlamak isteyen uygulamalar için idealdir.',
        getSeasonGamesMatchday: 'Bu yöntem, belirli bir sezon içinde belirli bir maç gününe ait tüm maçları alır. Maç günü programlarını göstermek, belirli turları analiz etmek veya sezon boyunca belirli bir maç setine odaklanan analizler sunmak isteyen uygulamalar için özellikle kullanışlıdır.',
        getSeasonLeagueTable: 'Bu yöntem, belirli bir sezona ait lig tablosunu sağlar; sıralamalar, puanlar, galibiyetler, beraberlikler, mağlubiyetler ve her takım için diğer ilgili istatistikler gibi bilgileri içerir. Takım sıralamalarını takip etmek, lig ilerlemesini analiz etmek veya sezon boyunca kullanıcıya güncel sıralamaları sunmak isteyen uygulamalar için bu endpoint vazgeçilmezdir.',
        getTeamDetail: 'Bu yöntem, belirli bir takım hakkında detaylı bilgi sağlar; bu bilgiler arasında takımın adı, kuruluş yılı, stadyumu ve diğer meta veriler bulunur. Bu endpoint, detaylı takım profilleri, tarihsel bağlam veya zengin takım verileriyle kullanıcı deneyimini geliştiren uygulamalar için idealdir.',
        getTeamLoans: 'Bu yöntem, belirli bir takımı içeren kiralama işlemleri hakkında bilgi alır. Transfer analizi, takım kadrosu yönetimi veya bir sezon boyunca oyuncu hareketlerini takip eden uygulamalar için özellikle faydalıdır.',
        getTeamRoster: 'Bu yöntem, belirli bir takımın kadrosundaki tüm oyuncuların tam listesini sağlar. Takım dizilişlerini göstermek, oyuncu rolleri analiz etmek veya bir takım için kadro yönetimi işlevlerini sağlamak isteyen uygulamalar için idealdir.',
        getTeamGames: 'Bu yöntem, belirli bir takımın oynadığı tüm maçların bir listesini alır. Takım performansına odaklanan, program takibi yapan veya kullanıcılara bir takımın tam maç geçmişine erişim sağlayan uygulamalar için özellikle faydalıdır.',
        getTeamGameStats: 'Bu yöntem, belirli bir maçta bir takımın detaylı istatistiklerini sağlar. Maç analitiği, performans değerlendirmeleri veya bir takımın bireysel maçlardaki performansına ilişkin ayrıntılı analizler sunan uygulamalar için idealdir.',
        getTeamTransfers: 'Bu yöntem, belirli bir takımı içeren transfer işlemleri hakkında bilgi alır. Transfer piyasası analizi, takım kadrosundaki değişiklikler veya zaman içindeki oyuncu hareketlerini takip eden uygulamalar için özellikle uygundur.',
        getGameStatus: 'Bu yöntem, API\'de mevcut olan tüm olası maç durumlarının bir listesini sağlar. Bunlar arasında planlanmış, devam eden, tamamlanmış, ertelenmiş veya iptal edilmiş durumlar bulunur. Bu endpoint, gerçek zamanlı maç takibi, maçları duruma göre filtreleme veya kullanıcıya bir maçın ilerleyişi ya da durumu hakkında net güncellemeler sağlamak için özellikle faydalıdır.',
        getPlayerPositions: 'Bu yöntem, kaleci, defans, orta saha ve forvet gibi tüm olası oyuncu pozisyonlarının bir listesini döndürür. Oyuncuları sınıflandıran, pozisyon verilerini analiz eden veya kullanıcıların sahadaki rollerine göre oyuncuları filtrelemesine olanak tanıyan uygulamalar için özellikle kullanışlıdır.',
        getGameDetail: 'Bu yöntem, belirli bir maç hakkında kapsamlı bilgi sağlar. Katılan takımlar, tarih ve saat, stadyum, skor ve diğer önemli meta veriler gibi ayrıntıları içerir. Bu endpoint, detaylı maç önizlemeleri, raporlar veya analizler sunan uygulamalar için idealdir.',
        getGameStats: 'Bu yöntem, belirli bir maç için detaylı istatistikler sağlar. Gol sayısı, şutlar, topa sahip olma yüzdeleri, paslar ve savunma aksiyonları gibi metrikleri içerir. Maç analizi, maç sonrası raporlar veya maç sırasındaki takım performansının görselleştirilmesine odaklanan uygulamalar için özellikle faydalıdır.',
        getGamePlayerStats: 'Bu yöntem, belirli bir maça katılan tüm oyuncuların detaylı performans istatistiklerini alır. Bireysel oyuncu performanslarını analiz eden, maç raporları oluşturan veya tek bir maç bağlamında oyuncuları karşılaştıran uygulamalar için özellikle faydalıdır.',
        getGamePlayerPhysicalStats: 'Bu yöntem, belirli bir maçtaki oyuncuların detaylı fiziksel performans metriklerini sağlar. Oyuncu kondisyon analizi, fiziksel performans takibi veya bireysel oyuncular için detaylı maç içgörüsü üreten uygulamalar için özellikle faydalıdır.',
        getGameTeamPhysicalStats: 'Bu yöntem, belirli bir maçta takımların detaylı fiziksel performans metriklerini sağlar. Bu, toplam kat edilen mesafe, sprint sayısı, yüksek yoğunluklu koşular ve diğer fiziksel özellikler gibi verileri içerir. Takımların kondisyon analizine, fiziksel çabaların takımlar arasında karşılaştırılmasına veya bir maçtaki genel performansın değerlendirilmesine odaklanan uygulamalar için özellikle faydalıdır.',
        getGamePlayerArrigoMetrics: 'Bu yöntem, belirli bir maçtaki oyuncular için ayrıntılı arrigo ölçümleri sağlar. Özellikle analitiklere odaklanan ve bir maçtaki oyuncular hakkında ayrıntılı içgörüler üreten uygulamalar için faydalıdır.',
        getGameTeamArrigoMetrics: 'Bu yöntem, belirli bir maçtaki takım arrigo hakkında ayrıntılı ölçümler sağlar. Bu, yenilen oyuncular ve diğer nitelikler gibi verileri içerir. Özellikle genel maç performansının değerlendirilmesinin analiz edilmesine odaklanan uygulamalar için faydalıdır.',
        getGameLineup: 'Bu yöntem, belirli bir maç için ilk 11 oyuncuları, yedekler ve pozisyonlarını içeren kadroyu alır. Maç öncesi bilgileri gösteren, takım dizilişlerini analiz eden veya takımların bir maça yönelik stratejik kararlarına ilişkin içgörüler sağlayan uygulamalar için özellikle kullanışlıdır.',
        getGameTimeline: 'Bu yöntem, belirli bir maç sırasında gerçekleşen olayların kronolojik bir listesini sağlar. Canlı maç güncellemeleri, maç sonrası özetler veya maç olaylarının detaylı analizlerini sunan uygulamalar için özellikle faydalıdır.',
        getGameTracking: 'Bu yöntem, belirli bir maç için takip verileri dosyasını indirmek üzere bir bağlantı sağlar. Bu dosya, maç boyunca oyuncuların ve topun hareketleri ve pozisyonlarına dair detaylı veriler içerir. İleri düzey analiz, taktik analiz veya maç sırasındaki oyuncu ve top hareketlerinin görselleştirilmesine odaklanan uygulamalar için özellikle faydalıdır.',
        getTrackingStatus: 'Bu yöntem, her bir durumun benzersiz tanımlayıcısı ve adı gibi önemli ayrıntıları sağlayarak, izlemede mevcut olan tüm durumların tam bir listesini döndürür. Bu uç nokta, durum seçimi, filtreleme ve analiz gibi özellikleri etkinleştirerek maç takibi gerektiren uygulamalar için idealdir. Ayrıca, bir statusId parametresine bağlı olan diğer uç noktalarla etkileşimde bulunmak için kritik bir kaynak görevi görerek API\'nin daha geniş veri kümesiyle kusursuz gezinme ve entegrasyon sağlar.',
        getPlayerTransfersTypes: 'Bu yöntem, kalıcı transfer, kiralık transfer, bonservissiz transfer veya oyuncu takası gibi olası transfer türlerinin bir listesini döndürür. Bu endpoint, transfer piyasası trendlerini analiz eden, oyuncu hareketlerini sınıflandıran veya transfer işlemlerine ilişkin ayrıntılı bilgiler sunan uygulamalar için özellikle faydalıdır.',
        getPlayerDetail: 'Bu yöntem, belirli bir oyuncu hakkında kişisel bilgiler, kariyer istatistikleri ve mevcut takım bilgileri dahil olmak üzere detaylı bilgiler sağlar. Oyuncu profilleri, tarihsel analizler veya bireysel oyuncu performansı ve kariyer analizleri sunan uygulamalar için idealdir.',
        getPlayerGames: 'Bu yöntem, belirli bir oyuncunun katıldığı tüm maçların bir listesini alır. Oyuncu performansını takip eden, maç geçmişini analiz eden veya bireysel oyuncular için kapsamlı maç kayıtları sunan uygulamalar için özellikle faydalıdır.',
        getPlayerInjuries: 'Bu yöntem, belirli bir oyuncunun yaşadığı sakatlıkların detaylı bir kaydını sağlar. Oyuncu sağlık analizi, kariyere etkilerin değerlendirilmesi veya iyileşme sürelerinin izlenmesi üzerine çalışan uygulamalar için özellikle faydalıdır.',
        getPlayerNationalTeam: 'Bu yöntem, bir oyuncunun milli takım maçlarına katılımı hakkında detaylı bilgiler sunar. Milli düzeydeki performansı analiz eden, uluslararası kariyerleri takip eden veya turnuvalar ve hazırlık maçlarındaki katkıları inceleyen uygulamalar için idealdir.',
        getPlayerSeasons: 'Bu yöntem, belirli bir oyuncunun yer aldığı tüm sezonların bir listesini sağlar. Oyuncunun kariyer ilerlemesini izleyen, sezonlar arası performansları analiz eden veya başarıları için tarihsel bağlam sunan uygulamalar için özellikle kullanışlıdır.',
        getPlayerTransfers: 'Bu yöntem, belirli bir oyuncuyla ilgili transfer işlemlerinin detaylı geçmişini alır. Oyuncu kariyer analizi, transfer piyasası verileri veya zaman içinde oyuncunun takımlar arası hareketlerini izleyen uygulamalar için idealdir.',
        getPlayerSeasonTeamStats: 'Bu yöntem, belirli bir oyuncunun bir sezonda bir takım ile gösterdiği detaylı performans istatistiklerini sağlar. Sezon boyunca oyuncu analizine odaklanan, takımlar veya sezonlar arasında karşılaştırma yapan ve bireysel katkıları izleyen uygulamalar için özellikle faydalıdır.',
        getPlayerSeasonPhysicalStats: 'Bu yöntem, belirli bir oyuncunun bir sezon boyunca sergilediği fiziksel performans metriklerini detaylı bir şekilde sağlar. Oyuncu kondisyonunu takip eden, fiziksel performans analizleri yapan veya bir sezonda oyuncunun iş yükünü değerlendiren uygulamalar için idealdir.',
        getPlayerSeasonGamePhysicalStats: 'Bu yöntem, belirli bir oyuncunun bir sezondaki her maç için fiziksel performans metriklerini sağlar. Maç bazlı kondisyon analizine, oyuncu iş yükü takibine veya farklı maçlardaki fiziksel performansların karşılaştırılmasına odaklanan uygulamalar için özellikle faydalıdır.',
        getPlayerSeasonGameStats: 'Bu yöntem, belirli bir oyuncunun bir sezondaki her maç için detaylı performans istatistiklerini alır. Maç bazında oyuncu analizi yapan, performans trendlerini takip eden veya sezondaki maçlar arasında detaylı karşılaştırmalar sunan uygulamalar için idealdir.',
        getCoachDetail: 'Bu yöntem, belirli bir teknik direktör hakkında isim, kariyer geçmişi, yönettiği takımlar ve kayda değer başarılar dahil olmak üzere detaylı bilgiler sağlar. Teknik direktör profillerini öne çıkaran, antrenörlük kariyerlerini izleyen veya teknik direktörlerin takım performansına etkilerini analiz eden uygulamalar için özellikle faydalıdır.',
        getCoachHistory: 'Bu yöntem, belirli bir teknik direktörün kariyer geçmişini, yönettiği takımları, katıldığı turnuvaları ve görev sürelerini içeren kapsamlı bir şekilde sağlar. Teknik direktör kariyerlerini analiz eden, yönetim değişikliklerini izleyen veya bir antrenörün profesyonel yolculuğu ve başarıları hakkında bilgi sunan uygulamalar için idealdir.',
        getGameEventing: 'Bu yöntem tüm olayları sağlar',
        getLinkStream: 'Bu yöntem, oyun videosunu izleme bağlantısını alır',
        getLinkDownload: 'Bu yöntem oyun videosunu indirmek için bağlantıyı alır',
        getGameTs: 'Bu yöntem belirli bir maçtaki son zaman damgasını sağlar',
        getGameFileTypes: 'Bu yöntem eşleşme için dosya türlerini sağlar',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Bu yöntem, kaleci, defans oyuncusu, orta saha oyuncusu ve forvet gibi olası genel pozisyonların bir listesini döndürür.',
        getPercentiles: 'Bu yöntem mevcut tüm yüzdelik dilimleri sağlar',
        getPlayerPercentilesEventing: 'Bu yöntem belirli bir yüzdelik dilim ve konum için tüm istatistikleri sağlar'
      },
      responseCodes: 'Yanıt Kodları',
      furtherInformation: 'Daha fazla bilgi için lütfen API dökümanımızı oku',
      clipboard: 'Panoya kopyalandı!',
      limit50: 'Yalnızca ilk 50 sonuç gösteriliyor'
    }
  },
  globalSearch: {
    subtitle: 'Derin Filtreleme'
  },
  global: {
    teamElos: {
      title: 'ELO DERGİSİ',
      subtitle: 'Dünya çapında lig gücü eğilimleri ve sıralamalarından içgörüler edinin.',
      team: 'Takım',
      teams: 'Takımlar',
      dates: 'Tarihler',
      excludeInternational: 'Uluslararası Turnuvaları Hariç Tut',
      elo: 'ELO',
      selectButton: 'Üstü Seç',
      selectTeamFromTable: 'Takım tablosundan bir takım seçerek ELO eğilimini görüntüleyin.',
      showingTeamAveragesLastSeason: 'Sadece takımların son aktif sezonlarındaki ortalamaları gösteriliyor',
      showingTeamStatsLastSeason: 'Sadece takımların son aktif sezonlarındaki istatistikleri gösteriliyor',
      searchToolTip: 'İpucu: Arama çubuğuna doğrudan erişim için Ctrl + B tuşlarına basın',
      selectTopTooltip: 'Karşılaştırma için grafikte ek ekipleri görüntüleyin',
      loadingPage: 'Veriler Hazırlanıyor...'
    },
    leagueElos: {
      title: 'LİG ELO\'SU',
      subtitle: 'Dünya çapında lig sıralamaları ve analizler',
      rankings: 'SIRALAMALAR',
      insights: 'İÇGÖRÜLER',
      filters: 'FİLTRELER',
      leagues: 'Ligler',
      from: 'Başlangıç',
      to: 'Bitiş',
      elo: 'ELO',
      change: 'Değişim',
      league: 'Lig',
      excludeContinental: 'Uluslararası Turnuvaları Hariç Tut',
      eloTrend: 'ELO Eğilimi',
      eloRanking: 'ELO Sıralaması',
      currentELOLabel: '(Mevcut ELO)',
      allTime: 'Tüm Zamanlar',
      average: 'Ortalama',
      noChartData: 'Seçilen filtreler için grafik verisi mevcut değil.',
      selectLeagueFromTable: 'Lig tablosundan bir lig seçerek ELO eğilimini görüntüleyin.',
      noInsightsData: 'Seçilen ligler için içgörü verisi mevcut değil. Lütfen liglerin mevcut sezonlara ve takım içgörü verilerine sahip olduğundan emin olun.',
      showingLeagueAveragesLastSeason: 'Sadece liglerin son aktif sezonlarındaki ortalamaları gösteriliyor',
      selectTopTooltip: 'Karşılaştırma için grafikte ek ligleri görüntüleyin',
      confederations: {
        world: 'Dünya',
        top5: 'EN İYİ 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Lig sayısı',
      minimumElo: 'Asgari ELO'
    },
    players: {
      title: 'Oyuncunun GPI\'sı',
      subtitle: 'Küresel oyuncu sıralamaları ve öngörüleri',
      gpiRanking: 'GPI Sıralaması',
      rankTooltip: 'Küresel sıralamayı görüntülemek için üzerine gelin',
      globalRanking: 'Küresel Sıralama',
      player: 'Oyuncu',
      players: 'Oyuncular',
      gpiTrend: 'GPI Trendi',
      currentGPILabel: '(Mevcut GPI)',
      nationality: 'Doğduğu Ülke',
      position: 'Konum',
      marketValue: 'Piyasa Değeri',
      apply: 'Uygula',
      marketValueAndAgeTooltip: 'Bir aralık girin ve Uygula\'ya tıklayın veya Enter\'a basın.',
      searchPlaceholder: 'Oyuncu Ara...',
      selectTopTooltip: 'Karşılaştırma için grafikte ek oyuncuları görüntüleyin',
      gpi: 'GPI',
      numberOfPlayers: 'Oyuncu sayısı',
      showingPlayerStatsLastSeason: 'Yalnızca oyuncuların son aktif sezonlarına ait ortalama istatistikleri gösteriliyor',
      date: 'TARİH',
      showChartLabels: 'Etiketleri Göster',
      marketValueTooltip: 'Bir aralık girin ve Uygula\'ya tıklayın veya Enter\'a basın.',
      freeAgents: 'Ücretsiz Temsilciler',
      selectPlayerFromTable: 'GPI trendini görüntülemek için tablodan bir oyuncu seçin.'
    }
  },
  iso: {
    AF: 'Afganistan',
    DZ: 'Cezayir',
    AO: 'Angola',
    AR: 'Arjantin',
    AU: 'Avustralya',
    AZ: 'Azerbaycan',
    BH: 'Bahreyn',
    BB: 'Barbados',
    BE: 'Belçika',
    BJ: 'Benin',
    BO: 'Bolivya',
    BW: 'Botsvana',
    BN: 'Bruney',
    BF: 'Burkina Faso',
    KH: 'Kamboçya',
    CA: 'Kanada',
    CF: 'Orta Afrika Cumhuriyeti',
    CL: 'Şili',
    CO: 'Kolombiya',
    CD: 'Kongo DR',
    CG: 'Kongo',
    CI: 'Fildişi Sahili',
    CU: 'Küba',
    CZ: 'Çek Cumhuriyeti',
    DJ: 'Cibuti',
    DO: 'Dominik Cumhuriyeti',
    EC: 'Ekvador',
    SV: 'El Salvador',
    ER: 'Eritre',
    ET: 'Etiyopya',
    FI: 'Finlandiya',
    PF: 'Fransız Polinezyası',
    GM: 'Gambiya',
    DE: 'Almanya',
    GI: 'Cebelitarık',
    GL: 'Grönland',
    GP: 'Guadeloupe',
    GN: 'Gine',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Macaristan',
    IN: 'Hindistan',
    IR: 'İran',
    IE: 'İrlanda',
    IT: 'İtalya',
    JP: 'Japonya',
    KZ: 'Kazakistan',
    KI: 'Kiribati',
    KR: 'Kore, Güney',
    KG: 'Kırgızistan',
    LV: 'Letonya',
    LS: 'Lesotho',
    LY: 'Libya',
    LT: 'Litvanya',
    MO: 'Makao',
    MG: 'Madagaskar',
    MY: 'Malezya',
    ML: 'Mali',
    MH: 'Marshall Adaları',
    MR: 'Moritanya',
    MX: 'Meksika',
    MD: 'Moldova',
    MN: 'Moğolistan',
    MA: 'Fas',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Hollanda',
    NZ: 'Yeni Zelanda',
    NE: 'Nijer',
    MP: 'Kuzey Mariana Adaları',
    OM: 'Uman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Filipinler',
    PT: 'Portekiz',
    QA: 'Katar',
    RO: 'Romanya',
    RW: 'Ruanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Suudi Arabistan',
    RS: 'Sırbistan',
    SL: 'Sierra Leone',
    SK: 'Slovakya',
    SB: 'Solomon Adaları',
    ZA: 'Güney Afrika',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Esvatini',
    CH: 'İsviçre',
    TW: 'Tayvan',
    TZ: 'Tanzanya',
    TG: 'Togo',
    TT: 'Trinidad ve Tobago',
    TR: 'Türkiye',
    TV: 'Tuvalu',
    UA: 'Ukrayna',
    GB: 'Birleşik Krallık',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virjin Adaları, Britanya',
    EH: 'Batı Sahra',
    ZM: 'Zambiya',
    AL: 'Arnavutluk',
    AD: 'Andorra',
    AG: 'Antigua ve Barbuda',
    AM: 'Ermenistan',
    AT: 'Avusturya',
    BS: 'Bahamalar',
    BD: 'Bangladeş',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Butan',
    BA: 'Bosna Hersek',
    BR: 'Brezilya',
    BG: 'Bulgaristan',
    BI: 'Burundi',
    CM: 'Kamerun',
    CV: 'Yeşil Burun Adaları',
    TD: 'Çad',
    CN: 'Çin',
    KM: 'Komorlar',
    CR: 'Kosta Rica',
    HR: 'Hırvatistan',
    CY: 'KKTC',
    DK: 'Danimarka',
    DM: 'Dominika',
    TL: 'Doğu Timor',
    EG: 'Mısır',
    GQ: 'Ekvator Ginesi',
    EE: 'Estonya',
    FJ: 'Fiji',
    FR: 'Fransa',
    GA: 'Gabon',
    GE: 'Gürcistan',
    GH: 'Gana',
    GR: 'Yunanistan',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Gine-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong',
    IS: 'İzlanda',
    ID: 'Endonezya',
    IQ: 'Irak',
    IL: 'Israil',
    JM: 'Jamaika',
    JO: 'Ürdün',
    KE: 'Kenya',
    KP: 'Kore, Kuzey',
    KW: 'Kuveyt',
    LA: 'Laos',
    LB: 'Lübnan',
    LR: 'Liberya',
    LI: 'Lihtenştayn',
    LU: 'Lüksemburg',
    MK: 'Makedonya',
    MW: 'Malavi',
    MV: 'Maldivler',
    MT: 'Malta',
    MQ: 'Martinik',
    MU: 'Mauritius',
    FM: 'Mikronezya',
    MC: 'Monako',
    ME: 'Karadağ',
    MZ: 'Mozambik',
    NA: 'Namibya',
    NP: 'Nepal',
    NC: 'Yeni Kaledonya',
    NI: 'Nikaragua',
    NG: 'Nijerya',
    NO: 'Norveç',
    PK: 'Pakistan',
    PS: 'Filistin Ulusal Yönetimi',
    PG: 'Papua Yeni Gine',
    PE: 'Peru',
    PL: 'Polonya',
    PR: 'Porto Riko',
    RE: 'Reunion',
    RU: 'Rusya Federasyonu',
    KN: 'Saint Kitts ve Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome ve Princ.',
    SN: 'Senegal',
    SC: 'Seyşeller',
    SG: 'Singapur',
    SI: 'Slovenya',
    SO: 'Somali',
    ES: 'İspanya',
    VC: 'St Vincent ve Gren.',
    SR: 'Surinam',
    SE: 'İsveç',
    SY: 'Suriye',
    TJ: 'Tacikistan',
    TH: 'Tayland',
    TO: 'Tonga',
    TN: 'Tunus',
    TM: 'Türkmenistan',
    UG: 'Uganda',
    AE: 'Birleşik Arap Emirlikleri',
    US: 'Amerika Birleşik Devletleri',
    UZ: 'Özbekistan',
    VA: 'Vatikan',
    VN: 'Vietnam',
    VI: 'Virjin Adaları, ABD',
    YE: 'Yemen',
    ZW: 'Zimbabve',
    EU: 'Avrupa',
    INT: 'Uluslararası',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'İngiltere',
    'GB-WLS': 'Galler',
    'GB-SCT': 'İskoçya',
    LATAM: 'Güney Amerika',
    CAF: 'AFK',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Oyuncu Hazırlama',
    teams: 'Takım Düzenleme',
    games: 'Maç Alma',
    stats: 'Metrik Hesaplama',
    graphs: 'Grafik Çizme',
    gettingReady: 'Isınmak',
    placeholder: 'Hazır ol'
  },
  requestReport: {
    subtitle: 'İhtiyacınız olan her bilgiyi içeren detaylı bir rapor al',
    categories: {
      scouting: {
        title: 'İzcilik',
        subtitle: 'Belirli bir ligin en iyi oyuncuları kimlerdir? Peki birden fazla ligin birleşiminden mi? İstediğiniz filtreyi (yaş, boy, sözleşme sonu vb.) içeren özel hazırlanmış bir rapor talep edin ve hangi oyuncuların en uygun olduğunu öğrenin'
      },
      coaches: {
        title: 'Antrenörler',
        subtitle: 'Bir antrenör takımınızın oyun sistemine nasıl uyum sağlar? Ayrıntılı bilgi alın veya belirli bir profil verildiğinde hangi koçların en uygun olduğunu öğrenin.'
      },
      'team analysis': {
        title: 'Takım',
        subtitle: 'Bir takım belirleyin ve stil, savunma ve hücum performansı, zayıf noktalar, en iyi oyuncular vb. hakkında değerli bilgiler içeren sezon özetini edinin.'
      },
      'game analysis': {
        title: 'Oyun Analizi',
        subtitle: 'Bir maç olduğunda, ayrıntılı bigilerle, derin bir oyun öncesi ve oyun sonrası analizi alın'
      },
      'special projects': {
        title: 'Özel Projeler',
        subtitle: 'Bir oyuncu yabancı saha maçlarında nasıl performans gösteriyor? Oyuncular ligden lige nasıl değişim gösteriyor? Hangi oyuncular kiralık için uygun? Aklına gelen her şeyi sor'
      },
      conversation: {
        title: 'Konuşma',
        subtitle: 'Takımımız ile bir konuşma başlatın'
      },
      'oyuncu izleme': {
        title: 'Oyuncu İzleme',
        subtitle: 'Güncel lig içerisinde en iyi oyuncu kim? Ve daha bir sürü ligde? En uygun oyuncuyu bulmak için çeşitli filtreler kullanabileceğiniz (yaş, boy, kontrat bitişi vb.) kişiye özel hazırlanmış rapor talep edin'
      },
      'Takım Analizi': {
        title: 'Takım',
        subtitle: 'Bir takım belirleyin ve oyun stili, savunma ve hücum performansı, zayıf noktaları, en iyi oyuncular vb. hakkında değerli bilgiler içeren sezon özetini edinin'
      }
    },
    notesPlaceholder: 'Daha fazla bilgi edinmek istediğin, lig, profil, istatistik, antrenör, takım veya oyunu bize bildir',
    chooseType: 'Rapor Tipi seç',
    requestSummary: 'Özet Talep et',
    reportType: 'Rapor Tipi',
    reportLanguage: 'Rapor Dili',
    detailTitle: 'Raporun takibi',
    detailSubtitle: 'Talep ettiğiniz raporla ilgili tüm bilgiler'
  },
  bugReport: {
    modalSubtitle: 'Gelişmemize yardımcı ol',
    about: 'Hakkında',
    sendSuccess: 'Başarıyla bildiridi. Gelen kutusundaki yenilikleri kontrol et',
    bugs: 'Hatalar'
  },
  gbe: {
    autopass: 'Oto Geçiş',
    bandX: 'Grup {0}',
    bandXCont: 'Grup {0} Kıtasal Karşılaşma',
    points: 'Puan',
    titleWinner: 'Şampiyonluk Kazanan',
    qualifiedGroupsBandX: 'Bir grup mücadelesi için yeterli {0} Kıtasal Karşılaşma',
    qualifiedQualifiersBandX: 'Bir eleme mücadelesi için yeterli {0} Kıtasal Karşılaşma',
    midTable: 'Orta Sıra',
    relegation: 'Düşme',
    promotion: 'Yükselme',
    final: 'Final',
    semifinal: 'Yarı Final',
    quarterfinal: 'Çeyrek Final',
    round16: 'Son 16 Turu',
    round32: 'Son 32 Turu',
    groupstage: 'Grup Etabı',
    firstRound: '1. Tur',
    secondRound: '2. Tur',
    thirdRound: '3. Tur',
    fourthRound: '4. Tur',
    preliminaryRound: 'Eleme Turu',
    other: 'Diğer',
    score: 'Skor',
    totalSummary: 'Toplam Özet',
    currentlyPlayingInUK: 'Oyuncu Birleşik Krallık veya İrlanda vatandaşıdır, veya oyuncu kalıcı olarak Birlekşik Krallıkta yaşamaktadır',
    bandsAlert: 'Birden fazla grupta oynanan dakikalar var, toplam maksimum değerdir',
    bandsAlertMax: 'Birden fazla grupta oynanan dakikalar var, toplam maksimum değerdir.',
    bandsAlertAvg: 'Birden fazla grupta oynanan dakikalar var, toplam ortalama değerdir',
    generate: 'GBEAplikasyonFormu',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: 'Oyuncunun Milli Forma Giyme Sayısı',
      title1: 'Oyuncunun Milli Takımının FIFA Dünya Sıralaması',
      title2: ' Oyuncunun Milli Forma Giyme Sayısı '
    },
    table2: {
      name: 'Oyuncunun Yerel Dakikaları',
      title1: 'Oyuncunun Yerel Dakikaları'
    },
    table3: {
      name: 'Oyuncunun Kıtasal Dakikaları',
      title1: 'Oyuncunun Kıtasal Dakikaları'
    },
    table4: {
      name: 'Oyuncunun Son Takımının Ligdeki Son Pozisyonu',
      title1: 'Son Takımının Ligdeki Son Pozisyonu'
    },
    table5: {
      name: 'Oyuncunun Son Takımının Kıtasal İlerlemesi',
      title1: 'Kıtasal İlerleme'
    },
    table6: {
      name: 'Oyuncunun Mevcut Kulübünün Lig Kalitesi',
      title1: 'Oyuncunun Mevcut Takımının Grubu'
    },
    table7: {
      name: 'Altyapı – İlk Maç',
      title1: 'Grup'
    },
    table8: {
      name: 'Altyapı – Ligdeki Son Pozisyon',
      title1: 'Son Takımının Ligdeki Son Pozisyonu'
    },
    table9: {
      name: 'Altyapı – Kıtasal İlerleme',
      title1: 'Kıtasal İlerleme'
    },
    table10: {
      name: 'Altyapı – Oyuncunun Mevcut Lig Kalitesi ',
      title1: 'Oyuncunun Mevcut Kulübünün Grubu'
    },
    table11: {
      name: 'Altyapı – Oyuncunun Mevcut Lig Kalitesi',
      title1: 'Oyuncunun Mevcut Kulübünün Grubu'
    },
    table12: {
      name: 'Genç – Uluslararası Kariyer',
      title1: 'Oyuncunun Milli Forma Giyme Sayısı'
    }
  },
  mediaMode: {
    borderColor: 'Kenar Rengi',
    fillColor: 'Dolgu Rengi',
    bgColor: 'Arkaplan Rengi',
    upperText: 'Üst Metin',
    lowerText: 'Alt Metin',
    socialMedia: 'Sosyal Medya',
    textColor: 'Metin Rengi',
    axisColor: 'Aks Rengi',
    logo: 'Logo',
    comparisonBorderColor: 'Karşılaştırma Kenar Rengi',
    comparisonFillColor: 'Karşılaştırma Dolgu Rengi',
    comparisonUpperText: 'Karşılaştırma Üst Metin',
    comparisonLowerText: 'Karşılaştırma Alt Metin',
    homeFillColor: 'İç Saha Dolgu Rengi',
    homeBorderColor: 'İç Saha Kenar Rengi',
    awayFillColor: 'Dış Saha Dolgu Rengi',
    awayBorderColor: 'Dış Saha Kenar Rengi',
    face: 'Surat',
    nationalTeam: 'Milli Takım',
    comparisonFace: 'Karşılaştırma Yüzü',
    upperTextX: 'Alt Metin {0}',
    lowerTextX: 'Üst Metin {0}',
    borderColorX: 'Kenar Rengi {0}',
    fillColorX: 'Dolgu Rengi {0}',
    homeFillColorX: 'Dolgu Rengi (İç Saha) {0}',
    homeBorderColorX: 'Kenar Rengi (İç Saha) {0}',
    awayFillColorX: 'Dolgu Rengi (Dış Saha) {0}',
    awayBorderColorX: 'Kenar Rengi (Dış SAha) {0}',
    faceX: 'Yüz {0}',
    selectField: 'Bir Özellik Seç',
    orientationX: 'Oryantasyon {0}',
    searchBarPlaceholder: 'Oyuncu ve/veya Oyun Seç...',
    title: 'Medya Panosu',
    pageSubtitle: 'Harita ve grafiklere göz atın ve indirin',
    chooseChart: 'Şema Seç...',
    headerTextX: 'Başlık Metni {0}',
    avatarLineLength: 'Avatar Çizgi Uzunluğu',
    avatarLineWeight: 'Avatar Çizgi Genişliği',
    avatarSize: 'Avatar Boyutu',
    chartX: 'Şema {0}',
    chartHeaderFontSize: 'Şema Başlığı Yazıtipi Boyutu',
    chartHeaderFontWeight: 'Şema Başlığı Yazıtipi Genişliği',
    upperTextFontSize: 'Üst Metin Yazıtipi Boyutu',
    upperTextFontWeight: 'Üst Metin Yazıtipi Genişliği',
    lowerTextFontSize: 'Alt Metin Yazıtipi Boyutu',
    lowerTextFontWeight: 'Alt Metin Yazıtipi Genişliği',
    socialMediaFontSize: 'Sosyal Medya Yazıtipi Boyutu',
    socialMediaFontWeight: 'Sosyal Medya Yazıtipi Genişliği',
    subtitle: 'Altyazı',
    subtitleFontSize: 'Altyazi Yazıtipi Boyutu',
    subtitleFontWeight: 'Altyazi Yazıtipi Genişliği',
    subtitleX: 'Altyazı {0}',
    subtitleFontSizeX: 'Altyazı ${0} Yazıtipi Boyutu',
    subtitleFontWeightX: 'Altyazı ${0} Yazıtipi Genişliği',
    titleX: 'Başlık {0}',
    titleFontSize: 'Başlık Yazıtipi Boyutu',
    titleFontWeight: 'Başlık Yazıtipi Genişliği',
    sponsor: 'Sponsor',
    fontFamily: 'Font family'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Oyuncu İzleme Raporları',
      GAME_REPORT: 'Oyun Raporları',
      MEDICAL_REPORT: 'Sağlık Raporları',
      PHYSICAL_REPORT: 'Fiziki Raporlar',
      PSYCHOLOGICAL_REPORT: 'Psikolojik Raporlar',
      OTHER: 'Diğerleri',
      QUICK_NOTES: 'Hızlı Notlar',
      PLAYER_REPORT: 'Oyuncu Raporları',
      GENERAL_COMMENTS: 'Genel Yorumlar',
      PLAYER_ANALYSIS: 'Oyuncu Analizi'
    },
    uploadDocument: 'Döküman Yükle',
    notesPlaceholder: 'Belgeyle ilgili açıklayıcı notları veya yorumları yaz',
    notesPlaceholderAlt: 'Oyuncu ile ilgili açıklayıcı notlar veya yorumlar yaz',
    uploadedBy: 'Tarafından Yüklendi',
    updatedBy: 'Tarafından güncellendi',
    seeNotes: 'Notlara Bak',
    addNote: 'Not Ekle',
    rating: 'Rating',
    position: 'En iyi konum',
    physical: 'Fiziksel',
    onBall: 'Topun Üzerinde',
    offBall: 'Topsuz',
    mental: 'Zihinsel',
    potential: 'Potansiyel',
    conclusion: 'Sonuç',
    recommendation: {
      1: 'Transfer Et',
      2: 'Takip Et',
      3: 'Vazgeç',
      4: 'İlginç',
      label: 'Tavsiye'
    },
    match: 'Maç',
    deleteQuickNote: 'Notu Sil',
    deleteQuickNoteMessage: 'Not kalıcı olarak silinecek. Emin misiniz?',
    noQuickNotes: 'Veri yok. Not eklemeye başlayın!',
    deleteDocument: 'Belgeyi Sil',
    deleteDocumentMessage: 'Belge kalıcı olarak silinecek. Emin misiniz?',
    noDocuments: 'Veri yok. Belge eklemeye başlayın!',
    bestPosition: 'En iyi pozisyon'
  },
  notifications: {
    newReportMessage: 'Raporda yeni bir mesaj var'
  },
  blog: {
    subtitle: 'Son makaleler, gelişmeler, haberler',
    newEntry: 'Yeni Yazı Gir',
    title: 'Başlık',
    text: 'Metin',
    link: 'Bağlantı',
    image: 'Görüntü',
    author: 'Yazar',
    date: 'Yayın tarihi',
    deleteEntry: 'Yazıyı Sil',
    deleteEntryMessage: 'Bu yazıyı silmek istediğine emin misin?',
    readMore: 'Daha fazla oku'
  },
  positionsOrlegi: {
    GK: 'Kaleci',
    DC: 'Defans',
    DR: 'Bek',
    MC: 'Orta Saha',
    AMC: 'Ofansif Orta Saha',
    FW: 'Forvet',
    FWR: 'Kanat'
  },
  library: {
    subtitle: 'Güncellenmiş belgeleri görüntüleyin ve paylaşın',
    mediaSubtitle: 'Dışa aktarılan grafikleri görüntüleme ve paylaşma',
    charts: 'Şemalar',
    goToLibrary: 'Kütüphaneye git'
  },
  scatterPlot: {
    bubbleSize: 'Baloncuk Boyutu',
    byMinutes: 'Dakikaya Göre',
    byAge: 'Yaşa Göre',
    byMarketValue: 'Piyasa Değerine Göre'
  },
  eventChart: {
    successfulEvent: 'Başarılı',
    unsuccessfulEvent: 'Başarısız',
    possessionLost: 'Başarılı kurtarılmadı',
    successfulPass: 'Başarılı Pas',
    unsuccessfulPass: 'Başarısız Pas',
    successfulCarry: 'Başarılı Top Taşımak',
    unsuccessfulCarry: 'Başarısız Top Taşımak',
    carryAndKeyPass: 'Topo Taşıma & Kilit Pas',
    carryAndAssist: 'Top Taşıma & Asist',
    carryAndShot: 'Top Taşıma & Şut',
    ballProgressionAndPass: 'Topu İleri Taşıma& Pas',
    ballProgression: 'Topu İleri Taşıma',
    ballProgressionAndKeyPass: 'Topu İleri Taşıma& Kilit Pas',
    ballProgressionAndAssist: 'Topu İleri Taşıma& Asist',
    ballProgressionAndShot: 'Topu İleri Taşıma& Şut',
    ballProgressionAndGoal: 'Topu İleri Taşıma& Gol',
    pass: 'Pas',
    carryAndPass: 'Top Taşıma & Pas',
    carryAndGoal: 'Top Taşıma & Gol',
    totalTouches: 'Toplam Dokunuş',
    totalPasses: 'Toplam Paslar',
    successful: 'Başarılı',
    unsuccessful: 'Başarısız',
    tacklePossessionLost: 'Başarılı - Topun Kaybolması',
    gamesSelected: '{count} maç seçildi',
    allGamesOfSeason: 'Sezonun tüm maçları',
    allGamesOfSeasons: 'Sezonların tüm maçları',
    allEvents: 'Tüm etkinlikler',
    eventTypesCount: '{count} etkinlik türü',
    totalEvents: 'Toplam Olaylar',
    zoneDominanceNote: 'Her takımın her bölgedeki yaptığı dokunuşlar yalnızca başarılı dokunuşları temsil eder',
    selectedEvents: 'Seçilmiş Etkinlikler'
  },
  event: {
    Pass: 'Pas',
    TakeOn: 'Oyuna Almak',
    Takeon: 'Oyuna Almak',
    Foul: 'Faul',
    Error: 'Hata',
    Tackle: 'Müdahele',
    Interception: 'Kesme',
    Clearance: 'Uzaklaştırma',
    MissedShot: 'Kaçan Şut',
    ShotOnPost: 'Direğe Çarpan Şut',
    SavedShot: 'Kurtarılan Şut',
    Goal: 'Gol',
    Aerial: 'Hava Topu',
    BallRecovery: 'Topu Geri Kazanmak',
    Dispossessed: 'Uzaklaştırmak',
    ChanceMissed: 'Kaçan Şans',
    BallTouch: 'Topa Temas',
    BlockedPass: 'Engellenen Pas',
    Challenge: 'Mücadele',
    lossPossession: 'Top kaybı',
    OffsidePass: 'Ofsayt pası',
    groundDuelsLost: 'Kaybedilen yer mücadeleleri',
    'Ball touch': 'Topa temas',
    Smother: 'Baskı altında kalmak',
    'Keeper pickup': 'Kaleci Seçimi',
    'Good skill': 'İyi beceri',
    Punch: 'Yumruk',
    'Saved shot': 'Kurtarılan şut',
    'Shot on post': 'Direğe çarpan şut',
    'Missed shot': 'Kaçan şut',
    Save: 'Kurtarış',
    'Take on': 'Oyuna Almak',
    'Offside pass': 'Ofsayt pas',
    Claim: 'İstek',
    'Blocked pass': 'Engellenen Pas',
    KeeperPickup: 'Kaleci Alımı',
    'Ball recovery': 'Topu Geri Kazanmak',
    'Ball Recovery': 'Topu Geri Kazanmak',
    'Chance missed': 'Kaçan Şans',
    'Loss possession': 'Top kaybı',
    Carries: 'Top Taşıma',
    BallProgression: 'Top İlerlemesi',
    MissedChance: 'Kaçırılan Şans',
    Event: 'Etkinlik',
    Shot: 'Şut',
    Assist: 'Asist',
    KeyPass: 'Kilit Pas',
    'Foul taken': 'Alınan Faul'
  },
  leagueTab: {
    leagueTable: 'Lig Tablosu',
    matchdays: 'Maç Günleri',
    playerInsights: 'Oyuncu Görünüşü',
    onlyLocalPlayers: 'Yalnızca yerel oyuncular',
    teamInsights: 'Takım Görünüşü',
    head2head: 'Kafa Kafaya',
    addNewChart: 'Yeni şema ekle',
    rounds: {
      16: 'Round of 16',
      32: 'Round of 32',
      W: 'Winner',
      F: 'Final',
      SF: 'Semi-Finals',
      QF: 'Quarter-Finals',
      GR: 'Group Stage',
      '4R': 'Fourth Round',
      '3R': 'Third Round',
      '2R': 'Second Round',
      '1R': 'First Round',
      PR: 'Preliminary Round',
      QPO1: 'Make Round of 32 Tier Below',
      QPO2: 'Qualifier Round of 16',
      QPO3: '32. Eleme Turu'
    },
    positions: 'Positions',
    prediction: 'Predictions',
    predicted: 'Tahmin',
    groups: 'Groups',
    ranking: 'Ranking',
    numberOfTeams: 'Takım sayısı',
    statsWithMinimum: {
      message: 'Seçilen sezonda yalnızca {0} {1} üzerindeki oyuncular gösteriliyor',
      dribblesTotal90: '90 dakikada çalım sayısı',
      crosses90: '90 dakikada orta sayısı',
      tacklesAttempted90: '90 dakikada yapılan müdahale sayısı',
      aerialsTotal90: '90 dakikada hava topu mücadelesi sayısı'
    },
    numberOfLeagues: 'Lig sayısı',
    position: {
      titleWinner: 'Başlık kazananı',
      championsLeague: 'Şampiyonlar Ligi',
      qualifierChampionsLeague: 'Eleme Şampiyonlar Ligi',
      europeLeague: 'Avrupa Ligi',
      qualifierEuropeLeague: 'Eleme Avrupa Ligi',
      conferenceLeague: 'Konferans Ligi',
      qualifierConferenceLeague: 'Eleme Konferansı Ligi',
      midTable: 'Orta masa',
      relegation: 'Düşme',
      promotion: 'Terfi',
      relegationPlayoff: 'Düşme Play-off\'u',
      promotionPlayoff: 'Yükselme Play-off\'u',
      championshipGroup: 'Şampiyona Grubu',
      relegationGroup: 'Düşme Grubu',
      championshipPlayoffs: 'Şampiyona Playoffları',
      preChampionshipPlayoffs2: 'Şampiyona Öncesi Playofflar 2',
      preChampionshipPlayoffs3: 'Şampiyona Öncesi Playofflar 3',
      playoffsQualifierBand3: 'Playoff Eleme Grubu 3',
      continentalGroup: 'Kıta Grubu'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'e',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'BEN',
      10: 'J',
      11: 'k',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Benzer oyuncuları bul',
    searchBarPlaceholder: 'Benzer oyuncu ara ve seç',
    radarFilters: 'Radar filtreleri',
    similarityFilters: 'Benzerlik Filtreleri',
    playersFilters: 'Oyuncu Filtreleri',
    similarPlayers: 'Benzer Oyuncular',
    seasonWarning: 'Yalnızca 450 dakikadan fazla süre aldığı sezonlar Similarity aracında kullanılabilir'
  },
  squadBuilder: {
    subtitle: 'Benzersiz On Birinizi Oluşturun',
    playerSelector: 'Player selector',
    loadSquad: 'Load squad',
    yearsOld: 'yo.',
    playersPerPosition: 'Players per position',
    custom: 'Custom',
    removeSquad: 'Kadroyu sil',
    removeSquadMessage: 'Kadroyu silmek istediğinizden emin misiniz?',
    deleteSquadSuccess: 'Manga başarıyla silindi',
    playerDetails: 'Detayların görünürlüğü',
    ageFormat: 'Yaş formatı',
    mainPlayer: 'Ana oyuncu',
    showDetails: 'Detayları göster',
    all: 'Hepsi',
    squadPosition: 'Kadro pozisyonu',
    noData: 'Veri yok. Sahaya birkaç oyuncu ekleyerek başlayın!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Bir Daha Gösterme',
      skipTour: 'Rehberli Turu Göster',
      previous: 'Önceki',
      next: 'Sonraki',
      finish: 'Bitir'
    },
    playerRadar: {
      step1: {
        title: 'KIŞISEL DOSYA',
        message: 'Temel oyuncu verilerini kontrol edin: yaş, boy veya sözleşme tarihi'
      },
      step2: {
        title: 'GBE FİLTRE',
        message: 'Bir oyuncunun Birleşik Krallık\'ta oynamak için yeterli GBE puanına sahip olup olmadığını bilmeyi sağlayan işlevsellik'
      },
      step3: {
        title: 'KULLANILABILIRLIK',
        message: 'Kullanılabilir dakika yüzdesi ve oynanan dakika yüzdesi'
      },
      step4: {
        title: 'POZİSYONLAR',
        message: 'Oyuncunun hangi pozisyonlarda oynadığını ve her pozisyonda kaç dakika oynadığını öğrenin'
      },
      step5: {
        title: 'EKRAN FORMATLARI',
        message: 'Pozisyonundaki oyuncularla karşılaştırmak için Radar, Polar, Lolipop ve Metin olmak üzere 4 farklı görselleştirme ile performansını ölçün'
      },
      step6: {
        title: 'PERFORMANS RADARI',
        message: 'Burada performans görsel olarak yansıtılmaktadır. Panel etkileşimlidir, her bir metriğin üzerine gelebilir ve tanımını alabilirsiniz'
      },
      step7: {
        title: 'SEZON SEÇIMI',
        message: 'Performansınızı ölçmek için sezonları seçin veya ekleyin'
      },
      step8: {
        title: 'ÖZEL ŞABLON SEÇIMI',
        message: 'Oyuncuyu standart radardan farklı metriklerle ölçmek için oluşturduğunuz özel şablonları kullanın'
      },
      step9: {
        title: 'ÇALINAN POZISYONLARIN SEÇIMI',
        message: 'Onu ölçmek istediğiniz pozisyonda ölçmek için farklı pozisyonları işaretleyin ve işaretlerini kaldırın'
      },
      step10: {
        title: 'MINIMA VE MAKSIMA SEÇIMI',
        message: 'Oyuncuyu sezonunun, ilk beş ligin veya kullanıcı hesabının kendi ve varsayılan sezonunun en yüksek ve en düşük seviyeleriyle ölçün'
      },
      step11: {
        title: 'KARŞILAŞTIRMALAR',
        message: 'Oyuncuyu önceki performansıyla, pozisyonundaki diğer oyuncularla ve pozisyonun ortalamasıyla karşılaştırır'
      },
      step12: {
        title: 'RESIM INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SEZON, TAKIM VE POZISYON',
        message: 'Oyuncuyu karşılaştırmak için sezonu, kadroyu ve pozisyonu seçin'
      },
      step2: {
        title: 'TEMEL FILTRELER',
        message: 'Oyuncuları yaşa, oynadığı dakikaya veya boya göre filtrele'
      },
      step3: {
        title: 'VURGULA VE HARIÇ TUT',
        message: 'İstediğiniz oyuncuları vurgulayın ve ekrandaki takımları hariç tutun'
      },
      step4: {
        title: 'KATEGORIYE GÖRE FILTRELE',
        message: 'İstatistikleri kategoriye göre filtreleyin: İlişkilendirme, Savunma, Paslaşma, Top Kullanma, vb.'
      },
      step5: {
        title: 'RESIM INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'EKRANI SEÇ',
        message: 'Sonlandırma haritasını ana görünümde, hedef görünümünde ve bir dağıtım tablosunda görebilirsiniz'
      },
      step2: {
        title: 'SEZONLARI SEÇİN',
        message: 'Atış verimliliğinizi ölçmek için mevsimler ekleyin'
      },
      step3: {
        title: 'ÇEKIM YERI',
        message: 'Atışın tam yerini (daireler) veya ceza sahasının ve sahanın alanlarına göre (alanlar) görme olanağını seçin'
      },
      step4: {
        title: 'xG HEDEFTE',
        message: 'Oyuncunun atıştan sonra ne kadar katma değer sağladığını görmek için xG to Goal ve xG Completion kutularını işaretleyin'
      },
      step5: {
        title: 'ATIŞ TÜRÜ',
        message: 'Çekim türüne, stratejiye, bölgeye veya vücut bölümüne göre filtreleme'
      },
      step6: {
        title: 'FİLTRE DAKİKALARI',
        message: 'Belirli oyun dönemlerine göre atılan şutları ve golleri seçmek için dakika çubuğu'
      },
      step7: {
        title: 'RESIM INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      },
      step8: {
        title: 'ATIŞ HARİTASI',
        message: 'Harita interaktiftir. Her atış için xG değerini öğrenmek için her daireyi fare ile kontrol edin'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SEZON SEÇİMİ',
        message: 'Atış verimliliğinizi ölçmek için sezonları ekleyin'
      },
      step2: {
        title: 'ANAHTAR GEÇIŞ KONUMU',
        message: 'Anahtar geçişin tam konumunu (daire) veya alanın ve sahanın alanlarına göre (alanlar) görüntüleme olanağını seçin'
      },
      step3: {
        title: 'ANAHTAR GEÇIŞINDEN SONRA FINIŞ TIPI',
        message: 'Tuş pasından sonra yapılan atış türüne, stratejiye, bölgeye veya vücut bölümüne göre filtreleme'
      },
      step4: {
        title: 'FİLTRE DAKİKALARI',
        message: 'Belirli oyun dönemlerine göre atılan şutları ve golleri seçmek için dakika çubuğu'
      },
      step5: {
        title: 'RESIM INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      },
      step6: {
        title: 'ANAHTAR GEÇİŞ HARİTASI',
        message: 'Harita interaktiftir. Her bir geçişin xA değerini öğrenmek için fare ile her bir daireye bakın'
      }
    },
    playerThreat: {
      step1: {
        title: 'SEZON SEÇİMİ',
        message: 'Atış verimliliğinizi ölçmek için sezonları ekleyin'
      },
      step2: {
        title: 'TEHDIT KONUMU',
        message: 'Anahtar geçişinin tam konumunu (daire) veya alan ve saha bölgelerine (alanlar) göre görüntüleme olanağını seçin'
      },
      step3: {
        title: 'EYLEM VE TAMAMLAMA',
        message: 'Haritada görüntülemek istediğiniz eylem ve tamamlanma türüne göre işaretleyin ve işareti kaldırın'
      },
      step4: {
        title: 'TUTANAKLAR VE TEHDIT',
        message: 'Dönem, dakika ve eylemlerin tehdit değerine göre filtreleyin'
      },
      step5: {
        title: 'RESIM INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      },
      step6: {
        title: 'TEHDİT HARİTASI',
        message: 'Harita interaktiftir. Her bir pasın her bir xT oyununda üretilen tehdidi öğrenmek için her bir daireye fare ile başvuru'
      }
    },
    playerTouches: {
      step1: {
        title: 'OYUN VE ETKINLIK SEÇIMI',
        message: 'Haritada görüntülemek istediğiniz oyunu ve etkinlikleri seçin'
      },
      step2: {
        title: 'ETKİNLİK TÜRÜ',
        message: 'Oyun boyunca oyuncunun etkinliğinin defansif veya ofansif niteliğine göre işaretleyin ve işareti kaldırın'
      },
      step3: {
        title: 'EKRAN FİLTRESİ',
        message: 'Haritayı temel eylemlere, ısı haritasına, dairelere veya kutulara göre filtreleyin'
      },
      step4: {
        title: 'RESIM INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      },
      step5: {
        title: 'DOKUNUŞLAR HARİTASI',
        message: 'Harita interaktiftir. Her bir etkinliğin üzerine tıklayarak her bir etkinliği görüntüleyebilirsiniz'
      }
    },
    playerAllGames: {
      step1: {
        title: 'KULLANILABİLİRLİK',
        message: 'Müsaitlik durumunu ve maç bazında oynanan dakikaları kontrol edin'
      },
      step2: {
        title: 'POZİSYONLAR',
        message: 'Her maçta oynadığı pozisyonlara bakın'
      }
    },
    playerInjuries: {
      step1: {
        title: 'TARIH VE KAYIP GÜNLER',
        message: 'Son bir yıldaki veya tüm geçmişteki yaralanmalara ve gün cinsinden sürelerine göre yaralanma aralığına bakın'
      },
      step2: {
        title: 'KULÜPLERE GÖRE SAKATLIKLAR',
        message: 'Yörüngesinin sezon ve/veya kulüplere göre ayrılmış sakatlıklarına bakın'
      }
    },
    playerInfo: {
      step1: {
        title: 'KARİYER VE TRANSFERLER',
        message: 'Oyuncunun kulübüyle, milli takımıyla ve kariyeri boyunca yaptığı transferlerle ilgili dakika, pozisyon veya müsaitlik geçmişine bakabilirsiniz'
      }
    },
    teamOverview: {
      step1: {
        title: 'TAKIM SAYFASI',
        message: 'Takımın temel verilerine bakın: ortalama yaş, temel oluşum, ELO veya transfer dengesi'
      },
      step2: {
        title: 'TEMEL İSTATİSTİKLER',
        message: 'Topa Sahip Olma, xG, Şut, PPDA veya Dikeyliğe bakın'
      },
      step3: {
        title: 'RADAR VE MEVSIM',
        message: 'Takımın performansını ölçmek için radar, sezon ve iç saha veya deplasman maçlarını seçin'
      },
      step4: {
        title: 'ANTRENÖRE VE MAÇLARA GÖRE FILTRELE',
        message: 'Her koç için aşamaya göre performans seçin'
      },
      step5: {
        title: 'PERFORMANS RADARI',
        message: 'Panel etkileşimlidir, her bir metriğin üzerine gelip tanımını alabilirsiniz'
      },
      step6: {
        title: 'GÖRÜNTÜ INDIRME FORMATLARI',
        message: 'İki indirme biçimi mevcuttur: png ve svg'
      },
      step7: {
        title: 'TAKVİM',
        message: 'Takımın maç programını görüntüleyin'
      },
      step8: {
        title: 'METRİKLERE GÖRE EN İYİ OYUNCULAR',
        message: 'Bu panelde farklı metrikleri seçebilir ve en önemli oyuncuların hangileri olduğunu görebilirsiniz'
      },
      step9: {
        title: 'BİR SONRAKİ MAÇ VE SAKATLIKLAR',
        message: 'Bir sonraki rakibi ve takımın sakat ve cezalı oyuncularını kontrol edin'
      },
      step10: {
        title: 'GRAFIKLER VE TRENDLER',
        message: 'Son 10 veya 20 maç için farklı grafikler görüntüleyin'
      }
    },
    teamRoster: {
      step1: {
        title: 'GÖRÜNÜM TÜRÜ',
        message: 'Kadroyu 6 farklı kategoriden görüntüleyin: pozisyona, sözleşme sonuna, yaşa, müsaitlik durumuna, yaş profiline ve sahaya göre'
      }
    },
    teamLoans: {
      step1: {
        title: 'KREDİ OYUNCULARI',
        message: 'Diğer takımlara kiralanan oyunculara ve hangi pozisyonda oynadıklarına bakın'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SEZON VE KADRO',
        message: 'Sezona, radar kadrosuna göre filtreleyin ve seçtiğiniz liglerle karşılaştırın'
      },
      step2: {
        title: 'METRİKLERE GÖRE PERFORMANS',
        message: 'Daha önce seçilen liglerdeki tüm takımlarla karşılaştırıldığında takımın her bir metrikte nerede olduğunu görün'
      },
      step3: {
        title: 'GÖRÜNTÜ INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SEZON SEÇİMİ',
        message: 'Atış verimliliğini ölçmek için sezonlar ekleyin'
      },
      step2: {
        title: 'KENDI VEYA RAKIBIN BITIRMESI',
        message: 'Takımın veya tüm rakiplerinin tamamlama haritasını görmek isteyip istemediğinizi seçin'
      },
      step3: {
        title: 'ATIŞ YERLEŞİMİ',
        message: 'Takımın şutlarını nasıl görmek istediğinizi seçin, dairelerle veya bölgelere (kutular) göre'
      },
      step4: {
        title: 'ATIŞ TÜRÜ',
        message: 'Çekim türüne, stratejiye, bölgeye veya vücut bölümüne göre filtreleme'
      },
      step5: {
        title: 'FİLTRE DAKİKALARI',
        message: 'Belirli maç dönemlerinde atılan şutları ve golleri seçmek için dakika çubuğu'
      },
      step6: {
        title: 'GÖRÜNTÜ INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      },
      step7: {
        title: 'ATIŞ HARİTASI',
        message: 'Harita interaktiftir. Her atışın xG değerini öğrenmek için fare ile her daireyi kontrol edin'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SEZON SEÇİMİ',
        message: 'Atış verimliliğini ölçmek için sezonlar ekleyin'
      },
      step2: {
        title: 'KENDI VEYA RAKIP ANAHTAR GEÇIŞLERI',
        message: 'Takımın veya tüm rakiplerinin önemli paslarının bir haritasını görmek isteyip istemediğinizi seçin'
      },
      step3: {
        title: 'ANAHTAR GEÇIŞ KONUMU',
        message: 'Anahtar geçişinin tam konumunu mu (daire) yoksa alan ve saha bazında mı (kutular) görmek istediğinizi seçin'
      },
      step4: {
        title: 'GEÇIŞ SONRASI FINIŞ TIPI',
        message: 'Tuş pasından sonra yapılan atış türüne, stratejiye, bölgeye veya vücut bölümüne göre filtreleme'
      },
      step5: {
        title: 'FİLTRE DAKİKALARI',
        message: 'Belirli maç dönemlerinde atılan şutları ve golleri seçmek için dakika çubuğu'
      },
      step6: {
        title: 'GÖRÜNTÜ INDIRME FORMATLARI',
        message: 'Üç indirme biçimi mevcuttur: png, svg ve embed'
      },
      step7: {
        title: 'ATIŞ HARİTASI',
        message: 'Harita interaktiftir. Her geçişin xA değerini öğrenmek için fare ile her daireye bakın'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'EN SON OYUNLAR',
        message: 'Takımın tüm maçlarının sonuçlarına, topa sahip olma, xG ve galibiyet yüzdesine bakın'
      }
    },
    teamTransfers: {
      step1: {
        title: 'GELİŞLER',
        message: 'Takvim yılı başına tüm varışlara (satın almalar + transferler) bakın'
      },
      step2: {
        title: 'DEPARTMANLAR',
        message: 'Takvim yılına göre tüm çıkışlara (satışlar + transferler) bakın'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDLER',
        message: 'Takım formunu seriler, galibiyetler, temiz skorlar, geri dönüşler, gollü dönemler veya gol türleri üzerinden sorgulayın'
      },
      step2: {
        title: 'DURAN TOP',
        message: 'Duran Oyunlarla Açık Oyun arasındaki Takımın Performansını karşılaştırın ve Duran Toplara ilişkin ayrıntılı bir genel bakış elde edin'
      },
      step3: {
        title: 'EKLER',
        message: 'Takımın ne zaman oyuncu değişikliği yaptığını ve en çok hangi oyuncuların değiştirildiğini görün'
      },
      step4: {
        title: 'BAĞLANTILAR',
        message: 'Oyuncular arasındaki en yaygın bağlantılara bakın. Sezona ve oyun türüne göre filtreleyin'
      },
      step5: {
        title: 'SALDIRI BÖLGELERİ',
        message: 'Takımın hücum bölgelerini keşfedin ve sezona veya hücum türüne göre filtreleyin'
      },
      step6: {
        title: 'FORMASYONLAR',
        message: 'En çok kullanılan dizilişleri ve her bir dizilişin galibiyet, beraberlik ve yenilgi yüzdelerini kontrol edin'
      },
      step7: {
        title: 'ATIŞ BÖLGELERİ',
        message: 'Sezona, takıma veya rakibe, haritayı görselleştirme şekline, şut türlerine veya dakikalara göre filtreleme'
      },
      step8: {
        title: 'ÇAPRAZLAR',
        message: 'Sezona, gösterim türüne, başarılı veya başarısız olmalarına, nereden başlayıp nerede bitirdiklerine veya köşe vuruşları dahil olmak üzere sorgulama ve filtreleme'
      },
      step9: {
        title: 'OYUNCULAR',
        message: 'Sezona, gösterim türüne, başarılı veya başarısız olmalarına, nereden başlayıp nerede bittiklerine veya köşe vuruşlarını içermelerine göre filtreleyin'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SEZONLAR VE MAÇLAR',
        message: 'Sezona, maçlara veya iç saha ya da deplasman maçlarına göre filtreleyin'
      },
      step2: {
        title: 'OYUNCULAR',
        message: 'Kadrodaki tüm oyuncuların performansını sayısız ölçümle görüntüleyin'
      }
    }
  },
  alerts: {
    numPlayers: 'Number of players',
    newPlayersLastWeek: 'New players last week',
    subtitle: 'Get alerts when new players meet your search criteria',
    generalSubtitle: 'Kriterlerinize göre yeni oyuncular ve favori oyuncularınızla ilgili haberler hakkında uyarılar alın',
    subtitlePlayer: 'Favori oyuncularınız hakkında haberler olduğunda uyarı alın',
    subtitleSearch: 'Arama kriterlerinize uygun yeni oyuncular olduğunda uyarı alın',
    favorite: 'Favori',
    newEventCalendar: 'Yeni Etkinlik',
    updatedEventCalendar: 'Güncellenmiş Etkinlik',
    newShareFrom: '\'dan Yeni Paylaşım',
    injuryAlert: 'Sakatlık Uyarısı',
    contractAlert: 'Sözleşme Uyarısı',
    teamAlert: 'İmza Uyarısı',
    marketValueAlert: 'Piyasa Değeri Uyarısı',
    gameAlert: 'Oynanan Maç Uyarısı'
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Full game',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Search player, game or team...',
    subtitle: 'Analyze events through video',
    successful: 'Success',
    unsuccessful: 'Fail',
    playing: 'Playing',
    games: 'Games',
    moreFilters: 'More filters...',
    startArea: 'Start area',
    endArea: 'End area',
    select: 'Select',
    selectLastXGames: 'Select last {0} games',
    advancedFilters: 'Advanced Filters',
    freeKicks: 'Free Kicks',
    cornerKicks: 'Corner Kicks',
    allShots: 'All Shots',
    generateZip: 'Generate ZIP',
    zippedModalMessage: 'ZIP process has been started, could take some minutes. You would receive an email when is finished',
    clickToSeeVideo: 'Click to see video'
  },
  videoUpload: {
    subtitle: 'Upload video and create new game',
    uploadVideo: 'Upload video',
    selectPeriod: 'Select period',
    gameData: 'Game Data',
    venue: 'Venue',
    matchType: 'Match type',
    matchGroup: 'Match group',
    roundType: 'Round type',
    roundNumber: 'Round number',
    offsetFh: 'Offset First Half',
    offsetSh: 'Offset Second Half',
    offsetFhOT: 'Offset Overtime First Half',
    offsetShOT: 'Offset Overtime Second Half',
    homeLineup: 'Home Lineup',
    awayLineup: 'Away Lineup',
    existingPlayer: 'Existing player',
    newPlayer: 'New player',
    startingTeam: 'Starting',
    saveAndUpload: 'Save and upload',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: '{1} ile {0} oyun yüklediniz. Limitiniz {2}',
    requestedGames: 'Talep edilen maçlar',
    limitClose: 'Talep edilebilecek yalnızca {0} maç kaldı',
    limitReached: 'Video yükleme limitinize ulaştınız. Ekstra maç yüklemek ek ücretlere neden olabilir.',
    seasonFinishedWarning: 'Bu, zaten bitmiş bir sezonda maç oluşturacaktır. Lütfen bunun doğru olduğundan emin olun.',
    teamCountryWarning: 'Bu takım, seçilen ligin ülkesinden farklı bir ülkeden. Lütfen bunun doğru olduğundan emin olun.',
    uploading: 'Yükleniyor',
    doNotNavigateAway: 'Lütfen yükleme devam ederken bu sekmeyi kapatmayın, sayfayı yenilemeyin veya başka yere gitmeyin.',
    severalMinutes: 'Bu işlem birkaç dakika sürebilir.'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: 'Tüm listeleri gör'
  },
  videoHighlights: {
    recap: 'Özet',
    homeCondensed: 'Evde yoğunlaştırılmış oyun',
    awayCondensed: 'Uzakta yoğunlaştırılmış oyun',
    selectedActions: 'Seçilen aksiyonlar',
    noActions: 'Belirtilen filtre kriterlerine uygun aksiyon yok',
    noGames: 'Henüz yüklenmiş maç yok',
    attackingActions: 'Hücum aksiyonları',
    defensiveActions: 'Savunma aksiyonları',
    groundDuels: 'Yer mücadeleleri',
    penaltiesProvoked: 'Provok edilen penaltılar',
    goalkeeperActions: 'Kaleci Hareketleri',
    addSomeGames: 'Bazı maçlar ekleyerek başlayın!',
    goToVideoUploadTool: 'Video Yükleme Aracına Git',
    ballInPlay: 'Top oyunda',
    filterSeasons: 'Sezonları Filtrele',
    streaming: 'Yayın',
    clips: 'Klipler',
    qualifiers: {
      Pass: 'Pas',
      Save: 'Kurtarış',
      'Saved Shot': 'Kurtarılan Şut',
      Shot: 'Şut',
      Goal: 'Gol',
      'Missed Shot': 'Kaçan Şut',
      'Shot on Post': 'Direğe Çarpan Şut',
      Error: 'Hata',
      Clearance: 'Uzaklaştırma',
      Aerial: 'Hava Mücadelesi',
      Challenge: 'Kaybedilen Mücadele',
      Dispossessed: 'Top Kaybı',
      Foul: 'Faul',
      Card: 'Kart',
      'Offside Pass': 'Ofsayt Pası',
      Claim: 'Topa Sahip Olma',
      'Keeper Pickup': 'Kalecinin Topu Alması',
      'Ball Touch': 'Top Teması',
      Dribble: 'Dripling',
      Interception: 'Top Kesme',
      Tackle: 'Müdahale',
      'Ball Recovery': 'Top Kazanma',
      Takeon: 'Dripling'
    },
    qualifierIds: {
      1: 'Uzun Pas',
      2: 'Orta',
      5: 'Doğrudan Serbest Vuruş',
      6: 'Korner',
      9: 'Penaltı',
      15: 'Kafa',
      20: 'Sağ Ayak',
      21: 'Vücudun Diğer Kısmı',
      22: 'Açık Oyun',
      23: 'Kontratak',
      24: 'Duran Top',
      25: 'Kornerden',
      26: 'Serbest Vuruş',
      28: 'Kendi kalesine gol',
      29: 'Asist',
      31: 'Sarı Kart',
      32: 'İkinci sarı kart',
      33: 'Kırmızı Kart',
      72: 'Sol Ayak',
      73: 'Sol',
      82: 'Kurtarılan şut (kaleci yok)',
      94: 'Savunma Bloğu',
      123: 'Kaleci atışı',
      124: 'Kaleci vuruşu',
      160: 'Taç Atışı',
      170: 'Gole yol açan',
      173: 'Güvenli Uzaklaştırma',
      174: 'Tehlikeli Uzaklaştırma',
      177: 'Alındı',
      178: 'Ayakta',
      179: 'Atlayarak',
      182: 'Eller',
      183: 'Ayaklar',
      185: 'Bloklanan Orta',
      210: 'Asist',
      215: 'Bireysel oyun',
      279: 'Başlama vuruşu',
      285: 'Savunma',
      286: 'Hücum'
    },
    areas: {
      goalArea: 'Altı Pas',
      boxLeft: 'Sol Ceza Sahası',
      boxCenter: 'Orta Ceza Sahası',
      boxRight: 'Sağ Ceza Sahası',
      outBoxDeepLeft: 'Ceza Sahası Dışı Sol Derin',
      outBoxDeepRight: 'Ceza Sahası Dışı Sağ Derin',
      outBoxLeft: 'Ceza Sahası Dışı Sol',
      outBoxCentreLeft: 'Ceza Sahası Dışı Orta Sol',
      outBoxCentre: 'Ceza Sahası Dışı Orta',
      outBoxCentreRight: 'Ceza Sahası Dışı Orta Sağ',
      outBoxRight: 'Ceza Sahası Dışı Sağ',
      midfieldLeft35: 'Orta Saha Sol',
      midfieldCentreLeft35: 'Orta Saha Orta Sol',
      midfieldCentre35: 'Orta Saha Orta',
      midfieldCentreRight35: 'Orta Saha Orta Sağ',
      midfieldRight35: 'Orta Saha Sağ',
      ownGoalArea: 'Kendi Altı Pas',
      ownBoxLeft: 'Kendi Sol Ceza Sahası',
      ownBoxCenter: 'Kendi Orta Ceza Sahası',
      ownBoxRight: 'Kendi Sağ Ceza Sahası',
      ownFieldOutOfBoxDeepLeft: 'Kendi Sahası Ceza Sahası Dışı Sol Derin',
      ownFieldOutOfBoxDeepRight: 'Kendi Sahası Ceza Sahası Dışı Sağ Derin',
      ownFieldOutOfBoxLeft: 'Kendi Sahası Ceza Sahası Dışı Sol',
      ownFieldOutOfBoxCentreLeft: 'Kendi Sahası Ceza Sahası Dışı Orta Sol',
      ownFieldOutOfBoxCentre: 'Kendi Sahası Ceza Sahası Dışı Orta',
      ownFieldOutOfBoxCentreRight: 'Kendi Sahası Ceza Sahası Dışı Orta Sağ',
      ownFieldOutOfBoxRight: 'Kendi Sahası Ceza Sahası Dışı Sağ',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Başarı',
      fail: 'Başarısızlık',
      possessionWon: 'Top Kazanıldı',
      possessionNotWon: 'Top Kazanılmadı',
      received: 'Alındı',
      provoked: 'Provokasyon'
    },
    homePlayerHighlights: 'Ev sahibi oyuncunun öne çıkanları',
    awayPlayerHighlights: 'Deplasman oyuncusunun öne çıkanları'
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: 'Alındı',
    fromMe: 'Gönderildi',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: 'Paylaşılanlar',
    subtitle: 'Paylaşım listenizdeki öğelerin genel görünümü',
    selectUser: 'Kullanıcıyı seç',
    expired: 'Günü geçmiş',
    limitReached: 'Bağlantı kullanım sınırına ulaştı'
  },
  homeStats: {
    data: 'Mevcut Veriler',
    players: 'oyuncular',
    totalPlayers: 'toplam oyuncu',
    teams: 'ekipler',
    totalTeams: 'toplam takımlar',
    leagues: 'ligler',
    totalLeagues: 'toplam li̇gler',
    seasons: 'mevsimler',
    totalSeasons: 'toplam sezonlar',
    games: 'oyunlar',
    totalGames: 'toplam oyun'
  },
  scoutingCalendar: {
    subtitle: 'Scouting görevlerinizi oluşturun ve düzenleyin',
    myCalendars: 'Özel takvim',
    publicCalendars: 'Halka açık takvimler',
    otherCalendars: 'Diğer takvimler',
    calendarSettings: 'Takvim ayarları',
    moreInfo: 'Daha fazla bilgi',
    individualScouting: 'Bireysel Scouting',
    matchScouting: 'Maç Scouting',
    calendarView: {
      type: 'Takvim türü',
      month: 'Ay',
      week: 'Hafta',
      day: 'Gün'
    },
    weekView: {
      type: 'Hafta türü',
      monSun: 'Pazartesi - Pazar',
      sunSat: 'Pazar - Cumartesi',
      monFri: 'Pazartesi - Cuma'
    },
    tasks: {
      addNew: 'Yeni görev ekle',
      myTasks: 'Görevlerim',
      filterTasks: 'Görevleri filtrele',
      sharedWithMe: 'Benimle paylaşılan',
      createTask: 'Görev oluştur',
      newTask: 'Yeni görev',
      taskName: 'Görev adı',
      allDay: 'Tüm gün',
      startDate: 'Başlangıç tarihi',
      endDate: 'Bitiş tarihi',
      startHour: 'Başlangıç saati',
      endHour: 'Bitiş saati',
      assignedTo: 'Atanan',
      assignedToMe: 'Bana atanan',
      color: 'Renk',
      scoutingType: 'Scouting türü',
      taskLocation: 'Görevin yeri',
      selectLeague: 'Lig seç',
      selectMatch: 'Maç seç',
      useMatchdate: 'Maç tarihini kullan',
      stadium: 'Stadyum',
      travel: 'Seyahat',
      hotel: 'Otel',
      tickets: 'Biletler',
      taskNotes: 'Göreve ilişkin açıklayıcı notlar veya yorumlar yazın',
      states: {
        toDo: 'Yapılacak',
        inProgress: 'Devam Ediyor',
        done: 'Tamamlandı'
      },
      type: {
        player: 'Oyuncu Değerlendirmesi',
        team: 'Takım Değerlendirmesi',
        other: 'Diğer'
      },
      location: {
        stadium: 'Stadyumda',
        video: 'Video'
      },
      accommodation: {
        accommodationDetails: 'Konaklama Detayları',
        ownArrangement: 'Kendi düzenlemesi',
        required: 'Gerekli',
        notRequired: 'Gerekli değil',
        booked: 'Rezerve edildi'
      },
      assignToMe: 'Bana ata',
      addOther: 'Diğer ekle',
      deleteTask: 'Görevi sil',
      deleteTaskMessage: 'Görev kaldırılacak, emin misiniz?',
      cancelUpdate: 'Güncellemeyi iptal et',
      cancelUpdateMessage: 'Değişiklikler kaydedilmeyecek, emin misiniz?',
      selectGame: 'Lütfen dosya eklemek için bir maç seçin',
      noData: 'Veri yok. Görev ekleyerek başlayın!',
      widgetSubtitle: 'Gelecek görevlerinizi kontrol edin',
      scoutingDetails: 'Scouting detayları',
      taskDetails: 'Görev detayları',
      playerDocuments: 'Oyuncu belgeleri',
      teamDocuments: 'Takım belgeleri',
      gameDocuments: 'Maç belgeleri',
      taskDocuments: 'Görev belgeleri',
      task: 'Görev'
    },
    nextGames: 'Yaklaşan maçlar'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Bu hafta',
      month: 'Bu ay',
      year: 'Bu yıl'
    },
    noTasks: 'Yeni görevler oluşturun veya birini buraya sürükleyin!',
    goToBoard: 'Board\'a git'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Hesap ve abonelik detaylarınızı özelleştirin'
  },
  hub: {
    onlyHub: 'Yalnızca Driblab Hub\'da mevcuttur',
    blue: 'mavi',
    purple: 'mor',
    orange: 'turuncu',
    grey: 'gri',
    indigo: 'çivit rengi',
    teal: 'turkuaz',
    lightBlue: 'açık mavi',
    brown: 'kahverengi'
  },
  uploadedGames: {
    subtitle: 'All uploaded games',
    timeRequested: 'Time it was requested',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: 'Yüklenen Maçlara Git',
    sla: 'Hizmet Düzeyi Anlaşması',
    matchDate: 'Maç tarihi',
    rejectedGame: 'Reddedildi',
    reviewed: 'İncelendi',
    requested: 'Talep edildi',
    koraStatus: 'Kora Durumu',
    aws: 'AWS',
    fullVideo: 'Tam Video',
    offset: 'Ofset',
    updateFullVideo: 'Tam Video Güncellensin mi?'
  },
  gameMap: {
    title: 'Oyun Haritası',
    subtitle: 'Gelecek günlerdeki maçları keşfedin',
    warning: 'Zaman ve yer doğru olmayabilir. Lütfen bu bilgileri teyit edin.',
    taskAdded: 'Görev başarıyla oluşturuldu. Scouting Calendar\'ı kontrol edin.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Başarıyla bildirildi',
    notPermissions: 'Görmek için izniniz yok',
    notPermissionsLeague: 'Bu ligi görmek için izniniz yok',
    notPermissionsGame: 'Bu maçı görmek için izniniz yok',
    requestAccessTo: 'Erişim iste',
    sendRequest: 'İstek Gönder'
  },
  videoTeams: {
    subtitle: 'Takıma göre etiketlenmiş son maçları bulun',
    noGamesUploaded: 'Henüz oyun yüklenmedi'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scouting Analizi',
    scoutingAnalyses: 'Scouting Analizleri',
    playerScoutingAnalyses: 'Oyuncu Scouting Analizleri',
    gameScoutingAnalyses: 'Maç Scouting Analizleri',
    analyses: 'Analizler',
    addReport: 'Analiz Ekle',
    technical: 'Teknik',
    tactical: 'Taktiksel',
    physical: 'Fiziksel',
    mental: 'Psikolojik',
    technicalNotes: 'Teknik notlar',
    tacticalNotes: 'Taktik notlar',
    physicalNotes: 'Fiziksel notlar',
    mentalNotes: 'Psikolojik profil notları',
    conclusion: 'Sonuç',
    charactersMax: 'Maksimum 1000 karakter',
    globalRating: 'Genel puanlama',
    noData: 'Veri yok. Scouting analizleri ekleyerek başlayın!',
    deleteAnalysis: 'Scouting Analizini Sil',
    deleteAnalysisMessage: 'Analiz kalıcı olarak kaldırılacak. Emin misiniz?',
    avgTooltip: 'Size görünür olan analizlerin son puanlamalarına dayanarak ortalama',
    avgOverallScoreTooltip: 'Ortalama, size görünür olan oyuncunun genel puanlarına dayanmaktadır',
    scouter: 'Scouter',
    lastEdited: 'Son düzenleme',
    analysisFilters: 'Analiz Filtreleri',
    generalFilters: 'Genel Filtreler',
    widgetSubtitle: 'Eklenen son analizler',
    addPlayerReport: 'Oyuncu scouting analizini ekle',
    seeReports: 'Raporları gör',
    addGameReport: 'Maç Analizi Ekle',
    keyPlayers: 'Kilit Oyuncular',
    formation: 'Formasyon',
    inPossession: 'Topla Oynarken',
    notesIP: 'Topla Oynarken Notlar',
    outOfPossession: 'Topsuz Oynarken',
    notesOP: 'Topsuz Oynarken Notlar',
    transitions: 'Geçişler',
    notesTransitions: 'Geçiş Notları',
    notesSP: 'Duran Top Notları',
    finalRating: 'Final Puanı',
    gameNotesPlaceholder: 'Maçla ilgili açıklayıcı notlar veya yorumlar yazın',
    avgPotentialTooltip: 'Gördüğünüz analizlerin potansiyeline dayalı ortalama',
    potential: 'Potansiyel',
    tags: 'Etiketler',
    tagsPlaceholder: 'Bazı etiketler ekleyin',
    tagsHint: 'Etiket eklemek için yazın ve Enter tuşuna basın',
    exampleTags: {
      leadership: 'Liderlik',
      resilience: 'Dayanıklılık',
      competitiveMindset: 'Rekabetçi zihniyet',
      calmUnderPressure: 'Baskı altında sakin',
      focus: 'Odak',
      discipline: 'Disiplin',
      coachability: 'Koçluk yapılabilirlik',
      poorBodyLanguage: 'Zayıf vücut dili',
      lowConfidence: 'Düşük güven',
      easilyFrustrated: 'Kolayca hayal kırıklığına uğrar'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Lig olmadan takım oluşturmak, uygulama içindeki dizin oluşturma ve sonraki arama üzerinde olumsuz etkiye sahip olabilir.'
  },
  expenses: {
    expense: 'Gider',
    expenses: 'Giderler',
    addExpense: 'Gider ekle',
    transportation: 'Ulaşım',
    accommodation: 'Konaklama',
    dietary: 'Beslenme',
    eventTicket: 'Etkinlik bileti',
    expenseType: 'Gider türü',
    amount: 'Tutar',
    expenseDate: 'Gider tarihi',
    expenseFilters: 'Gider filtreleri',
    noData: 'Veri yok. Bazı giderler ekleyerek başlayın!',
    deleteExpense: 'Gideri Sil',
    deleteExpenseMessage: 'Gider kalıcı olarak silinecek. Emin misiniz?'
  },
  disabledTooltips: {
    general: 'Bu özellik şu anda devre dışı',
    youth: 'Yaş belirlemek için genç olmalı',
    unit: 'İstatistik Runs, HSR veya SPR olmalı',
    seasonsWithout60MinsGames: 'Seçilen sezonda oyuncu bir maçta 60 dakikadan fazla oynamamış',
    notEditable: 'Bu düzenlenemez',
    noMatchdate: 'Maç tarihi mevcut değil',
    selectGame: 'Önce bir maç seçin',
    selectPlayer: 'Önce bir oyuncu seçin',
    selectTeam: 'Önce bir takım seçin',
    selectBoxes: 'Kutu görselleştirmesi seçilmelidir',
    selectYear: 'Önce bir yıl seçin',
    pdScoreNotAvailable: 'Bir maçta 60 dakika oynamayan oyuncular için puan mevcut değil',
    pdSeasonNotAvailable: 'Bu sezon için fiziksel veriler mevcut değil',
    pdGameNotAvailable: 'Bu maç için fiziksel veriler mevcut değil'
  },
  leagueTypes: {
    regular: 'Normal',
    continental: 'Kıtasal',
    nationalTeam: 'Milli Takım',
    countryCup: 'Ülke Kupası',
    qualifier: 'Eleme',
    playOff: 'Play-Off',
    regionalLeague: 'Bölgesel Lig',
    friendly: 'Hazırlık Maçı',
    nationalFriendly: 'Milli Hazırlık Maçı',
    nationaQualifier: 'Milli Eleme'
  },
  playerSides: {
    'Left/Right': 'Sol/Sağ',
    'Left/Centre/Right': 'Sol/Merkez/Sağ',
    Right: 'Sağ',
    Centre: 'Merkez',
    'Centre/Right': 'Merkez/Sağ',
    Left: 'Sol',
    'Left/Centre': 'Sol/Merkez'
  },
  areaSelector: {
    selectAreas: 'Alanları seç',
    filterAreas: 'Alanları filtrele'
  },
  spatialCoverage: {
    lastDefenderDist: 'Son savunma mesafesi',
    defensiveLineDist: 'Savunma hattı mesafesi',
    fullBackAvgDist: 'Ortalama yanal mesafe',
    offensiveLineDist: 'Hücum hattı mesafesi',
    distanceToGoal: 'Hedefe olan mesafe',
    avgLineWidth: 'Ort. çizgi genişliği',
    leagueAvgDistanceToGoal: 'Ort. lig mesafesi hedefe',
    leagueAvgLineWidth: 'Ort. lig çizgi genişliği',
    avgShort: 'Ort.',
    meters: 'metre',
    leagueAvgDist: 'Ortalama lig mesafesi',
    distance: 'Mesafe',
    avgPositionYAxis: 'Sahada ort. mesafe (Y)',
    leagueAvgPositionYAxis: 'Lig ort. saha mesafesi (Y)',
    lbRbDistanceSeparation: 'LB–RB mesafesi',
    leagueAvgLbRbDistanceSeparation: 'Lig ort. LB–RB mesafesi',
    legendTeam: 'Takım',
    legendLeagueAvg: 'Lig Ort.',
    maxLength: 'Maksimum Uzunluk',
    maxWidth: 'Maksimum Genişlik',
    avgBlockDistance: 'Ortalama blok mesafesi'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Akıllı Veri',
    passesUnderPressureSubtitle: 'Savunma baskısı altında yapılan pasların başarı oranını analiz edin',
    onBallPressureSubtitle: 'Savunma basınç olaylarını ve başarı oranını alan bölgelere göre analiz edin',
    ballReceiptsInSpaceSubtitle: 'Saha bölgesine göre uzayda alınan pasları analiz edin',
    ballReceipts: 'makbuzlar',
    totalBallReceipts: 'Toplam Top Alımları',
    totalBallReceiptsCompleted: 'Toplam Top Alımları Tamamlandı',
    completed: 'Tamamlandı',
    lineBreakingPassesSubtitle: 'Hatları delen ve avantaj yaratan pasları analiz et',
    bypassed: 'Bypassed',
    oppsBypassed: 'Rakipler Alt Edildi',
    passer: 'Pasör',
    passedTo: 'Geç',
    receivedFrom: 'Alındı',
    distanceToNearestDefender: 'En yakın savunmacıya olan mesafe',
    lineBreaking: 'satır sonu {0}',
    keyPass: 'AnahtarGeçişi',
    receiver: 'Alıcı',
    dynamicTracking: 'Dinamik Takip',
    eventLockTooltip: 'Bazı oyuncular oyunda görünmüyor',
    bypassedPlayers: '{0} geçilen oyuncu',
    playersCount: '{0} oyuncu',
    bothTeams: 'Her iki takım',
    matchesCount: '{0} maç',
    lbpType: {
      F: 'Hücüm hattı',
      M: 'Orta saha hattı',
      B: 'Defans hattı',
      MF: 'Orta saha ve hücum hatları',
      BM: 'Defans ve orta saha hatları',
      BF: 'Defans ve hücum hatları',
      BMF: 'Defans, orta saha ve hücum hatları'
    },
    lbpCategory: {
      'G-IN-T': 'Yerden içerden (defans hattını kırar)',
      'G-IN-NT': 'Yerden içerden (defans hattını kırmaz)',
      'G-OUT-T': 'Yerden dışardan (defans hattını kırar)',
      'G-OUT-NT': 'Yerden dışardan (defans hattını kırmaz)',
      'O-IN-T': 'Havadan içerden (defans hattını kırar)',
      'O-IN-NT': 'Havadan içerden (defans hattını kırmaz)',
      'O-OUT-T': 'Havadan dışardan (defans hattını kırar)',
      'O-OUT-NT': 'Havadan dışardan (defans hattını kırmaz)',
      ground: 'Yerden',
      over: 'Havadan',
      inside: 'İçerden',
      outside: 'Dışardan',
      through: 'Defans hattını kırar',
      notThrough: 'Defans hattını kırmaz',
      throughAbbr: 'Def\'i kırıyorum. astar',
      notThroughAbbr: 'Def\'i kırmıyorum. astar'
    },
    lbpCategorySplit: {
      G: 'Yer: Pas yerdendi',
      O: 'Uç: Pas uçtu',
      OUT: 'Dışarıda: Geçiş dışarı çıktı',
      IN: 'İçeri: Pas içeri gitti',
      T: 'Defans hattını kırar: pas savunma hattını içeriden kırar',
      NT: 'Defans hattını kırmaz: pas hattı içeriden kırmaz; dışarıdan dolanır',
      'DIŞARI': 'Dışarı: Pas dışarı gitti'
    },
    obrType: {
      OL: 'Üst Üste',
      UL: 'Alt Üste',
      RA: 'Önden Koş',
      RB: 'Arkadan Koş',
      CR: 'Çapraz Alıcı',
      SP: 'Destek',
      CS: 'Kısa Kalma'
    },
    visualization: 'Görselleştirme',
    points: 'Daireler',
    zones: 'Isı Haritası',
    pressureIntensity: 'Basınç Şiddeti',
    pressureOutcome: 'Basınç Sonucu',
    passesOutcome: 'Pas Sonucu',
    strong: 'Güçlü',
    light: 'Hafif',
    normal: 'Normal',
    successful: 'Başarılı',
    unsuccessful: 'Başarısız',
    presses: 'Basınçlar',
    passes: 'Geçişler',
    passUnder: 'Altından Geç',
    successRate: 'Başarı Oranı',
    pressureOn: 'Basınç',
    pressureOf: 'Baskısı',
    pressure: 'Basınç',
    totalLabel: 'toplam',
    totalPasses: 'Toplam Geçişler',
    unknown: 'bilinmiyor',
    selectGameToViewMap: 'Basınç haritasını görmek için bir maç seçin',
    noEventsFoundForGame: 'Bu maç için basınç olayları bulunamadı',
    noEventsFoundForTeamAndSeason: 'Bu takım ve sezon için basınç olayları bulunamadı',
    noEventsFoundForPlayerAndSeason: 'Bu oyuncu ve sezon için basınç olayları bulunamadı',
    noEventsMatchFilters: 'Bu filtreler için basınç olayları bulunamadı',
    totalEventsAvailable: 'toplam basınç olayı sayısı',
    passType: {
      P: 'Geçmek',
      A: 'Yardım',
      KP: 'Anahtar Geçiş',
      PiOB: 'Opp\'a geçin. Kutu',
      PiFT: 'Final Third\'e geçin',
      SoPP: 'Play Pass\'e geçiş'
    },
    minFrom: 'Min. Başlangıç ​​Tarihi:',
    minTo: 'Minimum Bitiş',
    secondFrom: 'Başlangıç ​​Noktası',
    secondTo: 'Bölümleme',
    positionPlayed: 'Oynanan Pozisyon',
    highlight: 'Vurgula',
    passTypeLabel: 'Geçiş Türü',
    offBallRunSubtitle: 'Topsuz koşuları analiz edin',
    insights: 'Analizler',
    insightsSubtitle: 'Gelişmiş Arrigo Analytics ile En İyiyi Sıralamak',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Bugün sana nasıl yardımcı olabilirim?',
    chatSubtext: 'Futbol verileriyle ilgili her şeyi sorun!',
    thinking: 'Düşünüyorum...',
    giveFeedback: 'Geri Bildirimde Bulunun',
    disclaimer: 'DriblabAI hata yapabilir. Lütfen bilgileri doğruladığınızdan emin olun.',
    recent: 'Son',
    noConversations: 'Burada son konuşmalarınızı göreceksiniz!',
    rename: 'Yeniden isimlendirmek',
    deleteConversation: 'Görüşmeyi sil',
    confirmDelete: 'Bu görüşmeyi silmek istediğinizden emin misiniz?',
    feedback: 'Geri bildirim',
    feedbackQuestion: 'Bu yanıt faydalı oldu mu?',
    feedbackComments: 'Ek yorumlar',
    feedbackPlaceholder: 'Neyin faydalı olduğunu veya nelerin geliştirilebileceğini bize bildirin...',
    errorMessage: 'Mesaj işlenemedi. Lütfen tekrar deneyin.',
    newConversation: 'Yeni Sohbet',
    write: 'Bir mesaj yazın...'
  },
  periodId: {
    1: 'İlk Yarı',
    2: 'İkinci Yarı',
    3: 'Uzatma Zamanı - 1°',
    4: 'Uzatma Zamanı - 2°',
    5: 'Penaltı Atışları',
    6: 'Tam zamanlı',
    7: 'Maç Öncesi',
    8: 'Terk edilmiş',
    9: 'Canlı',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Diğer'
  }
};
